/* resources/assets/js/libraries/cookies.min.js */
/*!
 * JavaScript Cookie v2.2.0
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
  var registeredInModuleLoader = false;
  if (typeof define === 'function' && define.amd) {
    define(factory);
    registeredInModuleLoader = true;
  }
  if (typeof exports === 'object') {
    module.exports = factory();
    registeredInModuleLoader = true;
  }
  if (!registeredInModuleLoader) {
    var OldCookies = window.Cookies;
    var api = window.Cookies = factory();
    api.noConflict = function () {
      window.Cookies = OldCookies;
      return api;
    };
  }
}(function () {
  function extend () {
    var i = 0;
    var result = {};
    for (; i < arguments.length; i++) {
      var attributes = arguments[ i ];
      for (var key in attributes) {
        result[key] = attributes[key];
      }
    }
    return result;
  }

  function init (converter) {
    function api (key, value, attributes) {
      var result;
      if (typeof document === 'undefined') {
        return;
      }

      // Write

      if (arguments.length > 1) {
        attributes = extend({
          path: '/'
        }, api.defaults, attributes);

        if (typeof attributes.expires === 'number') {
          var expires = new Date();
          expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
          attributes.expires = expires;
        }

        // We're using "expires" because "max-age" is not supported by IE
        attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

        try {
          result = JSON.stringify(value);
          if (/^[\{\[]/.test(result)) {
            value = result;
          }
        } catch (e) {}

        if (!converter.write) {
          value = encodeURIComponent(String(value))
            .replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
        } else {
          value = converter.write(value, key);
        }

        key = encodeURIComponent(String(key));
        key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
        key = key.replace(/[\(\)]/g, escape);

        var stringifiedAttributes = '';

        for (var attributeName in attributes) {
          if (!attributes[attributeName]) {
            continue;
          }
          stringifiedAttributes += '; ' + attributeName;
          if (attributes[attributeName] === true) {
            continue;
          }
          stringifiedAttributes += '=' + attributes[attributeName];
        }
        return (document.cookie = key + '=' + value + stringifiedAttributes);
      }

      // Read

      if (!key) {
        result = {};
      }

      // To prevent the for loop in the first place assign an empty array
      // in case there are no cookies at all. Also prevents odd result when
      // calling "get()"
      var cookies = document.cookie ? document.cookie.split('; ') : [];
      var rdecode = /(%[0-9A-Z]{2})+/g;
      var i = 0;

      for (; i < cookies.length; i++) {
        var parts = cookies[i].split('=');
        var cookie = parts.slice(1).join('=');

        if (!this.json && cookie.charAt(0) === '"') {
          cookie = cookie.slice(1, -1);
        }

        try {
          var name = parts[0].replace(rdecode, decodeURIComponent);
          cookie = converter.read ?
            converter.read(cookie, name) : converter(cookie, name) ||
                                           cookie.replace(rdecode, decodeURIComponent);

          if (this.json) {
            try {
              cookie = JSON.parse(cookie);
            } catch (e) {}
          }

          if (key === name) {
            result = cookie;
            break;
          }

          if (!key) {
            result[name] = cookie;
          }
        } catch (e) {}
      }

      return result;
    }

    api.set = api;
    api.get = function (key) {
      return api.call(api, key);
    };
    api.getJSON = function () {
      return api.apply({
        json: true
      }, [].slice.call(arguments));
    };
    api.defaults = {};

    api.remove = function (key, attributes) {
      api(key, '', extend(attributes, {
        expires: -1
      }));
    };

    api.withConverter = init;

    return api;
  }

  return init(function () {});
}));

/* resources/assets/js/libraries/jquery-3.6.0.js */
/*!
 * jQuery JavaScript Library v3.6.0
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2021-03-02T17:08Z
 */
( function( global, factory ) {

	"use strict";

	if ( typeof module === "object" && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var flat = arr.flat ? function( array ) {
	return arr.flat.call( array );
} : function( array ) {
	return arr.concat.apply( [], array );
};


var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};

var isFunction = function isFunction( obj ) {

		// Support: Chrome <=57, Firefox <=52
		// In some browsers, typeof returns "function" for HTML <object> elements
		// (i.e., `typeof document.createElement( "object" ) === "function"`).
		// We don't want to classify *any* DOM node as a function.
		// Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
		// Plus for old WebKit, typeof returns "function" for HTML collections
		// (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
		return typeof obj === "function" && typeof obj.nodeType !== "number" &&
			typeof obj.item !== "function";
	};


var isWindow = function isWindow( obj ) {
		return obj != null && obj === obj.window;
	};


var document = window.document;



	var preservedScriptAttributes = {
		type: true,
		src: true,
		nonce: true,
		noModule: true
	};

	function DOMEval( code, node, doc ) {
		doc = doc || document;

		var i, val,
			script = doc.createElement( "script" );

		script.text = code;
		if ( node ) {
			for ( i in preservedScriptAttributes ) {

				// Support: Firefox 64+, Edge 18+
				// Some browsers don't support the "nonce" property on scripts.
				// On the other hand, just using `getAttribute` is not enough as
				// the `nonce` attribute is reset to an empty string whenever it
				// becomes browsing-context connected.
				// See https://github.com/whatwg/html/issues/2369
				// See https://html.spec.whatwg.org/#nonce-attributes
				// The `node.getAttribute` check was added for the sake of
				// `jQuery.globalEval` so that it can fake a nonce-containing node
				// via an object.
				val = node[ i ] || node.getAttribute && node.getAttribute( i );
				if ( val ) {
					script.setAttribute( i, val );
				}
			}
		}
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}


function toType( obj ) {
	if ( obj == null ) {
		return obj + "";
	}

	// Support: Android <=2.3 only (functionish RegExp)
	return typeof obj === "object" || typeof obj === "function" ?
		class2type[ toString.call( obj ) ] || "object" :
		typeof obj;
}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var
	version = "3.6.0",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	};

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	even: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return ( i + 1 ) % 2;
		} ) );
	},

	odd: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return i % 2;
		} ) );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				copy = options[ name ];

				// Prevent Object.prototype pollution
				// Prevent never-ending loop
				if ( name === "__proto__" || target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {
					src = target[ name ];

					// Ensure proper type for the source value
					if ( copyIsArray && !Array.isArray( src ) ) {
						clone = [];
					} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
						clone = {};
					} else {
						clone = src;
					}
					copyIsArray = false;

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	// Evaluates a script in a provided context; falls back to the global one
	// if not specified.
	globalEval: function( code, options, doc ) {
		DOMEval( code, { nonce: options && options.nonce }, doc );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
						[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return flat( ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( _i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = toType( obj );

	if ( isFunction( obj ) || isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.3.6
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://js.foundation/
 *
 * Date: 2021-02-16
 */
( function( window ) {
var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	nonnativeSelectorCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// Instance methods
	hasOwn = ( {} ).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	pushNative = arr.push,
	push = arr.push,
	slice = arr.slice,

	// Use a stripped-down indexOf as it's faster than native
	// https://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[ i ] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|" +
		"ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
	identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace +
		"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +

		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +

		// "Attribute values must be CSS identifiers [capture 5]
		// or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" +
		whitespace + "*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +

		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +

		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +

		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" +
		whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace +
		"*" ),
	rdescend = new RegExp( whitespace + "|>" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
			whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" +
			whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),

		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace +
			"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace +
			"*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rhtml = /HTML$/i,
	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g" ),
	funescape = function( escape, nonHex ) {
		var high = "0x" + escape.slice( 1 ) - 0x10000;

		return nonHex ?

			// Strip the backslash prefix from a non-hex escape sequence
			nonHex :

			// Replace a hexadecimal escape sequence with the encoded Unicode code point
			// Support: IE <=11+
			// For values outside the Basic Multilingual Plane (BMP), manually construct a
			// surrogate pair
			high < 0 ?
				String.fromCharCode( high + 0x10000 ) :
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
	fcssescape = function( ch, asCodePoint ) {
		if ( asCodePoint ) {

			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}

			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" +
				ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}

		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	},

	inDisabledFieldset = addCombinator(
		function( elem ) {
			return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
		},
		{ dir: "parentNode", next: "legend" }
	);

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		( arr = slice.call( preferredDoc.childNodes ) ),
		preferredDoc.childNodes
	);

	// Support: Android<4.0
	// Detect silently failing push.apply
	// eslint-disable-next-line no-unused-expressions
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			pushNative.apply( target, slice.call( els ) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;

			// Can't trust NodeList.length
			while ( ( target[ j++ ] = els[ i++ ] ) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {
		setDocument( context );
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && ( match = rquickExpr.exec( selector ) ) ) {

				// ID selector
				if ( ( m = match[ 1 ] ) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( ( elem = context.getElementById( m ) ) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && ( elem = newContext.getElementById( m ) ) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[ 2 ] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( ( m = match[ 3 ] ) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!nonnativeSelectorCache[ selector + " " ] &&
				( !rbuggyQSA || !rbuggyQSA.test( selector ) ) &&

				// Support: IE 8 only
				// Exclude object elements
				( nodeType !== 1 || context.nodeName.toLowerCase() !== "object" ) ) {

				newSelector = selector;
				newContext = context;

				// qSA considers elements outside a scoping root when evaluating child or
				// descendant combinators, which is not what we want.
				// In such cases, we work around the behavior by prefixing every selector in the
				// list with an ID selector referencing the scope context.
				// The technique has to be used as well when a leading combinator is used
				// as such selectors are not recognized by querySelectorAll.
				// Thanks to Andrew Dupont for this technique.
				if ( nodeType === 1 &&
					( rdescend.test( selector ) || rcombinators.test( selector ) ) ) {

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;

					// We can use :scope instead of the ID hack if the browser
					// supports it & if we're not changing the context.
					if ( newContext !== context || !support.scope ) {

						// Capture the context ID, setting it first if necessary
						if ( ( nid = context.getAttribute( "id" ) ) ) {
							nid = nid.replace( rcssescape, fcssescape );
						} else {
							context.setAttribute( "id", ( nid = expando ) );
						}
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[ i ] = ( nid ? "#" + nid : ":scope" ) + " " +
							toSelector( groups[ i ] );
					}
					newSelector = groups.join( "," );
				}

				try {
					push.apply( results,
						newContext.querySelectorAll( newSelector )
					);
					return results;
				} catch ( qsaError ) {
					nonnativeSelectorCache( selector, true );
				} finally {
					if ( nid === expando ) {
						context.removeAttribute( "id" );
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {

		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {

			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return ( cache[ key + " " ] = value );
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement( "fieldset" );

	try {
		return !!fn( el );
	} catch ( e ) {
		return false;
	} finally {

		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}

		// release memory in IE
		el = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split( "|" ),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[ i ] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			a.sourceIndex - b.sourceIndex;

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( ( cur = cur.nextSibling ) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return ( name === "input" || name === "button" ) && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					/* jshint -W018 */
					elem.isDisabled !== !disabled &&
					inDisabledFieldset( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction( function( argument ) {
		argument = +argument;
		return markFunction( function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ ( j = matchIndexes[ i ] ) ] ) {
					seed[ j ] = !( matches[ j ] = seed[ j ] );
				}
			}
		} );
	} );
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	var namespace = elem && elem.namespaceURI,
		docElem = elem && ( elem.ownerDocument || elem ).documentElement;

	// Support: IE <=8
	// Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
	// https://bugs.jquery.com/ticket/4833
	return !rhtml.test( namespace || docElem && docElem.nodeName || "HTML" );
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( doc == document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9 - 11+, Edge 12 - 18+
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( preferredDoc != document &&
		( subWindow = document.defaultView ) && subWindow.top !== subWindow ) {

		// Support: IE 11, Edge
		if ( subWindow.addEventListener ) {
			subWindow.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( subWindow.attachEvent ) {
			subWindow.attachEvent( "onunload", unloadHandler );
		}
	}

	// Support: IE 8 - 11+, Edge 12 - 18+, Chrome <=16 - 25 only, Firefox <=3.6 - 31 only,
	// Safari 4 - 5 only, Opera <=11.6 - 12.x only
	// IE/Edge & older browsers don't support the :scope pseudo-class.
	// Support: Safari 6.0 only
	// Safari 6.0 supports :scope but it's an alias of :root there.
	support.scope = assert( function( el ) {
		docElem.appendChild( el ).appendChild( document.createElement( "div" ) );
		return typeof el.querySelectorAll !== "undefined" &&
			!el.querySelectorAll( ":scope fieldset div" ).length;
	} );

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert( function( el ) {
		el.className = "i";
		return !el.getAttribute( "className" );
	} );

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert( function( el ) {
		el.appendChild( document.createComment( "" ) );
		return !el.getElementsByTagName( "*" ).length;
	} );

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert( function( el ) {
		docElem.appendChild( el ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	} );

	// ID filter and find
	if ( support.getById ) {
		Expr.filter[ "ID" ] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute( "id" ) === attrId;
			};
		};
		Expr.find[ "ID" ] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter[ "ID" ] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode( "id" );
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find[ "ID" ] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode( "id" );
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( ( elem = elems[ i++ ] ) ) {
						node = elem.getAttributeNode( "id" );
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find[ "TAG" ] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,

				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( ( elem = results[ i++ ] ) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find[ "CLASS" ] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See https://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( ( support.qsa = rnative.test( document.querySelectorAll ) ) ) {

		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert( function( el ) {

			var input;

			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// https://bugs.jquery.com/ticket/12359
			docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( el.querySelectorAll( "[msallowcapture^='']" ).length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !el.querySelectorAll( "[selected]" ).length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push( "~=" );
			}

			// Support: IE 11+, Edge 15 - 18+
			// IE 11/Edge don't find elements on a `[name='']` query in some cases.
			// Adding a temporary attribute to the document before the selection works
			// around the issue.
			// Interestingly, IE 10 & older don't seem to have the issue.
			input = document.createElement( "input" );
			input.setAttribute( "name", "" );
			el.appendChild( input );
			if ( !el.querySelectorAll( "[name='']" ).length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*name" + whitespace + "*=" +
					whitespace + "*(?:''|\"\")" );
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !el.querySelectorAll( ":checked" ).length ) {
				rbuggyQSA.push( ":checked" );
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push( ".#.+[+~]" );
			}

			// Support: Firefox <=3.6 - 5 only
			// Old Firefox doesn't throw on a badly-escaped identifier.
			el.querySelectorAll( "\\\f" );
			rbuggyQSA.push( "[\\r\\n\\f]" );
		} );

		assert( function( el ) {
			el.innerHTML = "<a href='' disabled='disabled'></a>" +
				"<select disabled='disabled'><option/></select>";

			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement( "input" );
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( el.querySelectorAll( "[name=d]" ).length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( el.querySelectorAll( ":enabled" ).length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: IE9-11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			docElem.appendChild( el ).disabled = true;
			if ( el.querySelectorAll( ":disabled" ).length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: Opera 10 - 11 only
			// Opera 10-11 does not throw on post-comma invalid pseudos
			el.querySelectorAll( "*,:x" );
			rbuggyQSA.push( ",.*:" );
		} );
	}

	if ( ( support.matchesSelector = rnative.test( ( matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector ) ) ) ) {

		assert( function( el ) {

			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( el, "*" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( el, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		} );
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join( "|" ) );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join( "|" ) );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			) );
		} :
		function( a, b ) {
			if ( b ) {
				while ( ( b = b.parentNode ) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		compare = ( a.ownerDocument || a ) == ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			( !support.sortDetached && b.compareDocumentPosition( a ) === compare ) ) {

			// Choose the first element that is related to our preferred document
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( a == document || a.ownerDocument == preferredDoc &&
				contains( preferredDoc, a ) ) {
				return -1;
			}

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( b == document || b.ownerDocument == preferredDoc &&
				contains( preferredDoc, b ) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {

		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			/* eslint-disable eqeqeq */
			return a == document ? -1 :
				b == document ? 1 :
				/* eslint-enable eqeqeq */
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( ( cur = cur.parentNode ) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( ( cur = cur.parentNode ) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[ i ] === bp[ i ] ) {
			i++;
		}

		return i ?

			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[ i ], bp[ i ] ) :

			// Otherwise nodes in our document sort first
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			/* eslint-disable eqeqeq */
			ap[ i ] == preferredDoc ? -1 :
			bp[ i ] == preferredDoc ? 1 :
			/* eslint-enable eqeqeq */
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	setDocument( elem );

	if ( support.matchesSelector && documentIsHTML &&
		!nonnativeSelectorCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||

				// As well, disconnected nodes are said to be in a document
				// fragment in IE 9
				elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch ( e ) {
			nonnativeSelectorCache( expr, true );
		}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( context.ownerDocument || context ) != document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( elem.ownerDocument || elem ) != document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],

		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			( val = elem.getAttributeNode( name ) ) && val.specified ?
				val.value :
				null;
};

Sizzle.escape = function( sel ) {
	return ( sel + "" ).replace( rcssescape, fcssescape );
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( ( elem = results[ i++ ] ) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {

		// If no nodeType, this is expected to be an array
		while ( ( node = elem[ i++ ] ) ) {

			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {

		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {

			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}

	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[ 1 ] = match[ 1 ].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[ 3 ] = ( match[ 3 ] || match[ 4 ] ||
				match[ 5 ] || "" ).replace( runescape, funescape );

			if ( match[ 2 ] === "~=" ) {
				match[ 3 ] = " " + match[ 3 ] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {

			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[ 1 ] = match[ 1 ].toLowerCase();

			if ( match[ 1 ].slice( 0, 3 ) === "nth" ) {

				// nth-* requires argument
				if ( !match[ 3 ] ) {
					Sizzle.error( match[ 0 ] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[ 4 ] = +( match[ 4 ] ?
					match[ 5 ] + ( match[ 6 ] || 1 ) :
					2 * ( match[ 3 ] === "even" || match[ 3 ] === "odd" ) );
				match[ 5 ] = +( ( match[ 7 ] + match[ 8 ] ) || match[ 3 ] === "odd" );

				// other types prohibit arguments
			} else if ( match[ 3 ] ) {
				Sizzle.error( match[ 0 ] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[ 6 ] && match[ 2 ];

			if ( matchExpr[ "CHILD" ].test( match[ 0 ] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[ 3 ] ) {
				match[ 2 ] = match[ 4 ] || match[ 5 ] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&

				// Get excess from tokenize (recursively)
				( excess = tokenize( unquoted, true ) ) &&

				// advance to the next closing parenthesis
				( excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length ) ) {

				// excess is a negative index
				match[ 0 ] = match[ 0 ].slice( 0, excess );
				match[ 2 ] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() {
					return true;
				} :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				( pattern = new RegExp( "(^|" + whitespace +
					")" + className + "(" + whitespace + "|$)" ) ) && classCache(
						className, function( elem ) {
							return pattern.test(
								typeof elem.className === "string" && elem.className ||
								typeof elem.getAttribute !== "undefined" &&
									elem.getAttribute( "class" ) ||
								""
							);
				} );
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				/* eslint-disable max-len */

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
				/* eslint-enable max-len */

			};
		},

		"CHILD": function( type, what, _argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, _context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( ( node = node[ dir ] ) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}

								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || ( node[ expando ] = {} );

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								( outerCache[ node.uniqueID ] = {} );

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( ( node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								( diff = nodeIndex = 0 ) || start.pop() ) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {

							// Use previously-cached element index if available
							if ( useCache ) {

								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || ( node[ expando ] = {} );

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									( outerCache[ node.uniqueID ] = {} );

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {

								// Use the same loop as above to seek `elem` from the start
								while ( ( node = ++nodeIndex && node && node[ dir ] ||
									( diff = nodeIndex = 0 ) || start.pop() ) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] ||
												( node[ expando ] = {} );

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												( outerCache[ node.uniqueID ] = {} );

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {

			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction( function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[ i ] );
							seed[ idx ] = !( matches[ idx ] = matched[ i ] );
						}
					} ) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {

		// Potentially complex pseudos
		"not": markFunction( function( selector ) {

			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction( function( seed, matches, _context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( ( elem = unmatched[ i ] ) ) {
							seed[ i ] = !( matches[ i ] = elem );
						}
					}
				} ) :
				function( elem, _context, xml ) {
					input[ 0 ] = elem;
					matcher( input, null, xml, results );

					// Don't keep the element (issue #299)
					input[ 0 ] = null;
					return !results.pop();
				};
		} ),

		"has": markFunction( function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		} ),

		"contains": markFunction( function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || getText( elem ) ).indexOf( text ) > -1;
			};
		} ),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {

			// lang value must be a valid identifier
			if ( !ridentifier.test( lang || "" ) ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( ( elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute( "xml:lang" ) || elem.getAttribute( "lang" ) ) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( ( elem = elem.parentNode ) && elem.nodeType === 1 );
				return false;
			};
		} ),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement &&
				( !document.hasFocus || document.hasFocus() ) &&
				!!( elem.type || elem.href || ~elem.tabIndex );
		},

		// Boolean properties
		"enabled": createDisabledPseudo( false ),
		"disabled": createDisabledPseudo( true ),

		"checked": function( elem ) {

			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return ( nodeName === "input" && !!elem.checked ) ||
				( nodeName === "option" && !!elem.selected );
		},

		"selected": function( elem ) {

			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				// eslint-disable-next-line no-unused-expressions
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {

			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos[ "empty" ]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( ( attr = elem.getAttribute( "type" ) ) == null ||
					attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo( function() {
			return [ 0 ];
		} ),

		"last": createPositionalPseudo( function( _matchIndexes, length ) {
			return [ length - 1 ];
		} ),

		"eq": createPositionalPseudo( function( _matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		} ),

		"even": createPositionalPseudo( function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		"odd": createPositionalPseudo( function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		"lt": createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i = argument < 0 ?
				argument + length :
				argument > length ?
					length :
					argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		"gt": createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} )
	}
};

Expr.pseudos[ "nth" ] = Expr.pseudos[ "eq" ];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || ( match = rcomma.exec( soFar ) ) ) {
			if ( match ) {

				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[ 0 ].length ) || soFar;
			}
			groups.push( ( tokens = [] ) );
		}

		matched = false;

		// Combinators
		if ( ( match = rcombinators.exec( soFar ) ) ) {
			matched = match.shift();
			tokens.push( {
				value: matched,

				// Cast descendant combinators to space
				type: match[ 0 ].replace( rtrim, " " )
			} );
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( ( match = matchExpr[ type ].exec( soFar ) ) && ( !preFilters[ type ] ||
				( match = preFilters[ type ]( match ) ) ) ) {
				matched = match.shift();
				tokens.push( {
					value: matched,
					type: type,
					matches: match
				} );
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :

			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[ i ].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?

		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( ( elem = elem[ dir ] ) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || ( elem[ expando ] = {} );

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] ||
							( outerCache[ elem.uniqueID ] = {} );

						if ( skip && skip === elem.nodeName.toLowerCase() ) {
							elem = elem[ dir ] || elem;
						} else if ( ( oldCache = uniqueCache[ key ] ) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return ( newCache[ 2 ] = oldCache[ 2 ] );
						} else {

							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( ( newCache[ 2 ] = matcher( elem, context, xml ) ) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[ i ]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[ 0 ];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[ i ], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( ( elem = unmatched[ i ] ) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction( function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts(
				selector || "*",
				context.nodeType ? [ context ] : context,
				[]
			),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?

				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( ( elem = temp[ i ] ) ) {
					matcherOut[ postMap[ i ] ] = !( matcherIn[ postMap[ i ] ] = elem );
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {

					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( ( elem = matcherOut[ i ] ) ) {

							// Restore matcherIn since elem is not yet a final match
							temp.push( ( matcherIn[ i ] = elem ) );
						}
					}
					postFinder( null, ( matcherOut = [] ), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( ( elem = matcherOut[ i ] ) &&
						( temp = postFinder ? indexOf( seed, elem ) : preMap[ i ] ) > -1 ) {

						seed[ temp ] = !( results[ temp ] = elem );
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	} );
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[ 0 ].type ],
		implicitRelative = leadingRelative || Expr.relative[ " " ],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				( checkContext = context ).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );

			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( ( matcher = Expr.relative[ tokens[ i ].type ] ) ) {
			matchers = [ addCombinator( elementMatcher( matchers ), matcher ) ];
		} else {
			matcher = Expr.filter[ tokens[ i ].type ].apply( null, tokens[ i ].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {

				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[ j ].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(

					// If the preceding token was a descendant combinator, insert an implicit any-element `*`
					tokens
						.slice( 0, i - 1 )
						.concat( { value: tokens[ i - 2 ].type === " " ? "*" : "" } )
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( ( tokens = tokens.slice( j ) ) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,

				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find[ "TAG" ]( "*", outermost ),

				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = ( dirruns += contextBackup == null ? 1 : Math.random() || 0.1 ),
				len = elems.length;

			if ( outermost ) {

				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				outermostContext = context == document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && ( elem = elems[ i ] ) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;

					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					if ( !context && elem.ownerDocument != document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( ( matcher = elementMatchers[ j++ ] ) ) {
						if ( matcher( elem, context || document, xml ) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {

					// They will have gone through all possible matchers
					if ( ( elem = !matcher && elem ) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( ( matcher = setMatchers[ j++ ] ) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {

					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !( unmatched[ i ] || setMatched[ i ] ) ) {
								setMatched[ i ] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {

		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[ i ] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache(
			selector,
			matcherFromGroupMatchers( elementMatchers, setMatchers )
		);

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( ( selector = compiled.selector || selector ) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[ 0 ] = match[ 0 ].slice( 0 );
		if ( tokens.length > 2 && ( token = tokens[ 0 ] ).type === "ID" &&
			context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[ 1 ].type ] ) {

			context = ( Expr.find[ "ID" ]( token.matches[ 0 ]
				.replace( runescape, funescape ), context ) || [] )[ 0 ];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr[ "needsContext" ].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[ i ];

			// Abort if we hit a combinator
			if ( Expr.relative[ ( type = token.type ) ] ) {
				break;
			}
			if ( ( find = Expr.find[ type ] ) ) {

				// Search, expanding context for leading sibling combinators
				if ( ( seed = find(
					token.matches[ 0 ].replace( runescape, funescape ),
					rsibling.test( tokens[ 0 ].type ) && testContext( context.parentNode ) ||
						context
				) ) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split( "" ).sort( sortOrder ).join( "" ) === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert( function( el ) {

	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement( "fieldset" ) ) & 1;
} );

// Support: IE<8
// Prevent attribute/property "interpolation"
// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert( function( el ) {
	el.innerHTML = "<a href='#'></a>";
	return el.firstChild.getAttribute( "href" ) === "#";
} ) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	} );
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert( function( el ) {
	el.innerHTML = "<input/>";
	el.firstChild.setAttribute( "value", "" );
	return el.firstChild.getAttribute( "value" ) === "";
} ) ) {
	addHandle( "value", function( elem, _name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	} );
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert( function( el ) {
	return el.getAttribute( "disabled" ) == null;
} ) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
				( val = elem.getAttributeNode( name ) ) && val.specified ?
					val.value :
					null;
		}
	} );
}

return Sizzle;

} )( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;
jQuery.escapeSelector = Sizzle.escape;




var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;



function nodeName( elem, name ) {

	return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

}
var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Filtered directly for both simple and complex selectors
	return jQuery.filter( qualifier, elements, not );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, _i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, _i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, _i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
		if ( elem.contentDocument != null &&

			// Support: IE 11+
			// <object> elements with no `data` attribute has an object
			// `contentDocument` with a `null` prototype.
			getProto( elem.contentDocument ) ) {

			return elem.contentDocument;
		}

		// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
		// Treat the template element as a regular one in browsers that
		// don't support it.
		if ( nodeName( elem, "template" ) ) {
			elem = elem.content || elem;
		}

		return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && toType( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( _i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.stackTrace );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the stack, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getStackHook ) {
									process.stackTrace = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// rejected_handlers.disable
					// fulfilled_handlers.disable
					tuples[ 3 - i ][ 3 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock,

					// progress_handlers.lock
					tuples[ 0 ][ 3 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the primary Deferred
			primary = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						primary.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, primary.done( updateFunc( i ) ).resolve, primary.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( primary.state() === "pending" ||
				isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return primary.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), primary.reject );
		}

		return primary.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

jQuery.Deferred.exceptionHook = function( error, stack ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( toType( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, _key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};


// Matches dashed string for camelizing
var rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g;

// Used by camelCase as callback to replace()
function fcamelCase( _all, letter ) {
	return letter.toUpperCase();
}

// Convert dashed to camelCase; used by the css and data modules
// Support: IE <=9 - 11, Edge 12 - 15
// Microsoft forgot to hump their vendor prefix (#9572)
function camelCase( string ) {
	return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
}
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( camelCase );
			} else {
				key = camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var documentElement = document.documentElement;



	var isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem );
		},
		composed = { composed: true };

	// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
	// Check attachment across shadow DOM boundaries when possible (gh-3504)
	// Support: iOS 10.0-10.2 only
	// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
	// leading to errors. We need to check for `getRootNode`.
	if ( documentElement.getRootNode ) {
		isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem ) ||
				elem.getRootNode( composed ) === elem.ownerDocument;
		};
	}
var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			isAttached( elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};



function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted, scale,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = elem.nodeType &&
			( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Support: Firefox <=54
		// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
		initial = initial / 2;

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		while ( maxIterations-- ) {

			// Evaluate and update our best guess (doubling guesses that zero out).
			// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
			jQuery.style( elem, prop, initialInUnit + unit );
			if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
				maxIterations = 0;
			}
			initialInUnit = initialInUnit / scale;

		}

		initialInUnit = initialInUnit * 2;
		jQuery.style( elem, prop, initialInUnit + unit );

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );

var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;

	// Support: IE <=9 only
	// IE <=9 replaces <option> tags with their contents when inserted outside of
	// the select element.
	div.innerHTML = "<option></option>";
	support.option = !!div.lastChild;
} )();


// We have to close these tags to support XHTML (#13200)
var wrapMap = {

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;

// Support: IE <=9 only
if ( !support.option ) {
	wrapMap.optgroup = wrapMap.option = [ 1, "<select multiple='multiple'>", "</select>" ];
}


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (#15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, attached, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( toType( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (#12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		attached = isAttached( elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( attached ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE <=9 - 11+
// focus() and blur() are asynchronous, except when they are no-op.
// So expect focus to be synchronous when the element is already active,
// and blur to be synchronous when the element is not already active.
// (focus and blur are always synchronous in other supported browsers,
// this just defines when we can count on it).
function expectSync( elem, type ) {
	return ( elem === safeActiveElement() ) === ( type === "focus" );
}

// Support: IE <=9 only
// Accessing document.activeElement can throw unexpectedly
// https://bugs.jquery.com/ticket/13393
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Only attach events to objects that accept data
		if ( !acceptData( elem ) ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = Object.create( null );
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),

			// Make a writable jQuery.Event from the native event object
			event = jQuery.event.fix( nativeEvent ),

			handlers = (
				dataPriv.get( this, "events" ) || Object.create( null )
			)[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// If the event is namespaced, then each handler is only invoked if it is
				// specially universal or its namespaces are a superset of the event's.
				if ( !event.rnamespace || handleObj.namespace === false ||
					event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (#13208)
				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
						return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
						return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		click: {

			// Utilize native event to ensure correct state for checkable inputs
			setup: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Claim the first handler
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					// dataPriv.set( el, "click", ... )
					leverageNative( el, "click", returnTrue );
				}

				// Return false to allow normal processing in the caller
				return false;
			},
			trigger: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Force setup before triggering a click
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					leverageNative( el, "click" );
				}

				// Return non-false to allow normal event-path propagation
				return true;
			},

			// For cross-browser consistency, suppress native .click() on links
			// Also prevent it if we're currently inside a leveraged native-event stack
			_default: function( event ) {
				var target = event.target;
				return rcheckableType.test( target.type ) &&
					target.click && nodeName( target, "input" ) &&
					dataPriv.get( target, "click" ) ||
					nodeName( target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

// Ensure the presence of an event listener that handles manually-triggered
// synthetic events by interrupting progress until reinvoked in response to
// *native* events that it fires directly, ensuring that state changes have
// already occurred before other listeners are invoked.
function leverageNative( el, type, expectSync ) {

	// Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
	if ( !expectSync ) {
		if ( dataPriv.get( el, type ) === undefined ) {
			jQuery.event.add( el, type, returnTrue );
		}
		return;
	}

	// Register the controller as a special universal handler for all event namespaces
	dataPriv.set( el, type, false );
	jQuery.event.add( el, type, {
		namespace: false,
		handler: function( event ) {
			var notAsync, result,
				saved = dataPriv.get( this, type );

			if ( ( event.isTrigger & 1 ) && this[ type ] ) {

				// Interrupt processing of the outer synthetic .trigger()ed event
				// Saved data should be false in such cases, but might be a leftover capture object
				// from an async native handler (gh-4350)
				if ( !saved.length ) {

					// Store arguments for use when handling the inner native event
					// There will always be at least one argument (an event object), so this array
					// will not be confused with a leftover capture object.
					saved = slice.call( arguments );
					dataPriv.set( this, type, saved );

					// Trigger the native event and capture its result
					// Support: IE <=9 - 11+
					// focus() and blur() are asynchronous
					notAsync = expectSync( this, type );
					this[ type ]();
					result = dataPriv.get( this, type );
					if ( saved !== result || notAsync ) {
						dataPriv.set( this, type, false );
					} else {
						result = {};
					}
					if ( saved !== result ) {

						// Cancel the outer synthetic event
						event.stopImmediatePropagation();
						event.preventDefault();

						// Support: Chrome 86+
						// In Chrome, if an element having a focusout handler is blurred by
						// clicking outside of it, it invokes the handler synchronously. If
						// that handler calls `.remove()` on the element, the data is cleared,
						// leaving `result` undefined. We need to guard against this.
						return result && result.value;
					}

				// If this is an inner synthetic event for an event with a bubbling surrogate
				// (focus or blur), assume that the surrogate already propagated from triggering the
				// native event and prevent that from happening again here.
				// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
				// bubbling surrogate propagates *after* the non-bubbling base), but that seems
				// less bad than duplication.
				} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
					event.stopPropagation();
				}

			// If this is a native event triggered above, everything is now in order
			// Fire an inner synthetic event with the original arguments
			} else if ( saved.length ) {

				// ...and capture the result
				dataPriv.set( this, type, {
					value: jQuery.event.trigger(

						// Support: IE <=9 - 11+
						// Extend with the prototype to reset the above stopImmediatePropagation()
						jQuery.extend( saved[ 0 ], jQuery.Event.prototype ),
						saved.slice( 1 ),
						this
					)
				} );

				// Abort handling of the native event
				event.stopImmediatePropagation();
			}
		}
	} );
}

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (#504, #13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || Date.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	code: true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,
	which: true
}, jQuery.event.addProp );

jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {
	jQuery.event.special[ type ] = {

		// Utilize native event if possible so blur/focus sequence is correct
		setup: function() {

			// Claim the first handler
			// dataPriv.set( this, "focus", ... )
			// dataPriv.set( this, "blur", ... )
			leverageNative( this, type, expectSync );

			// Return false to allow normal processing in the caller
			return false;
		},
		trigger: function() {

			// Force setup before trigger
			leverageNative( this, type );

			// Return non-false to allow normal event-path propagation
			return true;
		},

		// Suppress native focus or blur as it's already being fired
		// in leverageNative.
		_default: function() {
			return true;
		},

		delegateType: delegateType
	};
} );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	// Support: IE <=10 - 11, Edge 12 - 13 only
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
		elem.type = elem.type.slice( 5 );
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.get( src );
		events = pdataOld.events;

		if ( events ) {
			dataPriv.remove( dest, "handle events" );

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = flat( args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		valueIsFunction = isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( valueIsFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( valueIsFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (#8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl && !node.noModule ) {
								jQuery._evalUrl( node.src, {
									nonce: node.nonce || node.getAttribute( "nonce" )
								}, doc );
							}
						} else {
							DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && isAttached( node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html;
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = isAttached( elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

var swap = function( elem, options, callback ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.call( elem );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};


var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
			"margin-top:1px;padding:0;border:0";
		div.style.cssText =
			"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
			"margin:auto;border:1px;padding:1px;" +
			"width:60%;top:1%";
		documentElement.appendChild( container ).appendChild( div );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

		// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
		// Some styles come back with percentage values, even though they shouldn't
		div.style.right = "60%";
		pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

		// Support: IE 9 - 11 only
		// Detect misreporting of content dimensions for box-sizing:border-box elements
		boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

		// Support: IE 9 only
		// Detect overflow:scroll screwiness (gh-3699)
		// Support: Chrome <=64
		// Don't get tricked when zoom affects offsetWidth (gh-4029)
		div.style.position = "absolute";
		scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	function roundPixelMeasures( measure ) {
		return Math.round( parseFloat( measure ) );
	}

	var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
		reliableTrDimensionsVal, reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	jQuery.extend( support, {
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelBoxStyles: function() {
			computeStyleTests();
			return pixelBoxStylesVal;
		},
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		},
		scrollboxSize: function() {
			computeStyleTests();
			return scrollboxSizeVal;
		},

		// Support: IE 9 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Behavior in IE 9 is more subtle than in newer versions & it passes
		// some versions of this test; make sure not to make it pass there!
		//
		// Support: Firefox 70+
		// Only Firefox includes border widths
		// in computed dimensions. (gh-4529)
		reliableTrDimensions: function() {
			var table, tr, trChild, trStyle;
			if ( reliableTrDimensionsVal == null ) {
				table = document.createElement( "table" );
				tr = document.createElement( "tr" );
				trChild = document.createElement( "div" );

				table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
				tr.style.cssText = "border:1px solid";

				// Support: Chrome 86+
				// Height set through cssText does not get applied.
				// Computed height then comes back as 0.
				tr.style.height = "1px";
				trChild.style.height = "9px";

				// Support: Android 8 Chrome 86+
				// In our bodyBackground.html iframe,
				// display for all div elements is set to "inline",
				// which causes a problem only in Android 8 Chrome 86.
				// Ensuring the div is display: block
				// gets around this issue.
				trChild.style.display = "block";

				documentElement
					.appendChild( table )
					.appendChild( tr )
					.appendChild( trChild );

				trStyle = window.getComputedStyle( tr );
				reliableTrDimensionsVal = ( parseInt( trStyle.height, 10 ) +
					parseInt( trStyle.borderTopWidth, 10 ) +
					parseInt( trStyle.borderBottomWidth, 10 ) ) === tr.offsetHeight;

				documentElement.removeChild( table );
			}
			return reliableTrDimensionsVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, #12537)
	//   .css('--customProperty) (#3144)
	if ( computed ) {
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( ret === "" && !isAttached( elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style,
	vendorProps = {};

// Return a vendor-prefixed property or undefined
function vendorPropName( name ) {

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
function finalPropName( name ) {
	var final = jQuery.cssProps[ name ] || vendorProps[ name ];

	if ( final ) {
		return final;
	}
	if ( name in emptyStyle ) {
		return name;
	}
	return vendorProps[ name ] = vendorPropName( name ) || name;
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	rcustomProp = /^--/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	};

function setPositiveNumber( _elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
	var i = dimension === "width" ? 1 : 0,
		extra = 0,
		delta = 0;

	// Adjustment may not be necessary
	if ( box === ( isBorderBox ? "border" : "content" ) ) {
		return 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin
		if ( box === "margin" ) {
			delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
		}

		// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
		if ( !isBorderBox ) {

			// Add padding
			delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// For "border" or "margin", add border
			if ( box !== "padding" ) {
				delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

			// But still keep track of it otherwise
			} else {
				extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}

		// If we get here with a border-box (content + padding + border), we're seeking "content" or
		// "padding" or "margin"
		} else {

			// For "content", subtract padding
			if ( box === "content" ) {
				delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// For "content" or "padding", subtract border
			if ( box !== "margin" ) {
				delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	// Account for positive content-box scroll gutter when requested by providing computedVal
	if ( !isBorderBox && computedVal >= 0 ) {

		// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
		// Assuming integer scroll gutter, subtract the rest and round down
		delta += Math.max( 0, Math.ceil(
			elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
			computedVal -
			delta -
			extra -
			0.5

		// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
		// Use an explicit zero to avoid NaN (gh-3964)
		) ) || 0;
	}

	return delta;
}

function getWidthOrHeight( elem, dimension, extra ) {

	// Start with computed style
	var styles = getStyles( elem ),

		// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
		// Fake content-box until we know it's needed to know the true value.
		boxSizingNeeded = !support.boxSizingReliable() || extra,
		isBorderBox = boxSizingNeeded &&
			jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
		valueIsBorderBox = isBorderBox,

		val = curCSS( elem, dimension, styles ),
		offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );

	// Support: Firefox <=54
	// Return a confounding non-pixel value or feign ignorance, as appropriate.
	if ( rnumnonpx.test( val ) ) {
		if ( !extra ) {
			return val;
		}
		val = "auto";
	}


	// Support: IE 9 - 11 only
	// Use offsetWidth/offsetHeight for when box sizing is unreliable.
	// In those cases, the computed value can be trusted to be border-box.
	if ( ( !support.boxSizingReliable() && isBorderBox ||

		// Support: IE 10 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Interestingly, in some cases IE 9 doesn't suffer from this issue.
		!support.reliableTrDimensions() && nodeName( elem, "tr" ) ||

		// Fall back to offsetWidth/offsetHeight when value is "auto"
		// This happens for inline elements with no explicit setting (gh-3571)
		val === "auto" ||

		// Support: Android <=4.1 - 4.3 only
		// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
		!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&

		// Make sure the element is visible & connected
		elem.getClientRects().length ) {

		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

		// Where available, offsetWidth/offsetHeight approximate border box dimensions.
		// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
		// retrieved value as a content box dimension.
		valueIsBorderBox = offsetProp in elem;
		if ( valueIsBorderBox ) {
			val = elem[ offsetProp ];
		}
	}

	// Normalize "" and auto
	val = parseFloat( val ) || 0;

	// Adjust for the element's box model
	return ( val +
		boxModelAdjustment(
			elem,
			dimension,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles,

			// Provide the current computed size to request scroll gutter calculation (gh-3589)
			val
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"gridArea": true,
		"gridColumn": true,
		"gridColumnEnd": true,
		"gridColumnStart": true,
		"gridRow": true,
		"gridRowEnd": true,
		"gridRowStart": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
			// "px" to a few hardcoded values.
			if ( type === "number" && !isCustomProp ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( _i, dimension ) {
	jQuery.cssHooks[ dimension ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
					swap( elem, cssShow, function() {
						return getWidthOrHeight( elem, dimension, extra );
					} ) :
					getWidthOrHeight( elem, dimension, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = getStyles( elem ),

				// Only read styles.position if the test has a chance to fail
				// to avoid forcing a reflow.
				scrollboxSizeBuggy = !support.scrollboxSize() &&
					styles.position === "absolute",

				// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
				boxSizingNeeded = scrollboxSizeBuggy || extra,
				isBorderBox = boxSizingNeeded &&
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
				subtract = extra ?
					boxModelAdjustment(
						elem,
						dimension,
						extra,
						isBorderBox,
						styles
					) :
					0;

			// Account for unreliable border-box dimensions by comparing offset* to computed and
			// faking a content-box to get border and padding (gh-3699)
			if ( isBorderBox && scrollboxSizeBuggy ) {
				subtract -= Math.ceil(
					elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
					parseFloat( styles[ dimension ] ) -
					boxModelAdjustment( elem, dimension, "border", false, styles ) -
					0.5
				);
			}

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ dimension ] = value;
				value = jQuery.css( elem, dimension );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
			) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( prefix !== "margin" ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 && (
				jQuery.cssHooks[ tween.prop ] ||
					tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = Date.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 15
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY and Edge just mirrors
		// the overflowX value there.
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

				/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
					animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					result.stop.bind( result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};

		doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( _i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = Date.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( _i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				// Use proper attribute retrieval(#12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

function classesToArray( value ) {
	if ( Array.isArray( value ) ) {
		return value;
	}
	if ( typeof value === "string" ) {
		return value.match( rnothtmlwhite ) || [];
	}
	return [];
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );

				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {

						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value,
			isValidValue = type === "string" || Array.isArray( value );

		if ( typeof stateVal === "boolean" && isValidValue ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		return this.each( function() {
			var className, i, self, classNames;

			if ( isValidValue ) {

				// Toggle individual class names
				i = 0;
				self = jQuery( this );
				classNames = classesToArray( value );

				while ( ( className = classNames[ i++ ] ) ) {

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
				return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, valueIsFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		valueIsFunction = isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( valueIsFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (#14686, #14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion


support.focusin = "onfocusin" in window;


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	stopPropagationCallback = function( e ) {
		e.stopPropagation();
	};

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = lastElement = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
			lastElement = cur;
			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || Object.create( null ) )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;

					if ( event.isPropagationStopped() ) {
						lastElement.addEventListener( type, stopPropagationCallback );
					}

					elem[ type ]();

					if ( event.isPropagationStopped() ) {
						lastElement.removeEventListener( type, stopPropagationCallback );
					}

					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


// Support: Firefox <=44
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {

				// Handle: regular nodes (via `this.ownerDocument`), window
				// (via `this.document`) & document (via `this`).
				var doc = this.ownerDocument || this.document || this,
					attaches = dataPriv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this.document || this,
					attaches = dataPriv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					dataPriv.remove( doc, fix );

				} else {
					dataPriv.access( doc, fix, attaches );
				}
			}
		};
	} );
}
var location = window.location;

var nonce = { guid: Date.now() };

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml, parserErrorElem;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {}

	parserErrorElem = xml && xml.getElementsByTagName( "parsererror" )[ 0 ];
	if ( !xml || parserErrorElem ) {
		jQuery.error( "Invalid XML: " + (
			parserErrorElem ?
				jQuery.map( parserErrorElem.childNodes, function( el ) {
					return el.textContent;
				} ).join( "\n" ) :
				data
		) );
	}
	return xml;
};


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && toType( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	if ( a == null ) {
		return "";
	}

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} ).filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} ).map( function( _i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );

originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
				jQuery( callbackContext ) :
				jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
									( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
										.concat( match[ 2 ] );
							}
						}
						match = responseHeaders[ key.toLowerCase() + " " ];
					}
					return match == null ? null : match.join( ", " );
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 15
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available and should be processed, append data to url
			if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce.guid++ ) +
					uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Use a noop converter for missing script but not if jsonp
			if ( !isSuccess &&
				jQuery.inArray( "script", s.dataTypes ) > -1 &&
				jQuery.inArray( "json", s.dataTypes ) < 0 ) {
				s.converters[ "text script" ] = function() {};
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( _i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );

jQuery.ajaxPrefilter( function( s ) {
	var i;
	for ( i in s.headers ) {
		if ( i.toLowerCase() === "content-type" ) {
			s.contentType = s.headers[ i ] || "";
		}
	}
} );


jQuery._evalUrl = function( url, options, doc ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (#11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,

		// Only evaluate the response if it is successful (gh-4126)
		// dataFilter is not invoked for failure responses, so using it instead
		// of the default converter is kludgy but it works.
		converters: {
			"text script": function() {}
		},
		dataFilter: function( response ) {
			jQuery.globalEval( response, options, doc );
		}
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var htmlIsFunction = isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.ontimeout =
									xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see #8605, #14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain or forced-by-attrs requests
	if ( s.crossDomain || s.scriptAttrs ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" )
					.attr( s.scriptAttrs || {} )
					.prop( { charset: s.scriptCharset, src: s.url } )
					.on( "load error", callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					} );

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce.guid++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {

	// offset() relates an element's border box to the document origin
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		// Get document-relative position by adding viewport scroll to viewport-relative gBCR
		rect = elem.getBoundingClientRect();
		win = elem.ownerDocument.defaultView;
		return {
			top: rect.top + win.pageYOffset,
			left: rect.left + win.pageXOffset
		};
	},

	// position() relates an element's margin box to its offset parent's padding box
	// This corresponds to the behavior of CSS absolute positioning
	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset, doc,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// position:fixed elements are offset from the viewport, which itself always has zero offset
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume position:fixed implies availability of getBoundingClientRect
			offset = elem.getBoundingClientRect();

		} else {
			offset = this.offset();

			// Account for the *real* offset parent, which can be the document or its root element
			// when a statically positioned element is identified
			doc = elem.ownerDocument;
			offsetParent = elem.offsetParent || doc.documentElement;
			while ( offsetParent &&
				( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
				jQuery.css( offsetParent, "position" ) === "static" ) {

				offsetParent = offsetParent.parentNode;
			}
			if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

				// Incorporate borders into its offset, since they are outside its content origin
				parentOffset = jQuery( offsetParent ).offset();
				parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
			}
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( _i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( {
		padding: "inner" + name,
		content: type,
		"": "outer" + name
	}, function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( _i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	},

	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );

jQuery.each(
	( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( _i, name ) {

		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	}
);




// Support: Android <=4.0 only
// Make sure we trim BOM and NBSP
var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

// Bind a function to a context, optionally partially applying any
// arguments.
// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
// However, it is not slated for removal any time soon
jQuery.proxy = function( fn, context ) {
	var tmp, args, proxy;

	if ( typeof context === "string" ) {
		tmp = fn[ context ];
		context = fn;
		fn = tmp;
	}

	// Quick check to determine if target is callable, in the spec
	// this throws a TypeError, but we will just return undefined.
	if ( !isFunction( fn ) ) {
		return undefined;
	}

	// Simulated bind
	args = slice.call( arguments, 2 );
	proxy = function() {
		return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
	};

	// Set the guid of unique handler to the same of original handler, so it can be removed
	proxy.guid = fn.guid = fn.guid || jQuery.guid++;

	return proxy;
};

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;
jQuery.isFunction = isFunction;
jQuery.isWindow = isWindow;
jQuery.camelCase = camelCase;
jQuery.type = toType;

jQuery.now = Date.now;

jQuery.isNumeric = function( obj ) {

	// As of jQuery 3.0, isNumeric is limited to
	// strings and numbers (primitives or objects)
	// that can be coerced to finite numbers (gh-2662)
	var type = jQuery.type( obj );
	return ( type === "number" || type === "string" ) &&

		// parseFloat NaNs numeric-cast false positives ("")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		!isNaN( obj - parseFloat( obj ) );
};

jQuery.trim = function( text ) {
	return text == null ?
		"" :
		( text + "" ).replace( rtrim, "" );
};



// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( typeof define === "function" && define.amd ) {
	define( "jquery", [], function() {
		return jQuery;
	} );
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( typeof noGlobal === "undefined" ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );

/* resources/assets/js/app/ajaxSetup.js */
$.ajaxSetup({
  headers: {
    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
  }
});
setTimeout(function() {
  $.ajaxSettings.headers['X-CSRF-TOKEN']
  if (
    typeof $.ajaxSettings === "undefined" || $.ajaxSettings === null ||
    typeof $.ajaxSettings.headers === "undefined" || $.ajaxSettings.headers === null ||
    typeof $.ajaxSettings.headers['X-CSRF-TOKEN'] === "undefined" || $.ajaxSettings.headers['X-CSRF-TOKEN'] === null ||
    $.ajaxSettings.headers['X-CSRF-TOKEN'].length < 1
  ) {
    Sentry.captureMessage("CSRF token missing from page: " + window.Location);
  }


}, 1000);

/* resources/assets/js/libraries/popper.js */
/**!
 * @fileOverview Great library to create and place poppers near their reference elements.
 * @version 1.14.7
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.Popper = factory());
}(this, (function () { 'use strict';

var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';

var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
var timeoutDuration = 0;
for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
  if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
    timeoutDuration = 1;
    break;
  }
}

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent || null;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TH, TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width'], 10) + parseFloat(styles['border' + sideB + 'Width'], 10);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.right - result.left;
  var height = sizes.height || element.clientHeight || result.bottom - result.top;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth, 10);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth, 10);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop, 10);
    var marginLeft = parseFloat(styles.marginLeft, 10);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  var parentNode = getParentNode(element);
  if (!parentNode) {
    return false;
  }
  return isFixed(parentNode);
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var window = element.ownerDocument.defaultView;
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicity asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */
function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var round = Math.round,
      floor = Math.floor;

  var noRound = function noRound(v) {
    return v;
  };

  var referenceWidth = round(reference.width);
  var popperWidth = round(popper.width);

  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf('-') !== -1;
  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;

  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
  var verticalToInteger = !shouldRound ? noRound : round;

  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}

var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized], 10);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width'], 10);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
    var flippedVariation = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport'
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {HTMLElement|referenceObject} reference - The reference element used to position the popper
   * @param {HTMLElement} popper - The HTML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

return Popper;

})));
//# sourceMappingURL=popper.js.map

/* resources/assets/js/libraries/slick.min.js */
/*! Slick.js | Version: 1.6.0 | Author: Ken Wheeler | Docs: http://kenwheeler.github.io/slick */
!function(a){"use strict";"function"==typeof define&&define.amd?define(["jquery"],a):"undefined"!=typeof exports?module.exports=a(require("jquery")):a(jQuery)}(function(a){"use strict";var b=window.Slick||{};b=function(){function c(c,d){var f,e=this;e.defaults={accessibility:!0,adaptiveHeight:!1,appendArrows:a(c),appendDots:a(c),arrows:!0,asNavFor:null,prevArrow:'<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button">Previous</button>',nextArrow:'<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button">Next</button>',autoplay:!1,autoplaySpeed:3e3,centerMode:!1,centerPadding:"50px",cssEase:"ease",customPaging:function(b,c){return a('<button type="button" data-role="none" role="button" tabindex="0" />').text(c+1)},dots:!1,dotsClass:"slick-dots",draggable:!0,easing:"linear",edgeFriction:.35,fade:!1,focusOnSelect:!1,infinite:!0,initialSlide:0,lazyLoad:"ondemand",mobileFirst:!1,pauseOnHover:!0,pauseOnFocus:!0,pauseOnDotsHover:!1,respondTo:"window",responsive:null,rows:1,rtl:!1,slide:"",slidesPerRow:1,slidesToShow:1,slidesToScroll:1,speed:500,swipe:!0,swipeToSlide:!1,touchMove:!0,touchThreshold:5,useCSS:!0,useTransform:!0,variableWidth:!1,vertical:!1,verticalSwiping:!1,waitForAnimate:!0,zIndex:1e3},e.initials={animating:!1,dragging:!1,autoPlayTimer:null,currentDirection:0,currentLeft:null,currentSlide:0,direction:1,$dots:null,listWidth:null,listHeight:null,loadIndex:0,$nextArrow:null,$prevArrow:null,slideCount:null,slideWidth:null,$slideTrack:null,$slides:null,sliding:!1,slideOffset:0,swipeLeft:null,$list:null,touchObject:{},transformsEnabled:!1,unslicked:!1},a.extend(e,e.initials),e.activeBreakpoint=null,e.animType=null,e.animProp=null,e.breakpoints=[],e.breakpointSettings=[],e.cssTransitions=!1,e.focussed=!1,e.interrupted=!1,e.hidden="hidden",e.paused=!0,e.positionProp=null,e.respondTo=null,e.rowCount=1,e.shouldClick=!0,e.$slider=a(c),e.$slidesCache=null,e.transformType=null,e.transitionType=null,e.visibilityChange="visibilitychange",e.windowWidth=0,e.windowTimer=null,f=a(c).data("slick")||{},e.options=a.extend({},e.defaults,d,f),e.currentSlide=e.options.initialSlide,e.originalSettings=e.options,"undefined"!=typeof document.mozHidden?(e.hidden="mozHidden",e.visibilityChange="mozvisibilitychange"):"undefined"!=typeof document.webkitHidden&&(e.hidden="webkitHidden",e.visibilityChange="webkitvisibilitychange"),e.autoPlay=a.proxy(e.autoPlay,e),e.autoPlayClear=a.proxy(e.autoPlayClear,e),e.autoPlayIterator=a.proxy(e.autoPlayIterator,e),e.changeSlide=a.proxy(e.changeSlide,e),e.clickHandler=a.proxy(e.clickHandler,e),e.selectHandler=a.proxy(e.selectHandler,e),e.setPosition=a.proxy(e.setPosition,e),e.swipeHandler=a.proxy(e.swipeHandler,e),e.dragHandler=a.proxy(e.dragHandler,e),e.keyHandler=a.proxy(e.keyHandler,e),e.instanceUid=b++,e.htmlExpr=/^(?:\s*(<[\w\W]+>)[^>]*)$/,e.registerBreakpoints(),e.init(!0)}var b=0;return c}(),b.prototype.activateADA=function(){var a=this;a.$slideTrack.find(".slick-active").attr({"aria-hidden":"false"}).find("a, input, button, select").attr({tabindex:"0"})},b.prototype.addSlide=b.prototype.slickAdd=function(b,c,d){var e=this;if("boolean"==typeof c)d=c,c=null;else if(0>c||c>=e.slideCount)return!1;e.unload(),"number"==typeof c?0===c&&0===e.$slides.length?a(b).appendTo(e.$slideTrack):d?a(b).insertBefore(e.$slides.eq(c)):a(b).insertAfter(e.$slides.eq(c)):d===!0?a(b).prependTo(e.$slideTrack):a(b).appendTo(e.$slideTrack),e.$slides=e.$slideTrack.children(this.options.slide),e.$slideTrack.children(this.options.slide).detach(),e.$slideTrack.append(e.$slides),e.$slides.each(function(b,c){a(c).attr("data-slick-index",b)}),e.$slidesCache=e.$slides,e.reinit()},b.prototype.animateHeight=function(){var a=this;if(1===a.options.slidesToShow&&a.options.adaptiveHeight===!0&&a.options.vertical===!1){var b=a.$slides.eq(a.currentSlide).outerHeight(!0);a.$list.animate({height:b},a.options.speed)}},b.prototype.animateSlide=function(b,c){var d={},e=this;e.animateHeight(),e.options.rtl===!0&&e.options.vertical===!1&&(b=-b),e.transformsEnabled===!1?e.options.vertical===!1?e.$slideTrack.animate({left:b},e.options.speed,e.options.easing,c):e.$slideTrack.animate({top:b},e.options.speed,e.options.easing,c):e.cssTransitions===!1?(e.options.rtl===!0&&(e.currentLeft=-e.currentLeft),a({animStart:e.currentLeft}).animate({animStart:b},{duration:e.options.speed,easing:e.options.easing,step:function(a){a=Math.ceil(a),e.options.vertical===!1?(d[e.animType]="translate("+a+"px, 0px)",e.$slideTrack.css(d)):(d[e.animType]="translate(0px,"+a+"px)",e.$slideTrack.css(d))},complete:function(){c&&c.call()}})):(e.applyTransition(),b=Math.ceil(b),e.options.vertical===!1?d[e.animType]="translate3d("+b+"px, 0px, 0px)":d[e.animType]="translate3d(0px,"+b+"px, 0px)",e.$slideTrack.css(d),c&&setTimeout(function(){e.disableTransition(),c.call()},e.options.speed))},b.prototype.getNavTarget=function(){var b=this,c=b.options.asNavFor;return c&&null!==c&&(c=a(c).not(b.$slider)),c},b.prototype.asNavFor=function(b){var c=this,d=c.getNavTarget();null!==d&&"object"==typeof d&&d.each(function(){var c=a(this).slick("getSlick");c.unslicked||c.slideHandler(b,!0)})},b.prototype.applyTransition=function(a){var b=this,c={};b.options.fade===!1?c[b.transitionType]=b.transformType+" "+b.options.speed+"ms "+b.options.cssEase:c[b.transitionType]="opacity "+b.options.speed+"ms "+b.options.cssEase,b.options.fade===!1?b.$slideTrack.css(c):b.$slides.eq(a).css(c)},b.prototype.autoPlay=function(){var a=this;a.autoPlayClear(),a.slideCount>a.options.slidesToShow&&(a.autoPlayTimer=setInterval(a.autoPlayIterator,a.options.autoplaySpeed))},b.prototype.autoPlayClear=function(){var a=this;a.autoPlayTimer&&clearInterval(a.autoPlayTimer)},b.prototype.autoPlayIterator=function(){var a=this,b=a.currentSlide+a.options.slidesToScroll;a.paused||a.interrupted||a.focussed||(a.options.infinite===!1&&(1===a.direction&&a.currentSlide+1===a.slideCount-1?a.direction=0:0===a.direction&&(b=a.currentSlide-a.options.slidesToScroll,a.currentSlide-1===0&&(a.direction=1))),a.slideHandler(b))},b.prototype.buildArrows=function(){var b=this;b.options.arrows===!0&&(b.$prevArrow=a(b.options.prevArrow).addClass("slick-arrow"),b.$nextArrow=a(b.options.nextArrow).addClass("slick-arrow"),b.slideCount>b.options.slidesToShow?(b.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),b.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),b.htmlExpr.test(b.options.prevArrow)&&b.$prevArrow.prependTo(b.options.appendArrows),b.htmlExpr.test(b.options.nextArrow)&&b.$nextArrow.appendTo(b.options.appendArrows),b.options.infinite!==!0&&b.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true")):b.$prevArrow.add(b.$nextArrow).addClass("slick-hidden").attr({"aria-disabled":"true",tabindex:"-1"}))},b.prototype.buildDots=function(){var c,d,b=this;if(b.options.dots===!0&&b.slideCount>b.options.slidesToShow){for(b.$slider.addClass("slick-dotted"),d=a("<ul />").addClass(b.options.dotsClass),c=0;c<=b.getDotCount();c+=1)d.append(a("<li />").append(b.options.customPaging.call(this,b,c)));b.$dots=d.appendTo(b.options.appendDots),b.$dots.find("li").first().addClass("slick-active").attr("aria-hidden","false")}},b.prototype.buildOut=function(){var b=this;b.$slides=b.$slider.children(b.options.slide+":not(.slick-cloned)").addClass("slick-slide"),b.slideCount=b.$slides.length,b.$slides.each(function(b,c){a(c).attr("data-slick-index",b).data("originalStyling",a(c).attr("style")||"")}),b.$slider.addClass("slick-slider"),b.$slideTrack=0===b.slideCount?a('<div class="slick-track"/>').appendTo(b.$slider):b.$slides.wrapAll('<div class="slick-track"/>').parent(),b.$list=b.$slideTrack.wrap('<div aria-live="polite" class="slick-list"/>').parent(),b.$slideTrack.css("opacity",0),(b.options.centerMode===!0||b.options.swipeToSlide===!0)&&(b.options.slidesToScroll=1),a("img[data-lazy]",b.$slider).not("[src]").addClass("slick-loading"),b.setupInfinite(),b.buildArrows(),b.buildDots(),b.updateDots(),b.setSlideClasses("number"==typeof b.currentSlide?b.currentSlide:0),b.options.draggable===!0&&b.$list.addClass("draggable")},b.prototype.buildRows=function(){var b,c,d,e,f,g,h,a=this;if(e=document.createDocumentFragment(),g=a.$slider.children(),a.options.rows>1){for(h=a.options.slidesPerRow*a.options.rows,f=Math.ceil(g.length/h),b=0;f>b;b++){var i=document.createElement("div");for(c=0;c<a.options.rows;c++){var j=document.createElement("div");for(d=0;d<a.options.slidesPerRow;d++){var k=b*h+(c*a.options.slidesPerRow+d);g.get(k)&&j.appendChild(g.get(k))}i.appendChild(j)}e.appendChild(i)}a.$slider.empty().append(e),a.$slider.children().children().children().css({width:100/a.options.slidesPerRow+"%",display:"inline-block"})}},b.prototype.checkResponsive=function(b,c){var e,f,g,d=this,h=!1,i=d.$slider.width(),j=window.innerWidth||a(window).width();if("window"===d.respondTo?g=j:"slider"===d.respondTo?g=i:"min"===d.respondTo&&(g=Math.min(j,i)),d.options.responsive&&d.options.responsive.length&&null!==d.options.responsive){f=null;for(e in d.breakpoints)d.breakpoints.hasOwnProperty(e)&&(d.originalSettings.mobileFirst===!1?g<d.breakpoints[e]&&(f=d.breakpoints[e]):g>d.breakpoints[e]&&(f=d.breakpoints[e]));null!==f?null!==d.activeBreakpoint?(f!==d.activeBreakpoint||c)&&(d.activeBreakpoint=f,"unslick"===d.breakpointSettings[f]?d.unslick(f):(d.options=a.extend({},d.originalSettings,d.breakpointSettings[f]),b===!0&&(d.currentSlide=d.options.initialSlide),d.refresh(b)),h=f):(d.activeBreakpoint=f,"unslick"===d.breakpointSettings[f]?d.unslick(f):(d.options=a.extend({},d.originalSettings,d.breakpointSettings[f]),b===!0&&(d.currentSlide=d.options.initialSlide),d.refresh(b)),h=f):null!==d.activeBreakpoint&&(d.activeBreakpoint=null,d.options=d.originalSettings,b===!0&&(d.currentSlide=d.options.initialSlide),d.refresh(b),h=f),b||h===!1||d.$slider.trigger("breakpoint",[d,h])}},b.prototype.changeSlide=function(b,c){var f,g,h,d=this,e=a(b.currentTarget);switch(e.is("a")&&b.preventDefault(),e.is("li")||(e=e.closest("li")),h=d.slideCount%d.options.slidesToScroll!==0,f=h?0:(d.slideCount-d.currentSlide)%d.options.slidesToScroll,b.data.message){case"previous":g=0===f?d.options.slidesToScroll:d.options.slidesToShow-f,d.slideCount>d.options.slidesToShow&&d.slideHandler(d.currentSlide-g,!1,c);break;case"next":g=0===f?d.options.slidesToScroll:f,d.slideCount>d.options.slidesToShow&&d.slideHandler(d.currentSlide+g,!1,c);break;case"index":var i=0===b.data.index?0:b.data.index||e.index()*d.options.slidesToScroll;d.slideHandler(d.checkNavigable(i),!1,c),e.children().trigger("focus");break;default:return}},b.prototype.checkNavigable=function(a){var c,d,b=this;if(c=b.getNavigableIndexes(),d=0,a>c[c.length-1])a=c[c.length-1];else for(var e in c){if(a<c[e]){a=d;break}d=c[e]}return a},b.prototype.cleanUpEvents=function(){var b=this;b.options.dots&&null!==b.$dots&&a("li",b.$dots).off("click.slick",b.changeSlide).off("mouseenter.slick",a.proxy(b.interrupt,b,!0)).off("mouseleave.slick",a.proxy(b.interrupt,b,!1)),b.$slider.off("focus.slick blur.slick"),b.options.arrows===!0&&b.slideCount>b.options.slidesToShow&&(b.$prevArrow&&b.$prevArrow.off("click.slick",b.changeSlide),b.$nextArrow&&b.$nextArrow.off("click.slick",b.changeSlide)),b.$list.off("touchstart.slick mousedown.slick",b.swipeHandler),b.$list.off("touchmove.slick mousemove.slick",b.swipeHandler),b.$list.off("touchend.slick mouseup.slick",b.swipeHandler),b.$list.off("touchcancel.slick mouseleave.slick",b.swipeHandler),b.$list.off("click.slick",b.clickHandler),a(document).off(b.visibilityChange,b.visibility),b.cleanUpSlideEvents(),b.options.accessibility===!0&&b.$list.off("keydown.slick",b.keyHandler),b.options.focusOnSelect===!0&&a(b.$slideTrack).children().off("click.slick",b.selectHandler),a(window).off("orientationchange.slick.slick-"+b.instanceUid,b.orientationChange),a(window).off("resize.slick.slick-"+b.instanceUid,b.resize),a("[draggable!=true]",b.$slideTrack).off("dragstart",b.preventDefault),a(window).off("load.slick.slick-"+b.instanceUid,b.setPosition),a(document).off("ready.slick.slick-"+b.instanceUid,b.setPosition)},b.prototype.cleanUpSlideEvents=function(){var b=this;b.$list.off("mouseenter.slick",a.proxy(b.interrupt,b,!0)),b.$list.off("mouseleave.slick",a.proxy(b.interrupt,b,!1))},b.prototype.cleanUpRows=function(){var b,a=this;a.options.rows>1&&(b=a.$slides.children().children(),b.removeAttr("style"),a.$slider.empty().append(b))},b.prototype.clickHandler=function(a){var b=this;b.shouldClick===!1&&(a.stopImmediatePropagation(),a.stopPropagation(),a.preventDefault())},b.prototype.destroy=function(b){var c=this;c.autoPlayClear(),c.touchObject={},c.cleanUpEvents(),a(".slick-cloned",c.$slider).detach(),c.$dots&&c.$dots.remove(),c.$prevArrow&&c.$prevArrow.length&&(c.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),c.htmlExpr.test(c.options.prevArrow)&&c.$prevArrow.remove()),c.$nextArrow&&c.$nextArrow.length&&(c.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),c.htmlExpr.test(c.options.nextArrow)&&c.$nextArrow.remove()),c.$slides&&(c.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function(){a(this).attr("style",a(this).data("originalStyling"))}),c.$slideTrack.children(this.options.slide).detach(),c.$slideTrack.detach(),c.$list.detach(),c.$slider.append(c.$slides)),c.cleanUpRows(),c.$slider.removeClass("slick-slider"),c.$slider.removeClass("slick-initialized"),c.$slider.removeClass("slick-dotted"),c.unslicked=!0,b||c.$slider.trigger("destroy",[c])},b.prototype.disableTransition=function(a){var b=this,c={};c[b.transitionType]="",b.options.fade===!1?b.$slideTrack.css(c):b.$slides.eq(a).css(c)},b.prototype.fadeSlide=function(a,b){var c=this;c.cssTransitions===!1?(c.$slides.eq(a).css({zIndex:c.options.zIndex}),c.$slides.eq(a).animate({opacity:1},c.options.speed,c.options.easing,b)):(c.applyTransition(a),c.$slides.eq(a).css({opacity:1,zIndex:c.options.zIndex}),b&&setTimeout(function(){c.disableTransition(a),b.call()},c.options.speed))},b.prototype.fadeSlideOut=function(a){var b=this;b.cssTransitions===!1?b.$slides.eq(a).animate({opacity:0,zIndex:b.options.zIndex-2},b.options.speed,b.options.easing):(b.applyTransition(a),b.$slides.eq(a).css({opacity:0,zIndex:b.options.zIndex-2}))},b.prototype.filterSlides=b.prototype.slickFilter=function(a){var b=this;null!==a&&(b.$slidesCache=b.$slides,b.unload(),b.$slideTrack.children(this.options.slide).detach(),b.$slidesCache.filter(a).appendTo(b.$slideTrack),b.reinit())},b.prototype.focusHandler=function(){var b=this;b.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick","*:not(.slick-arrow)",function(c){c.stopImmediatePropagation();var d=a(this);setTimeout(function(){b.options.pauseOnFocus&&(b.focussed=d.is(":focus"),b.autoPlay())},0)})},b.prototype.getCurrent=b.prototype.slickCurrentSlide=function(){var a=this;return a.currentSlide},b.prototype.getDotCount=function(){var a=this,b=0,c=0,d=0;if(a.options.infinite===!0)for(;b<a.slideCount;)++d,b=c+a.options.slidesToScroll,c+=a.options.slidesToScroll<=a.options.slidesToShow?a.options.slidesToScroll:a.options.slidesToShow;else if(a.options.centerMode===!0)d=a.slideCount;else if(a.options.asNavFor)for(;b<a.slideCount;)++d,b=c+a.options.slidesToScroll,c+=a.options.slidesToScroll<=a.options.slidesToShow?a.options.slidesToScroll:a.options.slidesToShow;else d=1+Math.ceil((a.slideCount-a.options.slidesToShow)/a.options.slidesToScroll);return d-1},b.prototype.getLeft=function(a){var c,d,f,b=this,e=0;return b.slideOffset=0,d=b.$slides.first().outerHeight(!0),b.options.infinite===!0?(b.slideCount>b.options.slidesToShow&&(b.slideOffset=b.slideWidth*b.options.slidesToShow*-1,e=d*b.options.slidesToShow*-1),b.slideCount%b.options.slidesToScroll!==0&&a+b.options.slidesToScroll>b.slideCount&&b.slideCount>b.options.slidesToShow&&(a>b.slideCount?(b.slideOffset=(b.options.slidesToShow-(a-b.slideCount))*b.slideWidth*-1,e=(b.options.slidesToShow-(a-b.slideCount))*d*-1):(b.slideOffset=b.slideCount%b.options.slidesToScroll*b.slideWidth*-1,e=b.slideCount%b.options.slidesToScroll*d*-1))):a+b.options.slidesToShow>b.slideCount&&(b.slideOffset=(a+b.options.slidesToShow-b.slideCount)*b.slideWidth,e=(a+b.options.slidesToShow-b.slideCount)*d),b.slideCount<=b.options.slidesToShow&&(b.slideOffset=0,e=0),b.options.centerMode===!0&&b.options.infinite===!0?b.slideOffset+=b.slideWidth*Math.floor(b.options.slidesToShow/2)-b.slideWidth:b.options.centerMode===!0&&(b.slideOffset=0,b.slideOffset+=b.slideWidth*Math.floor(b.options.slidesToShow/2)),c=b.options.vertical===!1?a*b.slideWidth*-1+b.slideOffset:a*d*-1+e,b.options.variableWidth===!0&&(f=b.slideCount<=b.options.slidesToShow||b.options.infinite===!1?b.$slideTrack.children(".slick-slide").eq(a):b.$slideTrack.children(".slick-slide").eq(a+b.options.slidesToShow),c=b.options.rtl===!0?f[0]?-1*(b.$slideTrack.width()-f[0].offsetLeft-f.width()):0:f[0]?-1*f[0].offsetLeft:0,b.options.centerMode===!0&&(f=b.slideCount<=b.options.slidesToShow||b.options.infinite===!1?b.$slideTrack.children(".slick-slide").eq(a):b.$slideTrack.children(".slick-slide").eq(a+b.options.slidesToShow+1),c=b.options.rtl===!0?f[0]?-1*(b.$slideTrack.width()-f[0].offsetLeft-f.width()):0:f[0]?-1*f[0].offsetLeft:0,c+=(b.$list.width()-f.outerWidth())/2)),c},b.prototype.getOption=b.prototype.slickGetOption=function(a){var b=this;return b.options[a]},b.prototype.getNavigableIndexes=function(){var e,a=this,b=0,c=0,d=[];for(a.options.infinite===!1?e=a.slideCount:(b=-1*a.options.slidesToScroll,c=-1*a.options.slidesToScroll,e=2*a.slideCount);e>b;)d.push(b),b=c+a.options.slidesToScroll,c+=a.options.slidesToScroll<=a.options.slidesToShow?a.options.slidesToScroll:a.options.slidesToShow;return d},b.prototype.getSlick=function(){return this},b.prototype.getSlideCount=function(){var c,d,e,b=this;return e=b.options.centerMode===!0?b.slideWidth*Math.floor(b.options.slidesToShow/2):0,b.options.swipeToSlide===!0?(b.$slideTrack.find(".slick-slide").each(function(c,f){return f.offsetLeft-e+a(f).outerWidth()/2>-1*b.swipeLeft?(d=f,!1):void 0}),c=Math.abs(a(d).attr("data-slick-index")-b.currentSlide)||1):b.options.slidesToScroll},b.prototype.goTo=b.prototype.slickGoTo=function(a,b){var c=this;c.changeSlide({data:{message:"index",index:parseInt(a)}},b)},b.prototype.init=function(b){var c=this;a(c.$slider).hasClass("slick-initialized")||(a(c.$slider).addClass("slick-initialized"),c.buildRows(),c.buildOut(),c.setProps(),c.startLoad(),c.loadSlider(),c.initializeEvents(),c.updateArrows(),c.updateDots(),c.checkResponsive(!0),c.focusHandler()),b&&c.$slider.trigger("init",[c]),c.options.accessibility===!0&&c.initADA(),c.options.autoplay&&(c.paused=!1,c.autoPlay())},b.prototype.initADA=function(){var b=this;b.$slides.add(b.$slideTrack.find(".slick-cloned")).attr({"aria-hidden":"true",tabindex:"-1"}).find("a, input, button, select").attr({tabindex:"-1"}),b.$slideTrack.attr("role","listbox"),b.$slides.not(b.$slideTrack.find(".slick-cloned")).each(function(c){a(this).attr({role:"option","aria-describedby":"slick-slide"+b.instanceUid+c})}),null!==b.$dots&&b.$dots.attr("role","tablist").find("li").each(function(c){a(this).attr({role:"presentation","aria-selected":"false","aria-controls":"navigation"+b.instanceUid+c,id:"slick-slide"+b.instanceUid+c})}).first().attr("aria-selected","true").end().find("button").attr("role","button").end().closest("div").attr("role","toolbar"),b.activateADA()},b.prototype.initArrowEvents=function(){var a=this;a.options.arrows===!0&&a.slideCount>a.options.slidesToShow&&(a.$prevArrow.off("click.slick").on("click.slick",{message:"previous"},a.changeSlide),a.$nextArrow.off("click.slick").on("click.slick",{message:"next"},a.changeSlide))},b.prototype.initDotEvents=function(){var b=this;b.options.dots===!0&&b.slideCount>b.options.slidesToShow&&a("li",b.$dots).on("click.slick",{message:"index"},b.changeSlide),b.options.dots===!0&&b.options.pauseOnDotsHover===!0&&a("li",b.$dots).on("mouseenter.slick",a.proxy(b.interrupt,b,!0)).on("mouseleave.slick",a.proxy(b.interrupt,b,!1))},b.prototype.initSlideEvents=function(){var b=this;b.options.pauseOnHover&&(b.$list.on("mouseenter.slick",a.proxy(b.interrupt,b,!0)),b.$list.on("mouseleave.slick",a.proxy(b.interrupt,b,!1)))},b.prototype.initializeEvents=function(){var b=this;b.initArrowEvents(),b.initDotEvents(),b.initSlideEvents(),b.$list.on("touchstart.slick mousedown.slick",{action:"start"},b.swipeHandler),b.$list.on("touchmove.slick mousemove.slick",{action:"move"},b.swipeHandler),b.$list.on("touchend.slick mouseup.slick",{action:"end"},b.swipeHandler),b.$list.on("touchcancel.slick mouseleave.slick",{action:"end"},b.swipeHandler),b.$list.on("click.slick",b.clickHandler),a(document).on(b.visibilityChange,a.proxy(b.visibility,b)),b.options.accessibility===!0&&b.$list.on("keydown.slick",b.keyHandler),b.options.focusOnSelect===!0&&a(b.$slideTrack).children().on("click.slick",b.selectHandler),a(window).on("orientationchange.slick.slick-"+b.instanceUid,a.proxy(b.orientationChange,b)),a(window).on("resize.slick.slick-"+b.instanceUid,a.proxy(b.resize,b)),a("[draggable!=true]",b.$slideTrack).on("dragstart",b.preventDefault),a(window).on("load.slick.slick-"+b.instanceUid,b.setPosition),a(document).on("ready.slick.slick-"+b.instanceUid,b.setPosition)},b.prototype.initUI=function(){var a=this;a.options.arrows===!0&&a.slideCount>a.options.slidesToShow&&(a.$prevArrow.show(),a.$nextArrow.show()),a.options.dots===!0&&a.slideCount>a.options.slidesToShow&&a.$dots.show()},b.prototype.keyHandler=function(a){var b=this;a.target.tagName.match("TEXTAREA|INPUT|SELECT")||(37===a.keyCode&&b.options.accessibility===!0?b.changeSlide({data:{message:b.options.rtl===!0?"next":"previous"}}):39===a.keyCode&&b.options.accessibility===!0&&b.changeSlide({data:{message:b.options.rtl===!0?"previous":"next"}}))},b.prototype.lazyLoad=function(){function g(c){a("img[data-lazy]",c).each(function(){var c=a(this),d=a(this).attr("data-lazy"),e=document.createElement("img");e.onload=function(){c.animate({opacity:0},100,function(){c.attr("src",d).animate({opacity:1},200,function(){c.removeAttr("data-lazy").removeClass("slick-loading")}),b.$slider.trigger("lazyLoaded",[b,c,d])})},e.onerror=function(){c.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),b.$slider.trigger("lazyLoadError",[b,c,d])},e.src=d})}var c,d,e,f,b=this;b.options.centerMode===!0?b.options.infinite===!0?(e=b.currentSlide+(b.options.slidesToShow/2+1),f=e+b.options.slidesToShow+2):(e=Math.max(0,b.currentSlide-(b.options.slidesToShow/2+1)),f=2+(b.options.slidesToShow/2+1)+b.currentSlide):(e=b.options.infinite?b.options.slidesToShow+b.currentSlide:b.currentSlide,f=Math.ceil(e+b.options.slidesToShow),b.options.fade===!0&&(e>0&&e--,f<=b.slideCount&&f++)),c=b.$slider.find(".slick-slide").slice(e,f),g(c),b.slideCount<=b.options.slidesToShow?(d=b.$slider.find(".slick-slide"),g(d)):b.currentSlide>=b.slideCount-b.options.slidesToShow?(d=b.$slider.find(".slick-cloned").slice(0,b.options.slidesToShow),g(d)):0===b.currentSlide&&(d=b.$slider.find(".slick-cloned").slice(-1*b.options.slidesToShow),g(d))},b.prototype.loadSlider=function(){var a=this;a.setPosition(),a.$slideTrack.css({opacity:1}),a.$slider.removeClass("slick-loading"),a.initUI(),"progressive"===a.options.lazyLoad&&a.progressiveLazyLoad()},b.prototype.next=b.prototype.slickNext=function(){var a=this;a.changeSlide({data:{message:"next"}})},b.prototype.orientationChange=function(){var a=this;a.checkResponsive(),a.setPosition()},b.prototype.pause=b.prototype.slickPause=function(){var a=this;a.autoPlayClear(),a.paused=!0},b.prototype.play=b.prototype.slickPlay=function(){var a=this;a.autoPlay(),a.options.autoplay=!0,a.paused=!1,a.focussed=!1,a.interrupted=!1},b.prototype.postSlide=function(a){var b=this;b.unslicked||(b.$slider.trigger("afterChange",[b,a]),b.animating=!1,b.setPosition(),b.swipeLeft=null,b.options.autoplay&&b.autoPlay(),b.options.accessibility===!0&&b.initADA())},b.prototype.prev=b.prototype.slickPrev=function(){var a=this;a.changeSlide({data:{message:"previous"}})},b.prototype.preventDefault=function(a){a.preventDefault()},b.prototype.progressiveLazyLoad=function(b){b=b||1;var e,f,g,c=this,d=a("img[data-lazy]",c.$slider);d.length?(e=d.first(),f=e.attr("data-lazy"),g=document.createElement("img"),g.onload=function(){e.attr("src",f).removeAttr("data-lazy").removeClass("slick-loading"),c.options.adaptiveHeight===!0&&c.setPosition(),c.$slider.trigger("lazyLoaded",[c,e,f]),c.progressiveLazyLoad()},g.onerror=function(){3>b?setTimeout(function(){c.progressiveLazyLoad(b+1)},500):(e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),c.$slider.trigger("lazyLoadError",[c,e,f]),c.progressiveLazyLoad())},g.src=f):c.$slider.trigger("allImagesLoaded",[c])},b.prototype.refresh=function(b){var d,e,c=this;e=c.slideCount-c.options.slidesToShow,!c.options.infinite&&c.currentSlide>e&&(c.currentSlide=e),c.slideCount<=c.options.slidesToShow&&(c.currentSlide=0),d=c.currentSlide,c.destroy(!0),a.extend(c,c.initials,{currentSlide:d}),c.init(),b||c.changeSlide({data:{message:"index",index:d}},!1)},b.prototype.registerBreakpoints=function(){var c,d,e,b=this,f=b.options.responsive||null;if("array"===a.type(f)&&f.length){b.respondTo=b.options.respondTo||"window";for(c in f)if(e=b.breakpoints.length-1,d=f[c].breakpoint,f.hasOwnProperty(c)){for(;e>=0;)b.breakpoints[e]&&b.breakpoints[e]===d&&b.breakpoints.splice(e,1),e--;b.breakpoints.push(d),b.breakpointSettings[d]=f[c].settings}b.breakpoints.sort(function(a,c){return b.options.mobileFirst?a-c:c-a})}},b.prototype.reinit=function(){var b=this;b.$slides=b.$slideTrack.children(b.options.slide).addClass("slick-slide"),b.slideCount=b.$slides.length,b.currentSlide>=b.slideCount&&0!==b.currentSlide&&(b.currentSlide=b.currentSlide-b.options.slidesToScroll),b.slideCount<=b.options.slidesToShow&&(b.currentSlide=0),b.registerBreakpoints(),b.setProps(),b.setupInfinite(),b.buildArrows(),b.updateArrows(),b.initArrowEvents(),b.buildDots(),b.updateDots(),b.initDotEvents(),b.cleanUpSlideEvents(),b.initSlideEvents(),b.checkResponsive(!1,!0),b.options.focusOnSelect===!0&&a(b.$slideTrack).children().on("click.slick",b.selectHandler),b.setSlideClasses("number"==typeof b.currentSlide?b.currentSlide:0),b.setPosition(),b.focusHandler(),b.paused=!b.options.autoplay,b.autoPlay(),b.$slider.trigger("reInit",[b])},b.prototype.resize=function(){var b=this;a(window).width()!==b.windowWidth&&(clearTimeout(b.windowDelay),b.windowDelay=window.setTimeout(function(){b.windowWidth=a(window).width(),b.checkResponsive(),b.unslicked||b.setPosition()},50))},b.prototype.removeSlide=b.prototype.slickRemove=function(a,b,c){var d=this;return"boolean"==typeof a?(b=a,a=b===!0?0:d.slideCount-1):a=b===!0?--a:a,d.slideCount<1||0>a||a>d.slideCount-1?!1:(d.unload(),c===!0?d.$slideTrack.children().remove():d.$slideTrack.children(this.options.slide).eq(a).remove(),d.$slides=d.$slideTrack.children(this.options.slide),d.$slideTrack.children(this.options.slide).detach(),d.$slideTrack.append(d.$slides),d.$slidesCache=d.$slides,void d.reinit())},b.prototype.setCSS=function(a){var d,e,b=this,c={};b.options.rtl===!0&&(a=-a),d="left"==b.positionProp?Math.ceil(a)+"px":"0px",e="top"==b.positionProp?Math.ceil(a)+"px":"0px",c[b.positionProp]=a,b.transformsEnabled===!1?b.$slideTrack.css(c):(c={},b.cssTransitions===!1?(c[b.animType]="translate("+d+", "+e+")",b.$slideTrack.css(c)):(c[b.animType]="translate3d("+d+", "+e+", 0px)",b.$slideTrack.css(c)))},b.prototype.setDimensions=function(){var a=this;a.options.vertical===!1?a.options.centerMode===!0&&a.$list.css({padding:"0px "+a.options.centerPadding}):(a.$list.height(a.$slides.first().outerHeight(!0)*a.options.slidesToShow),a.options.centerMode===!0&&a.$list.css({padding:a.options.centerPadding+" 0px"})),a.listWidth=a.$list.width(),a.listHeight=a.$list.height(),a.options.vertical===!1&&a.options.variableWidth===!1?(a.slideWidth=Math.ceil(a.listWidth/a.options.slidesToShow),a.$slideTrack.width(Math.ceil(a.slideWidth*a.$slideTrack.children(".slick-slide").length))):a.options.variableWidth===!0?a.$slideTrack.width(5e3*a.slideCount):(a.slideWidth=Math.ceil(a.listWidth),a.$slideTrack.height(Math.ceil(a.$slides.first().outerHeight(!0)*a.$slideTrack.children(".slick-slide").length)));var b=a.$slides.first().outerWidth(!0)-a.$slides.first().width();a.options.variableWidth===!1&&a.$slideTrack.children(".slick-slide").width(a.slideWidth-b)},b.prototype.setFade=function(){var c,b=this;b.$slides.each(function(d,e){c=b.slideWidth*d*-1,b.options.rtl===!0?a(e).css({position:"relative",right:c,top:0,zIndex:b.options.zIndex-2,opacity:0}):a(e).css({position:"relative",left:c,top:0,zIndex:b.options.zIndex-2,opacity:0})}),b.$slides.eq(b.currentSlide).css({zIndex:b.options.zIndex-1,opacity:1})},b.prototype.setHeight=function(){var a=this;if(1===a.options.slidesToShow&&a.options.adaptiveHeight===!0&&a.options.vertical===!1){var b=a.$slides.eq(a.currentSlide).outerHeight(!0);a.$list.css("height",b)}},b.prototype.setOption=b.prototype.slickSetOption=function(){var c,d,e,f,h,b=this,g=!1;if("object"===a.type(arguments[0])?(e=arguments[0],g=arguments[1],h="multiple"):"string"===a.type(arguments[0])&&(e=arguments[0],f=arguments[1],g=arguments[2],"responsive"===arguments[0]&&"array"===a.type(arguments[1])?h="responsive":"undefined"!=typeof arguments[1]&&(h="single")),"single"===h)b.options[e]=f;else if("multiple"===h)a.each(e,function(a,c){b.options[a]=c});else if("responsive"===h)for(d in f)if("array"!==a.type(b.options.responsive))b.options.responsive=[f[d]];else{for(c=b.options.responsive.length-1;c>=0;)b.options.responsive[c].breakpoint===f[d].breakpoint&&b.options.responsive.splice(c,1),c--;b.options.responsive.push(f[d])}g&&(b.unload(),b.reinit())},b.prototype.setPosition=function(){var a=this;a.setDimensions(),a.setHeight(),a.options.fade===!1?a.setCSS(a.getLeft(a.currentSlide)):a.setFade(),a.$slider.trigger("setPosition",[a])},b.prototype.setProps=function(){var a=this,b=document.body.style;a.positionProp=a.options.vertical===!0?"top":"left","top"===a.positionProp?a.$slider.addClass("slick-vertical"):a.$slider.removeClass("slick-vertical"),(void 0!==b.WebkitTransition||void 0!==b.MozTransition||void 0!==b.msTransition)&&a.options.useCSS===!0&&(a.cssTransitions=!0),a.options.fade&&("number"==typeof a.options.zIndex?a.options.zIndex<3&&(a.options.zIndex=3):a.options.zIndex=a.defaults.zIndex),void 0!==b.OTransform&&(a.animType="OTransform",a.transformType="-o-transform",a.transitionType="OTransition",void 0===b.perspectiveProperty&&void 0===b.webkitPerspective&&(a.animType=!1)),void 0!==b.MozTransform&&(a.animType="MozTransform",a.transformType="-moz-transform",a.transitionType="MozTransition",void 0===b.perspectiveProperty&&void 0===b.MozPerspective&&(a.animType=!1)),void 0!==b.webkitTransform&&(a.animType="webkitTransform",a.transformType="-webkit-transform",a.transitionType="webkitTransition",void 0===b.perspectiveProperty&&void 0===b.webkitPerspective&&(a.animType=!1)),void 0!==b.msTransform&&(a.animType="msTransform",a.transformType="-ms-transform",a.transitionType="msTransition",void 0===b.msTransform&&(a.animType=!1)),void 0!==b.transform&&a.animType!==!1&&(a.animType="transform",a.transformType="transform",a.transitionType="transition"),a.transformsEnabled=a.options.useTransform&&null!==a.animType&&a.animType!==!1},b.prototype.setSlideClasses=function(a){var c,d,e,f,b=this;d=b.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden","true"),b.$slides.eq(a).addClass("slick-current"),b.options.centerMode===!0?(c=Math.floor(b.options.slidesToShow/2),b.options.infinite===!0&&(a>=c&&a<=b.slideCount-1-c?b.$slides.slice(a-c,a+c+1).addClass("slick-active").attr("aria-hidden","false"):(e=b.options.slidesToShow+a,
d.slice(e-c+1,e+c+2).addClass("slick-active").attr("aria-hidden","false")),0===a?d.eq(d.length-1-b.options.slidesToShow).addClass("slick-center"):a===b.slideCount-1&&d.eq(b.options.slidesToShow).addClass("slick-center")),b.$slides.eq(a).addClass("slick-center")):a>=0&&a<=b.slideCount-b.options.slidesToShow?b.$slides.slice(a,a+b.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"):d.length<=b.options.slidesToShow?d.addClass("slick-active").attr("aria-hidden","false"):(f=b.slideCount%b.options.slidesToShow,e=b.options.infinite===!0?b.options.slidesToShow+a:a,b.options.slidesToShow==b.options.slidesToScroll&&b.slideCount-a<b.options.slidesToShow?d.slice(e-(b.options.slidesToShow-f),e+f).addClass("slick-active").attr("aria-hidden","false"):d.slice(e,e+b.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false")),"ondemand"===b.options.lazyLoad&&b.lazyLoad()},b.prototype.setupInfinite=function(){var c,d,e,b=this;if(b.options.fade===!0&&(b.options.centerMode=!1),b.options.infinite===!0&&b.options.fade===!1&&(d=null,b.slideCount>b.options.slidesToShow)){for(e=b.options.centerMode===!0?b.options.slidesToShow+1:b.options.slidesToShow,c=b.slideCount;c>b.slideCount-e;c-=1)d=c-1,a(b.$slides[d]).clone(!0).attr("id","").attr("data-slick-index",d-b.slideCount).prependTo(b.$slideTrack).addClass("slick-cloned");for(c=0;e>c;c+=1)d=c,a(b.$slides[d]).clone(!0).attr("id","").attr("data-slick-index",d+b.slideCount).appendTo(b.$slideTrack).addClass("slick-cloned");b.$slideTrack.find(".slick-cloned").find("[id]").each(function(){a(this).attr("id","")})}},b.prototype.interrupt=function(a){var b=this;a||b.autoPlay(),b.interrupted=a},b.prototype.selectHandler=function(b){var c=this,d=a(b.target).is(".slick-slide")?a(b.target):a(b.target).parents(".slick-slide"),e=parseInt(d.attr("data-slick-index"));return e||(e=0),c.slideCount<=c.options.slidesToShow?(c.setSlideClasses(e),void c.asNavFor(e)):void c.slideHandler(e)},b.prototype.slideHandler=function(a,b,c){var d,e,f,g,j,h=null,i=this;return b=b||!1,i.animating===!0&&i.options.waitForAnimate===!0||i.options.fade===!0&&i.currentSlide===a||i.slideCount<=i.options.slidesToShow?void 0:(b===!1&&i.asNavFor(a),d=a,h=i.getLeft(d),g=i.getLeft(i.currentSlide),i.currentLeft=null===i.swipeLeft?g:i.swipeLeft,i.options.infinite===!1&&i.options.centerMode===!1&&(0>a||a>i.getDotCount()*i.options.slidesToScroll)?void(i.options.fade===!1&&(d=i.currentSlide,c!==!0?i.animateSlide(g,function(){i.postSlide(d)}):i.postSlide(d))):i.options.infinite===!1&&i.options.centerMode===!0&&(0>a||a>i.slideCount-i.options.slidesToScroll)?void(i.options.fade===!1&&(d=i.currentSlide,c!==!0?i.animateSlide(g,function(){i.postSlide(d)}):i.postSlide(d))):(i.options.autoplay&&clearInterval(i.autoPlayTimer),e=0>d?i.slideCount%i.options.slidesToScroll!==0?i.slideCount-i.slideCount%i.options.slidesToScroll:i.slideCount+d:d>=i.slideCount?i.slideCount%i.options.slidesToScroll!==0?0:d-i.slideCount:d,i.animating=!0,i.$slider.trigger("beforeChange",[i,i.currentSlide,e]),f=i.currentSlide,i.currentSlide=e,i.setSlideClasses(i.currentSlide),i.options.asNavFor&&(j=i.getNavTarget(),j=j.slick("getSlick"),j.slideCount<=j.options.slidesToShow&&j.setSlideClasses(i.currentSlide)),i.updateDots(),i.updateArrows(),i.options.fade===!0?(c!==!0?(i.fadeSlideOut(f),i.fadeSlide(e,function(){i.postSlide(e)})):i.postSlide(e),void i.animateHeight()):void(c!==!0?i.animateSlide(h,function(){i.postSlide(e)}):i.postSlide(e))))},b.prototype.startLoad=function(){var a=this;a.options.arrows===!0&&a.slideCount>a.options.slidesToShow&&(a.$prevArrow.hide(),a.$nextArrow.hide()),a.options.dots===!0&&a.slideCount>a.options.slidesToShow&&a.$dots.hide(),a.$slider.addClass("slick-loading")},b.prototype.swipeDirection=function(){var a,b,c,d,e=this;return a=e.touchObject.startX-e.touchObject.curX,b=e.touchObject.startY-e.touchObject.curY,c=Math.atan2(b,a),d=Math.round(180*c/Math.PI),0>d&&(d=360-Math.abs(d)),45>=d&&d>=0?e.options.rtl===!1?"left":"right":360>=d&&d>=315?e.options.rtl===!1?"left":"right":d>=135&&225>=d?e.options.rtl===!1?"right":"left":e.options.verticalSwiping===!0?d>=35&&135>=d?"down":"up":"vertical"},b.prototype.swipeEnd=function(a){var c,d,b=this;if(b.dragging=!1,b.interrupted=!1,b.shouldClick=b.touchObject.swipeLength>10?!1:!0,void 0===b.touchObject.curX)return!1;if(b.touchObject.edgeHit===!0&&b.$slider.trigger("edge",[b,b.swipeDirection()]),b.touchObject.swipeLength>=b.touchObject.minSwipe){switch(d=b.swipeDirection()){case"left":case"down":c=b.options.swipeToSlide?b.checkNavigable(b.currentSlide+b.getSlideCount()):b.currentSlide+b.getSlideCount(),b.currentDirection=0;break;case"right":case"up":c=b.options.swipeToSlide?b.checkNavigable(b.currentSlide-b.getSlideCount()):b.currentSlide-b.getSlideCount(),b.currentDirection=1}"vertical"!=d&&(b.slideHandler(c),b.touchObject={},b.$slider.trigger("swipe",[b,d]))}else b.touchObject.startX!==b.touchObject.curX&&(b.slideHandler(b.currentSlide),b.touchObject={})},b.prototype.swipeHandler=function(a){var b=this;if(!(b.options.swipe===!1||"ontouchend"in document&&b.options.swipe===!1||b.options.draggable===!1&&-1!==a.type.indexOf("mouse")))switch(b.touchObject.fingerCount=a.originalEvent&&void 0!==a.originalEvent.touches?a.originalEvent.touches.length:1,b.touchObject.minSwipe=b.listWidth/b.options.touchThreshold,b.options.verticalSwiping===!0&&(b.touchObject.minSwipe=b.listHeight/b.options.touchThreshold),a.data.action){case"start":b.swipeStart(a);break;case"move":b.swipeMove(a);break;case"end":b.swipeEnd(a)}},b.prototype.swipeMove=function(a){var d,e,f,g,h,b=this;return h=void 0!==a.originalEvent?a.originalEvent.touches:null,!b.dragging||h&&1!==h.length?!1:(d=b.getLeft(b.currentSlide),b.touchObject.curX=void 0!==h?h[0].pageX:a.clientX,b.touchObject.curY=void 0!==h?h[0].pageY:a.clientY,b.touchObject.swipeLength=Math.round(Math.sqrt(Math.pow(b.touchObject.curX-b.touchObject.startX,2))),b.options.verticalSwiping===!0&&(b.touchObject.swipeLength=Math.round(Math.sqrt(Math.pow(b.touchObject.curY-b.touchObject.startY,2)))),e=b.swipeDirection(),"vertical"!==e?(void 0!==a.originalEvent&&b.touchObject.swipeLength>4&&a.preventDefault(),g=(b.options.rtl===!1?1:-1)*(b.touchObject.curX>b.touchObject.startX?1:-1),b.options.verticalSwiping===!0&&(g=b.touchObject.curY>b.touchObject.startY?1:-1),f=b.touchObject.swipeLength,b.touchObject.edgeHit=!1,b.options.infinite===!1&&(0===b.currentSlide&&"right"===e||b.currentSlide>=b.getDotCount()&&"left"===e)&&(f=b.touchObject.swipeLength*b.options.edgeFriction,b.touchObject.edgeHit=!0),b.options.vertical===!1?b.swipeLeft=d+f*g:b.swipeLeft=d+f*(b.$list.height()/b.listWidth)*g,b.options.verticalSwiping===!0&&(b.swipeLeft=d+f*g),b.options.fade===!0||b.options.touchMove===!1?!1:b.animating===!0?(b.swipeLeft=null,!1):void b.setCSS(b.swipeLeft)):void 0)},b.prototype.swipeStart=function(a){var c,b=this;return b.interrupted=!0,1!==b.touchObject.fingerCount||b.slideCount<=b.options.slidesToShow?(b.touchObject={},!1):(void 0!==a.originalEvent&&void 0!==a.originalEvent.touches&&(c=a.originalEvent.touches[0]),b.touchObject.startX=b.touchObject.curX=void 0!==c?c.pageX:a.clientX,b.touchObject.startY=b.touchObject.curY=void 0!==c?c.pageY:a.clientY,void(b.dragging=!0))},b.prototype.unfilterSlides=b.prototype.slickUnfilter=function(){var a=this;null!==a.$slidesCache&&(a.unload(),a.$slideTrack.children(this.options.slide).detach(),a.$slidesCache.appendTo(a.$slideTrack),a.reinit())},b.prototype.unload=function(){var b=this;a(".slick-cloned",b.$slider).remove(),b.$dots&&b.$dots.remove(),b.$prevArrow&&b.htmlExpr.test(b.options.prevArrow)&&b.$prevArrow.remove(),b.$nextArrow&&b.htmlExpr.test(b.options.nextArrow)&&b.$nextArrow.remove(),b.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden","true").css("width","")},b.prototype.unslick=function(a){var b=this;b.$slider.trigger("unslick",[b,a]),b.destroy()},b.prototype.updateArrows=function(){var b,a=this;b=Math.floor(a.options.slidesToShow/2),a.options.arrows===!0&&a.slideCount>a.options.slidesToShow&&!a.options.infinite&&(a.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false"),a.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false"),0===a.currentSlide?(a.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true"),a.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false")):a.currentSlide>=a.slideCount-a.options.slidesToShow&&a.options.centerMode===!1?(a.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),a.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")):a.currentSlide>=a.slideCount-1&&a.options.centerMode===!0&&(a.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),a.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")))},b.prototype.updateDots=function(){var a=this;null!==a.$dots&&(a.$dots.find("li").removeClass("slick-active").attr("aria-hidden","true"),a.$dots.find("li").eq(Math.floor(a.currentSlide/a.options.slidesToScroll)).addClass("slick-active").attr("aria-hidden","false"))},b.prototype.visibility=function(){var a=this;a.options.autoplay&&(document[a.hidden]?a.interrupted=!0:a.interrupted=!1)},a.fn.slick=function(){var f,g,a=this,c=arguments[0],d=Array.prototype.slice.call(arguments,1),e=a.length;for(f=0;e>f;f++)if("object"==typeof c||"undefined"==typeof c?a[f].slick=new b(a[f],c):g=a[f].slick[c].apply(a[f].slick,d),"undefined"!=typeof g)return g;return a}});

/* resources/assets/js/libraries/bootstrap_v4.js */
/*!
  * Bootstrap v4.0.0 (https://getbootstrap.com)
  * Copyright 2011-2018 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
  */
(function(global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('jquery'), require('popper.js')) :
    typeof define === 'function' && define.amd ? define(['exports', 'jquery', 'popper.js'], factory) :
      (factory((global.bootstrap = {}), global.jQuery, global.Popper));
}(this, (function(exports, $, Popper) {
  'use strict';

  $      = $ && $.hasOwnProperty('default') ? $['default'] : $;
  Popper = Popper && Popper.hasOwnProperty('default') ? Popper['default'] : Popper;

  function _defineProperties(target, props)
  {
    for (var i = 0; i < props.length; i++) {
      var descriptor          = props[i];
      descriptor.enumerable   = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) {
        descriptor.writable = true;
      }
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps)
  {
    if (protoProps) {
      _defineProperties(Constructor.prototype, protoProps);
    }
    if (staticProps) {
      _defineProperties(Constructor, staticProps);
    }
    return Constructor;
  }

  function _extends()
  {
    _extends = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function _inheritsLoose(subClass, superClass)
  {
    subClass.prototype             = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__             = superClass;
  }

  /**
   * --------------------------------------------------------------------------
   * Bootstrap (v4.0.0): util.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
   * --------------------------------------------------------------------------
   */

  var Util = function($$$1) {
    /**
     * ------------------------------------------------------------------------
     * Private TransitionEnd Helpers
     * ------------------------------------------------------------------------
     */
    var transition = false;
    var MAX_UID    = 1000000; // Shoutout AngusCroll (https://goo.gl/pxwQGp)

    function toType(obj)
    {
      return {}.toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
    }

    function getSpecialTransitionEndEvent()
    {
      return {
        bindType    : transition.end,
        delegateType: transition.end,
        handle      : function handle(event) {
          if ($$$1(event.target).is(this)) {
            return event.handleObj.handler.apply(this, arguments); // eslint-disable-line prefer-rest-params
          }

          return undefined; // eslint-disable-line no-undefined
        }
      };
    }

    function transitionEndTest()
    {
      if (typeof window !== 'undefined' && window.QUnit) {
        return false;
      }

      return {
        end: 'transitionend'
      };
    }

    function transitionEndEmulator(duration)
    {
      var _this = this;

      var called = false;
      $$$1(this).one(Util.TRANSITION_END, function() {
        called = true;
      });
      setTimeout(function() {
        if (!called) {
          Util.triggerTransitionEnd(_this);
        }
      }, duration);
      return this;
    }

    function setTransitionEndSupport()
    {
      transition                   = transitionEndTest();
      $$$1.fn.emulateTransitionEnd = transitionEndEmulator;

      if (Util.supportsTransitionEnd()) {
        $$$1.event.special[Util.TRANSITION_END] = getSpecialTransitionEndEvent();
      }
    }

    function escapeId(selector)
    {
      // We escape IDs in case of special selectors (selector = '#myId:something')
      // $.escapeSelector does not exist in jQuery < 3
      selector =
        typeof $$$1.escapeSelector === 'function' ? $$$1.escapeSelector(selector).substr(1) : selector.replace(/(:|\.|\[|\]|,|=|@)/g, '\\$1');
      return selector;
    }

    /**
     * --------------------------------------------------------------------------
     * Public Util Api
     * --------------------------------------------------------------------------
     */


    var Util = {
      TRANSITION_END        : 'bsTransitionEnd',
      getUID                : function getUID(prefix) {
        do {
          // eslint-disable-next-line no-bitwise
          prefix += ~~(Math.random() * MAX_UID); // "~~" acts like a faster Math.floor() here
        }while (document.getElementById(prefix));

        return prefix;
      },
      getSelectorFromElement: function getSelectorFromElement(element) {
        var selector = element.getAttribute('data-target');

        if (!selector || selector === '#') {
          selector = element.getAttribute('href') || '';
        } // If it's an ID


        if (selector.charAt(0) === '#') {
          selector = escapeId(selector);
        }

        try {
          var $selector = $$$1(document).find(selector);
          return $selector.length > 0 ? selector : null;
        }
        catch (err) {
          return null;
        }
      },
      reflow                : function reflow(element) {
        return element.offsetHeight;
      },
      triggerTransitionEnd  : function triggerTransitionEnd(element) {
        $$$1(element).trigger(transition.end);
      },
      supportsTransitionEnd : function supportsTransitionEnd() {
        return Boolean(transition);
      },
      isElement             : function isElement(obj) {
        return (obj[0] || obj).nodeType;
      },
      typeCheckConfig       : function typeCheckConfig(componentName, config, configTypes) {
        for (var property in configTypes) {
          if (Object.prototype.hasOwnProperty.call(configTypes, property)) {
            var expectedTypes = configTypes[property];
            var value         = config[property];
            var valueType     = value && Util.isElement(value) ? 'element' : toType(value);

            if (!new RegExp(expectedTypes).test(valueType)) {
              throw new Error(componentName.toUpperCase() +
                              ": " +
                              ("Option \"" + property + "\" provided type \"" + valueType + "\" ") +
                              ("but expected type \"" + expectedTypes + "\"."));
            }
          }
        }
      }
    };
    setTransitionEndSupport();
    return Util;
  }($);

  /**
   * --------------------------------------------------------------------------
   * Bootstrap (v4.0.0): alert.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
   * --------------------------------------------------------------------------
   */

  var Alert = function($$$1) {
    /**
     * ------------------------------------------------------------------------
     * Constants
     * ------------------------------------------------------------------------
     */
    var NAME                = 'alert';
    var VERSION             = '4.0.0';
    var DATA_KEY            = 'bs.alert';
    var EVENT_KEY           = "." + DATA_KEY;
    var DATA_API_KEY        = '.data-api';
    var JQUERY_NO_CONFLICT  = $$$1.fn[NAME];
    var TRANSITION_DURATION = 150;
    var Selector            = {
      DISMISS: '[data-dismiss="alert"]'
    };
    var Event               = {
      CLOSE         : "close" + EVENT_KEY,
      CLOSED        : "closed" + EVENT_KEY,
      CLICK_DATA_API: "click" + EVENT_KEY + DATA_API_KEY
    };
    var ClassName           = {
      ALERT: 'alert',
      FADE : 'fade',
      SHOW : 'show'
      /**
       * ------------------------------------------------------------------------
       * Class Definition
       * ------------------------------------------------------------------------
       */

    };

    var Alert =
          /*#__PURE__*/
          function() {
            function Alert(element)
            {
              this._element = element;
            } // Getters


            var _proto = Alert.prototype;

            // Public
            _proto.close = function close(element) {
              element = element || this._element;

              var rootElement = this._getRootElement(element);

              var customEvent = this._triggerCloseEvent(rootElement);

              if (customEvent.isDefaultPrevented()) {
                return;
              }

              this._removeElement(rootElement);
            };

            _proto.dispose = function dispose() {
              $$$1.removeData(this._element, DATA_KEY);
              this._element = null;
            }; // Private


            _proto._getRootElement = function _getRootElement(element) {
              var selector = Util.getSelectorFromElement(element);
              var parent   = false;

              if (selector) {
                parent = $$$1(selector)[0];
              }

              if (!parent) {
                parent = $$$1(element).closest("." + ClassName.ALERT)[0];
              }

              return parent;
            };

            _proto._triggerCloseEvent = function _triggerCloseEvent(element) {
              var closeEvent = $$$1.Event(Event.CLOSE);
              $$$1(element).trigger(closeEvent);
              return closeEvent;
            };

            _proto._removeElement = function _removeElement(element) {
              var _this = this;

              $$$1(element).removeClass(ClassName.SHOW);

              if (!Util.supportsTransitionEnd() || !$$$1(element).hasClass(ClassName.FADE)) {
                this._destroyElement(element);

                return;
              }

              $$$1(element).one(Util.TRANSITION_END, function(event) {
                return _this._destroyElement(element, event);
              }).emulateTransitionEnd(TRANSITION_DURATION);
            };

            _proto._destroyElement = function _destroyElement(element) {
              $$$1(element).detach().trigger(Event.CLOSED).remove();
            }; // Static


            Alert._jQueryInterface = function _jQueryInterface(config) {
              return this.each(function() {
                var $element = $$$1(this);
                var data     = $element.data(DATA_KEY);

                if (!data) {
                  data = new Alert(this);
                  $element.data(DATA_KEY, data);
                }

                if (config === 'close') {
                  data[config](this);
                }
              });
            };

            Alert._handleDismiss = function _handleDismiss(alertInstance) {
              return function(event) {
                if (event) {
                  event.preventDefault();
                }

                alertInstance.close(this);
              };
            };

            _createClass(Alert, null, [{
              key: "VERSION",
              get: function get() {
                return VERSION;
              }
            }
            ]);
            return Alert;
          }();
    /**
     * ------------------------------------------------------------------------
     * Data Api implementation
     * ------------------------------------------------------------------------
     */


    $$$1(document).on(Event.CLICK_DATA_API, Selector.DISMISS, Alert._handleDismiss(new Alert()));
    /**
     * ------------------------------------------------------------------------
     * jQuery
     * ------------------------------------------------------------------------
     */

    $$$1.fn[NAME] = Alert._jQueryInterface;
    $$$1.fn[NAME].Constructor = Alert;

    $$$1.fn[NAME].noConflict = function() {
      $$$1.fn[NAME] = JQUERY_NO_CONFLICT;
      return Alert._jQueryInterface;
    };

    return Alert;
  }($);

  /**
   * --------------------------------------------------------------------------
   * Bootstrap (v4.0.0): button.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
   * --------------------------------------------------------------------------
   */

  var Button = function($$$1) {
    /**
     * ------------------------------------------------------------------------
     * Constants
     * ------------------------------------------------------------------------
     */
    var NAME               = 'button';
    var VERSION            = '4.0.0';
    var DATA_KEY           = 'bs.button';
    var EVENT_KEY          = "." + DATA_KEY;
    var DATA_API_KEY       = '.data-api';
    var JQUERY_NO_CONFLICT = $$$1.fn[NAME];
    var ClassName          = {
      ACTIVE: 'active',
      BUTTON: 'btn',
      FOCUS : 'focus'
    };
    var Selector           = {
      DATA_TOGGLE_CARROT: '[data-toggle^="button"]',
      DATA_TOGGLE       : '[data-toggle="buttons"]',
      INPUT             : 'input',
      ACTIVE            : '.active',
      BUTTON            : '.btn'
    };
    var Event              = {
      CLICK_DATA_API     : "click" + EVENT_KEY + DATA_API_KEY,
      FOCUS_BLUR_DATA_API: "focus" + EVENT_KEY + DATA_API_KEY + " " + ("blur" + EVENT_KEY + DATA_API_KEY)
      /**
       * ------------------------------------------------------------------------
       * Class Definition
       * ------------------------------------------------------------------------
       */

    };

    var Button =
          /*#__PURE__*/
          function() {
            function Button(element)
            {
              this._element = element;
            } // Getters


            var _proto = Button.prototype;

            // Public
            _proto.toggle = function toggle() {
              var triggerChangeEvent = true;
              var addAriaPressed     = true;
              var rootElement        = $$$1(this._element).closest(Selector.DATA_TOGGLE)[0];

              if (rootElement) {
                var input = $$$1(this._element).find(Selector.INPUT)[0];

                if (input) {
                  if (input.type === 'radio') {
                    if (input.checked && $$$1(this._element).hasClass(ClassName.ACTIVE)) {
                      triggerChangeEvent = false;
                    }
                    else {
                      var activeElement = $$$1(rootElement).find(Selector.ACTIVE)[0];

                      if (activeElement) {
                        $$$1(activeElement).removeClass(ClassName.ACTIVE);
                      }
                    }
                  }

                  if (triggerChangeEvent) {
                    if (input.hasAttribute('disabled') ||
                        rootElement.hasAttribute('disabled') ||
                        input.classList.contains('disabled') ||
                        rootElement.classList.contains('disabled')) {
                      return;
                    }

                    input.checked = !$$$1(this._element).hasClass(ClassName.ACTIVE);
                    $$$1(input).trigger('change');
                  }

                  input.focus();
                  addAriaPressed = false;
                }
              }

              if (addAriaPressed) {
                this._element.setAttribute('aria-pressed', !$$$1(this._element).hasClass(ClassName.ACTIVE));
              }

              if (triggerChangeEvent) {
                $$$1(this._element).toggleClass(ClassName.ACTIVE);
              }
            };

            _proto.dispose = function dispose() {
              $$$1.removeData(this._element, DATA_KEY);
              this._element = null;
            }; // Static


            Button._jQueryInterface = function _jQueryInterface(config) {
              return this.each(function() {
                var data = $$$1(this).data(DATA_KEY);

                if (!data) {
                  data = new Button(this);
                  $$$1(this).data(DATA_KEY, data);
                }

                if (config === 'toggle') {
                  data[config]();
                }
              });
            };

            _createClass(Button, null, [{
              key: "VERSION",
              get: function get() {
                return VERSION;
              }
            }
            ]);
            return Button;
          }();
    /**
     * ------------------------------------------------------------------------
     * Data Api implementation
     * ------------------------------------------------------------------------
     */


    $$$1(document).on(Event.CLICK_DATA_API, Selector.DATA_TOGGLE_CARROT, function(event) {
      event.preventDefault();
      var button = event.target;

      if (!$$$1(button).hasClass(ClassName.BUTTON)) {
        button = $$$1(button).closest(Selector.BUTTON);
      }

      Button._jQueryInterface.call($$$1(button), 'toggle');
    }).on(Event.FOCUS_BLUR_DATA_API, Selector.DATA_TOGGLE_CARROT, function(event) {
      var button = $$$1(event.target).closest(Selector.BUTTON)[0];
      $$$1(button).toggleClass(ClassName.FOCUS, /^focus(in)?$/.test(event.type));
    });
    /**
     * ------------------------------------------------------------------------
     * jQuery
     * ------------------------------------------------------------------------
     */

    $$$1.fn[NAME] = Button._jQueryInterface;
    $$$1.fn[NAME].Constructor = Button;

    $$$1.fn[NAME].noConflict = function() {
      $$$1.fn[NAME] = JQUERY_NO_CONFLICT;
      return Button._jQueryInterface;
    };

    return Button;
  }($);

  /**
   * --------------------------------------------------------------------------
   * Bootstrap (v4.0.0): carousel.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
   * --------------------------------------------------------------------------
   */

  var Carousel = function($$$1) {
    /**
     * ------------------------------------------------------------------------
     * Constants
     * ------------------------------------------------------------------------
     */
    var NAME                = 'carousel';
    var VERSION             = '4.0.0';
    var DATA_KEY            = 'bs.carousel';
    var EVENT_KEY           = "." + DATA_KEY;
    var DATA_API_KEY        = '.data-api';
    var JQUERY_NO_CONFLICT  = $$$1.fn[NAME];
    var TRANSITION_DURATION = 600;
    var ARROW_LEFT_KEYCODE  = 37; // KeyboardEvent.which value for left arrow key

    var ARROW_RIGHT_KEYCODE = 39; // KeyboardEvent.which value for right arrow key

    var TOUCHEVENT_COMPAT_WAIT = 500; // Time for mouse compat events to fire after touch

    var Default     = {
      interval: 5000,
      keyboard: true,
      slide   : false,
      pause   : 'hover',
      wrap    : true
    };
    var DefaultType = {
      interval: '(number|boolean)',
      keyboard: 'boolean',
      slide   : '(boolean|string)',
      pause   : '(string|boolean)',
      wrap    : 'boolean'
    };
    var Direction   = {
      NEXT : 'next',
      PREV : 'prev',
      LEFT : 'left',
      RIGHT: 'right'
    };
    var Event       = {
      SLIDE         : "slide" + EVENT_KEY,
      SLID          : "slid" + EVENT_KEY,
      KEYDOWN       : "keydown" + EVENT_KEY,
      MOUSEENTER    : "mouseenter" + EVENT_KEY,
      MOUSELEAVE    : "mouseleave" + EVENT_KEY,
      TOUCHEND      : "touchend" + EVENT_KEY,
      LOAD_DATA_API : "load" + EVENT_KEY + DATA_API_KEY,
      CLICK_DATA_API: "click" + EVENT_KEY + DATA_API_KEY
    };
    var ClassName   = {
      CAROUSEL: 'carousel',
      ACTIVE  : 'active',
      SLIDE   : 'slide',
      RIGHT   : 'carousel-item-right',
      LEFT    : 'carousel-item-left',
      NEXT    : 'carousel-item-next',
      PREV    : 'carousel-item-prev',
      ITEM    : 'carousel-item'
    };
    var Selector    = {
      ACTIVE     : '.active',
      ACTIVE_ITEM: '.active.carousel-item',
      ITEM       : '.carousel-item',
      NEXT_PREV  : '.carousel-item-next, .carousel-item-prev',
      INDICATORS : '.carousel-indicators',
      DATA_SLIDE : '[data-slide], [data-slide-to]',
      DATA_RIDE  : '[data-ride="carousel"]'
      /**
       * ------------------------------------------------------------------------
       * Class Definition
       * ------------------------------------------------------------------------
       */

    };

    var Carousel =
          /*#__PURE__*/
          function() {
            function Carousel(element, config)
            {
              this._items             = null;
              this._interval          = null;
              this._activeElement     = null;
              this._isPaused          = false;
              this._isSliding         = false;
              this.touchTimeout       = null;
              this._config            = this._getConfig(config);
              this._element           = $$$1(element)[0];
              this._indicatorsElement = $$$1(this._element).find(Selector.INDICATORS)[0];

              this._addEventListeners();
            } // Getters


            var _proto = Carousel.prototype;

            // Public
            _proto.next = function next() {
              if (!this._isSliding) {
                this._slide(Direction.NEXT);
              }
            };

            _proto.nextWhenVisible = function nextWhenVisible() {
              // Don't call next when the page isn't visible
              // or the carousel or its parent isn't visible
              if (!document.hidden && $$$1(this._element).is(':visible') && $$$1(this._element).css('visibility') !== 'hidden') {
                this.next();
              }
            };

            _proto.prev = function prev() {
              if (!this._isSliding) {
                this._slide(Direction.PREV);
              }
            };

            _proto.pause = function pause(event) {
              if (!event) {
                this._isPaused = true;
              }

              if ($$$1(this._element).find(Selector.NEXT_PREV)[0] && Util.supportsTransitionEnd()) {
                Util.triggerTransitionEnd(this._element);
                this.cycle(true);
              }

              clearInterval(this._interval);
              this._interval = null;
            };

            _proto.cycle = function cycle(event) {
              if (!event) {
                this._isPaused = false;
              }

              if (this._interval) {
                clearInterval(this._interval);
                this._interval = null;
              }

              if (this._config.interval && !this._isPaused) {
                this._interval = setInterval((document.visibilityState ? this.nextWhenVisible : this.next).bind(this), this._config.interval);
              }
            };

            _proto.to = function to(index) {
              var _this = this;

              this._activeElement = $$$1(this._element).find(Selector.ACTIVE_ITEM)[0];

              var activeIndex = this._getItemIndex(this._activeElement);

              if (index > this._items.length - 1 || index < 0) {
                return;
              }

              if (this._isSliding) {
                $$$1(this._element).one(Event.SLID, function() {
                  return _this.to(index);
                });
                return;
              }

              if (activeIndex === index) {
                this.pause();
                this.cycle();
                return;
              }

              var direction = index > activeIndex ? Direction.NEXT : Direction.PREV;

              this._slide(direction, this._items[index]);
            };

            _proto.dispose = function dispose() {
              $$$1(this._element).off(EVENT_KEY);
              $$$1.removeData(this._element, DATA_KEY);
              this._items             = null;
              this._config            = null;
              this._element           = null;
              this._interval          = null;
              this._isPaused          = null;
              this._isSliding         = null;
              this._activeElement     = null;
              this._indicatorsElement = null;
            }; // Private


            _proto._getConfig = function _getConfig(config) {
              config = _extends({}, Default, config);
              Util.typeCheckConfig(NAME, config, DefaultType);
              return config;
            };

            _proto._addEventListeners = function _addEventListeners() {
              var _this2 = this;

              if (this._config.keyboard) {
                $$$1(this._element).on(Event.KEYDOWN, function(event) {
                  return _this2._keydown(event);
                });
              }

              if (this._config.pause === 'hover') {
                $$$1(this._element).on(Event.MOUSEENTER, function(event) {
                  return _this2.pause(event);
                }).on(Event.MOUSELEAVE, function(event) {
                  return _this2.cycle(event);
                });

                if ('ontouchstart' in document.documentElement) {
                  // If it's a touch-enabled device, mouseenter/leave are fired as
                  // part of the mouse compatibility events on first tap - the carousel
                  // would stop cycling until user tapped out of it;
                  // here, we listen for touchend, explicitly pause the carousel
                  // (as if it's the second time we tap on it, mouseenter compat event
                  // is NOT fired) and after a timeout (to allow for mouse compatibility
                  // events to fire) we explicitly restart cycling
                  $$$1(this._element).on(Event.TOUCHEND, function() {
                    _this2.pause();

                    if (_this2.touchTimeout) {
                      clearTimeout(_this2.touchTimeout);
                    }

                    _this2.touchTimeout = setTimeout(function(event) {
                      return _this2.cycle(event);
                    }, TOUCHEVENT_COMPAT_WAIT + _this2._config.interval);
                  });
                }
              }
            };

            _proto._keydown = function _keydown(event) {
              if (/input|textarea/i.test(event.target.tagName)) {
                return;
              }

              switch (event.which) {
                case ARROW_LEFT_KEYCODE:
                  event.preventDefault();
                  this.prev();
                  break;

                case ARROW_RIGHT_KEYCODE:
                  event.preventDefault();
                  this.next();
                  break;

                default:
              }
            };

            _proto._getItemIndex = function _getItemIndex(element) {
              this._items = $$$1.makeArray($$$1(element).parent().find(Selector.ITEM));
              return this._items.indexOf(element);
            };

            _proto._getItemByDirection = function _getItemByDirection(direction, activeElement) {
              var isNextDirection = direction === Direction.NEXT;
              var isPrevDirection = direction === Direction.PREV;

              var activeIndex = this._getItemIndex(activeElement);

              var lastItemIndex = this._items.length - 1;
              var isGoingToWrap = isPrevDirection && activeIndex === 0 || isNextDirection && activeIndex === lastItemIndex;

              if (isGoingToWrap && !this._config.wrap) {
                return activeElement;
              }

              var delta     = direction === Direction.PREV ? -1 : 1;
              var itemIndex = (activeIndex + delta) % this._items.length;
              return itemIndex === -1 ? this._items[this._items.length - 1] : this._items[itemIndex];
            };

            _proto._triggerSlideEvent = function _triggerSlideEvent(relatedTarget, eventDirectionName) {
              var targetIndex = this._getItemIndex(relatedTarget);

              var fromIndex = this._getItemIndex($$$1(this._element).find(Selector.ACTIVE_ITEM)[0]);

              var slideEvent = $$$1.Event(Event.SLIDE, {
                relatedTarget: relatedTarget,
                direction    : eventDirectionName,
                from         : fromIndex,
                to           : targetIndex
              });
              $$$1(this._element).trigger(slideEvent);
              return slideEvent;
            };

            _proto._setActiveIndicatorElement = function _setActiveIndicatorElement(element) {
              if (this._indicatorsElement) {
                $$$1(this._indicatorsElement).find(Selector.ACTIVE).removeClass(ClassName.ACTIVE);

                var nextIndicator = this._indicatorsElement.children[this._getItemIndex(element)];

                if (nextIndicator) {
                  $$$1(nextIndicator).addClass(ClassName.ACTIVE);
                }
              }
            };

            _proto._slide = function _slide(direction, element) {
              var _this3 = this;

              var activeElement = $$$1(this._element).find(Selector.ACTIVE_ITEM)[0];

              var activeElementIndex = this._getItemIndex(activeElement);

              var nextElement = element || activeElement && this._getItemByDirection(direction, activeElement);

              var nextElementIndex = this._getItemIndex(nextElement);

              var isCycling = Boolean(this._interval);
              var directionalClassName;
              var orderClassName;
              var eventDirectionName;

              if (direction === Direction.NEXT) {
                directionalClassName = ClassName.LEFT;
                orderClassName       = ClassName.NEXT;
                eventDirectionName   = Direction.LEFT;
              }
              else {
                directionalClassName = ClassName.RIGHT;
                orderClassName       = ClassName.PREV;
                eventDirectionName   = Direction.RIGHT;
              }

              if (nextElement && $$$1(nextElement).hasClass(ClassName.ACTIVE)) {
                this._isSliding = false;
                return;
              }

              var slideEvent = this._triggerSlideEvent(nextElement, eventDirectionName);

              if (slideEvent.isDefaultPrevented()) {
                return;
              }

              if (!activeElement || !nextElement) {
                // Some weirdness is happening, so we bail
                return;
              }

              this._isSliding = true;

              if (isCycling) {
                this.pause();
              }

              this._setActiveIndicatorElement(nextElement);

              var slidEvent = $$$1.Event(Event.SLID, {
                relatedTarget: nextElement,
                direction    : eventDirectionName,
                from         : activeElementIndex,
                to           : nextElementIndex
              });

              if (Util.supportsTransitionEnd() && $$$1(this._element).hasClass(ClassName.SLIDE)) {
                $$$1(nextElement).addClass(orderClassName);
                Util.reflow(nextElement);
                $$$1(activeElement).addClass(directionalClassName);
                $$$1(nextElement).addClass(directionalClassName);
                $$$1(activeElement).one(Util.TRANSITION_END, function() {
                  $$$1(nextElement).removeClass(directionalClassName + " " + orderClassName).addClass(ClassName.ACTIVE);
                  $$$1(activeElement).removeClass(ClassName.ACTIVE + " " + orderClassName + " " + directionalClassName);
                  _this3._isSliding = false;
                  setTimeout(function() {
                    return $$$1(_this3._element).trigger(slidEvent);
                  }, 0);
                }).emulateTransitionEnd(TRANSITION_DURATION);
              }
              else {
                $$$1(activeElement).removeClass(ClassName.ACTIVE);
                $$$1(nextElement).addClass(ClassName.ACTIVE);
                this._isSliding = false;
                $$$1(this._element).trigger(slidEvent);
              }

              if (isCycling) {
                this.cycle();
              }
            }; // Static


            Carousel._jQueryInterface = function _jQueryInterface(config) {
              return this.each(function() {
                var data = $$$1(this).data(DATA_KEY);

                var _config = _extends({}, Default, $$$1(this).data());

                if (typeof config === 'object') {
                  _config = _extends({}, _config, config);
                }

                var action = typeof config === 'string' ? config : _config.slide;

                if (!data) {
                  data = new Carousel(this, _config);
                  $$$1(this).data(DATA_KEY, data);
                }

                if (typeof config === 'number') {
                  data.to(config);
                }
                else if (typeof action === 'string') {
                  if (typeof data[action] === 'undefined') {
                    throw new TypeError("No method named \"" + action + "\"");
                  }

                  data[action]();
                }
                else if (_config.interval) {
                  data.pause();
                  data.cycle();
                }
              });
            };

            Carousel._dataApiClickHandler = function _dataApiClickHandler(event) {
              var selector = Util.getSelectorFromElement(this);

              if (!selector) {
                return;
              }

              var target = $$$1(selector)[0];

              if (!target || !$$$1(target).hasClass(ClassName.CAROUSEL)) {
                return;
              }

              var config     = _extends({}, $$$1(target).data(), $$$1(this).data());
              var slideIndex = this.getAttribute('data-slide-to');

              if (slideIndex) {
                config.interval = false;
              }

              Carousel._jQueryInterface.call($$$1(target), config);

              if (slideIndex) {
                $$$1(target).data(DATA_KEY).to(slideIndex);
              }

              event.preventDefault();
            };

            _createClass(Carousel, null, [{
              key: "VERSION",
              get: function get() {
                return VERSION;
              }
            }, {
              key: "Default",
              get: function get() {
                return Default;
              }
            }
            ]);
            return Carousel;
          }();
    /**
     * ------------------------------------------------------------------------
     * Data Api implementation
     * ------------------------------------------------------------------------
     */


    $$$1(document).on(Event.CLICK_DATA_API, Selector.DATA_SLIDE, Carousel._dataApiClickHandler);
    $$$1(window).on(Event.LOAD_DATA_API, function() {
      $$$1(Selector.DATA_RIDE).each(function() {
        var $carousel = $$$1(this);

        Carousel._jQueryInterface.call($carousel, $carousel.data());
      });
    });
    /**
     * ------------------------------------------------------------------------
     * jQuery
     * ------------------------------------------------------------------------
     */

    $$$1.fn[NAME] = Carousel._jQueryInterface;
    $$$1.fn[NAME].Constructor = Carousel;

    $$$1.fn[NAME].noConflict = function() {
      $$$1.fn[NAME] = JQUERY_NO_CONFLICT;
      return Carousel._jQueryInterface;
    };

    return Carousel;
  }($);

  /**
   * --------------------------------------------------------------------------
   * Bootstrap (v4.0.0): collapse.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
   * --------------------------------------------------------------------------
   */

  var Collapse = function($$$1) {
    /**
     * ------------------------------------------------------------------------
     * Constants
     * ------------------------------------------------------------------------
     */
    var NAME                = 'collapse';
    var VERSION             = '4.0.0';
    var DATA_KEY            = 'bs.collapse';
    var EVENT_KEY           = "." + DATA_KEY;
    var DATA_API_KEY        = '.data-api';
    var JQUERY_NO_CONFLICT  = $$$1.fn[NAME];
    var TRANSITION_DURATION = 600;
    var Default             = {
      toggle: true,
      parent: ''
    };
    var DefaultType         = {
      toggle: 'boolean',
      parent: '(string|element)'
    };
    var Event               = {
      SHOW          : "show" + EVENT_KEY,
      SHOWN         : "shown" + EVENT_KEY,
      HIDE          : "hide" + EVENT_KEY,
      HIDDEN        : "hidden" + EVENT_KEY,
      CLICK_DATA_API: "click" + EVENT_KEY + DATA_API_KEY
    };
    var ClassName           = {
      SHOW      : 'show',
      COLLAPSE  : 'collapse',
      COLLAPSING: 'collapsing',
      COLLAPSED : 'collapsed'
    };
    var Dimension           = {
      WIDTH : 'width',
      HEIGHT: 'height'
    };
    var Selector            = {
      ACTIVES    : '.show, .collapsing',
      DATA_TOGGLE: '[data-toggle="collapse"]'
      /**
       * ------------------------------------------------------------------------
       * Class Definition
       * ------------------------------------------------------------------------
       */

    };

    var Collapse =
          /*#__PURE__*/
          function() {
            function Collapse(element, config)
            {
              this._isTransitioning = false;
              this._element         = element;
              this._config          = this._getConfig(config);
              this._triggerArray    =
                $$$1.makeArray($$$1("[data-toggle=\"collapse\"][href=\"#" +
                                    element.id +
                                    "\"]," +
                                    ("[data-toggle=\"collapse\"][data-target=\"#" + element.id + "\"]")));
              var tabToggles        = $$$1(Selector.DATA_TOGGLE);

              for (var i = 0; i < tabToggles.length; i++) {
                var elem     = tabToggles[i];
                var selector = Util.getSelectorFromElement(elem);

                if (selector !== null && $$$1(selector).filter(element).length > 0) {
                  this._selector = selector;

                  this._triggerArray.push(elem);
                }
              }

              this._parent = this._config.parent ? this._getParent() : null;

              if (!this._config.parent) {
                this._addAriaAndCollapsedClass(this._element, this._triggerArray);
              }

              if (this._config.toggle) {
                this.toggle();
              }
            } // Getters


            var _proto = Collapse.prototype;

            // Public
            _proto.toggle = function toggle() {
              if ($$$1(this._element).hasClass(ClassName.SHOW)) {
                this.hide();
              }
              else {
                this.show();
              }
            };

            _proto.show = function show() {
              var _this = this;

              if (this._isTransitioning || $$$1(this._element).hasClass(ClassName.SHOW)) {
                return;
              }

              var actives;
              var activesData;

              if (this._parent) {
                actives = $$$1.makeArray($$$1(this._parent).find(Selector.ACTIVES).filter("[data-parent=\"" + this._config.parent + "\"]"));

                if (actives.length === 0) {
                  actives = null;
                }
              }

              if (actives) {
                activesData = $$$1(actives).not(this._selector).data(DATA_KEY);

                if (activesData && activesData._isTransitioning) {
                  return;
                }
              }

              var startEvent = $$$1.Event(Event.SHOW);
              $$$1(this._element).trigger(startEvent);

              if (startEvent.isDefaultPrevented()) {
                return;
              }

              if (actives) {
                Collapse._jQueryInterface.call($$$1(actives).not(this._selector), 'hide');

                if (!activesData) {
                  $$$1(actives).data(DATA_KEY, null);
                }
              }

              var dimension = this._getDimension();

              $$$1(this._element).removeClass(ClassName.COLLAPSE).addClass(ClassName.COLLAPSING);
              this._element.style[dimension] = 0;

              if (this._triggerArray.length > 0) {
                $$$1(this._triggerArray).removeClass(ClassName.COLLAPSED).attr('aria-expanded', true);
              }

              this.setTransitioning(true);

              var complete = function complete() {
                $$$1(_this._element).removeClass(ClassName.COLLAPSING).addClass(ClassName.COLLAPSE).addClass(ClassName.SHOW);
                _this._element.style[dimension] = '';

                _this.setTransitioning(false);

                $$$1(_this._element).trigger(Event.SHOWN);
              };

              if (!Util.supportsTransitionEnd()) {
                complete();
                return;
              }

              var capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
              var scrollSize           = "scroll" + capitalizedDimension;
              $$$1(this._element).one(Util.TRANSITION_END, complete).emulateTransitionEnd(TRANSITION_DURATION);
              this._element.style[dimension] = this._element[scrollSize] + "px";
            };

            _proto.hide = function hide() {
              var _this2 = this;

              if (this._isTransitioning || !$$$1(this._element).hasClass(ClassName.SHOW)) {
                return;
              }

              var startEvent = $$$1.Event(Event.HIDE);
              $$$1(this._element).trigger(startEvent);

              if (startEvent.isDefaultPrevented()) {
                return;
              }

              var dimension = this._getDimension();

              this._element.style[dimension] = this._element.getBoundingClientRect()[dimension] + "px";
              Util.reflow(this._element);
              $$$1(this._element).addClass(ClassName.COLLAPSING).removeClass(ClassName.COLLAPSE).removeClass(ClassName.SHOW);

              if (this._triggerArray.length > 0) {
                for (var i = 0; i < this._triggerArray.length; i++) {
                  var trigger  = this._triggerArray[i];
                  var selector = Util.getSelectorFromElement(trigger);

                  if (selector !== null) {
                    var $elem = $$$1(selector);

                    if (!$elem.hasClass(ClassName.SHOW)) {
                      $$$1(trigger).addClass(ClassName.COLLAPSED).attr('aria-expanded', false);
                    }
                  }
                }
              }

              this.setTransitioning(true);

              var complete = function complete() {
                _this2.setTransitioning(false);

                $$$1(_this2._element).removeClass(ClassName.COLLAPSING).addClass(ClassName.COLLAPSE).trigger(Event.HIDDEN);
              };

              this._element.style[dimension] = '';

              if (!Util.supportsTransitionEnd()) {
                complete();
                return;
              }

              $$$1(this._element).one(Util.TRANSITION_END, complete).emulateTransitionEnd(TRANSITION_DURATION);
            };

            _proto.setTransitioning = function setTransitioning(isTransitioning) {
              this._isTransitioning = isTransitioning;
            };

            _proto.dispose = function dispose() {
              $$$1.removeData(this._element, DATA_KEY);
              this._config          = null;
              this._parent          = null;
              this._element         = null;
              this._triggerArray    = null;
              this._isTransitioning = null;
            }; // Private


            _proto._getConfig = function _getConfig(config) {
              config        = _extends({}, Default, config);
              config.toggle = Boolean(config.toggle); // Coerce string values

              Util.typeCheckConfig(NAME, config, DefaultType);
              return config;
            };

            _proto._getDimension = function _getDimension() {
              var hasWidth = $$$1(this._element).hasClass(Dimension.WIDTH);
              return hasWidth ? Dimension.WIDTH : Dimension.HEIGHT;
            };

            _proto._getParent = function _getParent() {
              var _this3 = this;

              var parent = null;

              if (Util.isElement(this._config.parent)) {
                parent = this._config.parent; // It's a jQuery object

                if (typeof this._config.parent.jquery !== 'undefined') {
                  parent = this._config.parent[0];
                }
              }
              else {
                parent = $$$1(this._config.parent)[0];
              }

              var selector = "[data-toggle=\"collapse\"][data-parent=\"" + this._config.parent + "\"]";
              $$$1(parent).find(selector).each(function(i, element) {
                _this3._addAriaAndCollapsedClass(Collapse._getTargetFromElement(element), [element]);
              });
              return parent;
            };

            _proto._addAriaAndCollapsedClass = function _addAriaAndCollapsedClass(element, triggerArray) {
              if (element) {
                var isOpen = $$$1(element).hasClass(ClassName.SHOW);

                if (triggerArray.length > 0) {
                  $$$1(triggerArray).toggleClass(ClassName.COLLAPSED, !isOpen).attr('aria-expanded', isOpen);
                }
              }
            }; // Static


            Collapse._getTargetFromElement = function _getTargetFromElement(element) {
              var selector = Util.getSelectorFromElement(element);
              return selector ? $$$1(selector)[0] : null;
            };

            Collapse._jQueryInterface = function _jQueryInterface(config) {
              return this.each(function() {
                var $this = $$$1(this);
                var data  = $this.data(DATA_KEY);

                var _config = _extends({}, Default, $this.data(), typeof config === 'object' && config);

                if (!data && _config.toggle && /show|hide/.test(config)) {
                  _config.toggle = false;
                }

                if (!data) {
                  data = new Collapse(this, _config);
                  $this.data(DATA_KEY, data);
                }

                if (typeof config === 'string') {
                  if (typeof data[config] === 'undefined') {
                    throw new TypeError("No method named \"" + config + "\"");
                  }

                  data[config]();
                }
              });
            };

            _createClass(Collapse, null, [{
              key: "VERSION",
              get: function get() {
                return VERSION;
              }
            }, {
              key: "Default",
              get: function get() {
                return Default;
              }
            }
            ]);
            return Collapse;
          }();
    /**
     * ------------------------------------------------------------------------
     * Data Api implementation
     * ------------------------------------------------------------------------
     */


    $$$1(document).on(Event.CLICK_DATA_API, Selector.DATA_TOGGLE, function(event) {
      // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
      if (event.currentTarget.tagName === 'A') {
        event.preventDefault();
      }

      var $trigger = $$$1(this);
      var selector = Util.getSelectorFromElement(this);
      $$$1(selector).each(function() {
        var $target = $$$1(this);
        var data    = $target.data(DATA_KEY);
        var config  = data ? 'toggle' : $trigger.data();

        Collapse._jQueryInterface.call($target, config);
      });
    });
    /**
     * ------------------------------------------------------------------------
     * jQuery
     * ------------------------------------------------------------------------
     */

    $$$1.fn[NAME] = Collapse._jQueryInterface;
    $$$1.fn[NAME].Constructor = Collapse;

    $$$1.fn[NAME].noConflict = function() {
      $$$1.fn[NAME] = JQUERY_NO_CONFLICT;
      return Collapse._jQueryInterface;
    };

    return Collapse;
  }($);

  /**
   * --------------------------------------------------------------------------
   * Bootstrap (v4.0.0): dropdown.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
   * --------------------------------------------------------------------------
   */

  var Dropdown = function($$$1) {
    /**
     * ------------------------------------------------------------------------
     * Constants
     * ------------------------------------------------------------------------
     */
    var NAME               = 'dropdown';
    var VERSION            = '4.0.0';
    var DATA_KEY           = 'bs.dropdown';
    var EVENT_KEY          = "." + DATA_KEY;
    var DATA_API_KEY       = '.data-api';
    var JQUERY_NO_CONFLICT = $$$1.fn[NAME];
    var ESCAPE_KEYCODE     = 27; // KeyboardEvent.which value for Escape (Esc) key

    var SPACE_KEYCODE = 32; // KeyboardEvent.which value for space key

    var TAB_KEYCODE = 9; // KeyboardEvent.which value for tab key

    var ARROW_UP_KEYCODE = 38; // KeyboardEvent.which value for up arrow key

    var ARROW_DOWN_KEYCODE = 40; // KeyboardEvent.which value for down arrow key

    var RIGHT_MOUSE_BUTTON_WHICH = 3; // MouseEvent.which value for the right button (assuming a right-handed mouse)

    var REGEXP_KEYDOWN = new RegExp(ARROW_UP_KEYCODE + "|" + ARROW_DOWN_KEYCODE + "|" + ESCAPE_KEYCODE);
    var Event          = {
      HIDE            : "hide" + EVENT_KEY,
      HIDDEN          : "hidden" + EVENT_KEY,
      SHOW            : "show" + EVENT_KEY,
      SHOWN           : "shown" + EVENT_KEY,
      CLICK           : "click" + EVENT_KEY,
      CLICK_DATA_API  : "click" + EVENT_KEY + DATA_API_KEY,
      KEYDOWN_DATA_API: "keydown" + EVENT_KEY + DATA_API_KEY,
      KEYUP_DATA_API  : "keyup" + EVENT_KEY + DATA_API_KEY
    };
    var ClassName      = {
      DISABLED       : 'disabled',
      SHOW           : 'show',
      DROPUP         : 'dropup',
      DROPRIGHT      : 'dropright',
      DROPLEFT       : 'dropleft',
      MENURIGHT      : 'dropdown-menu-right',
      MENULEFT       : 'dropdown-menu-left',
      POSITION_STATIC: 'position-static'
    };
    var Selector       = {
      DATA_TOGGLE  : '[data-toggle="dropdown"]',
      FORM_CHILD   : '.dropdown form',
      MENU         : '.dropdown-menu',
      NAVBAR_NAV   : '.navbar-nav',
      VISIBLE_ITEMS: '.dropdown-menu .dropdown-item:not(.disabled)'
    };
    var AttachmentMap  = {
      TOP      : 'top-start',
      TOPEND   : 'top-end',
      BOTTOM   : 'bottom-start',
      BOTTOMEND: 'bottom-end',
      RIGHT    : 'right-start',
      RIGHTEND : 'right-end',
      LEFT     : 'left-start',
      LEFTEND  : 'left-end'
    };
    var Default        = {
      offset  : 0,
      flip    : true,
      boundary: 'scrollParent'
    };
    var DefaultType    = {
      offset  : '(number|string|function)',
      flip    : 'boolean',
      boundary: '(string|element)'
      /**
       * ------------------------------------------------------------------------
       * Class Definition
       * ------------------------------------------------------------------------
       */

    };

    var Dropdown =
          /*#__PURE__*/
          function() {
            function Dropdown(element, config)
            {
              this._element  = element;
              this._popper   = null;
              this._config   = this._getConfig(config);
              this._menu     = this._getMenuElement();
              this._inNavbar = this._detectNavbar();

              this._addEventListeners();
            } // Getters


            var _proto = Dropdown.prototype;

            // Public
            _proto.toggle = function toggle() {
              if (this._element.disabled || $$$1(this._element).hasClass(ClassName.DISABLED)) {
                return;
              }

              var parent = Dropdown._getParentFromElement(this._element);

              var isActive = $$$1(this._menu).hasClass(ClassName.SHOW);

              Dropdown._clearMenus();

              if (isActive) {
                return;
              }

              var relatedTarget = {
                relatedTarget: this._element
              };
              var showEvent     = $$$1.Event(Event.SHOW, relatedTarget);
              $$$1(parent).trigger(showEvent);

              if (showEvent.isDefaultPrevented()) {
                return;
              } // Disable totally Popper.js for Dropdown in Navbar


              if (!this._inNavbar) {
                /**
                 * Check for Popper dependency
                 * Popper - https://popper.js.org
                 */
                if (typeof Popper === 'undefined') {
                  throw new TypeError('Bootstrap dropdown require Popper.js (https://popper.js.org)');
                }

                var element = this._element; // For dropup with alignment we use the parent as popper container

                if ($$$1(parent).hasClass(ClassName.DROPUP)) {
                  if ($$$1(this._menu).hasClass(ClassName.MENULEFT) || $$$1(this._menu).hasClass(ClassName.MENURIGHT)) {
                    element = parent;
                  }
                } // If boundary is not `scrollParent`, then set position to `static`
                // to allow the menu to "escape" the scroll parent's boundaries
                // https://github.com/twbs/bootstrap/issues/24251


                if (this._config.boundary !== 'scrollParent') {
                  $$$1(parent).addClass(ClassName.POSITION_STATIC);
                }

                this._popper = new Popper(element, this._menu, this._getPopperConfig());
              } // If this is a touch-enabled device we add extra
              // empty mouseover listeners to the body's immediate children;
              // only needed because of broken event delegation on iOS
              // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html


              if ('ontouchstart' in document.documentElement && $$$1(parent).closest(Selector.NAVBAR_NAV).length === 0) {
                $$$1('body').children().on('mouseover', null, $$$1.noop);
              }

              this._element.focus();

              this._element.setAttribute('aria-expanded', true);

              $$$1(this._menu).toggleClass(ClassName.SHOW);
              $$$1(parent).toggleClass(ClassName.SHOW).trigger($$$1.Event(Event.SHOWN, relatedTarget));
            };

            _proto.dispose = function dispose() {
              $$$1.removeData(this._element, DATA_KEY);
              $$$1(this._element).off(EVENT_KEY);
              this._element = null;
              this._menu    = null;

              if (this._popper !== null) {
                this._popper.destroy();

                this._popper = null;
              }
            };

            _proto.update = function update() {
              this._inNavbar = this._detectNavbar();

              if (this._popper !== null) {
                this._popper.scheduleUpdate();
              }
            }; // Private


            _proto._addEventListeners = function _addEventListeners() {
              var _this = this;

              $$$1(this._element).on(Event.CLICK, function(event) {
                event.preventDefault();
                event.stopPropagation();

                _this.toggle();
              });
            };

            _proto._getConfig = function _getConfig(config) {
              config = _extends({}, this.constructor.Default, $$$1(this._element).data(), config);
              Util.typeCheckConfig(NAME, config, this.constructor.DefaultType);
              return config;
            };

            _proto._getMenuElement = function _getMenuElement() {
              if (!this._menu) {
                var parent = Dropdown._getParentFromElement(this._element);

                this._menu = $$$1(parent).find(Selector.MENU)[0];
              }

              return this._menu;
            };

            _proto._getPlacement = function _getPlacement() {
              var $parentDropdown = $$$1(this._element).parent();
              var placement       = AttachmentMap.BOTTOM; // Handle dropup

              if ($parentDropdown.hasClass(ClassName.DROPUP)) {
                placement = AttachmentMap.TOP;

                if ($$$1(this._menu).hasClass(ClassName.MENURIGHT)) {
                  placement = AttachmentMap.TOPEND;
                }
              }
              else if ($parentDropdown.hasClass(ClassName.DROPRIGHT)) {
                placement = AttachmentMap.RIGHT;
              }
              else if ($parentDropdown.hasClass(ClassName.DROPLEFT)) {
                placement = AttachmentMap.LEFT;
              }
              else if ($$$1(this._menu).hasClass(ClassName.MENURIGHT)) {
                placement = AttachmentMap.BOTTOMEND;
              }

              return placement;
            };

            _proto._detectNavbar = function _detectNavbar() {
              return $$$1(this._element).closest('.navbar').length > 0;
            };

            _proto._getPopperConfig = function _getPopperConfig() {
              var _this2 = this;

              var offsetConf = {};

              if (typeof this._config.offset === 'function') {
                offsetConf.fn = function(data) {
                  data.offsets = _extends({}, data.offsets, _this2._config.offset(data.offsets) || {});
                  return data;
                };
              }
              else {
                offsetConf.offset = this._config.offset;
              }

              var popperConfig = {
                placement: this._getPlacement(),
                modifiers: {
                  offset         : offsetConf,
                  flip           : {
                    enabled: this._config.flip
                  },
                  preventOverflow: {
                    boundariesElement: this._config.boundary
                  }
                }
              };
              return popperConfig;
            }; // Static


            Dropdown._jQueryInterface = function _jQueryInterface(config) {
              return this.each(function() {
                var data = $$$1(this).data(DATA_KEY);

                var _config = typeof config === 'object' ? config : null;

                if (!data) {
                  data = new Dropdown(this, _config);
                  $$$1(this).data(DATA_KEY, data);
                }

                if (typeof config === 'string') {
                  if (typeof data[config] === 'undefined') {
                    throw new TypeError("No method named \"" + config + "\"");
                  }

                  data[config]();
                }
              });
            };

            Dropdown._clearMenus = function _clearMenus(event) {
              if (event && (event.which === RIGHT_MOUSE_BUTTON_WHICH || event.type === 'keyup' && event.which !== TAB_KEYCODE)) {
                return;
              }

              var toggles = $$$1.makeArray($$$1(Selector.DATA_TOGGLE));

              for (var i = 0; i < toggles.length; i++) {
                var parent = Dropdown._getParentFromElement(toggles[i]);

                var context       = $$$1(toggles[i]).data(DATA_KEY);
                var relatedTarget = {
                  relatedTarget: toggles[i]
                };

                if (!context) {
                  continue;
                }

                var dropdownMenu = context._menu;

                if (!$$$1(parent).hasClass(ClassName.SHOW)) {
                  continue;
                }

                if (event &&
                    (event.type ===
                     'click' &&
                     /input|textarea/i.test(event.target.tagName) ||
                     event.type ===
                     'keyup' &&
                     event.which ===
                     TAB_KEYCODE) &&
                    $$$1.contains(parent, event.target)) {
                  continue;
                }

                var hideEvent = $$$1.Event(Event.HIDE, relatedTarget);
                $$$1(parent).trigger(hideEvent);

                if (hideEvent.isDefaultPrevented()) {
                  continue;
                } // If this is a touch-enabled device we remove the extra
                // empty mouseover listeners we added for iOS support


                if ('ontouchstart' in document.documentElement) {
                  $$$1('body').children().off('mouseover', null, $$$1.noop);
                }

                toggles[i].setAttribute('aria-expanded', 'false');
                $$$1(dropdownMenu).removeClass(ClassName.SHOW);
                $$$1(parent).removeClass(ClassName.SHOW).trigger($$$1.Event(Event.HIDDEN, relatedTarget));
              }
            };

            Dropdown._getParentFromElement = function _getParentFromElement(element) {
              var parent;
              var selector = Util.getSelectorFromElement(element);

              if (selector) {
                parent = $$$1(selector)[0];
              }

              return parent || element.parentNode;
            }; // eslint-disable-next-line complexity


            Dropdown._dataApiKeydownHandler = function _dataApiKeydownHandler(event) {
              // If not input/textarea:
              //  - And not a key in REGEXP_KEYDOWN => not a dropdown command
              // If input/textarea:
              //  - If space key => not a dropdown command
              //  - If key is other than escape
              //    - If key is not up or down => not a dropdown command
              //    - If trigger inside the menu => not a dropdown command
              if (/input|textarea/i.test(event.target.tagName) ? event.which ===
                                                                 SPACE_KEYCODE ||
                                                                 event.which !==
                                                                 ESCAPE_KEYCODE &&
                                                                 (event.which !==
                                                                 ARROW_DOWN_KEYCODE &&
                                                                 event.which !==
                                                                 ARROW_UP_KEYCODE ||
                                                                 $$$1(event.target)
                                                                   .closest(Selector.MENU).length) : !REGEXP_KEYDOWN.test(event.which)) {
                return;
              }

              event.preventDefault();
              event.stopPropagation();

              if (this.disabled || $$$1(this).hasClass(ClassName.DISABLED)) {
                return;
              }

              var parent = Dropdown._getParentFromElement(this);

              var isActive = $$$1(parent).hasClass(ClassName.SHOW);

              if (!isActive &&
                  (event.which !== ESCAPE_KEYCODE || event.which !== SPACE_KEYCODE) ||
                  isActive &&
                  (event.which === ESCAPE_KEYCODE || event.which === SPACE_KEYCODE)) {
                if (event.which === ESCAPE_KEYCODE) {
                  var toggle = $$$1(parent).find(Selector.DATA_TOGGLE)[0];
                  $$$1(toggle).trigger('focus');
                }

                $$$1(this).trigger('click');
                return;
              }

              var items = $$$1(parent).find(Selector.VISIBLE_ITEMS).get();

              if (items.length === 0) {
                return;
              }

              var index = items.indexOf(event.target);

              if (event.which === ARROW_UP_KEYCODE && index > 0) {
                // Up
                index--;
              }

              if (event.which === ARROW_DOWN_KEYCODE && index < items.length - 1) {
                // Down
                index++;
              }

              if (index < 0) {
                index = 0;
              }

              items[index].focus();
            };

            _createClass(Dropdown, null, [{
              key: "VERSION",
              get: function get() {
                return VERSION;
              }
            }, {
              key: "Default",
              get: function get() {
                return Default;
              }
            }, {
              key: "DefaultType",
              get: function get() {
                return DefaultType;
              }
            }
            ]);
            return Dropdown;
          }();
    /**
     * ------------------------------------------------------------------------
     * Data Api implementation
     * ------------------------------------------------------------------------
     */


    $$$1(document)
      .on(Event.KEYDOWN_DATA_API, Selector.DATA_TOGGLE, Dropdown._dataApiKeydownHandler)
      .on(Event.KEYDOWN_DATA_API, Selector.MENU, Dropdown._dataApiKeydownHandler)
      .on(Event.CLICK_DATA_API + " " + Event.KEYUP_DATA_API, Dropdown._clearMenus)
      .on(Event.CLICK_DATA_API, Selector.DATA_TOGGLE, function(event) {
        event.preventDefault();
        event.stopPropagation();

        Dropdown._jQueryInterface.call($$$1(this), 'toggle');
      })
      .on(Event.CLICK_DATA_API, Selector.FORM_CHILD, function(e) {
        e.stopPropagation();
      });
    /**
     * ------------------------------------------------------------------------
     * jQuery
     * ------------------------------------------------------------------------
     */

    $$$1.fn[NAME] = Dropdown._jQueryInterface;
    $$$1.fn[NAME].Constructor = Dropdown;

    $$$1.fn[NAME].noConflict = function() {
      $$$1.fn[NAME] = JQUERY_NO_CONFLICT;
      return Dropdown._jQueryInterface;
    };

    return Dropdown;
  }($, Popper);

  /**
   * --------------------------------------------------------------------------
   * Bootstrap (v4.0.0): modal.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
   * --------------------------------------------------------------------------
   */

  var Modal = function($$$1) {
    /**
     * ------------------------------------------------------------------------
     * Constants
     * ------------------------------------------------------------------------
     */
    var NAME                         = 'modal';
    var VERSION                      = '4.0.0';
    var DATA_KEY                     = 'bs.modal';
    var EVENT_KEY                    = "." + DATA_KEY;
    var DATA_API_KEY                 = '.data-api';
    var JQUERY_NO_CONFLICT           = $$$1.fn[NAME];
    var TRANSITION_DURATION          = 300;
    var BACKDROP_TRANSITION_DURATION = 150;
    var ESCAPE_KEYCODE               = 27; // KeyboardEvent.which value for Escape (Esc) key

    var Default     = {
      backdrop: true,
      keyboard: true,
      focus   : true,
      show    : true
    };
    var DefaultType = {
      backdrop: '(boolean|string)',
      keyboard: 'boolean',
      focus   : 'boolean',
      show    : 'boolean'
    };
    var Event       = {
      HIDE             : "hide" + EVENT_KEY,
      HIDDEN           : "hidden" + EVENT_KEY,
      SHOW             : "show" + EVENT_KEY,
      SHOWN            : "shown" + EVENT_KEY,
      FOCUSIN          : "focusin" + EVENT_KEY,
      RESIZE           : "resize" + EVENT_KEY,
      CLICK_DISMISS    : "click.dismiss" + EVENT_KEY,
      KEYDOWN_DISMISS  : "keydown.dismiss" + EVENT_KEY,
      MOUSEUP_DISMISS  : "mouseup.dismiss" + EVENT_KEY,
      MOUSEDOWN_DISMISS: "mousedown.dismiss" + EVENT_KEY,
      CLICK_DATA_API   : "click" + EVENT_KEY + DATA_API_KEY
    };
    var ClassName   = {
      SCROLLBAR_MEASURER: 'modal-scrollbar-measure',
      BACKDROP          : 'modal-backdrop',
      OPEN              : 'modal-open',
      FADE              : 'fade',
      SHOW              : 'show'
    };
    var Selector    = {
      DIALOG        : '.modal-dialog',
      DATA_TOGGLE   : '[data-toggle="modal"]',
      DATA_DISMISS  : '[data-dismiss="modal"]',
      FIXED_CONTENT : '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top',
      STICKY_CONTENT: '.sticky-top',
      NAVBAR_TOGGLER: '.navbar-toggler'
      /**
       * ------------------------------------------------------------------------
       * Class Definition
       * ------------------------------------------------------------------------
       */

    };

    var Modal =
          /*#__PURE__*/
          function() {
            function Modal(element, config)
            {
              this._config              = this._getConfig(config);
              this._element             = element;
              this._dialog              = $$$1(element).find(Selector.DIALOG)[0];
              this._backdrop            = null;
              this._isShown             = false;
              this._isBodyOverflowing   = false;
              this._ignoreBackdropClick = false;
              this._originalBodyPadding = 0;
              this._scrollbarWidth      = 0;
            } // Getters


            var _proto = Modal.prototype;

            // Public
            _proto.toggle = function toggle(relatedTarget) {
              return this._isShown ? this.hide() : this.show(relatedTarget);
            };

            _proto.show = function show(relatedTarget) {
              var _this = this;

              if (this._isTransitioning || this._isShown) {
                return;
              }

              if (Util.supportsTransitionEnd() && $$$1(this._element).hasClass(ClassName.FADE)) {
                this._isTransitioning = true;
              }

              var showEvent = $$$1.Event(Event.SHOW, {
                relatedTarget: relatedTarget
              });
              $$$1(this._element).trigger(showEvent);

              if (this._isShown || showEvent.isDefaultPrevented()) {
                return;
              }

              this._isShown = true;

              this._checkScrollbar();

              this._setScrollbar();

              this._adjustDialog();

              $$$1(document.body).addClass(ClassName.OPEN);

              this._setEscapeEvent();

              this._setResizeEvent();

              $$$1(this._element).on(Event.CLICK_DISMISS, Selector.DATA_DISMISS, function(event) {
                return _this.hide(event);
              });
              $$$1(this._dialog).on(Event.MOUSEDOWN_DISMISS, function() {
                $$$1(_this._element).one(Event.MOUSEUP_DISMISS, function(event) {
                  if ($$$1(event.target).is(_this._element)) {
                    _this._ignoreBackdropClick = true;
                  }
                });
              });

              this._showBackdrop(function() {
                return _this._showElement(relatedTarget);
              });
            };

            _proto.hide = function hide(event) {
              var _this2 = this;

              if (event) {
                event.preventDefault();
              }

              if (this._isTransitioning || !this._isShown) {
                return;
              }

              var hideEvent = $$$1.Event(Event.HIDE);
              $$$1(this._element).trigger(hideEvent);

              if (!this._isShown || hideEvent.isDefaultPrevented()) {
                return;
              }

              this._isShown  = false;
              var transition = Util.supportsTransitionEnd() && $$$1(this._element).hasClass(ClassName.FADE);

              if (transition) {
                this._isTransitioning = true;
              }

              this._setEscapeEvent();

              this._setResizeEvent();

              $$$1(document).off(Event.FOCUSIN);
              $$$1(this._element).removeClass(ClassName.SHOW);
              $$$1(this._element).off(Event.CLICK_DISMISS);
              $$$1(this._dialog).off(Event.MOUSEDOWN_DISMISS);

              if (transition) {
                $$$1(this._element).one(Util.TRANSITION_END, function(event) {
                  return _this2._hideModal(event);
                }).emulateTransitionEnd(TRANSITION_DURATION);
              }
              else {
                this._hideModal();
              }
            };

            _proto.dispose = function dispose() {
              $$$1.removeData(this._element, DATA_KEY);
              $$$1(window, document, this._element, this._backdrop).off(EVENT_KEY);
              this._config              = null;
              this._element             = null;
              this._dialog              = null;
              this._backdrop            = null;
              this._isShown             = null;
              this._isBodyOverflowing   = null;
              this._ignoreBackdropClick = null;
              this._scrollbarWidth      = null;
            };

            _proto.handleUpdate = function handleUpdate() {
              this._adjustDialog();
            }; // Private


            _proto._getConfig = function _getConfig(config) {
              config = _extends({}, Default, config);
              Util.typeCheckConfig(NAME, config, DefaultType);
              return config;
            };

            _proto._showElement = function _showElement(relatedTarget) {
              var _this3 = this;

              var transition = Util.supportsTransitionEnd() && $$$1(this._element).hasClass(ClassName.FADE);

              if (!this._element.parentNode || this._element.parentNode.nodeType !== Node.ELEMENT_NODE) {
                // Don't move modal's DOM position
                document.body.appendChild(this._element);
              }

              this._element.style.display = 'block';

              this._element.removeAttribute('aria-hidden');

              this._element.scrollTop = 0;

              if (transition) {
                Util.reflow(this._element);
              }

              $$$1(this._element).addClass(ClassName.SHOW);

              if (this._config.focus) {
                this._enforceFocus();
              }

              var shownEvent = $$$1.Event(Event.SHOWN, {
                relatedTarget: relatedTarget
              });

              var transitionComplete = function transitionComplete() {
                if (_this3._config.focus) {
                  _this3._element.focus();
                }

                _this3._isTransitioning = false;
                $$$1(_this3._element).trigger(shownEvent);
              };

              if (transition) {
                $$$1(this._dialog).one(Util.TRANSITION_END, transitionComplete).emulateTransitionEnd(TRANSITION_DURATION);
              }
              else {
                transitionComplete();
              }
            };

            _proto._enforceFocus = function _enforceFocus() {
              var _this4 = this;

              $$$1(document).off(Event.FOCUSIN) // Guard against infinite focus loop
                            .on(Event.FOCUSIN, function(event) {
                              if (document !==
                                  event.target &&
                                  _this4._element !==
                                  event.target &&
                                  $$$1(_this4._element).has(event.target).length ===
                                  0) {
                                _this4._element.focus();
                              }
                            });
            };

            _proto._setEscapeEvent = function _setEscapeEvent() {
              var _this5 = this;

              if (this._isShown && this._config.keyboard) {
                $$$1(this._element).on(Event.KEYDOWN_DISMISS, function(event) {
                  if (event.which === ESCAPE_KEYCODE) {
                    event.preventDefault();

                    _this5.hide();
                  }
                });
              }
              else if (!this._isShown) {
                $$$1(this._element).off(Event.KEYDOWN_DISMISS);
              }
            };

            _proto._setResizeEvent = function _setResizeEvent() {
              var _this6 = this;

              if (this._isShown) {
                $$$1(window).on(Event.RESIZE, function(event) {
                  return _this6.handleUpdate(event);
                });
              }
              else {
                $$$1(window).off(Event.RESIZE);
              }
            };

            _proto._hideModal = function _hideModal() {
              var _this7 = this;

              this._element.style.display = 'none';

              this._element.setAttribute('aria-hidden', true);

              this._isTransitioning = false;

              this._showBackdrop(function() {
                $$$1(document.body).removeClass(ClassName.OPEN);

                _this7._resetAdjustments();

                _this7._resetScrollbar();

                $$$1(_this7._element).trigger(Event.HIDDEN);
              });
            };

            _proto._removeBackdrop = function _removeBackdrop() {
              if (this._backdrop) {
                $$$1(this._backdrop).remove();
                this._backdrop = null;
              }
            };

            _proto._showBackdrop = function _showBackdrop(callback) {
              var _this8 = this;

              var animate = $$$1(this._element).hasClass(ClassName.FADE) ? ClassName.FADE : '';

              if (this._isShown && this._config.backdrop) {
                var doAnimate            = Util.supportsTransitionEnd() && animate;
                this._backdrop           = document.createElement('div');
                this._backdrop.className = ClassName.BACKDROP;

                if (animate) {
                  $$$1(this._backdrop).addClass(animate);
                }

                $$$1(this._backdrop).appendTo(document.body);
                $$$1(this._element).on(Event.CLICK_DISMISS, function(event) {
                  if (_this8._ignoreBackdropClick) {
                    _this8._ignoreBackdropClick = false;
                    return;
                  }

                  if (event.target !== event.currentTarget) {
                    return;
                  }

                  if (_this8._config.backdrop === 'static') {
                    _this8._element.focus();
                  }
                  else {
                    _this8.hide();
                  }
                });

                if (doAnimate) {
                  Util.reflow(this._backdrop);
                }

                $$$1(this._backdrop).addClass(ClassName.SHOW);

                if (!callback) {
                  return;
                }

                if (!doAnimate) {
                  callback();
                  return;
                }

                $$$1(this._backdrop).one(Util.TRANSITION_END, callback).emulateTransitionEnd(BACKDROP_TRANSITION_DURATION);
              }
              else if (!this._isShown && this._backdrop) {
                $$$1(this._backdrop).removeClass(ClassName.SHOW);

                var callbackRemove = function callbackRemove() {
                  _this8._removeBackdrop();

                  if (callback) {
                    callback();
                  }
                };

                if (Util.supportsTransitionEnd() && $$$1(this._element).hasClass(ClassName.FADE)) {
                  $$$1(this._backdrop).one(Util.TRANSITION_END, callbackRemove).emulateTransitionEnd(BACKDROP_TRANSITION_DURATION);
                }
                else {
                  callbackRemove();
                }
              }
              else if (callback) {
                callback();
              }
            }; // ----------------------------------------------------------------------
            // the following methods are used to handle overflowing modals
            // todo (fat): these should probably be refactored out of modal.js
            // ----------------------------------------------------------------------


            _proto._adjustDialog = function _adjustDialog() {
              var isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;

              if (!this._isBodyOverflowing && isModalOverflowing) {
                this._element.style.paddingLeft = this._scrollbarWidth + "px";
              }

              if (this._isBodyOverflowing && !isModalOverflowing) {
                this._element.style.paddingRight = this._scrollbarWidth + "px";
              }
            };

            _proto._resetAdjustments = function _resetAdjustments() {
              this._element.style.paddingLeft  = '';
              this._element.style.paddingRight = '';
            };

            _proto._checkScrollbar = function _checkScrollbar() {
              var rect                = document.body.getBoundingClientRect();
              this._isBodyOverflowing = rect.left + rect.right < window.innerWidth;
              this._scrollbarWidth    = this._getScrollbarWidth();
            };

            _proto._setScrollbar = function _setScrollbar() {
              var _this9 = this;

              if (this._isBodyOverflowing) {
                // Note: DOMNode.style.paddingRight returns the actual value or '' if not set
                //   while $(DOMNode).css('padding-right') returns the calculated value or 0 if not set
                // Adjust fixed content padding
                $$$1(Selector.FIXED_CONTENT).each(function(index, element) {
                  var actualPadding     = $$$1(element)[0].style.paddingRight;
                  var calculatedPadding = $$$1(element).css('padding-right');
                  $$$1(element).data('padding-right', actualPadding).css('padding-right', parseFloat(calculatedPadding) +
                                                                                          _this9._scrollbarWidth +
                                                                                          "px");
                }); // Adjust sticky content margin

                $$$1(Selector.STICKY_CONTENT).each(function(index, element) {
                  var actualMargin     = $$$1(element)[0].style.marginRight;
                  var calculatedMargin = $$$1(element).css('margin-right');
                  $$$1(element).data('margin-right', actualMargin).css('margin-right', parseFloat(calculatedMargin) - _this9._scrollbarWidth + "px");
                }); // Adjust navbar-toggler margin

                $$$1(Selector.NAVBAR_TOGGLER).each(function(index, element) {
                  var actualMargin     = $$$1(element)[0].style.marginRight;
                  var calculatedMargin = $$$1(element).css('margin-right');
                  $$$1(element).data('margin-right', actualMargin).css('margin-right', parseFloat(calculatedMargin) + _this9._scrollbarWidth + "px");
                }); // Adjust body padding

                var actualPadding     = document.body.style.paddingRight;
                var calculatedPadding = $$$1('body').css('padding-right');
                $$$1('body').data('padding-right', actualPadding).css('padding-right', parseFloat(calculatedPadding) + this._scrollbarWidth + "px");
              }
            };

            _proto._resetScrollbar = function _resetScrollbar() {
              // Restore fixed content padding
              $$$1(Selector.FIXED_CONTENT).each(function(index, element) {
                var padding = $$$1(element).data('padding-right');

                if (typeof padding !== 'undefined') {
                  $$$1(element).css('padding-right', padding).removeData('padding-right');
                }
              }); // Restore sticky content and navbar-toggler margin

              $$$1(Selector.STICKY_CONTENT + ", " + Selector.NAVBAR_TOGGLER).each(function(index, element) {
                var margin = $$$1(element).data('margin-right');

                if (typeof margin !== 'undefined') {
                  $$$1(element).css('margin-right', margin).removeData('margin-right');
                }
              }); // Restore body padding

              var padding = $$$1('body').data('padding-right');

              if (typeof padding !== 'undefined') {
                $$$1('body').css('padding-right', padding).removeData('padding-right');
              }
            };

            _proto._getScrollbarWidth = function _getScrollbarWidth() {
              // thx d.walsh
              var scrollDiv       = document.createElement('div');
              scrollDiv.className = ClassName.SCROLLBAR_MEASURER;
              document.body.appendChild(scrollDiv);
              var scrollbarWidth = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
              document.body.removeChild(scrollDiv);
              return scrollbarWidth;
            }; // Static


            Modal._jQueryInterface = function _jQueryInterface(config, relatedTarget) {
              return this.each(function() {
                var data = $$$1(this).data(DATA_KEY);

                var _config = _extends({}, Modal.Default, $$$1(this).data(), typeof config === 'object' && config);

                if (!data) {
                  data = new Modal(this, _config);
                  $$$1(this).data(DATA_KEY, data);
                }

                if (typeof config === 'string') {
                  if (typeof data[config] === 'undefined') {
                    throw new TypeError("No method named \"" + config + "\"");
                  }

                  data[config](relatedTarget);
                }
                else if (_config.show) {
                  data.show(relatedTarget);
                }
              });
            };

            _createClass(Modal, null, [{
              key: "VERSION",
              get: function get() {
                return VERSION;
              }
            }, {
              key: "Default",
              get: function get() {
                return Default;
              }
            }
            ]);
            return Modal;
          }();
    /**
     * ------------------------------------------------------------------------
     * Data Api implementation
     * ------------------------------------------------------------------------
     */


    $$$1(document).on(Event.CLICK_DATA_API, Selector.DATA_TOGGLE, function(event) {
      var _this10 = this;

      var target;
      var selector = Util.getSelectorFromElement(this);

      if (selector) {
        target = $$$1(selector)[0];
      }

      var config = $$$1(target).data(DATA_KEY) ? 'toggle' : _extends({}, $$$1(target).data(), $$$1(this).data());

      if (this.tagName === 'A' || this.tagName === 'AREA') {
        event.preventDefault();
      }

      var $target = $$$1(target).one(Event.SHOW, function(showEvent) {
        if (showEvent.isDefaultPrevented()) {
          // Only register focus restorer if modal will actually get shown
          return;
        }

        $target.one(Event.HIDDEN, function() {
          if ($$$1(_this10).is(':visible')) {
            _this10.focus();
          }
        });
      });

      Modal._jQueryInterface.call($$$1(target), config, this);
    });
    /**
     * ------------------------------------------------------------------------
     * jQuery
     * ------------------------------------------------------------------------
     */

    $$$1.fn[NAME] = Modal._jQueryInterface;
    $$$1.fn[NAME].Constructor = Modal;

    $$$1.fn[NAME].noConflict = function() {
      $$$1.fn[NAME] = JQUERY_NO_CONFLICT;
      return Modal._jQueryInterface;
    };

    return Modal;
  }($);

  /**
   * --------------------------------------------------------------------------
   * Bootstrap (v4.0.0): tooltip.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
   * --------------------------------------------------------------------------
   */

  var Tooltip = function($$$1) {
    /**
     * ------------------------------------------------------------------------
     * Constants
     * ------------------------------------------------------------------------
     */
    var NAME                = 'tooltip';
    var VERSION             = '4.0.0';
    var DATA_KEY            = 'bs.tooltip';
    var EVENT_KEY           = "." + DATA_KEY;
    var JQUERY_NO_CONFLICT  = $$$1.fn[NAME];
    var TRANSITION_DURATION = 150;
    var CLASS_PREFIX        = 'bs-tooltip';
    var BSCLS_PREFIX_REGEX  = new RegExp("(^|\\s)" + CLASS_PREFIX + "\\S+", 'g');
    var DefaultType         = {
      animation        : 'boolean',
      template         : 'string',
      title            : '(string|element|function)',
      trigger          : 'string',
      delay            : '(number|object)',
      html             : 'boolean',
      selector         : '(string|boolean)',
      placement        : '(string|function)',
      offset           : '(number|string)',
      container        : '(string|element|boolean)',
      fallbackPlacement: '(string|array)',
      boundary         : '(string|element)'
    };
    var AttachmentMap       = {
      AUTO  : 'auto',
      TOP   : 'top',
      RIGHT : 'right',
      BOTTOM: 'bottom',
      LEFT  : 'left'
    };
    var Default             = {
      animation        : true,
      template         : '<div class="tooltip" role="tooltip">' + '<div class="arrow"></div>' + '<div class="tooltip-inner"></div></div>',
      trigger          : 'hover focus',
      title            : '',
      delay            : 0,
      html             : false,
      selector         : false,
      placement        : 'top',
      offset           : 0,
      container        : false,
      fallbackPlacement: 'flip',
      boundary         : 'scrollParent'
    };
    var HoverState          = {
      SHOW: 'show',
      OUT : 'out'
    };
    var Event               = {
      HIDE      : "hide" + EVENT_KEY,
      HIDDEN    : "hidden" + EVENT_KEY,
      SHOW      : "show" + EVENT_KEY,
      SHOWN     : "shown" + EVENT_KEY,
      INSERTED  : "inserted" + EVENT_KEY,
      CLICK     : "click" + EVENT_KEY,
      FOCUSIN   : "focusin" + EVENT_KEY,
      FOCUSOUT  : "focusout" + EVENT_KEY,
      MOUSEENTER: "mouseenter" + EVENT_KEY,
      MOUSELEAVE: "mouseleave" + EVENT_KEY
    };
    var ClassName           = {
      FADE: 'fade',
      SHOW: 'show'
    };
    var Selector            = {
      TOOLTIP      : '.tooltip',
      TOOLTIP_INNER: '.tooltip-inner',
      ARROW        : '.arrow'
    };
    var Trigger             = {
      HOVER : 'hover',
      FOCUS : 'focus',
      CLICK : 'click',
      MANUAL: 'manual'
      /**
       * ------------------------------------------------------------------------
       * Class Definition
       * ------------------------------------------------------------------------
       */

    };

    var Tooltip =
          /*#__PURE__*/
          function() {
            function Tooltip(element, config)
            {
              /**
               * Check for Popper dependency
               * Popper - https://popper.js.org
               */
              if (typeof Popper === 'undefined') {
                throw new TypeError('Bootstrap tooltips require Popper.js (https://popper.js.org)');
              } // private


              this._isEnabled     = true;
              this._timeout       = 0;
              this._hoverState    = '';
              this._activeTrigger = {};
              this._popper        = null; // Protected

              this.element = element;
              this.config  = this._getConfig(config);
              this.tip     = null;

              this._setListeners();
            } // Getters


            var _proto = Tooltip.prototype;

            // Public
            _proto.enable = function enable() {
              this._isEnabled = true;
            };

            _proto.disable = function disable() {
              this._isEnabled = false;
            };

            _proto.toggleEnabled = function toggleEnabled() {
              this._isEnabled = !this._isEnabled;
            };

            _proto.toggle = function toggle(event) {
              if (!this._isEnabled) {
                return;
              }

              if (event) {
                var dataKey = this.constructor.DATA_KEY;
                var context = $$$1(event.currentTarget).data(dataKey);

                if (!context) {
                  context = new this.constructor(event.currentTarget, this._getDelegateConfig());
                  $$$1(event.currentTarget).data(dataKey, context);
                }

                context._activeTrigger.click = !context._activeTrigger.click;

                if (context._isWithActiveTrigger()) {
                  context._enter(null, context);
                }
                else {
                  context._leave(null, context);
                }
              }
              else {
                if ($$$1(this.getTipElement()).hasClass(ClassName.SHOW)) {
                  this._leave(null, this);

                  return;
                }

                this._enter(null, this);
              }
            };

            _proto.dispose = function dispose() {
              clearTimeout(this._timeout);
              $$$1.removeData(this.element, this.constructor.DATA_KEY);
              $$$1(this.element).off(this.constructor.EVENT_KEY);
              $$$1(this.element).closest('.modal').off('hide.bs.modal');

              if (this.tip) {
                $$$1(this.tip).remove();
              }

              this._isEnabled     = null;
              this._timeout       = null;
              this._hoverState    = null;
              this._activeTrigger = null;

              if (this._popper !== null) {
                this._popper.destroy();
              }

              this._popper = null;
              this.element = null;
              this.config  = null;
              this.tip     = null;
            };

            _proto.show = function show() {
              var _this = this;

              if ($$$1(this.element).css('display') === 'none') {
                throw new Error('Please use show on visible elements');
              }

              var showEvent = $$$1.Event(this.constructor.Event.SHOW);

              if (this.isWithContent() && this._isEnabled) {
                $$$1(this.element).trigger(showEvent);
                var isInTheDom = $$$1.contains(this.element.ownerDocument.documentElement, this.element);

                if (showEvent.isDefaultPrevented() || !isInTheDom) {
                  return;
                }

                var tip   = this.getTipElement();
                var tipId = Util.getUID(this.constructor.NAME);
                tip.setAttribute('id', tipId);
                this.element.setAttribute('aria-describedby', tipId);
                this.setContent();

                if (this.config.animation) {
                  $$$1(tip).addClass(ClassName.FADE);
                }

                var placement = typeof this.config.placement ===
                                'function' ? this.config.placement.call(this, tip, this.element) : this.config.placement;

                var attachment = this._getAttachment(placement);

                this.addAttachmentClass(attachment);
                var container = this.config.container === false ? document.body : $$$1(this.config.container);
                $$$1(tip).data(this.constructor.DATA_KEY, this);

                if (!$$$1.contains(this.element.ownerDocument.documentElement, this.tip)) {
                  $$$1(tip).appendTo(container);
                }

                $$$1(this.element).trigger(this.constructor.Event.INSERTED);
                this._popper = new Popper(this.element, tip, {
                  placement: attachment,
                  modifiers: {
                    offset         : {
                      offset: this.config.offset
                    },
                    flip           : {
                      behavior: this.config.fallbackPlacement
                    },
                    arrow          : {
                      element: Selector.ARROW
                    },
                    preventOverflow: {
                      boundariesElement: this.config.boundary
                    }
                  },
                  onCreate : function onCreate(data) {
                    if (data.originalPlacement !== data.placement) {
                      _this._handlePopperPlacementChange(data);
                    }
                  },
                  onUpdate : function onUpdate(data) {
                    _this._handlePopperPlacementChange(data);
                  }
                });
                $$$1(tip).addClass(ClassName.SHOW); // If this is a touch-enabled device we add extra
                // empty mouseover listeners to the body's immediate children;
                // only needed because of broken event delegation on iOS
                // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html

                if ('ontouchstart' in document.documentElement) {
                  $$$1('body').children().on('mouseover', null, $$$1.noop);
                }

                var complete = function complete() {
                  if (_this.config.animation) {
                    _this._fixTransition();
                  }

                  var prevHoverState = _this._hoverState;
                  _this._hoverState  = null;
                  $$$1(_this.element).trigger(_this.constructor.Event.SHOWN);

                  if (prevHoverState === HoverState.OUT) {
                    _this._leave(null, _this);
                  }
                };

                if (Util.supportsTransitionEnd() && $$$1(this.tip).hasClass(ClassName.FADE)) {
                  $$$1(this.tip).one(Util.TRANSITION_END, complete).emulateTransitionEnd(Tooltip._TRANSITION_DURATION);
                }
                else {
                  complete();
                }
              }
            };

            _proto.hide = function hide(callback) {
              var _this2 = this;

              var tip       = this.getTipElement();
              var hideEvent = $$$1.Event(this.constructor.Event.HIDE);

              var complete = function complete() {
                if (_this2._hoverState !== HoverState.SHOW && tip.parentNode) {
                  tip.parentNode.removeChild(tip);
                }

                _this2._cleanTipClass();

                _this2.element.removeAttribute('aria-describedby');

                $$$1(_this2.element).trigger(_this2.constructor.Event.HIDDEN);

                if (_this2._popper !== null) {
                  _this2._popper.destroy();
                }

                if (callback) {
                  callback();
                }
              };

              $$$1(this.element).trigger(hideEvent);

              if (hideEvent.isDefaultPrevented()) {
                return;
              }

              $$$1(tip).removeClass(ClassName.SHOW); // If this is a touch-enabled device we remove the extra
              // empty mouseover listeners we added for iOS support

              if ('ontouchstart' in document.documentElement) {
                $$$1('body').children().off('mouseover', null, $$$1.noop);
              }

              this._activeTrigger[Trigger.CLICK] = false;
              this._activeTrigger[Trigger.FOCUS] = false;
              this._activeTrigger[Trigger.HOVER] = false;

              if (Util.supportsTransitionEnd() && $$$1(this.tip).hasClass(ClassName.FADE)) {
                $$$1(tip).one(Util.TRANSITION_END, complete).emulateTransitionEnd(TRANSITION_DURATION);
              }
              else {
                complete();
              }

              this._hoverState = '';
            };

            _proto.update = function update() {
              if (this._popper !== null) {
                this._popper.scheduleUpdate();
              }
            }; // Protected


            _proto.isWithContent = function isWithContent() {
              return Boolean(this.getTitle());
            };

            _proto.addAttachmentClass = function addAttachmentClass(attachment) {
              $$$1(this.getTipElement()).addClass(CLASS_PREFIX + "-" + attachment);
            };

            _proto.getTipElement = function getTipElement() {
              this.tip = this.tip || $$$1(this.config.template)[0];
              return this.tip;
            };

            _proto.setContent = function setContent() {
              var $tip = $$$1(this.getTipElement());
              this.setElementContent($tip.find(Selector.TOOLTIP_INNER), this.getTitle());
              $tip.removeClass(ClassName.FADE + " " + ClassName.SHOW);
            };

            _proto.setElementContent = function setElementContent($element, content) {
              var html = this.config.html;

              if (typeof content === 'object' && (content.nodeType || content.jquery)) {
                // Content is a DOM node or a jQuery
                if (html) {
                  if (!$$$1(content).parent().is($element)) {
                    $element.empty().append(content);
                  }
                }
                else {
                  $element.text($$$1(content).text());
                }
              }
              else {
                $element[html ? 'html' : 'text'](content);
              }
            };

            _proto.getTitle = function getTitle() {
              var title = this.element.getAttribute('data-original-title');

              if (!title) {
                title = typeof this.config.title === 'function' ? this.config.title.call(this.element) : this.config.title;
              }

              return title;
            }; // Private


            _proto._getAttachment = function _getAttachment(placement) {
              return AttachmentMap[placement.toUpperCase()];
            };

            _proto._setListeners = function _setListeners() {
              var _this3 = this;

              var triggers = this.config.trigger.split(' ');
              triggers.forEach(function(trigger) {
                if (trigger === 'click') {
                  $$$1(_this3.element).on(_this3.constructor.Event.CLICK, _this3.config.selector, function(event) {
                    return _this3.toggle(event);
                  });
                }
                else if (trigger !== Trigger.MANUAL) {
                  var eventIn  = trigger === Trigger.HOVER ? _this3.constructor.Event.MOUSEENTER : _this3.constructor.Event.FOCUSIN;
                  var eventOut = trigger === Trigger.HOVER ? _this3.constructor.Event.MOUSELEAVE : _this3.constructor.Event.FOCUSOUT;
                  $$$1(_this3.element).on(eventIn, _this3.config.selector, function(event) {
                    return _this3._enter(event);
                  }).on(eventOut, _this3.config.selector, function(event) {
                    return _this3._leave(event);
                  });
                }

                $$$1(_this3.element).closest('.modal').on('hide.bs.modal', function() {
                  return _this3.hide();
                });
              });

              if (this.config.selector) {
                this.config = _extends({}, this.config, {
                  trigger : 'manual',
                  selector: ''
                });
              }
              else {
                this._fixTitle();
              }
            };

            _proto._fixTitle = function _fixTitle() {
              var titleType = typeof this.element.getAttribute('data-original-title');

              if (this.element.getAttribute('title') || titleType !== 'string') {
                this.element.setAttribute('data-original-title', this.element.getAttribute('title') || '');
                this.element.setAttribute('title', '');
              }
            };

            _proto._enter = function _enter(event, context) {
              var dataKey = this.constructor.DATA_KEY;
              context     = context || $$$1(event.currentTarget).data(dataKey);

              if (!context) {
                context = new this.constructor(event.currentTarget, this._getDelegateConfig());
                $$$1(event.currentTarget).data(dataKey, context);
              }

              if (event) {
                context._activeTrigger[event.type === 'focusin' ? Trigger.FOCUS : Trigger.HOVER] = true;
              }

              if ($$$1(context.getTipElement()).hasClass(ClassName.SHOW) || context._hoverState === HoverState.SHOW) {
                context._hoverState = HoverState.SHOW;
                return;
              }

              clearTimeout(context._timeout);
              context._hoverState = HoverState.SHOW;

              if (!context.config.delay || !context.config.delay.show) {
                context.show();
                return;
              }

              context._timeout = setTimeout(function() {
                if (context._hoverState === HoverState.SHOW) {
                  context.show();
                }
              }, context.config.delay.show);
            };

            _proto._leave = function _leave(event, context) {
              var dataKey = this.constructor.DATA_KEY;
              context     = context || $$$1(event.currentTarget).data(dataKey);

              if (!context) {
                context = new this.constructor(event.currentTarget, this._getDelegateConfig());
                $$$1(event.currentTarget).data(dataKey, context);
              }

              if (event) {
                context._activeTrigger[event.type === 'focusout' ? Trigger.FOCUS : Trigger.HOVER] = false;
              }

              if (context._isWithActiveTrigger()) {
                return;
              }

              clearTimeout(context._timeout);
              context._hoverState = HoverState.OUT;

              if (!context.config.delay || !context.config.delay.hide) {
                context.hide();
                return;
              }

              context._timeout = setTimeout(function() {
                if (context._hoverState === HoverState.OUT) {
                  context.hide();
                }
              }, context.config.delay.hide);
            };

            _proto._isWithActiveTrigger = function _isWithActiveTrigger() {
              for (var trigger in this._activeTrigger) {
                if (this._activeTrigger[trigger]) {
                  return true;
                }
              }

              return false;
            };

            _proto._getConfig = function _getConfig(config) {
              config = _extends({}, this.constructor.Default, $$$1(this.element).data(), config);

              if (typeof config.delay === 'number') {
                config.delay = {
                  show: config.delay,
                  hide: config.delay
                };
              }

              if (typeof config.title === 'number') {
                config.title = config.title.toString();
              }

              if (typeof config.content === 'number') {
                config.content = config.content.toString();
              }

              Util.typeCheckConfig(NAME, config, this.constructor.DefaultType);
              return config;
            };

            _proto._getDelegateConfig = function _getDelegateConfig() {
              var config = {};

              if (this.config) {
                for (var key in this.config) {
                  if (this.constructor.Default[key] !== this.config[key]) {
                    config[key] = this.config[key];
                  }
                }
              }

              return config;
            };

            _proto._cleanTipClass = function _cleanTipClass() {
              var $tip     = $$$1(this.getTipElement());
              var tabClass = $tip.attr('class').match(BSCLS_PREFIX_REGEX);

              if (tabClass !== null && tabClass.length > 0) {
                $tip.removeClass(tabClass.join(''));
              }
            };

            _proto._handlePopperPlacementChange = function _handlePopperPlacementChange(data) {
              this._cleanTipClass();

              this.addAttachmentClass(this._getAttachment(data.placement));
            };

            _proto._fixTransition = function _fixTransition() {
              var tip                 = this.getTipElement();
              var initConfigAnimation = this.config.animation;

              if (tip.getAttribute('x-placement') !== null) {
                return;
              }

              $$$1(tip).removeClass(ClassName.FADE);
              this.config.animation = false;
              this.hide();
              this.show();
              this.config.animation = initConfigAnimation;
            }; // Static


            Tooltip._jQueryInterface = function _jQueryInterface(config) {
              return this.each(function() {
                var data = $$$1(this).data(DATA_KEY);

                var _config = typeof config === 'object' && config;

                if (!data && /dispose|hide/.test(config)) {
                  return;
                }

                if (!data) {
                  data = new Tooltip(this, _config);
                  $$$1(this).data(DATA_KEY, data);
                }

                if (typeof config === 'string') {
                  if (typeof data[config] === 'undefined') {
                    throw new TypeError("No method named \"" + config + "\"");
                  }

                  data[config]();
                }
              });
            };

            _createClass(Tooltip, null, [{
              key: "VERSION",
              get: function get() {
                return VERSION;
              }
            }, {
              key: "Default",
              get: function get() {
                return Default;
              }
            }, {
              key: "NAME",
              get: function get() {
                return NAME;
              }
            }, {
              key: "DATA_KEY",
              get: function get() {
                return DATA_KEY;
              }
            }, {
              key: "Event",
              get: function get() {
                return Event;
              }
            }, {
              key: "EVENT_KEY",
              get: function get() {
                return EVENT_KEY;
              }
            }, {
              key: "DefaultType",
              get: function get() {
                return DefaultType;
              }
            }
            ]);
            return Tooltip;
          }();
    /**
     * ------------------------------------------------------------------------
     * jQuery
     * ------------------------------------------------------------------------
     */


    $$$1.fn[NAME] = Tooltip._jQueryInterface;
    $$$1.fn[NAME].Constructor = Tooltip;

    $$$1.fn[NAME].noConflict = function() {
      $$$1.fn[NAME] = JQUERY_NO_CONFLICT;
      return Tooltip._jQueryInterface;
    };

    return Tooltip;
  }($, Popper);

  /**
   * --------------------------------------------------------------------------
   * Bootstrap (v4.0.0): popover.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
   * --------------------------------------------------------------------------
   */

  var Popover = function($$$1) {
    /**
     * ------------------------------------------------------------------------
     * Constants
     * ------------------------------------------------------------------------
     */
    var NAME               = 'popover';
    var VERSION            = '4.0.0';
    var DATA_KEY           = 'bs.popover';
    var EVENT_KEY          = "." + DATA_KEY;
    var JQUERY_NO_CONFLICT = $$$1.fn[NAME];
    var CLASS_PREFIX       = 'bs-popover';
    var BSCLS_PREFIX_REGEX = new RegExp("(^|\\s)" + CLASS_PREFIX + "\\S+", 'g');
    var Default            = _extends({}, Tooltip.Default, {
      placement: 'right',
      trigger  : 'click',
      content  : '',
      template : '<div class="popover" role="tooltip">' +
                 '<div class="arrow"></div>' +
                 '<h3 class="popover-header"></h3>' +
                 '<div class="popover-body"></div></div>'
    });
    var DefaultType        = _extends({}, Tooltip.DefaultType, {
      content: '(string|element|function)'
    });
    var ClassName          = {
      FADE: 'fade',
      SHOW: 'show'
    };
    var Selector           = {
      TITLE  : '.popover-header',
      CONTENT: '.popover-body'
    };
    var Event              = {
      HIDE      : "hide" + EVENT_KEY,
      HIDDEN    : "hidden" + EVENT_KEY,
      SHOW      : "show" + EVENT_KEY,
      SHOWN     : "shown" + EVENT_KEY,
      INSERTED  : "inserted" + EVENT_KEY,
      CLICK     : "click" + EVENT_KEY,
      FOCUSIN   : "focusin" + EVENT_KEY,
      FOCUSOUT  : "focusout" + EVENT_KEY,
      MOUSEENTER: "mouseenter" + EVENT_KEY,
      MOUSELEAVE: "mouseleave" + EVENT_KEY
      /**
       * ------------------------------------------------------------------------
       * Class Definition
       * ------------------------------------------------------------------------
       */

    };

    var Popover =
          /*#__PURE__*/
          function(_Tooltip) {
            _inheritsLoose(Popover, _Tooltip);

            function Popover()
            {
              return _Tooltip.apply(this, arguments) || this;
            }

            var _proto = Popover.prototype;

            // Overrides
            _proto.isWithContent = function isWithContent() {
              return this.getTitle() || this._getContent();
            };

            _proto.addAttachmentClass = function addAttachmentClass(attachment) {
              $$$1(this.getTipElement()).addClass(CLASS_PREFIX + "-" + attachment);
            };

            _proto.getTipElement = function getTipElement() {
              this.tip = this.tip || $$$1(this.config.template)[0];
              return this.tip;
            };

            _proto.setContent = function setContent() {
              var $tip = $$$1(this.getTipElement()); // We use append for html objects to maintain js events

              this.setElementContent($tip.find(Selector.TITLE), this.getTitle());

              var content = this._getContent();

              if (typeof content === 'function') {
                content = content.call(this.element);
              }

              this.setElementContent($tip.find(Selector.CONTENT), content);
              $tip.removeClass(ClassName.FADE + " " + ClassName.SHOW);
            }; // Private


            _proto._getContent = function _getContent() {
              return this.element.getAttribute('data-content') || this.config.content;
            };

            _proto._cleanTipClass = function _cleanTipClass() {
              var $tip     = $$$1(this.getTipElement());
              var tabClass = $tip.attr('class').match(BSCLS_PREFIX_REGEX);

              if (tabClass !== null && tabClass.length > 0) {
                $tip.removeClass(tabClass.join(''));
              }
            }; // Static


            Popover._jQueryInterface = function _jQueryInterface(config) {
              return this.each(function() {
                var data = $$$1(this).data(DATA_KEY);

                var _config = typeof config === 'object' ? config : null;

                if (!data && /destroy|hide/.test(config)) {
                  return;
                }

                if (!data) {
                  data = new Popover(this, _config);
                  $$$1(this).data(DATA_KEY, data);
                }

                if (typeof config === 'string') {
                  if (typeof data[config] === 'undefined') {
                    throw new TypeError("No method named \"" + config + "\"");
                  }

                  data[config]();
                }
              });
            };

            _createClass(Popover, null, [{
              key: "VERSION",
              // Getters
              get: function get() {
                return VERSION;
              }
            }, {
              key: "Default",
              get: function get() {
                return Default;
              }
            }, {
              key: "NAME",
              get: function get() {
                return NAME;
              }
            }, {
              key: "DATA_KEY",
              get: function get() {
                return DATA_KEY;
              }
            }, {
              key: "Event",
              get: function get() {
                return Event;
              }
            }, {
              key: "EVENT_KEY",
              get: function get() {
                return EVENT_KEY;
              }
            }, {
              key: "DefaultType",
              get: function get() {
                return DefaultType;
              }
            }
            ]);
            return Popover;
          }(Tooltip);
    /**
     * ------------------------------------------------------------------------
     * jQuery
     * ------------------------------------------------------------------------
     */


    $$$1.fn[NAME] = Popover._jQueryInterface;
    $$$1.fn[NAME].Constructor = Popover;

    $$$1.fn[NAME].noConflict = function() {
      $$$1.fn[NAME] = JQUERY_NO_CONFLICT;
      return Popover._jQueryInterface;
    };

    return Popover;
  }($);

  /**
   * --------------------------------------------------------------------------
   * Bootstrap (v4.0.0): scrollspy.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
   * --------------------------------------------------------------------------
   */

  var ScrollSpy = function($$$1) {
    /**
     * ------------------------------------------------------------------------
     * Constants
     * ------------------------------------------------------------------------
     */
    var NAME               = 'scrollspy';
    var VERSION            = '4.0.0';
    var DATA_KEY           = 'bs.scrollspy';
    var EVENT_KEY          = "." + DATA_KEY;
    var DATA_API_KEY       = '.data-api';
    var JQUERY_NO_CONFLICT = $$$1.fn[NAME];
    var Default            = {
      offset: 10,
      method: 'auto',
      target: ''
    };
    var DefaultType        = {
      offset: 'number',
      method: 'string',
      target: '(string|element)'
    };
    var Event              = {
      ACTIVATE     : "activate" + EVENT_KEY,
      SCROLL       : "scroll" + EVENT_KEY,
      LOAD_DATA_API: "load" + EVENT_KEY + DATA_API_KEY
    };
    var ClassName          = {
      DROPDOWN_ITEM: 'dropdown-item',
      DROPDOWN_MENU: 'dropdown-menu',
      ACTIVE       : 'active'
    };
    var Selector           = {
      DATA_SPY       : '[data-spy="scroll"]',
      ACTIVE         : '.active',
      NAV_LIST_GROUP : '.nav, .list-group',
      NAV_LINKS      : '.nav-link',
      NAV_ITEMS      : '.nav-item',
      LIST_ITEMS     : '.list-group-item',
      DROPDOWN       : '.dropdown',
      DROPDOWN_ITEMS : '.dropdown-item',
      DROPDOWN_TOGGLE: '.dropdown-toggle'
    };
    var OffsetMethod       = {
      OFFSET  : 'offset',
      POSITION: 'position'
      /**
       * ------------------------------------------------------------------------
       * Class Definition
       * ------------------------------------------------------------------------
       */

    };

    var ScrollSpy =
          /*#__PURE__*/
          function() {
            function ScrollSpy(element, config)
            {
              var _this = this;

              this._element       = element;
              this._scrollElement = element.tagName === 'BODY' ? window : element;
              this._config        = this._getConfig(config);
              this._selector      =
                this._config.target +
                " " +
                Selector.NAV_LINKS +
                "," +
                (this._config.target + " " + Selector.LIST_ITEMS + ",") +
                (this._config.target + " " + Selector.DROPDOWN_ITEMS);
              this._offsets       = [];
              this._targets       = [];
              this._activeTarget  = null;
              this._scrollHeight  = 0;
              $$$1(this._scrollElement).on(Event.SCROLL, function(event) {
                return _this._process(event);
              });
              this.refresh();

              this._process();
            } // Getters


            var _proto = ScrollSpy.prototype;

            // Public
            _proto.refresh = function refresh() {
              var _this2 = this;

              var autoMethod     = this._scrollElement === this._scrollElement.window ? OffsetMethod.OFFSET : OffsetMethod.POSITION;
              var offsetMethod   = this._config.method === 'auto' ? autoMethod : this._config.method;
              var offsetBase     = offsetMethod === OffsetMethod.POSITION ? this._getScrollTop() : 0;
              this._offsets      = [];
              this._targets      = [];
              this._scrollHeight = this._getScrollHeight();
              var targets        = $$$1.makeArray($$$1(this._selector));
              targets.map(function(element) {
                var target;
                var targetSelector = Util.getSelectorFromElement(element);

                if (targetSelector) {
                  target = $$$1(targetSelector)[0];
                }

                if (target) {
                  var targetBCR = target.getBoundingClientRect();

                  if (targetBCR.width || targetBCR.height) {
                    // TODO (fat): remove sketch reliance on jQuery position/offset
                    return [$$$1(target)[offsetMethod]().top + offsetBase, targetSelector];
                  }
                }

                return null;
              }).filter(function(item) {
                return item;
              }).sort(function(a, b) {
                return a[0] - b[0];
              }).forEach(function(item) {
                _this2._offsets.push(item[0]);

                _this2._targets.push(item[1]);
              });
            };

            _proto.dispose = function dispose() {
              $$$1.removeData(this._element, DATA_KEY);
              $$$1(this._scrollElement).off(EVENT_KEY);
              this._element       = null;
              this._scrollElement = null;
              this._config        = null;
              this._selector      = null;
              this._offsets       = null;
              this._targets       = null;
              this._activeTarget  = null;
              this._scrollHeight  = null;
            }; // Private


            _proto._getConfig = function _getConfig(config) {
              config = _extends({}, Default, config);

              if (typeof config.target !== 'string') {
                var id = $$$1(config.target).attr('id');

                if (!id) {
                  id = Util.getUID(NAME);
                  $$$1(config.target).attr('id', id);
                }

                config.target = "#" + id;
              }

              Util.typeCheckConfig(NAME, config, DefaultType);
              return config;
            };

            _proto._getScrollTop = function _getScrollTop() {
              return this._scrollElement === window ? this._scrollElement.pageYOffset : this._scrollElement.scrollTop;
            };

            _proto._getScrollHeight = function _getScrollHeight() {
              return this._scrollElement.scrollHeight || Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
            };

            _proto._getOffsetHeight = function _getOffsetHeight() {
              return this._scrollElement === window ? window.innerHeight : this._scrollElement.getBoundingClientRect().height;
            };

            _proto._process = function _process() {
              var scrollTop = this._getScrollTop() + this._config.offset;

              var scrollHeight = this._getScrollHeight();

              var maxScroll = this._config.offset + scrollHeight - this._getOffsetHeight();

              if (this._scrollHeight !== scrollHeight) {
                this.refresh();
              }

              if (scrollTop >= maxScroll) {
                var target = this._targets[this._targets.length - 1];

                if (this._activeTarget !== target) {
                  this._activate(target);
                }

                return;
              }

              if (this._activeTarget && scrollTop < this._offsets[0] && this._offsets[0] > 0) {
                this._activeTarget = null;

                this._clear();

                return;
              }

              for (var i = this._offsets.length; i--;) {
                var isActiveTarget = this._activeTarget !==
                                     this._targets[i] &&
                                     scrollTop >=
                                     this._offsets[i] &&
                                     (typeof this._offsets[i + 1] === 'undefined' || scrollTop < this._offsets[i + 1]);

                if (isActiveTarget) {
                  this._activate(this._targets[i]);
                }
              }
            };

            _proto._activate = function _activate(target) {
              this._activeTarget = target;

              this._clear();

              var queries = this._selector.split(','); // eslint-disable-next-line arrow-body-style


              queries   = queries.map(function(selector) {
                return selector + "[data-target=\"" + target + "\"]," + (selector + "[href=\"" + target + "\"]");
              });
              var $link = $$$1(queries.join(','));

              if ($link.hasClass(ClassName.DROPDOWN_ITEM)) {
                $link.closest(Selector.DROPDOWN).find(Selector.DROPDOWN_TOGGLE).addClass(ClassName.ACTIVE);
                $link.addClass(ClassName.ACTIVE);
              }
              else {
                // Set triggered link as active
                $link.addClass(ClassName.ACTIVE); // Set triggered links parents as active
                // With both <ul> and <nav> markup a parent is the previous sibling of any nav ancestor

                $link.parents(Selector.NAV_LIST_GROUP).prev(Selector.NAV_LINKS + ", " + Selector.LIST_ITEMS).addClass(ClassName.ACTIVE); // Handle
                                                                                                                                         // special
                                                                                                                                         // case when
                                                                                                                                         // .nav-link
                                                                                                                                         // is inside
                                                                                                                                         // .nav-item

                $link.parents(Selector.NAV_LIST_GROUP).prev(Selector.NAV_ITEMS).children(Selector.NAV_LINKS).addClass(ClassName.ACTIVE);
              }

              $$$1(this._scrollElement).trigger(Event.ACTIVATE, {
                relatedTarget: target
              });
            };

            _proto._clear = function _clear() {
              $$$1(this._selector).filter(Selector.ACTIVE).removeClass(ClassName.ACTIVE);
            }; // Static


            ScrollSpy._jQueryInterface = function _jQueryInterface(config) {
              return this.each(function() {
                var data = $$$1(this).data(DATA_KEY);

                var _config = typeof config === 'object' && config;

                if (!data) {
                  data = new ScrollSpy(this, _config);
                  $$$1(this).data(DATA_KEY, data);
                }

                if (typeof config === 'string') {
                  if (typeof data[config] === 'undefined') {
                    throw new TypeError("No method named \"" + config + "\"");
                  }

                  data[config]();
                }
              });
            };

            _createClass(ScrollSpy, null, [{
              key: "VERSION",
              get: function get() {
                return VERSION;
              }
            }, {
              key: "Default",
              get: function get() {
                return Default;
              }
            }
            ]);
            return ScrollSpy;
          }();
    /**
     * ------------------------------------------------------------------------
     * Data Api implementation
     * ------------------------------------------------------------------------
     */


    $$$1(window).on(Event.LOAD_DATA_API, function() {
      var scrollSpys = $$$1.makeArray($$$1(Selector.DATA_SPY));

      for (var i = scrollSpys.length; i--;) {
        var $spy = $$$1(scrollSpys[i]);

        ScrollSpy._jQueryInterface.call($spy, $spy.data());
      }
    });
    /**
     * ------------------------------------------------------------------------
     * jQuery
     * ------------------------------------------------------------------------
     */

    $$$1.fn[NAME] = ScrollSpy._jQueryInterface;
    $$$1.fn[NAME].Constructor = ScrollSpy;

    $$$1.fn[NAME].noConflict = function() {
      $$$1.fn[NAME] = JQUERY_NO_CONFLICT;
      return ScrollSpy._jQueryInterface;
    };

    return ScrollSpy;
  }($);

  /**
   * --------------------------------------------------------------------------
   * Bootstrap (v4.0.0): tab.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
   * --------------------------------------------------------------------------
   */

  var Tab = function($$$1) {
    /**
     * ------------------------------------------------------------------------
     * Constants
     * ------------------------------------------------------------------------
     */
    var NAME                = 'tab';
    var VERSION             = '4.0.0';
    var DATA_KEY            = 'bs.tab';
    var EVENT_KEY           = "." + DATA_KEY;
    var DATA_API_KEY        = '.data-api';
    var JQUERY_NO_CONFLICT  = $$$1.fn[NAME];
    var TRANSITION_DURATION = 150;
    var Event               = {
      HIDE          : "hide" + EVENT_KEY,
      HIDDEN        : "hidden" + EVENT_KEY,
      SHOW          : "show" + EVENT_KEY,
      SHOWN         : "shown" + EVENT_KEY,
      CLICK_DATA_API: "click" + EVENT_KEY + DATA_API_KEY
    };
    var ClassName           = {
      DROPDOWN_MENU: 'dropdown-menu',
      ACTIVE       : 'active',
      DISABLED     : 'disabled',
      FADE         : 'fade',
      SHOW         : 'show'
    };
    var Selector            = {
      DROPDOWN             : '.dropdown',
      NAV_LIST_GROUP       : '.nav, .list-group',
      ACTIVE               : '.active',
      ACTIVE_UL            : '> li > .active',
      DATA_TOGGLE          : '[data-toggle="tab"], [data-toggle="pill"], [data-toggle="list"]',
      DROPDOWN_TOGGLE      : '.dropdown-toggle',
      DROPDOWN_ACTIVE_CHILD: '> .dropdown-menu .active'
      /**
       * ------------------------------------------------------------------------
       * Class Definition
       * ------------------------------------------------------------------------
       */

    };

    var Tab =
          /*#__PURE__*/
          function() {
            function Tab(element)
            {
              this._element = element;
            } // Getters


            var _proto = Tab.prototype;

            // Public
            _proto.show = function show() {
              var _this = this;

              if (this._element.parentNode &&
                  this._element.parentNode.nodeType ===
                  Node.ELEMENT_NODE &&
                  $$$1(this._element).hasClass(ClassName.ACTIVE) ||
                  $$$1(this._element).hasClass(ClassName.DISABLED)) {
                return;
              }

              var target;
              var previous;
              var listElement = $$$1(this._element).closest(Selector.NAV_LIST_GROUP)[0];
              var selector    = Util.getSelectorFromElement(this._element);

              if (listElement) {
                var itemSelector = listElement.nodeName === 'UL' ? Selector.ACTIVE_UL : Selector.ACTIVE;
                previous         = $$$1.makeArray($$$1(listElement).find(itemSelector));
                previous         = previous[previous.length - 1];
              }

              var hideEvent = $$$1.Event(Event.HIDE, {
                relatedTarget: this._element
              });
              var showEvent = $$$1.Event(Event.SHOW, {
                relatedTarget: previous
              });

              if (previous) {
                $$$1(previous).trigger(hideEvent);
              }

              $$$1(this._element).trigger(showEvent);

              if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented()) {
                return;
              }

              if (selector) {
                target = $$$1(selector)[0];
              }

              this._activate(this._element, listElement);

              var complete = function complete() {
                var hiddenEvent = $$$1.Event(Event.HIDDEN, {
                  relatedTarget: _this._element
                });
                var shownEvent  = $$$1.Event(Event.SHOWN, {
                  relatedTarget: previous
                });
                $$$1(previous).trigger(hiddenEvent);
                $$$1(_this._element).trigger(shownEvent);
              };

              if (target) {
                this._activate(target, target.parentNode, complete);
              }
              else {
                complete();
              }
            };

            _proto.dispose = function dispose() {
              $$$1.removeData(this._element, DATA_KEY);
              this._element = null;
            }; // Private


            _proto._activate = function _activate(element, container, callback) {
              var _this2 = this;

              var activeElements;

              if (container.nodeName === 'UL') {
                activeElements = $$$1(container).find(Selector.ACTIVE_UL);
              }
              else {
                activeElements = $$$1(container).children(Selector.ACTIVE);
              }

              var active          = activeElements[0];
              var isTransitioning = callback && Util.supportsTransitionEnd() && active && $$$1(active).hasClass(ClassName.FADE);

              var complete = function complete() {
                return _this2._transitionComplete(element, active, callback);
              };

              if (active && isTransitioning) {
                $$$1(active).one(Util.TRANSITION_END, complete).emulateTransitionEnd(TRANSITION_DURATION);
              }
              else {
                complete();
              }
            };

            _proto._transitionComplete = function _transitionComplete(element, active, callback) {
              if (active) {
                $$$1(active).removeClass(ClassName.SHOW + " " + ClassName.ACTIVE);
                var dropdownChild = $$$1(active.parentNode).find(Selector.DROPDOWN_ACTIVE_CHILD)[0];

                if (dropdownChild) {
                  $$$1(dropdownChild).removeClass(ClassName.ACTIVE);
                }

                if (active.getAttribute('role') === 'tab') {
                  active.setAttribute('aria-selected', false);
                }
              }

              $$$1(element).addClass(ClassName.ACTIVE);

              if (element.getAttribute('role') === 'tab') {
                element.setAttribute('aria-selected', true);
              }

              Util.reflow(element);
              $$$1(element).addClass(ClassName.SHOW);

              if (element.parentNode && $$$1(element.parentNode).hasClass(ClassName.DROPDOWN_MENU)) {
                var dropdownElement = $$$1(element).closest(Selector.DROPDOWN)[0];

                if (dropdownElement) {
                  $$$1(dropdownElement).find(Selector.DROPDOWN_TOGGLE).addClass(ClassName.ACTIVE);
                }

                element.setAttribute('aria-expanded', true);
              }

              if (callback) {
                callback();
              }
            }; // Static


            Tab._jQueryInterface = function _jQueryInterface(config) {
              return this.each(function() {
                var $this = $$$1(this);
                var data  = $this.data(DATA_KEY);

                if (!data) {
                  data = new Tab(this);
                  $this.data(DATA_KEY, data);
                }

                if (typeof config === 'string') {
                  if (typeof data[config] === 'undefined') {
                    throw new TypeError("No method named \"" + config + "\"");
                  }

                  data[config]();
                }
              });
            };

            _createClass(Tab, null, [{
              key: "VERSION",
              get: function get() {
                return VERSION;
              }
            }
            ]);
            return Tab;
          }();
    /**
     * ------------------------------------------------------------------------
     * Data Api implementation
     * ------------------------------------------------------------------------
     */


    $$$1(document).on(Event.CLICK_DATA_API, Selector.DATA_TOGGLE, function(event) {
      event.preventDefault();

      Tab._jQueryInterface.call($$$1(this), 'show');
    });
    /**
     * ------------------------------------------------------------------------
     * jQuery
     * ------------------------------------------------------------------------
     */

    $$$1.fn[NAME] = Tab._jQueryInterface;
    $$$1.fn[NAME].Constructor = Tab;

    $$$1.fn[NAME].noConflict = function() {
      $$$1.fn[NAME] = JQUERY_NO_CONFLICT;
      return Tab._jQueryInterface;
    };

    return Tab;
  }($);

  /**
   * --------------------------------------------------------------------------
   * Bootstrap (v4.0.0-alpha.6): index.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
   * --------------------------------------------------------------------------
   */

  (function($$$1) {
    if (typeof $$$1 === 'undefined') {
      throw new TypeError('Bootstrap\'s JavaScript requires jQuery. jQuery must be included before Bootstrap\'s JavaScript.');
    }

    var version  = $$$1.fn.jquery.split(' ')[0].split('.');
    var minMajor = 1;
    var ltMajor  = 2;
    var minMinor = 9;
    var minPatch = 1;
    var maxMajor = 4;

    if (version[0] <
        ltMajor &&
        version[1] <
        minMinor ||
        version[0] ===
        minMajor &&
        version[1] ===
        minMinor &&
        version[2] <
        minPatch ||
        version[0] >=
        maxMajor) {
      throw new Error('Bootstrap\'s JavaScript requires at least jQuery v1.9.1 but less than v4.0.0');
    }
  })($);

  exports.Util      = Util;
  exports.Alert     = Alert;
  exports.Button    = Button;
  exports.Carousel  = Carousel;
  exports.Collapse  = Collapse;
  exports.Dropdown  = Dropdown;
  exports.Modal     = Modal;
  exports.Popover   = Popover;
  exports.Scrollspy = ScrollSpy;
  exports.Tab       = Tab;
  exports.Tooltip   = Tooltip;

  Object.defineProperty(exports, '__esModule', {value: true});

})));
// placing this here because locally bootstrap_customizations doesn't load fast enough (can be removed with no change on production)
// $.fn.dropdown.Constructor.Default.boundary = "none";
// $.fn.dropdown.Constructor.Default.flip     = false;
//# sourceMappingURL=bootstrap.js.map

/* resources/assets/js/libraries/bootstrap-select-bs-v4.js */
(function ($) {
  'use strict';

  var DISALLOWED_ATTRIBUTES = ['sanitize', 'whiteList', 'sanitizeFn'];

  var uriAttrs = [
    'background',
    'cite',
    'href',
    'itemtype',
    'longdesc',
    'poster',
    'src',
    'xlink:href'
  ];

  var ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;

  var DefaultWhitelist = {
    // Global attributes allowed on any supplied element below.
    '*': ['class', 'dir', 'id', 'lang', 'role', 'tabindex', 'style', ARIA_ATTRIBUTE_PATTERN],
    a: ['target', 'href', 'title', 'rel'],
    area: [],
    b: [],
    br: [],
    col: [],
    code: [],
    div: [],
    em: [],
    hr: [],
    h1: [],
    h2: [],
    h3: [],
    h4: [],
    h5: [],
    h6: [],
    i: [],
    img: ['src', 'alt', 'title', 'width', 'height'],
    li: [],
    ol: [],
    p: [],
    pre: [],
    s: [],
    small: [],
    span: [],
    sub: [],
    sup: [],
    strong: [],
    u: [],
    ul: []
  }

  /**
   * A pattern that recognizes a commonly useful subset of URLs that are safe.
   *
   * Shoutout to Angular 7 https://github.com/angular/angular/blob/7.2.4/packages/core/src/sanitization/url_sanitizer.ts
   */
  var SAFE_URL_PATTERN = /^(?:(?:https?|mailto|ftp|tel|file):|[^&:/?#]*(?:[/?#]|$))/gi;

  /**
   * A pattern that matches safe data URLs. Only matches image, video and audio types.
   *
   * Shoutout to Angular 7 https://github.com/angular/angular/blob/7.2.4/packages/core/src/sanitization/url_sanitizer.ts
   */
  var DATA_URL_PATTERN = /^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[a-z0-9+/]+=*$/i;

  function allowedAttribute (attr, allowedAttributeList) {
    var attrName = attr.nodeName.toLowerCase()

    if ($.inArray(attrName, allowedAttributeList) !== -1) {
      if ($.inArray(attrName, uriAttrs) !== -1) {
        return Boolean(attr.nodeValue.match(SAFE_URL_PATTERN) || attr.nodeValue.match(DATA_URL_PATTERN))
      }

      return true
    }

    var regExp = $(allowedAttributeList).filter(function (index, value) {
      return value instanceof RegExp
    })

    // Check if a regular expression validates the attribute.
    for (var i = 0, l = regExp.length; i < l; i++) {
      if (attrName.match(regExp[i])) {
        return true
      }
    }

    return false
  }

  function sanitizeHtml (unsafeElements, whiteList, sanitizeFn) {
    if (sanitizeFn && typeof sanitizeFn === 'function') {
      return sanitizeFn(unsafeElements);
    }

    var whitelistKeys = Object.keys(whiteList);

    for (var i = 0, len = unsafeElements.length; i < len; i++) {
      var elements = unsafeElements[i].querySelectorAll('*');

      for (var j = 0, len2 = elements.length; j < len2; j++) {
        var el = elements[j];
        var elName = el.nodeName.toLowerCase();

        if (whitelistKeys.indexOf(elName) === -1) {
          el.parentNode.removeChild(el);

          continue;
        }

        var attributeList = [].slice.call(el.attributes);
        var whitelistedAttributes = [].concat(whiteList['*'] || [], whiteList[elName] || []);

        for (var k = 0, len3 = attributeList.length; k < len3; k++) {
          var attr = attributeList[k];

          if (!allowedAttribute(attr, whitelistedAttributes)) {
            el.removeAttribute(attr.nodeName);
          }
        }
      }
    }
  }

  // Polyfill for browsers with no classList support
  // Remove in v2
  if (!('classList' in document.createElement('_'))) {
    (function (view) {
      if (!('Element' in view)) return;

      var classListProp = 'classList',
          protoProp = 'prototype',
          elemCtrProto = view.Element[protoProp],
          objCtr = Object,
          classListGetter = function () {
            var $elem = $(this);

            return {
              add: function (classes) {
                classes = Array.prototype.slice.call(arguments).join(' ');
                return $elem.addClass(classes);
              },
              remove: function (classes) {
                classes = Array.prototype.slice.call(arguments).join(' ');
                return $elem.removeClass(classes);
              },
              toggle: function (classes, force) {
                return $elem.toggleClass(classes, force);
              },
              contains: function (classes) {
                return $elem.hasClass(classes);
              }
            }
          };

      if (objCtr.defineProperty) {
        var classListPropDesc = {
          get: classListGetter,
          enumerable: true,
          configurable: true
        };
        try {
          objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
        } catch (ex) { // IE 8 doesn't support enumerable:true
          // adding undefined to fight this issue https://github.com/eligrey/classList.js/issues/36
          // modernie IE8-MSW7 machine has IE8 8.0.6001.18702 and is affected
          if (ex.number === undefined || ex.number === -0x7FF5EC54) {
            classListPropDesc.enumerable = false;
            objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
          }
        }
      } else if (objCtr[protoProp].__defineGetter__) {
        elemCtrProto.__defineGetter__(classListProp, classListGetter);
      }
    }(window));
  }

  var testElement = document.createElement('_');

  testElement.classList.add('c1', 'c2');

  if (!testElement.classList.contains('c2')) {
    var _add = DOMTokenList.prototype.add,
        _remove = DOMTokenList.prototype.remove;

    DOMTokenList.prototype.add = function () {
      Array.prototype.forEach.call(arguments, _add.bind(this));
    }

    DOMTokenList.prototype.remove = function () {
      Array.prototype.forEach.call(arguments, _remove.bind(this));
    }
  }

  testElement.classList.toggle('c3', false);

  // Polyfill for IE 10 and Firefox <24, where classList.toggle does not
  // support the second argument.
  if (testElement.classList.contains('c3')) {
    var _toggle = DOMTokenList.prototype.toggle;

    DOMTokenList.prototype.toggle = function (token, force) {
      if (1 in arguments && !this.contains(token) === !force) {
        return force;
      } else {
        return _toggle.call(this, token);
      }
    };
  }

  testElement = null;

  // shallow array comparison
  function isEqual (array1, array2) {
    return array1.length === array2.length && array1.every(function (element, index) {
      return element === array2[index];
    });
  };

  // <editor-fold desc="Shims">
  if (!String.prototype.startsWith) {
    (function () {
      'use strict'; // needed to support `apply`/`call` with `undefined`/`null`
      var defineProperty = (function () {
        // IE 8 only supports `Object.defineProperty` on DOM elements
        try {
          var object = {};
          var $defineProperty = Object.defineProperty;
          var result = $defineProperty(object, object, object) && $defineProperty;
        } catch (error) {
        }
        return result;
      }());
      var toString = {}.toString;
      var startsWith = function (search) {
        if (this == null) {
          throw new TypeError();
        }
        var string = String(this);
        if (search && toString.call(search) == '[object RegExp]') {
          throw new TypeError();
        }
        var stringLength = string.length;
        var searchString = String(search);
        var searchLength = searchString.length;
        var position = arguments.length > 1 ? arguments[1] : undefined;
        // `ToInteger`
        var pos = position ? Number(position) : 0;
        if (pos != pos) { // better `isNaN`
          pos = 0;
        }
        var start = Math.min(Math.max(pos, 0), stringLength);
        // Avoid the `indexOf` call if no match is possible
        if (searchLength + start > stringLength) {
          return false;
        }
        var index = -1;
        while (++index < searchLength) {
          if (string.charCodeAt(start + index) != searchString.charCodeAt(index)) {
            return false;
          }
        }
        return true;
      };
      if (defineProperty) {
        defineProperty(String.prototype, 'startsWith', {
          'value': startsWith,
          'configurable': true,
          'writable': true
        });
      } else {
        String.prototype.startsWith = startsWith;
      }
    }());
  }

  if (!Object.keys) {
    Object.keys = function (
      o, // object
      k, // key
      r  // result array
    ) {
      // initialize object and result
      r = [];
      // iterate over object keys
      for (k in o) {
        // fill result array with non-prototypical keys
        r.hasOwnProperty.call(o, k) && r.push(k);
      }
      // return result
      return r;
    };
  }

  if (HTMLSelectElement && !HTMLSelectElement.prototype.hasOwnProperty('selectedOptions')) {
    Object.defineProperty(HTMLSelectElement.prototype, 'selectedOptions', {
      get: function () {
        return this.querySelectorAll(':checked');
      }
    });
  }

  // much faster than $.val()
  function getSelectValues (select) {
    var result = [];
    var options = select.selectedOptions;
    var opt;

    if (select.multiple) {
      for (var i = 0, len = options.length; i < len; i++) {
        opt = options[i];

        result.push(opt.value || opt.text);
      }
    } else {
      result = select.value;
    }

    return result;
  }

  // set data-selected on select element if the value has been programmatically selected
  // prior to initialization of bootstrap-select
  // * consider removing or replacing an alternative method *
  var valHooks = {
    useDefault: false,
    _set: $.valHooks.select.set
  };

  $.valHooks.select.set = function (elem, value) {
    if (value && !valHooks.useDefault) $(elem).data('selected', true);

    return valHooks._set.apply(this, arguments);
  };

  var changedArguments = null;

  var EventIsSupported = (function () {
    try {
      new Event('change');
      return true;
    } catch (e) {
      return false;
    }
  })();

  $.fn.triggerNative = function (eventName) {
    var el = this[0],
        event;

    if (el.dispatchEvent) { // for modern browsers & IE9+
      if (EventIsSupported) {
        // For modern browsers
        event = new Event(eventName, {
          bubbles: true
        });
      } else {
        // For IE since it doesn't support Event constructor
        event = document.createEvent('Event');
        event.initEvent(eventName, true, false);
      }

      el.dispatchEvent(event);
    } else if (el.fireEvent) { // for IE8
      event = document.createEventObject();
      event.eventType = eventName;
      el.fireEvent('on' + eventName, event);
    } else {
      // fall back to jQuery.trigger
      this.trigger(eventName);
    }
  };
  // </editor-fold>

  function stringSearch (li, searchString, method, normalize) {
    var stringTypes = [
          'display',
          'subtext',
          'tokens'
        ],
        searchSuccess = false;

    for (var i = 0; i < stringTypes.length; i++) {
      var stringType = stringTypes[i],
          string = li[stringType];

      if (string) {
        string = string.toString();

        // Strip HTML tags. This isn't perfect, but it's much faster than any other method
        if (stringType === 'display') {
          string = string.replace(/<[^>]+>/g, '');
        }

        if (normalize) string = normalizeToBase(string);
        string = string.toUpperCase();

        if (method === 'contains') {
          searchSuccess = string.indexOf(searchString) >= 0;
        } else {
          searchSuccess = string.startsWith(searchString);
        }

        if (searchSuccess) break;
      }
    }

    return searchSuccess;
  }

  function toInteger (value) {
    return parseInt(value, 10) || 0;
  }

  // Borrowed from Lodash (_.deburr)
  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to compose unicode character classes. */
  var rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboMarksExtendedRange = '\\u1ab0-\\u1aff',
      rsComboMarksSupplementRange = '\\u1dc0-\\u1dff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange + rsComboMarksExtendedRange + rsComboMarksSupplementRange;

  /** Used to compose unicode capture groups. */
  var rsCombo = '[' + rsComboRange + ']';

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  function deburrLetter (key) {
    return deburredLetters[key];
  };

  function normalizeToBase (string) {
    string = string.toString();
    return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
  }

  // List of HTML entities for escaping.
  var escapeMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '`': '&#x60;'
  };

  // Functions for escaping and unescaping strings to/from HTML interpolation.
  var createEscaper = function (map) {
    var escaper = function (match) {
      return map[match];
    };
    // Regexes for identifying a key that needs to be escaped.
    var source = '(?:' + Object.keys(map).join('|') + ')';
    var testRegexp = RegExp(source);
    var replaceRegexp = RegExp(source, 'g');
    return function (string) {
      string = string == null ? '' : '' + string;
      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
    };
  };

  var htmlEscape = createEscaper(escapeMap);

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var keyCodeMap = {
    32: ' ',
    48: '0',
    49: '1',
    50: '2',
    51: '3',
    52: '4',
    53: '5',
    54: '6',
    55: '7',
    56: '8',
    57: '9',
    59: ';',
    65: 'A',
    66: 'B',
    67: 'C',
    68: 'D',
    69: 'E',
    70: 'F',
    71: 'G',
    72: 'H',
    73: 'I',
    74: 'J',
    75: 'K',
    76: 'L',
    77: 'M',
    78: 'N',
    79: 'O',
    80: 'P',
    81: 'Q',
    82: 'R',
    83: 'S',
    84: 'T',
    85: 'U',
    86: 'V',
    87: 'W',
    88: 'X',
    89: 'Y',
    90: 'Z',
    96: '0',
    97: '1',
    98: '2',
    99: '3',
    100: '4',
    101: '5',
    102: '6',
    103: '7',
    104: '8',
    105: '9'
  };

  var keyCodes = {
    ESCAPE: 27, // KeyboardEvent.which value for Escape (Esc) key
    ENTER: 13, // KeyboardEvent.which value for Enter key
    SPACE: 32, // KeyboardEvent.which value for space key
    TAB: 9, // KeyboardEvent.which value for tab key
    ARROW_UP: 38, // KeyboardEvent.which value for up arrow key
    ARROW_DOWN: 40 // KeyboardEvent.which value for down arrow key
  }

  var version = {
    success: false,
    major: '3'
  };

  try {
    version.full = ($.fn.dropdown.Constructor.VERSION || '').split(' ')[0].split('.');
    version.major = version.full[0];
    version.success = true;
  } catch (err) {
    // do nothing
  }

  var selectId = 0;

  var EVENT_KEY = '.bs.select';

  var classNames = {
    DISABLED: 'disabled',
    DIVIDER: 'divider',
    SHOW: 'open',
    DROPUP: 'dropup',
    MENU: 'dropdown-menu',
    MENURIGHT: 'dropdown-menu-right',
    MENULEFT: 'dropdown-menu-left',
    // to-do: replace with more advanced template/customization options
    BUTTONCLASS: 'btn-default',
    POPOVERHEADER: 'popover-title',
    ICONBASE: 'glyphicon',
    TICKICON: 'glyphicon-ok'
  }

  var Selector = {
    MENU: '.' + classNames.MENU
  }

  var elementTemplates = {
    span: document.createElement('span'),
    i: document.createElement('i'),
    subtext: document.createElement('small'),
    a: document.createElement('a'),
    li: document.createElement('li'),
    whitespace: document.createTextNode('\u00A0'),
    fragment: document.createDocumentFragment()
  }

  elementTemplates.a.setAttribute('role', 'option');
  elementTemplates.subtext.className = 'text-muted';

  elementTemplates.text = elementTemplates.span.cloneNode(false);
  elementTemplates.text.className = 'text';

  elementTemplates.checkMark = elementTemplates.span.cloneNode(false);

  var REGEXP_ARROW = new RegExp(keyCodes.ARROW_UP + '|' + keyCodes.ARROW_DOWN);
  var REGEXP_TAB_OR_ESCAPE = new RegExp('^' + keyCodes.TAB + '$|' + keyCodes.ESCAPE);

  var generateOption = {
    li: function (content, classes, optgroup) {
      var li = elementTemplates.li.cloneNode(false);

      if (content) {
        if (content.nodeType === 1 || content.nodeType === 11) {
          li.appendChild(content);
        } else {
          li.innerHTML = content;
        }
      }

      if (typeof classes !== 'undefined' && classes !== '') li.className = classes;
      if (typeof optgroup !== 'undefined' && optgroup !== null) li.classList.add('optgroup-' + optgroup);

      return li;
    },

    a: function (text, classes, inline) {
      var a = elementTemplates.a.cloneNode(true);

      if (text) {
        if (text.nodeType === 11) {
          a.appendChild(text);
        } else {
          a.insertAdjacentHTML('beforeend', text);
        }
      }

      if (typeof classes !== 'undefined' && classes !== '') a.className = classes;
      if (version.major === '4') a.classList.add('dropdown-item');
      if (inline) a.setAttribute('style', inline);

      return a;
    },

    text: function (options, useFragment) {
      var textElement = elementTemplates.text.cloneNode(false),
          subtextElement,
          iconElement;

      if (options.content) {
        textElement.innerHTML = options.content;
      } else {
        textElement.textContent = options.text;

        if (options.icon) {
          var whitespace = elementTemplates.whitespace.cloneNode(false);

          // need to use <i> for icons in the button to prevent a breaking change
          // note: switch to span in next major release
          iconElement = (useFragment === true ? elementTemplates.i : elementTemplates.span).cloneNode(false);
          iconElement.className = options.iconBase + ' ' + options.icon;

          elementTemplates.fragment.appendChild(iconElement);
          elementTemplates.fragment.appendChild(whitespace);
        }

        if (options.subtext) {
          subtextElement = elementTemplates.subtext.cloneNode(false);
          subtextElement.textContent = options.subtext;
          textElement.appendChild(subtextElement);
        }
      }

      if (useFragment === true) {
        while (textElement.childNodes.length > 0) {
          elementTemplates.fragment.appendChild(textElement.childNodes[0]);
        }
      } else {
        elementTemplates.fragment.appendChild(textElement);
      }

      return elementTemplates.fragment;
    },

    label: function (options) {
      var textElement = elementTemplates.text.cloneNode(false),
          subtextElement,
          iconElement;

      textElement.innerHTML = options.label;

      if (options.icon) {
        var whitespace = elementTemplates.whitespace.cloneNode(false);

        iconElement = elementTemplates.span.cloneNode(false);
        iconElement.className = options.iconBase + ' ' + options.icon;

        elementTemplates.fragment.appendChild(iconElement);
        elementTemplates.fragment.appendChild(whitespace);
      }

      if (options.subtext) {
        subtextElement = elementTemplates.subtext.cloneNode(false);
        subtextElement.textContent = options.subtext;
        textElement.appendChild(subtextElement);
      }

      elementTemplates.fragment.appendChild(textElement);

      return elementTemplates.fragment;
    }
  }

  var Selectpicker = function (element, options) {
    var that = this;

    // bootstrap-select has been initialized - revert valHooks.select.set back to its original function
    if (!valHooks.useDefault) {
      $.valHooks.select.set = valHooks._set;
      valHooks.useDefault = true;
    }

    this.$element = $(element);
    this.$newElement = null;
    this.$button = null;
    this.$menu = null;
    this.options = options;
    this.selectpicker = {
      main: {},
      current: {}, // current changes if a search is in progress
      search: {},
      view: {},
      keydown: {
        keyHistory: '',
        resetKeyHistory: {
          start: function () {
            return setTimeout(function () {
              that.selectpicker.keydown.keyHistory = '';
            }, 800);
          }
        }
      }
    };
    // If we have no title yet, try to pull it from the html title attribute (jQuery doesnt' pick it up as it's not a
    // data-attribute)
    if (this.options.title === null) {
      this.options.title = this.$element.attr('title');
    }

    // Format window padding
    var winPad = this.options.windowPadding;
    if (typeof winPad === 'number') {
      this.options.windowPadding = [winPad, winPad, winPad, winPad];
    }

    // Expose public methods
    this.val = Selectpicker.prototype.val;
    this.render = Selectpicker.prototype.render;
    this.refresh = Selectpicker.prototype.refresh;
    this.setStyle = Selectpicker.prototype.setStyle;
    this.selectAll = Selectpicker.prototype.selectAll;
    this.deselectAll = Selectpicker.prototype.deselectAll;
    this.destroy = Selectpicker.prototype.destroy;
    this.remove = Selectpicker.prototype.remove;
    this.show = Selectpicker.prototype.show;
    this.hide = Selectpicker.prototype.hide;

    this.init();
  };

  Selectpicker.VERSION = '1.13.9';

  // part of this is duplicated in i18n/defaults-en_US.js. Make sure to update both.
  Selectpicker.DEFAULTS = {
    noneSelectedText: 'Nothing selected',
    noneResultsText: 'No results matched {0}',
    countSelectedText: function (numSelected, numTotal) {
      return (numSelected == 1) ? '{0} item selected' : '{0} items selected';
    },
    maxOptionsText: function (numAll, numGroup) {
      return [
        (numAll == 1) ? 'Limit reached ({n} item max)' : 'Limit reached ({n} items max)',
        (numGroup == 1) ? 'Group limit reached ({n} item max)' : 'Group limit reached ({n} items max)'
      ];
    },
    selectAllText: 'Select All',
    deselectAllText: 'Deselect All',
    doneButton: false,
    doneButtonText: 'Close',
    multipleSeparator: ', ',
    styleBase: 'btn',
    style: classNames.BUTTONCLASS,
    size: 'auto',
    title: null,
    selectedTextFormat: 'values',
    width: false,
    container: false,
    hideDisabled: false,
    showSubtext: false,
    showIcon: true,
    showContent: true,
    dropupAuto: true,
    header: false,
    liveSearch: false,
    liveSearchPlaceholder: null,
    liveSearchNormalize: false,
    liveSearchStyle: 'contains',
    actionsBox: false,
    iconBase: classNames.ICONBASE,
    tickIcon: classNames.TICKICON,
    showTick: false,
    template: {
      caret: '<span class="caret"></span>'
    },
    maxOptions: false,
    mobile: false,
    selectOnTab: false,
    dropdownAlignRight: false,
    windowPadding: 0,
    virtualScroll: 600,
    display: false,
    sanitize: true,
    sanitizeFn: null,
    whiteList: DefaultWhitelist
  };

  Selectpicker.prototype = {

    constructor: Selectpicker,

    init: function () {
      var that = this,
          id = this.$element.attr('id');

      this.selectId = selectId++;

      this.$element[0].classList.add('bs-select-hidden');

      this.multiple = this.$element.prop('multiple');
      this.autofocus = this.$element.prop('autofocus');
      this.options.showTick = this.$element[0].classList.contains('show-tick');

      this.$newElement = this.createDropdown();
      this.$element
        .after(this.$newElement)
        .prependTo(this.$newElement);

      this.$button = this.$newElement.children('button');
      this.$menu = this.$newElement.children(Selector.MENU);
      this.$menuInner = this.$menu.children('.inner');
      this.$searchbox = this.$menu.find('input');

      this.$element[0].classList.remove('bs-select-hidden');

      if (this.options.dropdownAlignRight === true) this.$menu[0].classList.add(classNames.MENURIGHT);

      if (typeof id !== 'undefined') {
        this.$button.attr('data-id', id);
      }

      this.checkDisabled();
      this.clickListener();
      if (this.options.liveSearch) this.liveSearchListener();
      this.setStyle();
      this.render();
      this.setWidth();
      if (this.options.container) {
        this.selectPosition();
      } else {
        this.$element.on('hide' + EVENT_KEY, function () {
          if (that.isVirtual()) {
            // empty menu on close
            var menuInner = that.$menuInner[0],
                emptyMenu = menuInner.firstChild.cloneNode(false);

            // replace the existing UL with an empty one - this is faster than $.empty() or innerHTML = ''
            menuInner.replaceChild(emptyMenu, menuInner.firstChild);
            menuInner.scrollTop = 0;
          }
        });
      }
      this.$menu.data('this', this);
      this.$newElement.data('this', this);
      if (this.options.mobile) this.mobile();

      this.$newElement.on({
        'hide.bs.dropdown': function (e) {
          that.$menuInner.attr('aria-expanded', false);
          that.$element.trigger('hide' + EVENT_KEY, e);
        },
        'hidden.bs.dropdown': function (e) {
          that.$element.trigger('hidden' + EVENT_KEY, e);
        },
        'show.bs.dropdown': function (e) {
          that.$menuInner.attr('aria-expanded', true);
          that.$element.trigger('show' + EVENT_KEY, e);
        },
        'shown.bs.dropdown': function (e) {
          that.$element.trigger('shown' + EVENT_KEY, e);
        }
      });

      if (that.$element[0].hasAttribute('required')) {
        this.$element.on('invalid' + EVENT_KEY, function () {
          that.$button[0].classList.add('bs-invalid');

          that.$element
            .on('shown' + EVENT_KEY + '.invalid', function () {
              that.$element
                .val(that.$element.val()) // set the value to hide the validation message in Chrome when menu is opened
                .off('shown' + EVENT_KEY + '.invalid');
            })
            .on('rendered' + EVENT_KEY, function () {
              // if select is no longer invalid, remove the bs-invalid class
              if (this.validity.valid) that.$button[0].classList.remove('bs-invalid');
              that.$element.off('rendered' + EVENT_KEY);
            });

          that.$button.on('blur' + EVENT_KEY, function () {
            that.$element.trigger('focus').trigger('blur');
            that.$button.off('blur' + EVENT_KEY);
          });
        });
      }

      setTimeout(function () {
        that.createLi();
        that.$element.trigger('loaded' + EVENT_KEY);
      });
    },

    createDropdown: function () {
      // Options
      // If we are multiple or showTick option is set, then add the show-tick class
      var showTick = (this.multiple || this.options.showTick) ? ' show-tick' : '',
          inputGroup = '',
          autofocus = this.autofocus ? ' autofocus' : '';

      if (version.major < 4 && this.$element.parent().hasClass('input-group')) {
        inputGroup = ' input-group-btn';
      }

      // Elements
      var drop,
          header = '',
          searchbox = '',
          actionsbox = '',
          donebutton = '';

      if (this.options.header) {
        header =
          '<div class="' + classNames.POPOVERHEADER + '">' +
            '<button type="button" class="close" aria-hidden="true">&times;</button>' +
              this.options.header +
          '</div>';
      }

      if (this.options.liveSearch) {
        searchbox =
          '<div class="bs-searchbox">' +
            '<input type="text" class="form-control" autocomplete="off"' +
              (
                this.options.liveSearchPlaceholder === null ? ''
                :
                ' placeholder="' + htmlEscape(this.options.liveSearchPlaceholder) + '"'
              ) +
              ' role="textbox" aria-label="Search">' +
          '</div>';
      }

      if (this.multiple && this.options.actionsBox) {
        actionsbox =
          '<div class="bs-actionsbox">' +
            '<div class="btn-group btn-group-sm btn-block">' +
              '<button type="button" class="actions-btn bs-select-all btn ' + classNames.BUTTONCLASS + '">' +
                this.options.selectAllText +
              '</button>' +
              '<button type="button" class="actions-btn bs-deselect-all btn ' + classNames.BUTTONCLASS + '">' +
                this.options.deselectAllText +
              '</button>' +
            '</div>' +
          '</div>';
      }

      if (this.multiple && this.options.doneButton) {
        donebutton =
          '<div class="bs-donebutton">' +
            '<div class="btn-group btn-block">' +
              '<button type="button" class="btn btn-sm ' + classNames.BUTTONCLASS + '">' +
                this.options.doneButtonText +
              '</button>' +
            '</div>' +
          '</div>';
      }

      drop =
        '<div class="dropdown bootstrap-select' + showTick + inputGroup + '">' +
          '<button type="button" class="' + this.options.styleBase + ' dropdown-toggle" ' + (this.options.display === 'static' ? 'data-display="static"' : '') + 'data-toggle="dropdown"' + autofocus + ' role="button">' +
            '<div class="filter-option">' +
              '<div class="filter-option-inner">' +
                '<div class="filter-option-inner-inner"></div>' +
              '</div> ' +
            '</div>' +
            (
              version.major === '4' ? ''
              :
              '<span class="bs-caret">' +
                this.options.template.caret +
              '</span>'
            ) +
          '</button>' +
          '<div class="' + classNames.MENU + ' ' + (version.major === '4' ? '' : classNames.SHOW) + '" role="combobox">' +
            header +
            searchbox +
            actionsbox +
            '<div class="inner ' + classNames.SHOW + '" role="listbox" aria-expanded="false" tabindex="-1">' +
                '<ul class="' + classNames.MENU + ' inner ' + (version.major === '4' ? classNames.SHOW : '') + '">' +
                '</ul>' +
            '</div>' +
            donebutton +
          '</div>' +
        '</div>';

      return $(drop);
    },

    setPositionData: function () {
      this.selectpicker.view.canHighlight = [];

      for (var i = 0; i < this.selectpicker.current.data.length; i++) {
        var li = this.selectpicker.current.data[i],
            canHighlight = true;

        if (li.type === 'divider') {
          canHighlight = false;
          li.height = this.sizeInfo.dividerHeight;
        } else if (li.type === 'optgroup-label') {
          canHighlight = false;
          li.height = this.sizeInfo.dropdownHeaderHeight;
        } else {
          li.height = this.sizeInfo.liHeight;
        }

        if (li.disabled) canHighlight = false;

        this.selectpicker.view.canHighlight.push(canHighlight);

        li.position = (i === 0 ? 0 : this.selectpicker.current.data[i - 1].position) + li.height;
      }
    },

    isVirtual: function () {
      return (this.options.virtualScroll !== false) && (this.selectpicker.main.elements.length >= this.options.virtualScroll) || this.options.virtualScroll === true;
    },

    createView: function (isSearching, scrollTop) {
      scrollTop = scrollTop || 0;

      var that = this;

      this.selectpicker.current = isSearching ? this.selectpicker.search : this.selectpicker.main;

      var active = [];
      var selected;
      var prevActive;

      this.setPositionData();

      scroll(scrollTop, true);

      this.$menuInner.off('scroll.createView').on('scroll.createView', function (e, updateValue) {
        if (!that.noScroll) scroll(this.scrollTop, updateValue);
        that.noScroll = false;
      });

      function scroll (scrollTop, init) {
        var size = that.selectpicker.current.elements.length,
            chunks = [],
            chunkSize,
            chunkCount,
            firstChunk,
            lastChunk,
            currentChunk,
            prevPositions,
            positionIsDifferent,
            previousElements,
            menuIsDifferent = true,
            isVirtual = that.isVirtual();

        that.selectpicker.view.scrollTop = scrollTop;

        if (isVirtual === true) {
          // if an option that is encountered that is wider than the current menu width, update the menu width accordingly
          if (that.sizeInfo.hasScrollBar && that.$menu[0].offsetWidth > that.sizeInfo.totalMenuWidth) {
            that.sizeInfo.menuWidth = that.$menu[0].offsetWidth;
            that.sizeInfo.totalMenuWidth = that.sizeInfo.menuWidth + that.sizeInfo.scrollBarWidth;
            that.$menu.css('min-width', that.sizeInfo.menuWidth);
          }
        }

        chunkSize = Math.ceil(that.sizeInfo.menuInnerHeight / that.sizeInfo.liHeight * 1.5); // number of options in a chunk
        chunkCount = Math.round(size / chunkSize) || 1; // number of chunks

        for (var i = 0; i < chunkCount; i++) {
          var endOfChunk = (i + 1) * chunkSize;

          if (i === chunkCount - 1) {
            endOfChunk = size;
          }

          chunks[i] = [
            (i) * chunkSize + (!i ? 0 : 1),
            endOfChunk
          ];

          if (!size) break;

          if (currentChunk === undefined && scrollTop <= that.selectpicker.current.data[endOfChunk - 1].position - that.sizeInfo.menuInnerHeight) {
            currentChunk = i;
          }
        }

        if (currentChunk === undefined) currentChunk = 0;

        prevPositions = [that.selectpicker.view.position0, that.selectpicker.view.position1];

        // always display previous, current, and next chunks
        firstChunk = Math.max(0, currentChunk - 1);
        lastChunk = Math.min(chunkCount - 1, currentChunk + 1);

        that.selectpicker.view.position0 = isVirtual === false ? 0 : (Math.max(0, chunks[firstChunk][0]) || 0);
        that.selectpicker.view.position1 = isVirtual === false ? size : (Math.min(size, chunks[lastChunk][1]) || 0);

        positionIsDifferent = prevPositions[0] !== that.selectpicker.view.position0 || prevPositions[1] !== that.selectpicker.view.position1;

        if (that.activeIndex !== undefined) {
          prevActive = that.selectpicker.main.elements[that.prevActiveIndex];
          active = that.selectpicker.main.elements[that.activeIndex];
          selected = that.selectpicker.main.elements[that.selectedIndex];

          if (init) {
            if (that.activeIndex !== that.selectedIndex && active && active.length) {
              active.classList.remove('active');
              if (active.firstChild) active.firstChild.classList.remove('active');
            }
            that.activeIndex = undefined;
          }

          if (that.activeIndex && that.activeIndex !== that.selectedIndex && selected && selected.length) {
            selected.classList.remove('active');
            if (selected.firstChild) selected.firstChild.classList.remove('active');
          }
        }

        if (that.prevActiveIndex !== undefined && that.prevActiveIndex !== that.activeIndex && that.prevActiveIndex !== that.selectedIndex && prevActive && prevActive.length) {
          prevActive.classList.remove('active');
          if (prevActive.firstChild) prevActive.firstChild.classList.remove('active');
        }

        if (init || positionIsDifferent) {
          previousElements = that.selectpicker.view.visibleElements ? that.selectpicker.view.visibleElements.slice() : [];

          if (isVirtual === false) {
            that.selectpicker.view.visibleElements = that.selectpicker.current.elements;
          } else {
            that.selectpicker.view.visibleElements = that.selectpicker.current.elements.slice(that.selectpicker.view.position0, that.selectpicker.view.position1);
          }

          that.setOptionStatus();

          // if searching, check to make sure the list has actually been updated before updating DOM
          // this prevents unnecessary repaints
          if (isSearching || (isVirtual === false && init)) menuIsDifferent = !isEqual(previousElements, that.selectpicker.view.visibleElements);

          // if virtual scroll is disabled and not searching,
          // menu should never need to be updated more than once
          if ((init || isVirtual === true) && menuIsDifferent) {
            var menuInner = that.$menuInner[0],
                menuFragment = document.createDocumentFragment(),
                emptyMenu = menuInner.firstChild.cloneNode(false),
                marginTop,
                marginBottom,
                elements = that.selectpicker.view.visibleElements,
                toSanitize = [];

            // replace the existing UL with an empty one - this is faster than $.empty()
            menuInner.replaceChild(emptyMenu, menuInner.firstChild);

            for (var i = 0, visibleElementsLen = elements.length; i < visibleElementsLen; i++) {
              var element = elements[i],
                  elText,
                  elementData;

              if (that.options.sanitize) {
                elText = element.lastChild;

                if (elText) {
                  elementData = that.selectpicker.current.data[i + that.selectpicker.view.position0];

                  if (elementData && elementData.content && !elementData.sanitized) {
                    toSanitize.push(elText);
                    elementData.sanitized = true;
                  }
                }
              }

              menuFragment.appendChild(element);
            }

            if (that.options.sanitize && toSanitize.length) {
              sanitizeHtml(toSanitize, that.options.whiteList, that.options.sanitizeFn);
            }

            if (isVirtual === true) {
              marginTop = (that.selectpicker.view.position0 === 0 ? 0 : that.selectpicker.current.data[that.selectpicker.view.position0 - 1].position);
              marginBottom = (that.selectpicker.view.position1 > size - 1 ? 0 : that.selectpicker.current.data[size - 1].position - that.selectpicker.current.data[that.selectpicker.view.position1 - 1].position);

              menuInner.firstChild.style.marginTop = marginTop + 'px';
              menuInner.firstChild.style.marginBottom = marginBottom + 'px';
            }

            menuInner.firstChild.appendChild(menuFragment);
          }
        }

        that.prevActiveIndex = that.activeIndex;

        if (!that.options.liveSearch) {
          that.$menuInner.trigger('focus');
        } else if (isSearching && init) {
          var index = 0,
              newActive;

          if (!that.selectpicker.view.canHighlight[index]) {
            index = 1 + that.selectpicker.view.canHighlight.slice(1).indexOf(true);
          }

          newActive = that.selectpicker.view.visibleElements[index];

          if (that.selectpicker.view.currentActive) {
            that.selectpicker.view.currentActive.classList.remove('active');
            if (that.selectpicker.view.currentActive.firstChild) that.selectpicker.view.currentActive.firstChild.classList.remove('active');
          }

          if (newActive) {
            newActive.classList.add('active');
            if (newActive.firstChild) newActive.firstChild.classList.add('active');
          }

          that.activeIndex = (that.selectpicker.current.data[index] || {}).index;
        }
      }

      $(window)
        .off('resize' + EVENT_KEY + '.' + this.selectId + '.createView')
        .on('resize' + EVENT_KEY + '.' + this.selectId + '.createView', function () {
          var isActive = that.$newElement.hasClass(classNames.SHOW);

          if (isActive) scroll(that.$menuInner[0].scrollTop);
        });
    },

    setPlaceholder: function () {
      var updateIndex = false;

      if (this.options.title && !this.multiple) {
        if (!this.selectpicker.view.titleOption) this.selectpicker.view.titleOption = document.createElement('option');

        // this option doesn't create a new <li> element, but does add a new option at the start,
        // so startIndex should increase to prevent having to check every option for the bs-title-option class
        updateIndex = true;

        var element = this.$element[0],
            isSelected = false,
            titleNotAppended = !this.selectpicker.view.titleOption.parentNode;

        if (titleNotAppended) {
          // Use native JS to prepend option (faster)
          this.selectpicker.view.titleOption.className = 'bs-title-option';
          this.selectpicker.view.titleOption.value = '';

          // Check if selected or data-selected attribute is already set on an option. If not, select the titleOption option.
          // the selected item may have been changed by user or programmatically before the bootstrap select plugin runs,
          // if so, the select will have the data-selected attribute
          var $opt = $(element.options[element.selectedIndex]);
          isSelected = $opt.attr('selected') === undefined && this.$element.data('selected') === undefined;
        }

        if (titleNotAppended || this.selectpicker.view.titleOption.index !== 0) {
          element.insertBefore(this.selectpicker.view.titleOption, element.firstChild);
        }

        // Set selected *after* appending to select,
        // otherwise the option doesn't get selected in IE
        // set using selectedIndex, as setting the selected attr to true here doesn't work in IE11
        if (isSelected) element.selectedIndex = 0;
      }

      return updateIndex;
    },

    createLi: function () {
      var that = this,
          iconBase = this.options.iconBase,
          optionSelector = ':not([hidden]):not([data-hidden="true"])',
          mainElements = [],
          mainData = [],
          widestOptionLength = 0,
          optID = 0,
          startIndex = this.setPlaceholder() ? 1 : 0; // append the titleOption if necessary and skip the first option in the loop

      if (this.options.hideDisabled) optionSelector += ':not(:disabled)';

      if ((that.options.showTick || that.multiple) && !elementTemplates.checkMark.parentNode) {
        elementTemplates.checkMark.className = iconBase + ' ' + that.options.tickIcon + ' check-mark';
        elementTemplates.a.appendChild(elementTemplates.checkMark);
      }

      var selectOptions = this.$element[0].querySelectorAll('select > *' + optionSelector);

      function addDivider (config) {
        var previousData = mainData[mainData.length - 1];

        // ensure optgroup doesn't create back-to-back dividers
        if (
          previousData &&
          previousData.type === 'divider' &&
          (previousData.optID || config.optID)
        ) {
          return;
        }

        config = config || {};
        config.type = 'divider';

        mainElements.push(
          generateOption.li(
            false,
            classNames.DIVIDER,
            (config.optID ? config.optID + 'div' : undefined)
          )
        );

        mainData.push(config);
      }

      function addOption (option, config) {
        config = config || {};

        config.divider = option.getAttribute('data-divider') === 'true';

        if (config.divider) {
          addDivider({
            optID: config.optID
          });
        } else {
          var liIndex = mainData.length,
              cssText = option.style.cssText,
              inlineStyle = cssText ? htmlEscape(cssText) : '',
              optionClass = (option.className || '') + (config.optgroupClass || '');

          if (config.optID) optionClass = 'opt ' + optionClass;

          config.text = option.textContent;

          config.content = option.getAttribute('data-content');
          config.tokens = option.getAttribute('data-tokens');
          config.subtext = option.getAttribute('data-subtext');
          config.icon = option.getAttribute('data-icon');
          config.iconBase = iconBase;

          var textElement = generateOption.text(config);

          mainElements.push(
            generateOption.li(
              generateOption.a(
                textElement,
                optionClass,
                inlineStyle
              ),
              '',
              config.optID
            )
          );

          option.liIndex = liIndex;

          config.display = config.content || config.text;
          config.type = 'option';
          config.index = liIndex;
          config.option = option;
          config.disabled = config.disabled || option.disabled;

          mainData.push(config);

          var combinedLength = 0;

          // count the number of characters in the option - not perfect, but should work in most cases
          if (config.display) combinedLength += config.display.length;
          if (config.subtext) combinedLength += config.subtext.length;
          // if there is an icon, ensure this option's width is checked
          if (config.icon) combinedLength += 1;

          if (combinedLength > widestOptionLength) {
            widestOptionLength = combinedLength;

            // guess which option is the widest
            // use this when calculating menu width
            // not perfect, but it's fast, and the width will be updating accordingly when scrolling
            that.selectpicker.view.widestOption = mainElements[mainElements.length - 1];
          }
        }
      }

      function addOptgroup (index, selectOptions) {
        var optgroup = selectOptions[index],
            previous = selectOptions[index - 1],
            next = selectOptions[index + 1],
            options = optgroup.querySelectorAll('option' + optionSelector);

        if (!options.length) return;

        var config = {
              label: htmlEscape(optgroup.label),
              subtext: optgroup.getAttribute('data-subtext'),
              icon: optgroup.getAttribute('data-icon'),
              iconBase: iconBase
            },
            optgroupClass = ' ' + (optgroup.className || ''),
            headerIndex,
            lastIndex;

        optID++;

        if (previous) {
          addDivider({ optID: optID });
        }

        var labelElement = generateOption.label(config);

        mainElements.push(
          generateOption.li(labelElement, 'dropdown-header' + optgroupClass, optID)
        );

        mainData.push({
          display: config.label,
          subtext: config.subtext,
          type: 'optgroup-label',
          optID: optID
        });

        for (var j = 0, len = options.length; j < len; j++) {
          var option = options[j];

          if (j === 0) {
            headerIndex = mainData.length - 1;
            lastIndex = headerIndex + len;
          }

          addOption(option, {
            headerIndex: headerIndex,
            lastIndex: lastIndex,
            optID: optID,
            optgroupClass: optgroupClass,
            disabled: optgroup.disabled
          });
        }

        if (next) {
          addDivider({ optID: optID });
        }
      }

      for (var len = selectOptions.length; startIndex < len; startIndex++) {
        var item = selectOptions[startIndex];

        if (item.tagName !== 'OPTGROUP') {
          addOption(item, {});
        } else {
          addOptgroup(startIndex, selectOptions);
        }
      }

      this.selectpicker.main.elements = mainElements;
      this.selectpicker.main.data = mainData;

      this.selectpicker.current = this.selectpicker.main;
    },

    findLis: function () {
      return this.$menuInner.find('.inner > li');
    },

    render: function () {
      // ensure titleOption is appended and selected (if necessary) before getting selectedOptions
      this.setPlaceholder();

      var that = this,
          selectedOptions = this.$element[0].selectedOptions,
          selectedCount = selectedOptions.length,
          button = this.$button[0],
          buttonInner = button.querySelector('.filter-option-inner-inner'),
          multipleSeparator = document.createTextNode(this.options.multipleSeparator),
          titleFragment = elementTemplates.fragment.cloneNode(false),
          showCount,
          countMax,
          hasContent = false;

      this.togglePlaceholder();

      this.tabIndex();

      if (this.options.selectedTextFormat === 'static') {
        titleFragment = generateOption.text({ text: this.options.title }, true);
      } else {
        showCount = this.multiple && this.options.selectedTextFormat.indexOf('count') !== -1 && selectedCount > 1;

        // determine if the number of selected options will be shown (showCount === true)
        if (showCount) {
          countMax = this.options.selectedTextFormat.split('>');
          showCount = (countMax.length > 1 && selectedCount > countMax[1]) || (countMax.length === 1 && selectedCount >= 2);
        }

        // only loop through all selected options if the count won't be shown
        if (showCount === false) {
          for (var selectedIndex = 0; selectedIndex < selectedCount; selectedIndex++) {
            if (selectedIndex < 50) {
              var option = selectedOptions[selectedIndex],
                  titleOptions = {},
                  thisData = {
                    content: option.getAttribute('data-content'),
                    subtext: option.getAttribute('data-subtext'),
                    icon: option.getAttribute('data-icon')
                  };

              if (this.multiple && selectedIndex > 0) {
                titleFragment.appendChild(multipleSeparator.cloneNode(false));
              }

              if (option.title) {
                titleOptions.text = option.title;
              } else if (thisData.content && that.options.showContent) {
                titleOptions.content = thisData.content.toString();
                hasContent = true;
              } else {
                if (that.options.showIcon) {
                  titleOptions.icon = thisData.icon;
                  titleOptions.iconBase = this.options.iconBase;
                }
                if (that.options.showSubtext && !that.multiple && thisData.subtext) titleOptions.subtext = ' ' + thisData.subtext;
                titleOptions.text = option.textContent.trim();
              }

              titleFragment.appendChild(generateOption.text(titleOptions, true));
            } else {
              break;
            }
          }

          // add ellipsis
          if (selectedCount > 49) {
            titleFragment.appendChild(document.createTextNode('...'));
          }
        } else {
          var optionSelector = ':not([hidden]):not([data-hidden="true"]):not([data-divider="true"])';
          if (this.options.hideDisabled) optionSelector += ':not(:disabled)';

          // If this is a multiselect, and selectedTextFormat is count, then show 1 of 2 selected, etc.
          var totalCount = this.$element[0].querySelectorAll('select > option' + optionSelector + ', optgroup' + optionSelector + ' option' + optionSelector).length,
              tr8nText = (typeof this.options.countSelectedText === 'function') ? this.options.countSelectedText(selectedCount, totalCount) : this.options.countSelectedText;

          titleFragment = generateOption.text({
            text: tr8nText.replace('{0}', selectedCount.toString()).replace('{1}', totalCount.toString())
          }, true);
        }
      }

      if (this.options.title == undefined) {
        // use .attr to ensure undefined is returned if title attribute is not set
        this.options.title = this.$element.attr('title');
      }

      // If the select doesn't have a title, then use the default, or if nothing is set at all, use noneSelectedText
      if (!titleFragment.childNodes.length) {
        titleFragment = generateOption.text({
          text: typeof this.options.title !== 'undefined' ? this.options.title : this.options.noneSelectedText
        }, true);
      }

      // strip all HTML tags and trim the result, then unescape any escaped tags
      button.title = titleFragment.textContent.replace(/<[^>]*>?/g, '').trim();

      if (this.options.sanitize && hasContent) {
        sanitizeHtml([titleFragment], that.options.whiteList, that.options.sanitizeFn);
      }

      buttonInner.innerHTML = '';
      buttonInner.appendChild(titleFragment);

      if (version.major < 4 && this.$newElement[0].classList.contains('bs3-has-addon')) {
        var filterExpand = button.querySelector('.filter-expand'),
            clone = buttonInner.cloneNode(true);

        clone.className = 'filter-expand';

        if (filterExpand) {
          button.replaceChild(clone, filterExpand);
        } else {
          button.appendChild(clone);
        }
      }

      this.$element.trigger('rendered' + EVENT_KEY);
    },

    /**
     * @param [style]
     * @param [status]
     */
    setStyle: function (newStyle, status) {
      var button = this.$button[0],
          newElement = this.$newElement[0],
          style = this.options.style.trim(),
          buttonClass;

      if (this.$element.attr('class')) {
        this.$newElement.addClass(this.$element.attr('class').replace(/selectpicker|mobile-device|bs-select-hidden|validate\[.*\]/gi, ''));
      }

      if (version.major < 4) {
        newElement.classList.add('bs3');

        if (newElement.parentNode.classList.contains('input-group') &&
            (newElement.previousElementSibling || newElement.nextElementSibling) &&
            (newElement.previousElementSibling || newElement.nextElementSibling).classList.contains('input-group-addon')
        ) {
          newElement.classList.add('bs3-has-addon');
        }
      }

      if (newStyle) {
        buttonClass = newStyle.trim();
      } else {
        buttonClass = style;
      }

      if (status == 'add') {
        if (buttonClass) button.classList.add.apply(button.classList, buttonClass.split(' '));
      } else if (status == 'remove') {
        if (buttonClass) button.classList.remove.apply(button.classList, buttonClass.split(' '));
      } else {
        if (style) button.classList.remove.apply(button.classList, style.split(' '));
        if (buttonClass) button.classList.add.apply(button.classList, buttonClass.split(' '));
      }
    },

    liHeight: function (refresh) {
      if (!refresh && (this.options.size === false || this.sizeInfo)) return;

      if (!this.sizeInfo) this.sizeInfo = {};

      var newElement = document.createElement('div'),
          menu = document.createElement('div'),
          menuInner = document.createElement('div'),
          menuInnerInner = document.createElement('ul'),
          divider = document.createElement('li'),
          dropdownHeader = document.createElement('li'),
          li = document.createElement('li'),
          a = document.createElement('a'),
          text = document.createElement('span'),
          header = this.options.header && this.$menu.find('.' + classNames.POPOVERHEADER).length > 0 ? this.$menu.find('.' + classNames.POPOVERHEADER)[0].cloneNode(true) : null,
          search = this.options.liveSearch ? document.createElement('div') : null,
          actions = this.options.actionsBox && this.multiple && this.$menu.find('.bs-actionsbox').length > 0 ? this.$menu.find('.bs-actionsbox')[0].cloneNode(true) : null,
          doneButton = this.options.doneButton && this.multiple && this.$menu.find('.bs-donebutton').length > 0 ? this.$menu.find('.bs-donebutton')[0].cloneNode(true) : null,
          firstOption = this.$element.find('option')[0];

      this.sizeInfo.selectWidth = this.$newElement[0].offsetWidth;

      text.className = 'text';
      a.className = 'dropdown-item ' + (firstOption ? firstOption.className : '');
      newElement.className = this.$menu[0].parentNode.className + ' ' + classNames.SHOW;
      newElement.style.width = this.sizeInfo.selectWidth + 'px';
      if (this.options.width === 'auto') menu.style.minWidth = 0;
      menu.className = classNames.MENU + ' ' + classNames.SHOW;
      menuInner.className = 'inner ' + classNames.SHOW;
      menuInnerInner.className = classNames.MENU + ' inner ' + (version.major === '4' ? classNames.SHOW : '');
      divider.className = classNames.DIVIDER;
      dropdownHeader.className = 'dropdown-header';

      text.appendChild(document.createTextNode('\u200b'));
      a.appendChild(text);
      li.appendChild(a);
      dropdownHeader.appendChild(text.cloneNode(true));

      if (this.selectpicker.view.widestOption) {
        menuInnerInner.appendChild(this.selectpicker.view.widestOption.cloneNode(true));
      }

      menuInnerInner.appendChild(li);
      menuInnerInner.appendChild(divider);
      menuInnerInner.appendChild(dropdownHeader);
      if (header) menu.appendChild(header);
      if (search) {
        var input = document.createElement('input');
        search.className = 'bs-searchbox';
        input.className = 'form-control';
        search.appendChild(input);
        menu.appendChild(search);
      }
      if (actions) menu.appendChild(actions);
      menuInner.appendChild(menuInnerInner);
      menu.appendChild(menuInner);
      if (doneButton) menu.appendChild(doneButton);
      newElement.appendChild(menu);

      document.body.appendChild(newElement);

      var liHeight = li.offsetHeight,
          dropdownHeaderHeight = dropdownHeader ? dropdownHeader.offsetHeight : 0,
          headerHeight = header ? header.offsetHeight : 0,
          searchHeight = search ? search.offsetHeight : 0,
          actionsHeight = actions ? actions.offsetHeight : 0,
          doneButtonHeight = doneButton ? doneButton.offsetHeight : 0,
          dividerHeight = $(divider).outerHeight(true),
          // fall back to jQuery if getComputedStyle is not supported
          menuStyle = window.getComputedStyle ? window.getComputedStyle(menu) : false,
          menuWidth = menu.offsetWidth,
          $menu = menuStyle ? null : $(menu),
          menuPadding = {
            vert: toInteger(menuStyle ? menuStyle.paddingTop : $menu.css('paddingTop')) +
                  toInteger(menuStyle ? menuStyle.paddingBottom : $menu.css('paddingBottom')) +
                  toInteger(menuStyle ? menuStyle.borderTopWidth : $menu.css('borderTopWidth')) +
                  toInteger(menuStyle ? menuStyle.borderBottomWidth : $menu.css('borderBottomWidth')),
            horiz: toInteger(menuStyle ? menuStyle.paddingLeft : $menu.css('paddingLeft')) +
                  toInteger(menuStyle ? menuStyle.paddingRight : $menu.css('paddingRight')) +
                  toInteger(menuStyle ? menuStyle.borderLeftWidth : $menu.css('borderLeftWidth')) +
                  toInteger(menuStyle ? menuStyle.borderRightWidth : $menu.css('borderRightWidth'))
          },
          menuExtras = {
            vert: menuPadding.vert +
                  toInteger(menuStyle ? menuStyle.marginTop : $menu.css('marginTop')) +
                  toInteger(menuStyle ? menuStyle.marginBottom : $menu.css('marginBottom')) + 2,
            horiz: menuPadding.horiz +
                  toInteger(menuStyle ? menuStyle.marginLeft : $menu.css('marginLeft')) +
                  toInteger(menuStyle ? menuStyle.marginRight : $menu.css('marginRight')) + 2
          },
          scrollBarWidth;

      menuInner.style.overflowY = 'scroll';

      scrollBarWidth = menu.offsetWidth - menuWidth;

      document.body.removeChild(newElement);

      this.sizeInfo.liHeight = liHeight;
      this.sizeInfo.dropdownHeaderHeight = dropdownHeaderHeight;
      this.sizeInfo.headerHeight = headerHeight;
      this.sizeInfo.searchHeight = searchHeight;
      this.sizeInfo.actionsHeight = actionsHeight;
      this.sizeInfo.doneButtonHeight = doneButtonHeight;
      this.sizeInfo.dividerHeight = dividerHeight;
      this.sizeInfo.menuPadding = menuPadding;
      this.sizeInfo.menuExtras = menuExtras;
      this.sizeInfo.menuWidth = menuWidth;
      this.sizeInfo.totalMenuWidth = this.sizeInfo.menuWidth;
      this.sizeInfo.scrollBarWidth = scrollBarWidth;
      this.sizeInfo.selectHeight = this.$newElement[0].offsetHeight;

      this.setPositionData();
    },

    getSelectPosition: function () {
      var that = this,
          $window = $(window),
          pos = that.$newElement.offset(),
          $container = $(that.options.container),
          containerPos;

      if (that.options.container && $container.length && !$container.is('body')) {
        containerPos = $container.offset();
        containerPos.top += parseInt($container.css('borderTopWidth'));
        containerPos.left += parseInt($container.css('borderLeftWidth'));
      } else {
        containerPos = { top: 0, left: 0 };
      }

      var winPad = that.options.windowPadding;

      this.sizeInfo.selectOffsetTop = pos.top - containerPos.top - $window.scrollTop();
      this.sizeInfo.selectOffsetBot = $window.height() - this.sizeInfo.selectOffsetTop - this.sizeInfo.selectHeight - containerPos.top - winPad[2];
      this.sizeInfo.selectOffsetLeft = pos.left - containerPos.left - $window.scrollLeft();
      this.sizeInfo.selectOffsetRight = $window.width() - this.sizeInfo.selectOffsetLeft - this.sizeInfo.selectWidth - containerPos.left - winPad[1];
      this.sizeInfo.selectOffsetTop -= winPad[0];
      this.sizeInfo.selectOffsetLeft -= winPad[3];
    },

    setMenuSize: function (isAuto) {
      this.getSelectPosition();

      var selectWidth = this.sizeInfo.selectWidth,
          liHeight = this.sizeInfo.liHeight,
          headerHeight = this.sizeInfo.headerHeight,
          searchHeight = this.sizeInfo.searchHeight,
          actionsHeight = this.sizeInfo.actionsHeight,
          doneButtonHeight = this.sizeInfo.doneButtonHeight,
          divHeight = this.sizeInfo.dividerHeight,
          menuPadding = this.sizeInfo.menuPadding,
          menuInnerHeight,
          menuHeight,
          divLength = 0,
          minHeight,
          _minHeight,
          maxHeight,
          menuInnerMinHeight,
          estimate;

      if (this.options.dropupAuto) {
        // Get the estimated height of the menu without scrollbars.
        // This is useful for smaller menus, where there might be plenty of room
        // below the button without setting dropup, but we can't know
        // the exact height of the menu until createView is called later
        estimate = liHeight * this.selectpicker.current.elements.length + menuPadding.vert;
        this.$newElement.toggleClass(classNames.DROPUP, this.sizeInfo.selectOffsetTop - this.sizeInfo.selectOffsetBot > this.sizeInfo.menuExtras.vert && estimate + this.sizeInfo.menuExtras.vert + 50 > this.sizeInfo.selectOffsetBot);
      }

      if (this.options.size === 'auto') {
        _minHeight = this.selectpicker.current.elements.length > 3 ? this.sizeInfo.liHeight * 3 + this.sizeInfo.menuExtras.vert - 2 : 0;
        menuHeight = this.sizeInfo.selectOffsetBot - this.sizeInfo.menuExtras.vert;
        minHeight = _minHeight + headerHeight + searchHeight + actionsHeight + doneButtonHeight;
        menuInnerMinHeight = Math.max(_minHeight - menuPadding.vert, 0);

        if (this.$newElement.hasClass(classNames.DROPUP)) {
          menuHeight = this.sizeInfo.selectOffsetTop - this.sizeInfo.menuExtras.vert;
        }

        maxHeight = menuHeight;
        menuInnerHeight = menuHeight - headerHeight - searchHeight - actionsHeight - doneButtonHeight - menuPadding.vert;
      } else if (this.options.size && this.options.size != 'auto' && this.selectpicker.current.elements.length > this.options.size) {
        for (var i = 0; i < this.options.size; i++) {
          if (this.selectpicker.current.data[i].type === 'divider') divLength++;
        }

        menuHeight = liHeight * this.options.size + divLength * divHeight + menuPadding.vert;
        menuInnerHeight = menuHeight - menuPadding.vert;
        maxHeight = menuHeight + headerHeight + searchHeight + actionsHeight + doneButtonHeight;
        minHeight = menuInnerMinHeight = '';
      }

      if (this.options.dropdownAlignRight === 'auto') {
        this.$menu.toggleClass(classNames.MENURIGHT, this.sizeInfo.selectOffsetLeft > this.sizeInfo.selectOffsetRight && this.sizeInfo.selectOffsetRight < (this.sizeInfo.totalMenuWidth - selectWidth));
      }

      this.$menu.css({
        'max-height': maxHeight + 'px',
        'overflow': 'hidden',
        'min-height': minHeight + 'px'
      });

      this.$menuInner.css({
        'max-height': menuInnerHeight + 'px',
        'overflow-y': 'auto',
        'min-height': menuInnerMinHeight + 'px'
      });

      // ensure menuInnerHeight is always a positive number to prevent issues calculating chunkSize in createView
      this.sizeInfo.menuInnerHeight = Math.max(menuInnerHeight, 1);

      if (this.selectpicker.current.data.length && this.selectpicker.current.data[this.selectpicker.current.data.length - 1].position > this.sizeInfo.menuInnerHeight) {
        this.sizeInfo.hasScrollBar = true;
        this.sizeInfo.totalMenuWidth = this.sizeInfo.menuWidth + this.sizeInfo.scrollBarWidth;

        this.$menu.css('min-width', this.sizeInfo.totalMenuWidth);
      }

      if (this.dropdown && this.dropdown._popper) this.dropdown._popper.update();
    },

    setSize: function (refresh) {
      this.liHeight(refresh);

      if (this.options.header) this.$menu.css('padding-top', 0);
      if (this.options.size === false) return;

      var that = this,
          $window = $(window),
          selectedIndex,
          offset = 0;

      this.setMenuSize();

      if (this.options.liveSearch) {
        this.$searchbox
          .off('input.setMenuSize propertychange.setMenuSize')
          .on('input.setMenuSize propertychange.setMenuSize', function () {
            return that.setMenuSize();
          });
      }

      if (this.options.size === 'auto') {
        $window
          .off('resize' + EVENT_KEY + '.' + this.selectId + '.setMenuSize' + ' scroll' + EVENT_KEY + '.' + this.selectId + '.setMenuSize')
          .on('resize' + EVENT_KEY + '.' + this.selectId + '.setMenuSize' + ' scroll' + EVENT_KEY + '.' + this.selectId + '.setMenuSize', function () {
            return that.setMenuSize();
          });
      } else if (this.options.size && this.options.size != 'auto' && this.selectpicker.current.elements.length > this.options.size) {
        $window.off('resize' + EVENT_KEY + '.' + this.selectId + '.setMenuSize' + ' scroll' + EVENT_KEY + '.' + this.selectId + '.setMenuSize');
      }

      if (refresh) {
        offset = this.$menuInner[0].scrollTop;
      } else if (!that.multiple) {
        var element = that.$element[0];
        selectedIndex = (element.options[element.selectedIndex] || {}).liIndex;

        if (typeof selectedIndex === 'number' && that.options.size !== false) {
          offset = that.sizeInfo.liHeight * selectedIndex;
          offset = offset - (that.sizeInfo.menuInnerHeight / 2) + (that.sizeInfo.liHeight / 2);
        }
      }

      that.createView(false, offset);
    },

    setWidth: function () {
      var that = this;

      if (this.options.width === 'auto') {
        requestAnimationFrame(function () {
          that.$menu.css('min-width', '0');

          that.$element.on('loaded' + EVENT_KEY, function () {
            that.liHeight();
            that.setMenuSize();

            // Get correct width if element is hidden
            var $selectClone = that.$newElement.clone().appendTo('body'),
                btnWidth = $selectClone.css('width', 'auto').children('button').outerWidth();

            $selectClone.remove();

            // Set width to whatever's larger, button title or longest option
            that.sizeInfo.selectWidth = Math.max(that.sizeInfo.totalMenuWidth, btnWidth);
            that.$newElement.css('width', that.sizeInfo.selectWidth + 'px');
          });
        });
      } else if (this.options.width === 'fit') {
        // Remove inline min-width so width can be changed from 'auto'
        this.$menu.css('min-width', '');
        this.$newElement.css('width', '').addClass('fit-width');
      } else if (this.options.width) {
        // Remove inline min-width so width can be changed from 'auto'
        this.$menu.css('min-width', '');
        this.$newElement.css('width', this.options.width);
      } else {
        // Remove inline min-width/width so width can be changed
        this.$menu.css('min-width', '');
        this.$newElement.css('width', '');
      }
      // Remove fit-width class if width is changed programmatically
      if (this.$newElement.hasClass('fit-width') && this.options.width !== 'fit') {
        this.$newElement[0].classList.remove('fit-width');
      }
    },

    selectPosition: function () {
      this.$bsContainer = $('<div class="bs-container" />');

      var that = this,
          $container = $(this.options.container),
          pos,
          containerPos,
          actualHeight,
          getPlacement = function ($element) {
            var containerPosition = {},
                // fall back to dropdown's default display setting if display is not manually set
                display = that.options.display || (
                  // Bootstrap 3 doesn't have $.fn.dropdown.Constructor.Default
                  $.fn.dropdown.Constructor.Default ? $.fn.dropdown.Constructor.Default.display
                  : false
                );

            that.$bsContainer.addClass($element.attr('class').replace(/form-control|fit-width/gi, '')).toggleClass(classNames.DROPUP, $element.hasClass(classNames.DROPUP));
            pos = $element.offset();

            if (!$container.is('body')) {
              containerPos = $container.offset();
              containerPos.top += parseInt($container.css('borderTopWidth')) - $container.scrollTop();
              containerPos.left += parseInt($container.css('borderLeftWidth')) - $container.scrollLeft();
            } else {
              containerPos = { top: 0, left: 0 };
            }

            actualHeight = $element.hasClass(classNames.DROPUP) ? 0 : $element[0].offsetHeight;

            // Bootstrap 4+ uses Popper for menu positioning
            if (version.major < 4 || display === 'static') {
              containerPosition.top = pos.top - containerPos.top + actualHeight;
              containerPosition.left = pos.left - containerPos.left;
            }

            containerPosition.width = $element[0].offsetWidth;

            that.$bsContainer.css(containerPosition);
          };

      this.$button.on('click.bs.dropdown.data-api', function () {
        if (that.isDisabled()) {
          return;
        }

        getPlacement(that.$newElement);

        that.$bsContainer
          .appendTo(that.options.container)
          .toggleClass(classNames.SHOW, !that.$button.hasClass(classNames.SHOW))
          .append(that.$menu);
      });

      $(window)
        .off('resize' + EVENT_KEY + '.' + this.selectId + ' scroll' + EVENT_KEY + '.' + this.selectId)
        .on('resize' + EVENT_KEY + '.' + this.selectId + ' scroll' + EVENT_KEY + '.' + this.selectId, function () {
          var isActive = that.$newElement.hasClass(classNames.SHOW);

          if (isActive) getPlacement(that.$newElement);
        });

      this.$element.on('hide' + EVENT_KEY, function () {
        that.$menu.data('height', that.$menu.height());
        that.$bsContainer.detach();
      });
    },

    setOptionStatus: function () {
      var that = this;

      that.noScroll = false;

      if (that.selectpicker.view.visibleElements && that.selectpicker.view.visibleElements.length) {
        for (var i = 0; i < that.selectpicker.view.visibleElements.length; i++) {
          var liData = that.selectpicker.current.data[i + that.selectpicker.view.position0],
              option = liData.option;

          if (option) {
            that.setDisabled(
              liData.index,
              liData.disabled
            );

            that.setSelected(
              liData.index,
              option.selected
            );
          }
        }
      }
    },

    /**
     * @param {number} index - the index of the option that is being changed
     * @param {boolean} selected - true if the option is being selected, false if being deselected
     */
    setSelected: function (index, selected) {
      var li = this.selectpicker.main.elements[index],
          liData = this.selectpicker.main.data[index],
          activeIndexIsSet = this.activeIndex !== undefined,
          thisIsActive = this.activeIndex === index,
          prevActive,
          a,
          // if current option is already active
          // OR
          // if the current option is being selected, it's NOT multiple, and
          // activeIndex is undefined:
          //  - when the menu is first being opened, OR
          //  - after a search has been performed, OR
          //  - when retainActive is false when selecting a new option (i.e. index of the newly selected option is not the same as the current activeIndex)
          keepActive = thisIsActive || (selected && !this.multiple && !activeIndexIsSet);

      liData.selected = selected;

      a = li.firstChild;

      if (selected) {
        this.selectedIndex = index;
      }

      li.classList.toggle('selected', selected);
      li.classList.toggle('active', keepActive);

      if (keepActive) {
        this.selectpicker.view.currentActive = li;
        this.activeIndex = index;
      }

      if (a) {
        a.classList.toggle('selected', selected);
        a.classList.toggle('active', keepActive);
        a.setAttribute('aria-selected', selected);
      }

      if (!keepActive) {
        if (!activeIndexIsSet && selected && this.prevActiveIndex !== undefined) {
          prevActive = this.selectpicker.main.elements[this.prevActiveIndex];

          prevActive.classList.remove('active');
          if (prevActive.firstChild) {
            prevActive.firstChild.classList.remove('active');
          }
        }
      }
    },

    /**
     * @param {number} index - the index of the option that is being disabled
     * @param {boolean} disabled - true if the option is being disabled, false if being enabled
     */
    setDisabled: function (index, disabled) {
      var li = this.selectpicker.main.elements[index],
          a;

      this.selectpicker.main.data[index].disabled = disabled;

      a = li.firstChild;

      li.classList.toggle(classNames.DISABLED, disabled);

      if (a) {
        if (version.major === '4') a.classList.toggle(classNames.DISABLED, disabled);

        a.setAttribute('aria-disabled', disabled);

        if (disabled) {
          a.setAttribute('tabindex', -1);
        } else {
          a.setAttribute('tabindex', 0);
        }
      }
    },

    isDisabled: function () {
      return this.$element[0].disabled;
    },

    checkDisabled: function () {
      var that = this;

      if (this.isDisabled()) {
        this.$newElement[0].classList.add(classNames.DISABLED);
        this.$button.addClass(classNames.DISABLED).attr('tabindex', -1).attr('aria-disabled', true);
      } else {
        if (this.$button[0].classList.contains(classNames.DISABLED)) {
          this.$newElement[0].classList.remove(classNames.DISABLED);
          this.$button.removeClass(classNames.DISABLED).attr('aria-disabled', false);
        }

        if (this.$button.attr('tabindex') == -1 && !this.$element.data('tabindex')) {
          this.$button.removeAttr('tabindex');
        }
      }

      this.$button.on('click', function () {
        return !that.isDisabled();
      });
    },

    togglePlaceholder: function () {
      // much faster than calling $.val()
      var element = this.$element[0],
          selectedIndex = element.selectedIndex,
          nothingSelected = selectedIndex === -1;

      if (!nothingSelected && !element.options[selectedIndex].value) nothingSelected = true;

      this.$button.toggleClass('bs-placeholder', nothingSelected);
    },

    tabIndex: function () {
      if (this.$element.data('tabindex') !== this.$element.attr('tabindex') &&
        (this.$element.attr('tabindex') !== -98 && this.$element.attr('tabindex') !== '-98')) {
        this.$element.data('tabindex', this.$element.attr('tabindex'));
        this.$button.attr('tabindex', this.$element.data('tabindex'));
      }

      this.$element.attr('tabindex', -98);
    },

    clickListener: function () {
      var that = this,
          $document = $(document);

      $document.data('spaceSelect', false);

      this.$button.on('keyup', function (e) {
        if (/(32)/.test(e.keyCode.toString(10)) && $document.data('spaceSelect')) {
          e.preventDefault();
          $document.data('spaceSelect', false);
        }
      });

      this.$newElement.on('show.bs.dropdown', function () {
        if (version.major > 3 && !that.dropdown) {
          that.dropdown = that.$button.data('bs.dropdown');
          that.dropdown._menu = that.$menu[0];
        }
      });

      this.$button.on('click.bs.dropdown.data-api', function () {
        if (!that.$newElement.hasClass(classNames.SHOW)) {
          that.setSize();
        }
      });

      function setFocus () {
        if (that.options.liveSearch) {
          that.$searchbox.trigger('focus');
        } else {
          that.$menuInner.trigger('focus');
        }
      }

      function checkPopperExists () {
        if (that.dropdown && that.dropdown._popper && that.dropdown._popper.state.isCreated) {
          setFocus();
        } else {
          requestAnimationFrame(checkPopperExists);
        }
      }

      this.$element.on('shown' + EVENT_KEY, function () {
        if (that.$menuInner[0].scrollTop !== that.selectpicker.view.scrollTop) {
          that.$menuInner[0].scrollTop = that.selectpicker.view.scrollTop;
        }

        if (version.major > 3) {
          requestAnimationFrame(checkPopperExists);
        } else {
          setFocus();
        }
      });

      this.$menuInner.on('click', 'li a', function (e, retainActive) {
        var $this = $(this),
            position0 = that.isVirtual() ? that.selectpicker.view.position0 : 0,
            clickedData = that.selectpicker.current.data[$this.parent().index() + position0],
            clickedIndex = clickedData.index,
            prevValue = getSelectValues(that.$element[0]),
            prevIndex = that.$element.prop('selectedIndex'),
            triggerChange = true;

        // Don't close on multi choice menu
        if (that.multiple && that.options.maxOptions !== 1) {
          e.stopPropagation();
        }

        e.preventDefault();

        // Don't run if the select is disabled
        if (!that.isDisabled() && !$this.parent().hasClass(classNames.DISABLED)) {
          var $options = that.$element.find('option'),
              option = clickedData.option,
              $option = $(option),
              state = option.selected,
              $optgroup = $option.parent('optgroup'),
              $optgroupOptions = $optgroup.find('option'),
              maxOptions = that.options.maxOptions,
              maxOptionsGrp = $optgroup.data('maxOptions') || false;

          if (clickedIndex === that.activeIndex) retainActive = true;

          if (!retainActive) {
            that.prevActiveIndex = that.activeIndex;
            that.activeIndex = undefined;
          }

          if (!that.multiple) { // Deselect all others if not multi select box
            $options.prop('selected', false);
            option.selected = true;
            that.setSelected(clickedIndex, true);
          } else { // Toggle the one we have chosen if we are multi select.
            option.selected = !state;

            that.setSelected(clickedIndex, !state);
            $this.trigger('blur');

            if (maxOptions !== false || maxOptionsGrp !== false) {
              var maxReached = maxOptions < $options.filter(':selected').length,
                  maxReachedGrp = maxOptionsGrp < $optgroup.find('option:selected').length;

              if ((maxOptions && maxReached) || (maxOptionsGrp && maxReachedGrp)) {
                if (maxOptions && maxOptions == 1) {
                  $options.prop('selected', false);
                  $option.prop('selected', true);

                  for (var i = 0; i < $options.length; i++) {
                    that.setSelected(i, false);
                  }

                  that.setSelected(clickedIndex, true);
                } else if (maxOptionsGrp && maxOptionsGrp == 1) {
                  $optgroup.find('option:selected').prop('selected', false);
                  $option.prop('selected', true);

                  for (var i = 0; i < $optgroupOptions.length; i++) {
                    var option = $optgroupOptions[i];
                    that.setSelected($options.index(option), false);
                  }

                  that.setSelected(clickedIndex, true);
                } else {
                  var maxOptionsText = typeof that.options.maxOptionsText === 'string' ? [that.options.maxOptionsText, that.options.maxOptionsText] : that.options.maxOptionsText,
                      maxOptionsArr = typeof maxOptionsText === 'function' ? maxOptionsText(maxOptions, maxOptionsGrp) : maxOptionsText,
                      maxTxt = maxOptionsArr[0].replace('{n}', maxOptions),
                      maxTxtGrp = maxOptionsArr[1].replace('{n}', maxOptionsGrp),
                      $notify = $('<div class="notify"></div>');
                  // If {var} is set in array, replace it
                  /** @deprecated */
                  if (maxOptionsArr[2]) {
                    maxTxt = maxTxt.replace('{var}', maxOptionsArr[2][maxOptions > 1 ? 0 : 1]);
                    maxTxtGrp = maxTxtGrp.replace('{var}', maxOptionsArr[2][maxOptionsGrp > 1 ? 0 : 1]);
                  }

                  $option.prop('selected', false);

                  that.$menu.append($notify);

                  if (maxOptions && maxReached) {
                    $notify.append($('<div>' + maxTxt + '</div>'));
                    triggerChange = false;
                    that.$element.trigger('maxReached' + EVENT_KEY);
                  }

                  if (maxOptionsGrp && maxReachedGrp) {
                    $notify.append($('<div>' + maxTxtGrp + '</div>'));
                    triggerChange = false;
                    that.$element.trigger('maxReachedGrp' + EVENT_KEY);
                  }

                  setTimeout(function () {
                    that.setSelected(clickedIndex, false);
                  }, 10);

                  $notify.delay(750).fadeOut(300, function () {
                    $(this).remove();
                  });
                }
              }
            }
          }

          if (!that.multiple || (that.multiple && that.options.maxOptions === 1)) {
            that.$button.trigger('focus');
          } else if (that.options.liveSearch) {
            that.$searchbox.trigger('focus');
          }

          // Trigger select 'change'
          if (triggerChange) {
            if ((prevValue != getSelectValues(that.$element[0]) && that.multiple) || (prevIndex != that.$element.prop('selectedIndex') && !that.multiple)) {
              // $option.prop('selected') is current option state (selected/unselected). prevValue is the value of the select prior to being changed.
              changedArguments = [option.index, $option.prop('selected'), prevValue];
              that.$element
                .triggerNative('change');
            }
          }
        }
      });

      this.$menu.on('click', 'li.' + classNames.DISABLED + ' a, .' + classNames.POPOVERHEADER + ', .' + classNames.POPOVERHEADER + ' :not(.close)', function (e) {
        if (e.currentTarget == this) {
          e.preventDefault();
          e.stopPropagation();
          if (that.options.liveSearch && !$(e.target).hasClass('close')) {
            that.$searchbox.trigger('focus');
          } else {
            that.$button.trigger('focus');
          }
        }
      });

      this.$menuInner.on('click', '.divider, .dropdown-header', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (that.options.liveSearch) {
          that.$searchbox.trigger('focus');
        } else {
          that.$button.trigger('focus');
        }
      });

      this.$menu.on('click', '.' + classNames.POPOVERHEADER + ' .close', function () {
        that.$button.trigger('click');
      });

      this.$searchbox.on('click', function (e) {
        e.stopPropagation();
      });

      this.$menu.on('click', '.actions-btn', function (e) {
        if (that.options.liveSearch) {
          that.$searchbox.trigger('focus');
        } else {
          that.$button.trigger('focus');
        }

        e.preventDefault();
        e.stopPropagation();

        if ($(this).hasClass('bs-select-all')) {
          that.selectAll();
        } else {
          that.deselectAll();
        }
      });

      this.$element
        .on('change' + EVENT_KEY, function () {
          that.render();
          that.$element.trigger('changed' + EVENT_KEY, changedArguments);
          changedArguments = null;
        })
        .on('focus' + EVENT_KEY, function () {
          if (!that.options.mobile) that.$button.trigger('focus');
        });
    },

    liveSearchListener: function () {
      var that = this,
          noResults = document.createElement('li');

      this.$button.on('click.bs.dropdown.data-api', function () {
        if (!!that.$searchbox.val()) {
          that.$searchbox.val('');
        }
      });

      this.$searchbox.on('click.bs.dropdown.data-api focus.bs.dropdown.data-api touchend.bs.dropdown.data-api', function (e) {
        e.stopPropagation();
      });

      this.$searchbox.on('input propertychange', function () {
        var searchValue = that.$searchbox.val();

        that.selectpicker.search.elements = [];
        that.selectpicker.search.data = [];

        if (searchValue) {
          var i,
              searchMatch = [],
              q = searchValue.toUpperCase(),
              cache = {},
              cacheArr = [],
              searchStyle = that._searchStyle(),
              normalizeSearch = that.options.liveSearchNormalize;

          if (normalizeSearch) q = normalizeToBase(q);

          that._$lisSelected = that.$menuInner.find('.selected');

          for (var i = 0; i < that.selectpicker.main.data.length; i++) {
            var li = that.selectpicker.main.data[i];

            if (!cache[i]) {
              cache[i] = stringSearch(li, q, searchStyle, normalizeSearch);
            }

            if (cache[i] && li.headerIndex !== undefined && cacheArr.indexOf(li.headerIndex) === -1) {
              if (li.headerIndex > 0) {
                cache[li.headerIndex - 1] = true;
                cacheArr.push(li.headerIndex - 1);
              }

              cache[li.headerIndex] = true;
              cacheArr.push(li.headerIndex);

              cache[li.lastIndex + 1] = true;
            }

            if (cache[i] && li.type !== 'optgroup-label') cacheArr.push(i);
          }

          for (var i = 0, cacheLen = cacheArr.length; i < cacheLen; i++) {
            var index = cacheArr[i],
                prevIndex = cacheArr[i - 1],
                li = that.selectpicker.main.data[index],
                liPrev = that.selectpicker.main.data[prevIndex];

            if (li.type !== 'divider' || (li.type === 'divider' && liPrev && liPrev.type !== 'divider' && cacheLen - 1 !== i)) {
              that.selectpicker.search.data.push(li);
              searchMatch.push(that.selectpicker.main.elements[index]);
            }
          }

          that.activeIndex = undefined;
          that.noScroll = true;
          that.$menuInner.scrollTop(0);
          that.selectpicker.search.elements = searchMatch;
          that.createView(true);

          if (!searchMatch.length) {
            noResults.className = 'no-results';
            noResults.innerHTML = that.options.noneResultsText.replace('{0}', '"' + htmlEscape(searchValue) + '"');
            that.$menuInner[0].firstChild.appendChild(noResults);
          }
        } else {
          that.$menuInner.scrollTop(0);
          that.createView(false);
        }
      });
    },

    _searchStyle: function () {
      return this.options.liveSearchStyle || 'contains';
    },

    val: function (value) {
      if (typeof value !== 'undefined') {
        var prevValue = getSelectValues(this.$element[0]);

        changedArguments = [null, null, prevValue];

        this.$element
          .val(value)
          .trigger('changed' + EVENT_KEY, changedArguments);

        this.render();

        changedArguments = null;

        return this.$element;
      } else {
        return this.$element.val();
      }
    },

    changeAll: function (status) {
      if (!this.multiple) return;
      if (typeof status === 'undefined') status = true;

      var element = this.$element[0],
          previousSelected = 0,
          currentSelected = 0,
          prevValue = getSelectValues(element);

      element.classList.add('bs-select-hidden');

      for (var i = 0, len = this.selectpicker.current.elements.length; i < len; i++) {
        var liData = this.selectpicker.current.data[i],
            option = liData.option;

        if (option && !liData.disabled && liData.type !== 'divider') {
          if (liData.selected) previousSelected++;
          option.selected = status;
          if (status) currentSelected++;
        }
      }

      element.classList.remove('bs-select-hidden');

      if (previousSelected === currentSelected) return;

      this.setOptionStatus();

      this.togglePlaceholder();

      changedArguments = [null, null, prevValue];

      this.$element
        .triggerNative('change');
    },

    selectAll: function () {
      return this.changeAll(true);
    },

    deselectAll: function () {
      return this.changeAll(false);
    },

    toggle: function (e) {
      e = e || window.event;

      if (e) e.stopPropagation();

      this.$button.trigger('click.bs.dropdown.data-api');
    },

    keydown: function (e) {
      var $this = $(this),
          isToggle = $this.hasClass('dropdown-toggle'),
          $parent = isToggle ? $this.closest('.dropdown') : $this.closest(Selector.MENU),
          that = $parent.data('this'),
          $items = that.findLis(),
          index,
          isActive,
          liActive,
          activeLi,
          offset,
          updateScroll = false,
          downOnTab = e.which === keyCodes.TAB && !isToggle && !that.options.selectOnTab,
          isArrowKey = REGEXP_ARROW.test(e.which) || downOnTab,
          scrollTop = that.$menuInner[0].scrollTop,
          isVirtual = that.isVirtual(),
          position0 = isVirtual === true ? that.selectpicker.view.position0 : 0;

      isActive = that.$newElement.hasClass(classNames.SHOW);

      if (
        !isActive &&
        (
          isArrowKey ||
          (e.which >= 48 && e.which <= 57) ||
          (e.which >= 96 && e.which <= 105) ||
          (e.which >= 65 && e.which <= 90)
        )
      ) {
        that.$button.trigger('click.bs.dropdown.data-api');

        if (that.options.liveSearch) {
          that.$searchbox.trigger('focus');
          return;
        }
      }

      if (e.which === keyCodes.ESCAPE && isActive) {
        e.preventDefault();
        that.$button.trigger('click.bs.dropdown.data-api').trigger('focus');
      }

      if (isArrowKey) { // if up or down
        if (!$items.length) return;

        // $items.index/.filter is too slow with a large list and no virtual scroll
        index = isVirtual === true ? $items.index($items.filter('.active')) : that.activeIndex;

        if (index === undefined) index = -1;

        if (index !== -1) {
          liActive = that.selectpicker.current.elements[index + position0];
          liActive.classList.remove('active');
          if (liActive.firstChild) liActive.firstChild.classList.remove('active');
        }

        if (e.which === keyCodes.ARROW_UP) { // up
          if (index !== -1) index--;
          if (index + position0 < 0) index += $items.length;

          if (!that.selectpicker.view.canHighlight[index + position0]) {
            index = that.selectpicker.view.canHighlight.slice(0, index + position0).lastIndexOf(true) - position0;
            if (index === -1) index = $items.length - 1;
          }
        } else if (e.which === keyCodes.ARROW_DOWN || downOnTab) { // down
          index++;
          if (index + position0 >= that.selectpicker.view.canHighlight.length) index = 0;

          if (!that.selectpicker.view.canHighlight[index + position0]) {
            index = index + 1 + that.selectpicker.view.canHighlight.slice(index + position0 + 1).indexOf(true);
          }
        }

        e.preventDefault();

        var liActiveIndex = position0 + index;

        if (e.which === keyCodes.ARROW_UP) { // up
          // scroll to bottom and highlight last option
          if (position0 === 0 && index === $items.length - 1) {
            that.$menuInner[0].scrollTop = that.$menuInner[0].scrollHeight;

            liActiveIndex = that.selectpicker.current.elements.length - 1;
          } else {
            activeLi = that.selectpicker.current.data[liActiveIndex];
            offset = activeLi.position - activeLi.height;

            updateScroll = offset < scrollTop;
          }
        } else if (e.which === keyCodes.ARROW_DOWN || downOnTab) { // down
          // scroll to top and highlight first option
          if (index === 0) {
            that.$menuInner[0].scrollTop = 0;

            liActiveIndex = 0;
          } else {
            activeLi = that.selectpicker.current.data[liActiveIndex];
            offset = activeLi.position - that.sizeInfo.menuInnerHeight;

            updateScroll = offset > scrollTop;
          }
        }

        liActive = that.selectpicker.current.elements[liActiveIndex];

        if (liActive) {
          liActive.classList.add('active');
          if (liActive.firstChild) liActive.firstChild.classList.add('active');
        }

        that.activeIndex = that.selectpicker.current.data[liActiveIndex].index;

        that.selectpicker.view.currentActive = liActive;

        if (updateScroll) that.$menuInner[0].scrollTop = offset;

        if (that.options.liveSearch) {
          that.$searchbox.trigger('focus');
        } else {
          $this.trigger('focus');
        }
      } else if (
        (!$this.is('input') && !REGEXP_TAB_OR_ESCAPE.test(e.which)) ||
        (e.which === keyCodes.SPACE && that.selectpicker.keydown.keyHistory)
      ) {
        var searchMatch,
            matches = [],
            keyHistory;

        e.preventDefault();

        that.selectpicker.keydown.keyHistory += keyCodeMap[e.which];

        if (that.selectpicker.keydown.resetKeyHistory.cancel) clearTimeout(that.selectpicker.keydown.resetKeyHistory.cancel);
        that.selectpicker.keydown.resetKeyHistory.cancel = that.selectpicker.keydown.resetKeyHistory.start();

        keyHistory = that.selectpicker.keydown.keyHistory;

        // if all letters are the same, set keyHistory to just the first character when searching
        if (/^(.)\1+$/.test(keyHistory)) {
          keyHistory = keyHistory.charAt(0);
        }

        // find matches
        for (var i = 0; i < that.selectpicker.current.data.length; i++) {
          var li = that.selectpicker.current.data[i],
              hasMatch;

          hasMatch = stringSearch(li, keyHistory, 'startsWith', true);

          if (hasMatch && that.selectpicker.view.canHighlight[i]) {
            matches.push(li.index);
          }
        }

        if (matches.length) {
          var matchIndex = 0;

          $items.removeClass('active').find('a').removeClass('active');

          // either only one key has been pressed or they are all the same key
          if (keyHistory.length === 1) {
            matchIndex = matches.indexOf(that.activeIndex);

            if (matchIndex === -1 || matchIndex === matches.length - 1) {
              matchIndex = 0;
            } else {
              matchIndex++;
            }
          }

          searchMatch = matches[matchIndex];

          activeLi = that.selectpicker.main.data[searchMatch];

          if (scrollTop - activeLi.position > 0) {
            offset = activeLi.position - activeLi.height;
            updateScroll = true;
          } else {
            offset = activeLi.position - that.sizeInfo.menuInnerHeight;
            // if the option is already visible at the current scroll position, just keep it the same
            updateScroll = activeLi.position > scrollTop + that.sizeInfo.menuInnerHeight;
          }

          liActive = that.selectpicker.main.elements[searchMatch];
          liActive.classList.add('active');
          if (liActive.firstChild) liActive.firstChild.classList.add('active');
          that.activeIndex = matches[matchIndex];

          liActive.firstChild.focus();

          if (updateScroll) that.$menuInner[0].scrollTop = offset;

          $this.trigger('focus');
        }
      }

      // Select focused option if "Enter", "Spacebar" or "Tab" (when selectOnTab is true) are pressed inside the menu.
      if (
        isActive &&
        (
          (e.which === keyCodes.SPACE && !that.selectpicker.keydown.keyHistory) ||
          e.which === keyCodes.ENTER ||
          (e.which === keyCodes.TAB && that.options.selectOnTab)
        )
      ) {
        if (e.which !== keyCodes.SPACE) e.preventDefault();

        if (!that.options.liveSearch || e.which !== keyCodes.SPACE) {
          that.$menuInner.find('.active a').trigger('click', true); // retain active class
          $this.trigger('focus');

          if (!that.options.liveSearch) {
            // Prevent screen from scrolling if the user hits the spacebar
            e.preventDefault();
            // Fixes spacebar selection of dropdown items in FF & IE
            $(document).data('spaceSelect', true);
          }
        }
      }
    },

    mobile: function () {
      this.$element[0].classList.add('mobile-device');
    },

    refresh: function () {
      // update options if data attributes have been changed
      var config = $.extend({}, this.options, this.$element.data());
      this.options = config;

      this.checkDisabled();
      this.setStyle();
      this.render();
      this.createLi();
      this.setWidth();

      this.setSize(true);

      this.$element.trigger('refreshed' + EVENT_KEY);
    },

    hide: function () {
      this.$newElement.hide();
    },

    show: function () {
      this.$newElement.show();
    },

    remove: function () {
      this.$newElement.remove();
      this.$element.remove();
    },

    destroy: function () {
      this.$newElement.before(this.$element).remove();

      if (this.$bsContainer) {
        this.$bsContainer.remove();
      } else {
        this.$menu.remove();
      }

      this.$element
        .off(EVENT_KEY)
        .removeData('selectpicker')
        .removeClass('bs-select-hidden selectpicker');

      $(window).off(EVENT_KEY + '.' + this.selectId);
    }
  };

  // SELECTPICKER PLUGIN DEFINITION
  // ==============================
  function Plugin (option) {
    // get the args of the outer function..
    var args = arguments;
    // The arguments of the function are explicitly re-defined from the argument list, because the shift causes them
    // to get lost/corrupted in android 2.3 and IE9 #715 #775
    var _option = option;

    [].shift.apply(args);

    // if the version was not set successfully
    if (!version.success) {
      // try to retreive it again
      try {
        version.full = ($.fn.dropdown.Constructor.VERSION || '').split(' ')[0].split('.');
      } catch (err) {
        // fall back to use BootstrapVersion if set
        if (Selectpicker.BootstrapVersion) {
          version.full = Selectpicker.BootstrapVersion.split(' ')[0].split('.');
        } else {
          version.full = [version.major, '0', '0'];

          console.warn(
            'There was an issue retrieving Bootstrap\'s version. ' +
            'Ensure Bootstrap is being loaded before bootstrap-select and there is no namespace collision. ' +
            'If loading Bootstrap asynchronously, the version may need to be manually specified via $.fn.selectpicker.Constructor.BootstrapVersion.',
            err
          );
        }
      }

      version.major = version.full[0];
      version.success = true;
    }

    if (version.major === '4') {
      // some defaults need to be changed if using Bootstrap 4
      // check to see if they have already been manually changed before forcing them to update
      var toUpdate = [];

      if (Selectpicker.DEFAULTS.style === classNames.BUTTONCLASS) toUpdate.push({ name: 'style', className: 'BUTTONCLASS' });
      if (Selectpicker.DEFAULTS.iconBase === classNames.ICONBASE) toUpdate.push({ name: 'iconBase', className: 'ICONBASE' });
      if (Selectpicker.DEFAULTS.tickIcon === classNames.TICKICON) toUpdate.push({ name: 'tickIcon', className: 'TICKICON' });

      classNames.DIVIDER = 'dropdown-divider';
      classNames.SHOW = 'show';
      classNames.BUTTONCLASS = 'btn-light input-colors';
      classNames.POPOVERHEADER = 'popover-header';
      classNames.ICONBASE = '';
      classNames.TICKICON = 'bs-ok-default';

      for (var i = 0; i < toUpdate.length; i++) {
        var option = toUpdate[i];
        Selectpicker.DEFAULTS[option.name] = classNames[option.className];
      }
    }

    var value;
    var chain = this.each(function () {
      var $this = $(this);
      if ($this.is('select')) {
        var data = $this.data('selectpicker'),
            options = typeof _option == 'object' && _option;

        if (!data) {
          var dataAttributes = $this.data();

          for (var dataAttr in dataAttributes) {
            if (dataAttributes.hasOwnProperty(dataAttr) && $.inArray(dataAttr, DISALLOWED_ATTRIBUTES) !== -1) {
              delete dataAttributes[dataAttr];
            }
          }

          var config = $.extend({}, Selectpicker.DEFAULTS, $.fn.selectpicker.defaults || {}, dataAttributes, options);
          config.template = $.extend({}, Selectpicker.DEFAULTS.template, ($.fn.selectpicker.defaults ? $.fn.selectpicker.defaults.template : {}), dataAttributes.template, options.template);
          $this.data('selectpicker', (data = new Selectpicker(this, config)));
        } else if (options) {
          for (var i in options) {
            if (options.hasOwnProperty(i)) {
              data.options[i] = options[i];
            }
          }
        }

        if (typeof _option == 'string') {
          if (data[_option] instanceof Function) {
            value = data[_option].apply(data, args);
          } else {
            value = data.options[_option];
          }
        }
      }
    });

    if (typeof value !== 'undefined') {
      // noinspection JSUnusedAssignment
      return value;
    } else {
      return chain;
    }
  }

  var old = $.fn.selectpicker;
  $.fn.selectpicker = Plugin;
  $.fn.selectpicker.Constructor = Selectpicker;

  // SELECTPICKER NO CONFLICT
  // ========================
  $.fn.selectpicker.noConflict = function () {
    $.fn.selectpicker = old;
    return this;
  };

  $(document)
    .off('keydown.bs.dropdown.data-api')
    .on('keydown' + EVENT_KEY, '.bootstrap-select [data-toggle="dropdown"], .bootstrap-select [role="listbox"], .bootstrap-select .bs-searchbox input', Selectpicker.prototype.keydown)
    .on('focusin.modal', '.bootstrap-select [data-toggle="dropdown"], .bootstrap-select [role="listbox"], .bootstrap-select .bs-searchbox input', function (e) {
      e.stopPropagation();
    });

  // SELECTPICKER DATA-API
  // =====================
  $(window).on('load' + EVENT_KEY + '.data-api', function () {
    $('.selectpicker').each(function () {
      var $selectpicker = $(this);
      Plugin.call($selectpicker, $selectpicker.data());
    })
  });
})(jQuery);

/* resources/assets/js/libraries/bootstrap-slider.min.js */
/*! =======================================================
 VERSION  9.7.2
 ========================================================= */
"use strict";var _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(a){return typeof a}:function(a){return a&&"function"==typeof Symbol&&a.constructor===Symbol&&a!==Symbol.prototype?"symbol":typeof a},windowIsDefined="object"===("undefined"==typeof window?"undefined":_typeof(window));!function(a){if("function"==typeof define&&define.amd)define(["jquery"],a);else if("object"===("undefined"==typeof module?"undefined":_typeof(module))&&module.exports){var b;try{b=require("jquery")}catch(c){b=null}module.exports=a(b)}else window&&(window.Sliderinput=a(window.jQuery))}(function(a){var b="sliderinput",c="bootstrapSliderinput";windowIsDefined&&!window.console&&(window.console={}),windowIsDefined&&!window.console.log&&(window.console.log=function(){}),windowIsDefined&&!window.console.warn&&(window.console.warn=function(){});var d;return function(a){function b(){}function c(a){function c(b){b.prototype.option||(b.prototype.option=function(b){a.isPlainObject(b)&&(this.options=a.extend(!0,this.options,b))})}function e(b,c){a.fn[b]=function(e){if("string"==typeof e){for(var g=d.call(arguments,1),h=0,i=this.length;i>h;h++){var j=this[h],k=a.data(j,b);if(k)if(a.isFunction(k[e])&&"_"!==e.charAt(0)){var l=k[e].apply(k,g);if(void 0!==l&&l!==k)return l}else f("no such method '"+e+"' for "+b+" instance");else f("cannot call methods on "+b+" prior to initialization; attempted to call '"+e+"'")}return this}var m=this.map(function(){var d=a.data(this,b);return d?(d.option(e),d._init()):(d=new c(this,e),a.data(this,b,d)),a(this)});return!m||m.length>1?m:m[0]}}if(a){var f="undefined"==typeof console?b:function(a){console.error(a)};return a.bridget=function(a,b){c(b),e(a,b)},a.bridget}}var d=Array.prototype.slice;c(a)}(a),function(a){function e(b,c){function d(a,b){var c="data-sliderinput-"+b.replace(/_/g,"-"),d=a.getAttribute(c);try{return JSON.parse(d)}catch(e){return d}}this._state={value:null,enabled:null,offset:null,size:null,percentage:null,inDrag:!1,over:!1},this.ticksCallbackMap={},this.handleCallbackMap={},"string"==typeof b?this.element=document.querySelector(b):b instanceof HTMLElement&&(this.element=b),c=c?c:{};for(var e=Object.keys(this.defaultOptions),f=0;f<e.length;f++){var h=e[f],i=c[h];i="undefined"!=typeof i?i:d(this.element,h),i=null!==i?i:this.defaultOptions[h],this.options||(this.options={}),this.options[h]=i}"auto"===this.options.rtl&&(this.options.rtl="rtl"===window.getComputedStyle(this.element).direction),"vertical"!==this.options.orientation||"top"!==this.options.tooltip_position&&"bottom"!==this.options.tooltip_position?"horizontal"!==this.options.orientation||"left"!==this.options.tooltip_position&&"right"!==this.options.tooltip_position||(this.options.tooltip_position="top"):this.options.rtl?this.options.tooltip_position="left":this.options.tooltip_position="right";var j,k,l,m,n,o=this.element.style.width,p=!1,q=this.element.parentNode;if(this.sliderinputElem)p=!0;else{this.sliderinputElem=document.createElement("div"),this.sliderinputElem.className="sliderinput";var r=document.createElement("div");if(r.className="sliderinput-track",k=document.createElement("div"),k.className="sliderinput-track-low",j=document.createElement("div"),j.className="sliderinput-selection",l=document.createElement("div"),l.className="sliderinput-track-high",m=document.createElement("div"),m.className="sliderinput-handle min-sliderinput-handle",m.setAttribute("role","sliderinput"),m.setAttribute("aria-valuemin",this.options.min),m.setAttribute("aria-valuemax",this.options.max),n=document.createElement("div"),n.className="sliderinput-handle max-sliderinput-handle",n.setAttribute("role","sliderinput"),n.setAttribute("aria-valuemin",this.options.min),n.setAttribute("aria-valuemax",this.options.max),r.appendChild(k),r.appendChild(j),r.appendChild(l),this.rangeHighlightElements=[],Array.isArray(this.options.rangeHighlights)&&this.options.rangeHighlights.length>0)for(var s=0;s<this.options.rangeHighlights.length;s++){var t=document.createElement("div");t.className="sliderinput-rangeHighlight sliderinput-selection",this.rangeHighlightElements.push(t),r.appendChild(t)}var u=Array.isArray(this.options.labelledby);if(u&&this.options.labelledby[0]&&m.setAttribute("aria-labelledby",this.options.labelledby[0]),u&&this.options.labelledby[1]&&n.setAttribute("aria-labelledby",this.options.labelledby[1]),!u&&this.options.labelledby&&(m.setAttribute("aria-labelledby",this.options.labelledby),n.setAttribute("aria-labelledby",this.options.labelledby)),this.ticks=[],Array.isArray(this.options.ticks)&&this.options.ticks.length>0){for(this.ticksContainer=document.createElement("div"),this.ticksContainer.className="sliderinput-tick-container",f=0;f<this.options.ticks.length;f++){var v=document.createElement("div");if(v.className="sliderinput-tick",this.options.ticks_tooltip){var w=this._addTickListener(),x=w.addMouseEnter(this,v,f),y=w.addMouseLeave(this,v);this.ticksCallbackMap[f]={mouseEnter:x,mouseLeave:y}}this.ticks.push(v),this.ticksContainer.appendChild(v)}j.className+=" tick-sliderinput-selection"}if(this.tickLabels=[],Array.isArray(this.options.ticks_labels)&&this.options.ticks_labels.length>0)for(this.tickLabelContainer=document.createElement("div"),this.tickLabelContainer.className="sliderinput-tick-label-container",f=0;f<this.options.ticks_labels.length;f++){var z=document.createElement("div"),A=0===this.options.ticks_positions.length,B=this.options.reversed&&A?this.options.ticks_labels.length-(f+1):f;z.className="sliderinput-tick-label",z.innerHTML=this.options.ticks_labels[B],this.tickLabels.push(z),this.tickLabelContainer.appendChild(z)}var C=function(a){var b=document.createElement("div");b.className="tooltip-arrow";var c=document.createElement("div");c.className="tooltip-inner",a.appendChild(b),a.appendChild(c)},D=document.createElement("div");D.className="tooltip tooltip-main",D.setAttribute("role","presentation"),C(D);var E=document.createElement("div");E.className="tooltip tooltip-min",E.setAttribute("role","presentation"),C(E);var F=document.createElement("div");F.className="tooltip tooltip-max",F.setAttribute("role","presentation"),C(F),this.sliderinputElem.appendChild(r),this.sliderinputElem.appendChild(D),this.sliderinputElem.appendChild(E),this.sliderinputElem.appendChild(F),this.tickLabelContainer&&this.sliderinputElem.appendChild(this.tickLabelContainer),this.ticksContainer&&this.sliderinputElem.appendChild(this.ticksContainer),this.sliderinputElem.appendChild(m),this.sliderinputElem.appendChild(n),q.insertBefore(this.sliderinputElem,this.element),this.element.style.display="none"}if(a&&(this.$element=a(this.element),this.$sliderinputElem=a(this.sliderinputElem)),this.eventToCallbackMap={},this.sliderinputElem.id=this.options.id,this.touchCapable="ontouchstart"in window||window.DocumentTouch&&document instanceof window.DocumentTouch,this.touchX=0,this.touchY=0,this.tooltip=this.sliderinputElem.querySelector(".tooltip-main"),this.tooltipInner=this.tooltip.querySelector(".tooltip-inner"),this.tooltip_min=this.sliderinputElem.querySelector(".tooltip-min"),this.tooltipInner_min=this.tooltip_min.querySelector(".tooltip-inner"),this.tooltip_max=this.sliderinputElem.querySelector(".tooltip-max"),this.tooltipInner_max=this.tooltip_max.querySelector(".tooltip-inner"),g[this.options.scale]&&(this.options.scale=g[this.options.scale]),p===!0&&(this._removeClass(this.sliderinputElem,"sliderinput-horizontal"),this._removeClass(this.sliderinputElem,"sliderinput-vertical"),this._removeClass(this.sliderinputElem,"sliderinput-rtl"),this._removeClass(this.tooltip,"hide"),this._removeClass(this.tooltip_min,"hide"),this._removeClass(this.tooltip_max,"hide"),["left","right","top","width","height"].forEach(function(a){this._removeProperty(this.trackLow,a),this._removeProperty(this.trackSelection,a),this._removeProperty(this.trackHigh,a)},this),[this.handle1,this.handle2].forEach(function(a){this._removeProperty(a,"left"),this._removeProperty(a,"right"),this._removeProperty(a,"top")},this),[this.tooltip,this.tooltip_min,this.tooltip_max].forEach(function(a){this._removeProperty(a,"left"),this._removeProperty(a,"right"),this._removeProperty(a,"top"),this._removeProperty(a,"margin-left"),this._removeProperty(a,"margin-right"),this._removeProperty(a,"margin-top"),this._removeClass(a,"right"),this._removeClass(a,"left"),this._removeClass(a,"top")},this)),"vertical"===this.options.orientation?(this._addClass(this.sliderinputElem,"sliderinput-vertical"),this.stylePos="top",this.mousePos="pageY",this.sizePos="offsetHeight"):(this._addClass(this.sliderinputElem,"sliderinput-horizontal"),this.sliderinputElem.style.width=o,this.options.orientation="horizontal",this.options.rtl?this.stylePos="right":this.stylePos="left",this.mousePos="pageX",this.sizePos="offsetWidth"),this.options.rtl&&this._addClass(this.sliderinputElem,"sliderinput-rtl"),this._setTooltipPosition(),Array.isArray(this.options.ticks)&&this.options.ticks.length>0&&(this.options.max=Math.max.apply(Math,this.options.ticks),this.options.min=Math.min.apply(Math,this.options.ticks)),Array.isArray(this.options.value)?(this.options.range=!0,this._state.value=this.options.value):this.options.range?this._state.value=[this.options.value,this.options.max]:this._state.value=this.options.value,this.trackLow=k||this.trackLow,this.trackSelection=j||this.trackSelection,this.trackHigh=l||this.trackHigh,"none"===this.options.selection?(this._addClass(this.trackLow,"hide"),this._addClass(this.trackSelection,"hide"),this._addClass(this.trackHigh,"hide")):("after"===this.options.selection||"before"===this.options.selection)&&(this._removeClass(this.trackLow,"hide"),this._removeClass(this.trackSelection,"hide"),this._removeClass(this.trackHigh,"hide")),this.handle1=m||this.handle1,this.handle2=n||this.handle2,p===!0)for(this._removeClass(this.handle1,"round triangle"),this._removeClass(this.handle2,"round triangle hide"),f=0;f<this.ticks.length;f++)this._removeClass(this.ticks[f],"round triangle hide");var G=["round","triangle","custom"],H=-1!==G.indexOf(this.options.handle);if(H)for(this._addClass(this.handle1,this.options.handle),this._addClass(this.handle2,this.options.handle),f=0;f<this.ticks.length;f++)this._addClass(this.ticks[f],this.options.handle);if(this._state.offset=this._offset(this.sliderinputElem),this._state.size=this.sliderinputElem[this.sizePos],this.setValue(this._state.value),this.handle1Keydown=this._keydown.bind(this,0),this.handle1.addEventListener("keydown",this.handle1Keydown,!1),this.handle2Keydown=this._keydown.bind(this,1),this.handle2.addEventListener("keydown",this.handle2Keydown,!1),this.mousedown=this._mousedown.bind(this),this.touchstart=this._touchstart.bind(this),this.touchmove=this._touchmove.bind(this),this.touchCapable){var I=!1;try{var J=Object.defineProperty({},"passive",{get:function(){I=!0}});window.addEventListener("test",null,J)}catch(K){}var L=I?{passive:!0}:!1;this.sliderinputElem.addEventListener("touchstart",this.touchstart,L),this.sliderinputElem.addEventListener("touchmove",this.touchmove,L)}if(this.sliderinputElem.addEventListener("mousedown",this.mousedown,!1),this.resize=this._resize.bind(this),window.addEventListener("resize",this.resize,!1),"hide"===this.options.tooltip)this._addClass(this.tooltip,"hide"),this._addClass(this.tooltip_min,"hide"),this._addClass(this.tooltip_max,"hide");else if("always"===this.options.tooltip)this._showTooltip(),this._alwaysShowTooltip=!0;else{if(this.showTooltip=this._showTooltip.bind(this),this.hideTooltip=this._hideTooltip.bind(this),this.options.ticks_tooltip){var M=this._addTickListener(),N=M.addMouseEnter(this,this.handle1),O=M.addMouseLeave(this,this.handle1);this.handleCallbackMap.handle1={mouseEnter:N,mouseLeave:O},N=M.addMouseEnter(this,this.handle2),O=M.addMouseLeave(this,this.handle2),this.handleCallbackMap.handle2={mouseEnter:N,mouseLeave:O}}else this.sliderinputElem.addEventListener("mouseenter",this.showTooltip,!1),this.sliderinputElem.addEventListener("mouseleave",this.hideTooltip,!1);this.handle1.addEventListener("focus",this.showTooltip,!1),this.handle1.addEventListener("blur",this.hideTooltip,!1),this.handle2.addEventListener("focus",this.showTooltip,!1),this.handle2.addEventListener("blur",this.hideTooltip,!1)}this.options.enabled?this.enable():this.disable()}var f={formatInvalidInputErrorMsg:function(a){return"Invalid input value '"+a+"' passed in"},callingContextNotSliderinputInstance:"Calling context element does not have instance of Sliderinput bound to it. Check your code to make sure the JQuery object returned from the call to the sliderinput() initializer is calling the method"},g={linear:{toValue:function(a){var b=a/100*(this.options.max-this.options.min),c=!0;if(this.options.ticks_positions.length>0){for(var d,e,f,g=0,h=1;h<this.options.ticks_positions.length;h++)if(a<=this.options.ticks_positions[h]){d=this.options.ticks[h-1],f=this.options.ticks_positions[h-1],e=this.options.ticks[h],g=this.options.ticks_positions[h];break}var i=(a-f)/(g-f);b=d+i*(e-d),c=!1}var j=c?this.options.min:0,k=j+Math.round(b/this.options.step)*this.options.step;return k<this.options.min?this.options.min:k>this.options.max?this.options.max:k},toPercentage:function(a){if(this.options.max===this.options.min)return 0;if(this.options.ticks_positions.length>0){for(var b,c,d,e=0,f=0;f<this.options.ticks.length;f++)if(a<=this.options.ticks[f]){b=f>0?this.options.ticks[f-1]:0,d=f>0?this.options.ticks_positions[f-1]:0,c=this.options.ticks[f],e=this.options.ticks_positions[f];break}if(f>0){var g=(a-b)/(c-b);return d+g*(e-d)}}return 100*(a-this.options.min)/(this.options.max-this.options.min)}},logarithmic:{toValue:function(a){var b=0===this.options.min?0:Math.log(this.options.min),c=Math.log(this.options.max),d=Math.exp(b+(c-b)*a/100);return d=this.options.min+Math.round((d-this.options.min)/this.options.step)*this.options.step,d<this.options.min?this.options.min:d>this.options.max?this.options.max:d},toPercentage:function(a){if(this.options.max===this.options.min)return 0;var b=Math.log(this.options.max),c=0===this.options.min?0:Math.log(this.options.min),d=0===a?0:Math.log(a);return 100*(d-c)/(b-c)}}};d=function(a,b){return e.call(this,a,b),this},d.prototype={_init:function(){},constructor:d,defaultOptions:{id:"",min:0,max:10,step:1,precision:0,orientation:"horizontal",value:5,range:!1,selection:"before",tooltip:"show",tooltip_split:!1,handle:"round",reversed:!1,rtl:"auto",enabled:!0,formatter:function(a){return Array.isArray(a)?a[0]+" : "+a[1]:a},natural_arrow_keys:!1,ticks:[],ticks_positions:[],ticks_labels:[],ticks_snap_bounds:0,ticks_tooltip:!1,scale:"linear",focus:!1,tooltip_position:null,labelledby:null,rangeHighlights:[]},getElement:function(){return this.sliderinputElem},getValue:function(){return this.options.range?this._state.value:this._state.value[0]},setValue:function(a,b,c){a||(a=0);var d=this.getValue();this._state.value=this._validateInputValue(a);var e=this._applyPrecision.bind(this);this.options.range?(this._state.value[0]=e(this._state.value[0]),this._state.value[1]=e(this._state.value[1]),this._state.value[0]=Math.max(this.options.min,Math.min(this.options.max,this._state.value[0])),this._state.value[1]=Math.max(this.options.min,Math.min(this.options.max,this._state.value[1]))):(this._state.value=e(this._state.value),this._state.value=[Math.max(this.options.min,Math.min(this.options.max,this._state.value))],this._addClass(this.handle2,"hide"),"after"===this.options.selection?this._state.value[1]=this.options.max:this._state.value[1]=this.options.min),this.options.max>this.options.min?this._state.percentage=[this._toPercentage(this._state.value[0]),this._toPercentage(this._state.value[1]),100*this.options.step/(this.options.max-this.options.min)]:this._state.percentage=[0,0,100],this._layout();var f=this.options.range?this._state.value:this._state.value[0];return this._setDataVal(f),b===!0&&this._trigger("slide",f),d!==f&&c===!0&&this._trigger("change",{oldValue:d,newValue:f}),this},destroy:function(){this._removeSliderinputEventHandlers(),this.sliderinputElem.parentNode.removeChild(this.sliderinputElem),this.element.style.display="",this._cleanUpEventCallbacksMap(),this.element.removeAttribute("data"),a&&(this._unbindJQueryEventHandlers(),this.$element.removeData("sliderinput"))},disable:function(){return this._state.enabled=!1,this.handle1.removeAttribute("tabindex"),this.handle2.removeAttribute("tabindex"),this._addClass(this.sliderinputElem,"sliderinput-disabled"),this._trigger("slideDisabled"),this},enable:function(){return this._state.enabled=!0,this.handle1.setAttribute("tabindex",0),this.handle2.setAttribute("tabindex",0),this._removeClass(this.sliderinputElem,"sliderinput-disabled"),this._trigger("slideEnabled"),this},toggle:function(){return this._state.enabled?this.disable():this.enable(),this},isEnabled:function(){return this._state.enabled},on:function(a,b){return this._bindNonQueryEventHandler(a,b),this},off:function(b,c){a?(this.$element.off(b,c),this.$sliderinputElem.off(b,c)):this._unbindNonQueryEventHandler(b,c)},getAttribute:function(a){return a?this.options[a]:this.options},setAttribute:function(a,b){return this.options[a]=b,this},refresh:function(){return this._removeSliderinputEventHandlers(),e.call(this,this.element,this.options),a&&a.data(this.element,"sliderinput",this),this},relayout:function(){return this._resize(),this._layout(),this},_removeSliderinputEventHandlers:function(){if(this.handle1.removeEventListener("keydown",this.handle1Keydown,!1),this.handle2.removeEventListener("keydown",this.handle2Keydown,!1),this.options.ticks_tooltip){for(var a=this.ticksContainer.getElementsByClassName("sliderinput-tick"),b=0;b<a.length;b++)a[b].removeEventListener("mouseenter",this.ticksCallbackMap[b].mouseEnter,!1),a[b].removeEventListener("mouseleave",this.ticksCallbackMap[b].mouseLeave,!1);this.handle1.removeEventListener("mouseenter",this.handleCallbackMap.handle1.mouseEnter,!1),this.handle2.removeEventListener("mouseenter",this.handleCallbackMap.handle2.mouseEnter,!1),this.handle1.removeEventListener("mouseleave",this.handleCallbackMap.handle1.mouseLeave,!1),this.handle2.removeEventListener("mouseleave",this.handleCallbackMap.handle2.mouseLeave,!1)}this.handleCallbackMap=null,this.ticksCallbackMap=null,this.showTooltip&&(this.handle1.removeEventListener("focus",this.showTooltip,!1),this.handle2.removeEventListener("focus",this.showTooltip,!1)),this.hideTooltip&&(this.handle1.removeEventListener("blur",this.hideTooltip,!1),this.handle2.removeEventListener("blur",this.hideTooltip,!1)),this.showTooltip&&this.sliderinputElem.removeEventListener("mouseenter",this.showTooltip,!1),this.hideTooltip&&this.sliderinputElem.removeEventListener("mouseleave",this.hideTooltip,!1),this.sliderinputElem.removeEventListener("touchstart",this.touchstart,!1),this.sliderinputElem.removeEventListener("touchmove",this.touchmove,!1),this.sliderinputElem.removeEventListener("mousedown",this.mousedown,!1),window.removeEventListener("resize",this.resize,!1)},_bindNonQueryEventHandler:function(a,b){void 0===this.eventToCallbackMap[a]&&(this.eventToCallbackMap[a]=[]),this.eventToCallbackMap[a].push(b)},_unbindNonQueryEventHandler:function(a,b){var c=this.eventToCallbackMap[a];if(void 0!==c)for(var d=0;d<c.length;d++)if(c[d]===b){c.splice(d,1);break}},_cleanUpEventCallbacksMap:function(){for(var a=Object.keys(this.eventToCallbackMap),b=0;b<a.length;b++){var c=a[b];delete this.eventToCallbackMap[c]}},_showTooltip:function(){this.options.tooltip_split===!1?(this._addClass(this.tooltip,"in"),this.tooltip_min.style.display="none",this.tooltip_max.style.display="none"):(this._addClass(this.tooltip_min,"in"),this._addClass(this.tooltip_max,"in"),this.tooltip.style.display="none"),this._state.over=!0},_hideTooltip:function(){this._state.inDrag===!1&&this.alwaysShowTooltip!==!0&&(this._removeClass(this.tooltip,"in"),this._removeClass(this.tooltip_min,"in"),this._removeClass(this.tooltip_max,"in")),this._state.over=!1},_setToolTipOnMouseOver:function(a){function b(a,b){return b?[100-a.percentage[0],this.options.range?100-a.percentage[1]:a.percentage[1]]:[a.percentage[0],a.percentage[1]]}var c=this.options.formatter(a?a.value[0]:this._state.value[0]),d=a?b(a,this.options.reversed):b(this._state,this.options.reversed);this._setText(this.tooltipInner,c),this.tooltip.style[this.stylePos]=d[0]+"%","vertical"===this.options.orientation?this._css(this.tooltip,"margin-"+this.stylePos,-this.tooltip.offsetHeight/2+"px"):this._css(this.tooltip,"margin-"+this.stylePos,-this.tooltip.offsetWidth/2+"px")},_addTickListener:function(){return{addMouseEnter:function(a,b,c){var d=function(){var b=a._state,d=c>=0?c:this.attributes["aria-valuenow"].value,e=parseInt(d,10);b.value[0]=e,b.percentage[0]=a.options.ticks_positions[e],a._setToolTipOnMouseOver(b),a._showTooltip()};return b.addEventListener("mouseenter",d,!1),d},addMouseLeave:function(a,b){var c=function(){a._hideTooltip()};return b.addEventListener("mouseleave",c,!1),c}}},_layout:function(){var a;if(a=this.options.reversed?[100-this._state.percentage[0],this.options.range?100-this._state.percentage[1]:this._state.percentage[1]]:[this._state.percentage[0],this._state.percentage[1]],this.handle1.style[this.stylePos]=a[0]+"%",this.handle1.setAttribute("aria-valuenow",this._state.value[0]),isNaN(this.options.formatter(this._state.value[0]))&&this.handle1.setAttribute("aria-valuetext",this.options.formatter(this._state.value[0])),this.handle2.style[this.stylePos]=a[1]+"%",this.handle2.setAttribute("aria-valuenow",this._state.value[1]),isNaN(this.options.formatter(this._state.value[1]))&&this.handle2.setAttribute("aria-valuetext",this.options.formatter(this._state.value[1])),this.rangeHighlightElements.length>0&&Array.isArray(this.options.rangeHighlights)&&this.options.rangeHighlights.length>0)for(var b=0;b<this.options.rangeHighlights.length;b++){var c=this._toPercentage(this.options.rangeHighlights[b].start),d=this._toPercentage(this.options.rangeHighlights[b].end);if(this.options.reversed){var e=100-d;d=100-c,c=e}var f=this._createHighlightRange(c,d);f?"vertical"===this.options.orientation?(this.rangeHighlightElements[b].style.top=f.start+"%",this.rangeHighlightElements[b].style.height=f.size+"%"):(this.options.rtl?this.rangeHighlightElements[b].style.right=f.start+"%":this.rangeHighlightElements[b].style.left=f.start+"%",this.rangeHighlightElements[b].style.width=f.size+"%"):this.rangeHighlightElements[b].style.display="none"}if(Array.isArray(this.options.ticks)&&this.options.ticks.length>0){var g,h="vertical"===this.options.orientation?"height":"width";g="vertical"===this.options.orientation?"marginTop":this.options.rtl?"marginRight":"marginLeft";var i=this._state.size/(this.options.ticks.length-1);if(this.tickLabelContainer){var j=0;if(0===this.options.ticks_positions.length)"vertical"!==this.options.orientation&&(this.tickLabelContainer.style[g]=-i/2+"px"),j=this.tickLabelContainer.offsetHeight;else for(k=0;k<this.tickLabelContainer.childNodes.length;k++)this.tickLabelContainer.childNodes[k].offsetHeight>j&&(j=this.tickLabelContainer.childNodes[k].offsetHeight);"horizontal"===this.options.orientation&&(this.sliderinputElem.style.marginBottom=j+"px")}for(var k=0;k<this.options.ticks.length;k++){var l=this.options.ticks_positions[k]||this._toPercentage(this.options.ticks[k]);this.options.reversed&&(l=100-l),this.ticks[k].style[this.stylePos]=l+"%",this._removeClass(this.ticks[k],"in-selection"),this.options.range?l>=a[0]&&l<=a[1]&&this._addClass(this.ticks[k],"in-selection"):"after"===this.options.selection&&l>=a[0]?this._addClass(this.ticks[k],"in-selection"):"before"===this.options.selection&&l<=a[0]&&this._addClass(this.ticks[k],"in-selection"),this.tickLabels[k]&&(this.tickLabels[k].style[h]=i+"px","vertical"!==this.options.orientation&&void 0!==this.options.ticks_positions[k]?(this.tickLabels[k].style.position="absolute",this.tickLabels[k].style[this.stylePos]=l+"%",this.tickLabels[k].style[g]=-i/2+"px"):"vertical"===this.options.orientation&&(this.options.rtl?this.tickLabels[k].style.marginRight=this.sliderinputElem.offsetWidth+"px":this.tickLabels[k].style.marginLeft=this.sliderinputElem.offsetWidth+"px",this.tickLabelContainer.style[g]=this.sliderinputElem.offsetWidth/2*-1+"px"))}}var m;if(this.options.range){m=this.options.formatter(this._state.value),this._setText(this.tooltipInner,m),this.tooltip.style[this.stylePos]=(a[1]+a[0])/2+"%","vertical"===this.options.orientation?this._css(this.tooltip,"margin-"+this.stylePos,-this.tooltip.offsetHeight/2+"px"):this._css(this.tooltip,"margin-"+this.stylePos,-this.tooltip.offsetWidth/2+"px");var n=this.options.formatter(this._state.value[0]);this._setText(this.tooltipInner_min,n);var o=this.options.formatter(this._state.value[1]);this._setText(this.tooltipInner_max,o),this.tooltip_min.style[this.stylePos]=a[0]+"%","vertical"===this.options.orientation?this._css(this.tooltip_min,"margin-"+this.stylePos,-this.tooltip_min.offsetHeight/2+"px"):this._css(this.tooltip_min,"margin-"+this.stylePos,-this.tooltip_min.offsetWidth/2+"px"),this.tooltip_max.style[this.stylePos]=a[1]+"%","vertical"===this.options.orientation?this._css(this.tooltip_max,"margin-"+this.stylePos,-this.tooltip_max.offsetHeight/2+"px"):this._css(this.tooltip_max,"margin-"+this.stylePos,-this.tooltip_max.offsetWidth/2+"px")}else m=this.options.formatter(this._state.value[0]),this._setText(this.tooltipInner,m),this.tooltip.style[this.stylePos]=a[0]+"%","vertical"===this.options.orientation?this._css(this.tooltip,"margin-"+this.stylePos,-this.tooltip.offsetHeight/2+"px"):this._css(this.tooltip,"margin-"+this.stylePos,-this.tooltip.offsetWidth/2+"px");if("vertical"===this.options.orientation)this.trackLow.style.top="0",this.trackLow.style.height=Math.min(a[0],a[1])+"%",this.trackSelection.style.top=Math.min(a[0],a[1])+"%",this.trackSelection.style.height=Math.abs(a[0]-a[1])+"%",this.trackHigh.style.bottom="0",this.trackHigh.style.height=100-Math.min(a[0],a[1])-Math.abs(a[0]-a[1])+"%";else{"right"===this.stylePos?this.trackLow.style.right="0":this.trackLow.style.left="0",this.trackLow.style.width=Math.min(a[0],a[1])+"%","right"===this.stylePos?this.trackSelection.style.right=Math.min(a[0],a[1])+"%":this.trackSelection.style.left=Math.min(a[0],a[1])+"%",this.trackSelection.style.width=Math.abs(a[0]-a[1])+"%","right"===this.stylePos?this.trackHigh.style.left="0":this.trackHigh.style.right="0",this.trackHigh.style.width=100-Math.min(a[0],a[1])-Math.abs(a[0]-a[1])+"%";var p=this.tooltip_min.getBoundingClientRect(),q=this.tooltip_max.getBoundingClientRect();"bottom"===this.options.tooltip_position?p.right>q.left?(this._removeClass(this.tooltip_max,"bottom"),this._addClass(this.tooltip_max,"top"),this.tooltip_max.style.top="",this.tooltip_max.style.bottom="22px"):(this._removeClass(this.tooltip_max,"top"),this._addClass(this.tooltip_max,"bottom"),this.tooltip_max.style.top=this.tooltip_min.style.top,this.tooltip_max.style.bottom=""):p.right>q.left?(this._removeClass(this.tooltip_max,"top"),this._addClass(this.tooltip_max,"bottom"),this.tooltip_max.style.top="18px"):(this._removeClass(this.tooltip_max,"bottom"),this._addClass(this.tooltip_max,"top"),this.tooltip_max.style.top=this.tooltip_min.style.top)}},_createHighlightRange:function(a,b){return this._isHighlightRange(a,b)?a>b?{start:b,size:a-b}:{start:a,size:b-a}:null},_isHighlightRange:function(a,b){return a>=0&&100>=a&&b>=0&&100>=b?!0:!1},_resize:function(a){this._state.offset=this._offset(this.sliderinputElem),this._state.size=this.sliderinputElem[this.sizePos],this._layout()},_removeProperty:function(a,b){a.style.removeProperty?a.style.removeProperty(b):a.style.removeAttribute(b)},_mousedown:function(a){if(!this._state.enabled)return!1;this._state.offset=this._offset(this.sliderinputElem),this._state.size=this.sliderinputElem[this.sizePos];var b=this._getPercentage(a);if(this.options.range){var c=Math.abs(this._state.percentage[0]-b),d=Math.abs(this._state.percentage[1]-b);this._state.dragged=d>c?0:1,this._adjustPercentageForRangeSliderinputs(b)}else this._state.dragged=0;this._state.percentage[this._state.dragged]=b,this._layout(),this.touchCapable&&(document.removeEventListener("touchmove",this.mousemove,!1),document.removeEventListener("touchend",this.mouseup,!1)),this.mousemove&&document.removeEventListener("mousemove",this.mousemove,!1),this.mouseup&&document.removeEventListener("mouseup",this.mouseup,!1),this.mousemove=this._mousemove.bind(this),this.mouseup=this._mouseup.bind(this),this.touchCapable&&(document.addEventListener("touchmove",this.mousemove,!1),document.addEventListener("touchend",this.mouseup,!1)),document.addEventListener("mousemove",this.mousemove,!1),document.addEventListener("mouseup",this.mouseup,!1),this._state.inDrag=!0;var e=this._calculateValue();return this._trigger("slideStart",e),this._setDataVal(e),this.setValue(e,!1,!0),a.returnValue=!1,this.options.focus&&this._triggerFocusOnHandle(this._state.dragged),!0},_touchstart:function(a){if(void 0===a.changedTouches)return void this._mousedown(a);var b=a.changedTouches[0];this.touchX=b.pageX,this.touchY=b.pageY},_triggerFocusOnHandle:function(a){0===a&&this.handle1.focus(),1===a&&this.handle2.focus()},_keydown:function(a,b){if(!this._state.enabled)return!1;var c;switch(b.keyCode){case 37:case 40:c=-1;break;case 39:case 38:c=1}if(c){if(this.options.natural_arrow_keys){var d="vertical"===this.options.orientation&&!this.options.reversed,e="horizontal"===this.options.orientation&&this.options.reversed;(d||e)&&(c=-c)}var f=this._state.value[a]+c*this.options.step,g=f/this.options.max*100;if(this._state.keyCtrl=a,this.options.range){this._adjustPercentageForRangeSliderinputs(g);var h=this._state.keyCtrl?this._state.value[0]:f,i=this._state.keyCtrl?f:this._state.value[1];f=[h,i]}return this._trigger("slideStart",f),this._setDataVal(f),this.setValue(f,!0,!0),this._setDataVal(f),this._trigger("slideStop",f),this._layout(),this._pauseEvent(b),delete this._state.keyCtrl,!1}},_pauseEvent:function(a){a.stopPropagation&&a.stopPropagation(),a.preventDefault&&a.preventDefault(),a.cancelBubble=!0,a.returnValue=!1},_mousemove:function(a){if(!this._state.enabled)return!1;var b=this._getPercentage(a);this._adjustPercentageForRangeSliderinputs(b),this._state.percentage[this._state.dragged]=b,this._layout();var c=this._calculateValue(!0);return this.setValue(c,!0,!0),!1},_touchmove:function(a){if(void 0!==a.changedTouches){var b=a.changedTouches[0],c=b.pageX-this.touchX,d=b.pageY-this.touchY;this._state.inDrag||("vertical"===this.options.orientation&&5>=c&&c>=-5&&(d>=15||-15>=d)?this._mousedown(a):5>=d&&d>=-5&&(c>=15||-15>=c)&&this._mousedown(a))}},_adjustPercentageForRangeSliderinputs:function(a){if(this.options.range){var b=this._getNumDigitsAfterDecimalPlace(a);b=b?b-1:0;var c=this._applyToFixedAndParseFloat(a,b);0===this._state.dragged&&this._applyToFixedAndParseFloat(this._state.percentage[1],b)<c?(this._state.percentage[0]=this._state.percentage[1],this._state.dragged=1):1===this._state.dragged&&this._applyToFixedAndParseFloat(this._state.percentage[0],b)>c?(this._state.percentage[1]=this._state.percentage[0],this._state.dragged=0):0===this._state.keyCtrl&&this._state.value[1]/this.options.max*100<a?(this._state.percentage[0]=this._state.percentage[1],this._state.keyCtrl=1,this.handle2.focus()):1===this._state.keyCtrl&&this._state.value[0]/this.options.max*100>a&&(this._state.percentage[1]=this._state.percentage[0],this._state.keyCtrl=0,this.handle1.focus())}},_mouseup:function(){if(!this._state.enabled)return!1;this.touchCapable&&(document.removeEventListener("touchmove",this.mousemove,!1),document.removeEventListener("touchend",this.mouseup,!1)),document.removeEventListener("mousemove",this.mousemove,!1),document.removeEventListener("mouseup",this.mouseup,!1),this._state.inDrag=!1,this._state.over===!1&&this._hideTooltip();var a=this._calculateValue(!0);return this._layout(),this._setDataVal(a),this._trigger("slideStop",a),!1},_calculateValue:function(a){var b;if(this.options.range?(b=[this.options.min,this.options.max],0!==this._state.percentage[0]&&(b[0]=this._toValue(this._state.percentage[0]),b[0]=this._applyPrecision(b[0])),100!==this._state.percentage[1]&&(b[1]=this._toValue(this._state.percentage[1]),b[1]=this._applyPrecision(b[1]))):(b=this._toValue(this._state.percentage[0]),b=parseFloat(b),b=this._applyPrecision(b)),a){for(var c=[b,1/0],d=0;d<this.options.ticks.length;d++){
  var e=Math.abs(this.options.ticks[d]-b);e<=c[1]&&(c=[this.options.ticks[d],e])}if(c[1]<=this.options.ticks_snap_bounds)return c[0]}return b},_applyPrecision:function(a){var b=this.options.precision||this._getNumDigitsAfterDecimalPlace(this.options.step);return this._applyToFixedAndParseFloat(a,b)},_getNumDigitsAfterDecimalPlace:function(a){var b=(""+a).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);return b?Math.max(0,(b[1]?b[1].length:0)-(b[2]?+b[2]:0)):0},_applyToFixedAndParseFloat:function(a,b){var c=a.toFixed(b);return parseFloat(c)},_getPercentage:function(a){!this.touchCapable||"touchstart"!==a.type&&"touchmove"!==a.type||(a=a.touches[0]);var b=a[this.mousePos],c=this._state.offset[this.stylePos],d=b-c;"right"===this.stylePos&&(d=-d);var e=d/this._state.size*100;return e=Math.round(e/this._state.percentage[2])*this._state.percentage[2],this.options.reversed&&(e=100-e),Math.max(0,Math.min(100,e))},_validateInputValue:function(a){if(isNaN(+a)){if(Array.isArray(a))return this._validateArray(a),a;throw new Error(f.formatInvalidInputErrorMsg(a))}return+a},_validateArray:function(a){for(var b=0;b<a.length;b++){var c=a[b];if("number"!=typeof c)throw new Error(f.formatInvalidInputErrorMsg(c))}},_setDataVal:function(a){this.element.setAttribute("data-value",a),this.element.setAttribute("value",a),this.element.value=a},_trigger:function(b,c){c=c||0===c?c:void 0;var d=this.eventToCallbackMap[b];if(d&&d.length)for(var e=0;e<d.length;e++){var f=d[e];f(c)}a&&this._triggerJQueryEvent(b,c)},_triggerJQueryEvent:function(a,b){var c={type:a,value:b};this.$element.trigger(c),this.$sliderinputElem.trigger(c)},_unbindJQueryEventHandlers:function(){this.$element.off(),this.$sliderinputElem.off()},_setText:function(a,b){"undefined"!=typeof a.textContent?a.textContent=b:"undefined"!=typeof a.innerText&&(a.innerText=b)},_removeClass:function(a,b){for(var c=b.split(" "),d=a.className,e=0;e<c.length;e++){var f=c[e],g=new RegExp("(?:\\s|^)"+f+"(?:\\s|$)");d=d.replace(g," ")}a.className=d.trim()},_addClass:function(a,b){for(var c=b.split(" "),d=a.className,e=0;e<c.length;e++){var f=c[e],g=new RegExp("(?:\\s|^)"+f+"(?:\\s|$)"),h=g.test(d);h||(d+=" "+f)}a.className=d.trim()},_offsetLeft:function(a){return a.getBoundingClientRect().left},_offsetRight:function(a){return a.getBoundingClientRect().right},_offsetTop:function(a){for(var b=a.offsetTop;(a=a.offsetParent)&&!isNaN(a.offsetTop);)b+=a.offsetTop,"BODY"!==a.tagName&&(b-=a.scrollTop);return b},_offset:function(a){return{left:this._offsetLeft(a),right:this._offsetRight(a),top:this._offsetTop(a)}},_css:function(b,c,d){if(a)a.style(b,c,d);else{var e=c.replace(/^-ms-/,"ms-").replace(/-([\da-z])/gi,function(a,b){return b.toUpperCase()});b.style[e]=d}},_toValue:function(a){return this.options.scale.toValue.apply(this,[a])},_toPercentage:function(a){return this.options.scale.toPercentage.apply(this,[a])},_setTooltipPosition:function(){var a=[this.tooltip,this.tooltip_min,this.tooltip_max];if("vertical"===this.options.orientation){var b;b=this.options.tooltip_position?this.options.tooltip_position:this.options.rtl?"left":"right";var c="left"===b?"right":"left";a.forEach(function(a){this._addClass(a,b),a.style[c]="100%"}.bind(this))}else"bottom"===this.options.tooltip_position?a.forEach(function(a){this._addClass(a,"bottom"),a.style.top="22px"}.bind(this)):a.forEach(function(a){this._addClass(a,"top"),a.style.top=-this.tooltip.outerHeight-14+"px"}.bind(this))}},a&&a.fn&&!function(){var e=void 0;a.fn.sliderinput?(windowIsDefined&&window.console.warn("bootstrap-sliderinput.js - WARNING: $.fn.sliderinput namespace is already bound. Use the $.fn.bootstrapSliderinput namespace instead."),e=c):(a.bridget(b,d),e=b),a.bridget(c,d),a(function(){a("input[data-provide=sliderinput]")[e]()})}()}(a),d});

/* resources/assets/js/libraries/bootstrap-easy-modal.js */
window.showBSModal = function self(options) {

    options = $.extend({
            title : '',
            body : '',
            remote : false,
            backdrop : 'static',
            size : false,
            onShow : false,
            onHide : false,
            actions : false
        }, options);

    self.onShow = typeof options.onShow === 'function' ? options.onShow : function () {};
    self.onHide = typeof options.onHide === 'function' ? options.onHide : function () {};

    if (self.$modal === undefined) {
        self.$modal = $('<div class="modal fade sh-modal"><div class="modal-dialog"><div class="modal-content"></div></div></div>').appendTo('#modals');
        self.$modal.on('shown.bs.modal', function (e) {
            self.onShow.call(this, e);
        });
        self.$modal.on('hidden.bs.modal', function (e) {
            self.onHide.call(this, e);
        });
    }

    var modalClass = {
        small : "modal-sm",
        large : "modal-lg"
    };

    self.$modal.data('bs.modal', false);
    self.$modal.find('.modal-dialog').removeClass().addClass('modal-dialog ' + (modalClass[options.size] || ''));
    self.$modal.find('.modal-content').html('<div class="modal-header"><h4 class="modal-title">${title}</h4><button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button></div><div class="modal-body">${body}</div><div class="modal-footer"></div>'.replace('${title}', options.title).replace('${body}', options.body));

    var footer = self.$modal.find('.modal-footer');
    if (Object.prototype.toString.call(options.actions) === "[object Array]") {
        for (var i = 0, l = options.actions.length; i < l; i++) {
            options.actions[i].onClick = typeof options.actions[i].onClick === 'function' ? options.actions[i].onClick : function () {};
            $('<button type="button" class="btn ' + (options.actions[i].cssClass || '') + '">' + (options.actions[i].label || '{Label Missing!}') + '</button>').appendTo(footer).on('click', options.actions[i].onClick);
        }
    } else {
        $('<button type="button" class="btn btn-flat" data-dismiss="modal">Close</button>').appendTo(footer);
    }

    self.$modal.modal(options);
};

/* resources/assets/js/libraries/moment.js */
//! moment.js
//! version : 2.17.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
!function(a,b){"object"==typeof exports&&"undefined"!=typeof module?module.exports=b():"function"==typeof define&&define.amd?define(b):a.moment=b()}(this,function(){"use strict";function a(){return od.apply(null,arguments)}
// This is done to register the method called with moment()
// without creating circular dependencies.
  function b(a){od=a}function c(a){return a instanceof Array||"[object Array]"===Object.prototype.toString.call(a)}function d(a){
// IE8 will treat undefined and null as object if it wasn't for
// input != null
    return null!=a&&"[object Object]"===Object.prototype.toString.call(a)}function e(a){var b;for(b in a)
// even if its not own property I'd still call it non-empty
    return!1;return!0}function f(a){return"number"==typeof a||"[object Number]"===Object.prototype.toString.call(a)}function g(a){return a instanceof Date||"[object Date]"===Object.prototype.toString.call(a)}function h(a,b){var c,d=[];for(c=0;c<a.length;++c)d.push(b(a[c],c));return d}function i(a,b){return Object.prototype.hasOwnProperty.call(a,b)}function j(a,b){for(var c in b)i(b,c)&&(a[c]=b[c]);return i(b,"toString")&&(a.toString=b.toString),i(b,"valueOf")&&(a.valueOf=b.valueOf),a}function k(a,b,c,d){return rb(a,b,c,d,!0).utc()}function l(){
// We need to deep clone this object.
    return{empty:!1,unusedTokens:[],unusedInput:[],overflow:-2,charsLeftOver:0,nullInput:!1,invalidMonth:null,invalidFormat:!1,userInvalidated:!1,iso:!1,parsedDateParts:[],meridiem:null}}function m(a){return null==a._pf&&(a._pf=l()),a._pf}function n(a){if(null==a._isValid){var b=m(a),c=qd.call(b.parsedDateParts,function(a){return null!=a}),d=!isNaN(a._d.getTime())&&b.overflow<0&&!b.empty&&!b.invalidMonth&&!b.invalidWeekday&&!b.nullInput&&!b.invalidFormat&&!b.userInvalidated&&(!b.meridiem||b.meridiem&&c);if(a._strict&&(d=d&&0===b.charsLeftOver&&0===b.unusedTokens.length&&void 0===b.bigHour),null!=Object.isFrozen&&Object.isFrozen(a))return d;a._isValid=d}return a._isValid}function o(a){var b=k(NaN);return null!=a?j(m(b),a):m(b).userInvalidated=!0,b}function p(a){return void 0===a}function q(a,b){var c,d,e;if(p(b._isAMomentObject)||(a._isAMomentObject=b._isAMomentObject),p(b._i)||(a._i=b._i),p(b._f)||(a._f=b._f),p(b._l)||(a._l=b._l),p(b._strict)||(a._strict=b._strict),p(b._tzm)||(a._tzm=b._tzm),p(b._isUTC)||(a._isUTC=b._isUTC),p(b._offset)||(a._offset=b._offset),p(b._pf)||(a._pf=m(b)),p(b._locale)||(a._locale=b._locale),rd.length>0)for(c in rd)d=rd[c],e=b[d],p(e)||(a[d]=e);return a}
// Moment prototype object
  function r(b){q(this,b),this._d=new Date(null!=b._d?b._d.getTime():NaN),this.isValid()||(this._d=new Date(NaN)),
// Prevent infinite loop in case updateOffset creates new moment
// objects.
  sd===!1&&(sd=!0,a.updateOffset(this),sd=!1)}function s(a){return a instanceof r||null!=a&&null!=a._isAMomentObject}function t(a){return a<0?Math.ceil(a)||0:Math.floor(a)}function u(a){var b=+a,c=0;return 0!==b&&isFinite(b)&&(c=t(b)),c}
// compare two arrays, return the number of differences
  function v(a,b,c){var d,e=Math.min(a.length,b.length),f=Math.abs(a.length-b.length),g=0;for(d=0;d<e;d++)(c&&a[d]!==b[d]||!c&&u(a[d])!==u(b[d]))&&g++;return g+f}function w(b){a.suppressDeprecationWarnings===!1&&"undefined"!=typeof console&&console.warn&&console.warn("Deprecation warning: "+b)}function x(b,c){var d=!0;return j(function(){if(null!=a.deprecationHandler&&a.deprecationHandler(null,b),d){for(var e,f=[],g=0;g<arguments.length;g++){if(e="","object"==typeof arguments[g]){e+="\n["+g+"] ";for(var h in arguments[0])e+=h+": "+arguments[0][h]+", ";e=e.slice(0,-2)}else e=arguments[g];f.push(e)}w(b+"\nArguments: "+Array.prototype.slice.call(f).join("")+"\n"+(new Error).stack),d=!1}return c.apply(this,arguments)},c)}function y(b,c){null!=a.deprecationHandler&&a.deprecationHandler(b,c),td[b]||(w(c),td[b]=!0)}function z(a){return a instanceof Function||"[object Function]"===Object.prototype.toString.call(a)}function A(a){var b,c;for(c in a)b=a[c],z(b)?this[c]=b:this["_"+c]=b;this._config=a,
// Lenient ordinal parsing accepts just a number in addition to
// number + (possibly) stuff coming from _ordinalParseLenient.
    this._ordinalParseLenient=new RegExp(this._ordinalParse.source+"|"+/\d{1,2}/.source)}function B(a,b){var c,e=j({},a);for(c in b)i(b,c)&&(d(a[c])&&d(b[c])?(e[c]={},j(e[c],a[c]),j(e[c],b[c])):null!=b[c]?e[c]=b[c]:delete e[c]);for(c in a)i(a,c)&&!i(b,c)&&d(a[c])&&(
// make sure changes to properties don't modify parent config
    e[c]=j({},e[c]));return e}function C(a){null!=a&&this.set(a)}function D(a,b,c){var d=this._calendar[a]||this._calendar.sameElse;return z(d)?d.call(b,c):d}function E(a){var b=this._longDateFormat[a],c=this._longDateFormat[a.toUpperCase()];return b||!c?b:(this._longDateFormat[a]=c.replace(/MMMM|MM|DD|dddd/g,function(a){return a.slice(1)}),this._longDateFormat[a])}function F(){return this._invalidDate}function G(a){return this._ordinal.replace("%d",a)}function H(a,b,c,d){var e=this._relativeTime[c];return z(e)?e(a,b,c,d):e.replace(/%d/i,a)}function I(a,b){var c=this._relativeTime[a>0?"future":"past"];return z(c)?c(b):c.replace(/%s/i,b)}function J(a,b){var c=a.toLowerCase();Dd[c]=Dd[c+"s"]=Dd[b]=a}function K(a){return"string"==typeof a?Dd[a]||Dd[a.toLowerCase()]:void 0}function L(a){var b,c,d={};for(c in a)i(a,c)&&(b=K(c),b&&(d[b]=a[c]));return d}function M(a,b){Ed[a]=b}function N(a){var b=[];for(var c in a)b.push({unit:c,priority:Ed[c]});return b.sort(function(a,b){return a.priority-b.priority}),b}function O(b,c){return function(d){return null!=d?(Q(this,b,d),a.updateOffset(this,c),this):P(this,b)}}function P(a,b){return a.isValid()?a._d["get"+(a._isUTC?"UTC":"")+b]():NaN}function Q(a,b,c){a.isValid()&&a._d["set"+(a._isUTC?"UTC":"")+b](c)}
// MOMENTS
  function R(a){return a=K(a),z(this[a])?this[a]():this}function S(a,b){if("object"==typeof a){a=L(a);for(var c=N(a),d=0;d<c.length;d++)this[c[d].unit](a[c[d].unit])}else if(a=K(a),z(this[a]))return this[a](b);return this}function T(a,b,c){var d=""+Math.abs(a),e=b-d.length,f=a>=0;return(f?c?"+":"":"-")+Math.pow(10,Math.max(0,e)).toString().substr(1)+d}
// token:    'M'
// padded:   ['MM', 2]
// ordinal:  'Mo'
// callback: function () { this.month() + 1 }
  function U(a,b,c,d){var e=d;"string"==typeof d&&(e=function(){return this[d]()}),a&&(Id[a]=e),b&&(Id[b[0]]=function(){return T(e.apply(this,arguments),b[1],b[2])}),c&&(Id[c]=function(){return this.localeData().ordinal(e.apply(this,arguments),a)})}function V(a){return a.match(/\[[\s\S]/)?a.replace(/^\[|\]$/g,""):a.replace(/\\/g,"")}function W(a){var b,c,d=a.match(Fd);for(b=0,c=d.length;b<c;b++)Id[d[b]]?d[b]=Id[d[b]]:d[b]=V(d[b]);return function(b){var e,f="";for(e=0;e<c;e++)f+=d[e]instanceof Function?d[e].call(b,a):d[e];return f}}
// format date using native date object
  function X(a,b){return a.isValid()?(b=Y(b,a.localeData()),Hd[b]=Hd[b]||W(b),Hd[b](a)):a.localeData().invalidDate()}function Y(a,b){function c(a){return b.longDateFormat(a)||a}var d=5;for(Gd.lastIndex=0;d>=0&&Gd.test(a);)a=a.replace(Gd,c),Gd.lastIndex=0,d-=1;return a}function Z(a,b,c){$d[a]=z(b)?b:function(a,d){return a&&c?c:b}}function $(a,b){return i($d,a)?$d[a](b._strict,b._locale):new RegExp(_(a))}
// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
  function _(a){return aa(a.replace("\\","").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,function(a,b,c,d,e){return b||c||d||e}))}function aa(a){return a.replace(/[-\/\\^$*+?.()|[\]{}]/g,"\\$&")}function ba(a,b){var c,d=b;for("string"==typeof a&&(a=[a]),f(b)&&(d=function(a,c){c[b]=u(a)}),c=0;c<a.length;c++)_d[a[c]]=d}function ca(a,b){ba(a,function(a,c,d,e){d._w=d._w||{},b(a,d._w,d,e)})}function da(a,b,c){null!=b&&i(_d,a)&&_d[a](b,c._a,c,a)}function ea(a,b){return new Date(Date.UTC(a,b+1,0)).getUTCDate()}function fa(a,b){return a?c(this._months)?this._months[a.month()]:this._months[(this._months.isFormat||ke).test(b)?"format":"standalone"][a.month()]:this._months}function ga(a,b){return a?c(this._monthsShort)?this._monthsShort[a.month()]:this._monthsShort[ke.test(b)?"format":"standalone"][a.month()]:this._monthsShort}function ha(a,b,c){var d,e,f,g=a.toLocaleLowerCase();if(!this._monthsParse)for(
// this is not used
    this._monthsParse=[],this._longMonthsParse=[],this._shortMonthsParse=[],d=0;d<12;++d)f=k([2e3,d]),this._shortMonthsParse[d]=this.monthsShort(f,"").toLocaleLowerCase(),this._longMonthsParse[d]=this.months(f,"").toLocaleLowerCase();return c?"MMM"===b?(e=je.call(this._shortMonthsParse,g),e!==-1?e:null):(e=je.call(this._longMonthsParse,g),e!==-1?e:null):"MMM"===b?(e=je.call(this._shortMonthsParse,g),e!==-1?e:(e=je.call(this._longMonthsParse,g),e!==-1?e:null)):(e=je.call(this._longMonthsParse,g),e!==-1?e:(e=je.call(this._shortMonthsParse,g),e!==-1?e:null))}function ia(a,b,c){var d,e,f;if(this._monthsParseExact)return ha.call(this,a,b,c);
// add sorting
// Sorting makes sure if one month (or abbr) is a prefix of another
// see sorting in computeMonthsParse
    for(this._monthsParse||(this._monthsParse=[],this._longMonthsParse=[],this._shortMonthsParse=[]),d=0;d<12;d++){
// test the regex
      if(
// make the regex if we don't have it already
        e=k([2e3,d]),c&&!this._longMonthsParse[d]&&(this._longMonthsParse[d]=new RegExp("^"+this.months(e,"").replace(".","")+"$","i"),this._shortMonthsParse[d]=new RegExp("^"+this.monthsShort(e,"").replace(".","")+"$","i")),c||this._monthsParse[d]||(f="^"+this.months(e,"")+"|^"+this.monthsShort(e,""),this._monthsParse[d]=new RegExp(f.replace(".",""),"i")),c&&"MMMM"===b&&this._longMonthsParse[d].test(a))return d;if(c&&"MMM"===b&&this._shortMonthsParse[d].test(a))return d;if(!c&&this._monthsParse[d].test(a))return d}}
// MOMENTS
  function ja(a,b){var c;if(!a.isValid())
// No op
    return a;if("string"==typeof b)if(/^\d+$/.test(b))b=u(b);else
// Another silent failure?
  if(b=a.localeData().monthsParse(b),!f(b))return a;return c=Math.min(a.date(),ea(a.year(),b)),a._d["set"+(a._isUTC?"UTC":"")+"Month"](b,c),a}function ka(b){return null!=b?(ja(this,b),a.updateOffset(this,!0),this):P(this,"Month")}function la(){return ea(this.year(),this.month())}function ma(a){return this._monthsParseExact?(i(this,"_monthsRegex")||oa.call(this),a?this._monthsShortStrictRegex:this._monthsShortRegex):(i(this,"_monthsShortRegex")||(this._monthsShortRegex=ne),this._monthsShortStrictRegex&&a?this._monthsShortStrictRegex:this._monthsShortRegex)}function na(a){return this._monthsParseExact?(i(this,"_monthsRegex")||oa.call(this),a?this._monthsStrictRegex:this._monthsRegex):(i(this,"_monthsRegex")||(this._monthsRegex=oe),this._monthsStrictRegex&&a?this._monthsStrictRegex:this._monthsRegex)}function oa(){function a(a,b){return b.length-a.length}var b,c,d=[],e=[],f=[];for(b=0;b<12;b++)
// make the regex if we don't have it already
    c=k([2e3,b]),d.push(this.monthsShort(c,"")),e.push(this.months(c,"")),f.push(this.months(c,"")),f.push(this.monthsShort(c,""));for(
// Sorting makes sure if one month (or abbr) is a prefix of another it
// will match the longer piece.
    d.sort(a),e.sort(a),f.sort(a),b=0;b<12;b++)d[b]=aa(d[b]),e[b]=aa(e[b]);for(b=0;b<24;b++)f[b]=aa(f[b]);this._monthsRegex=new RegExp("^("+f.join("|")+")","i"),this._monthsShortRegex=this._monthsRegex,this._monthsStrictRegex=new RegExp("^("+e.join("|")+")","i"),this._monthsShortStrictRegex=new RegExp("^("+d.join("|")+")","i")}
// HELPERS
  function pa(a){return qa(a)?366:365}function qa(a){return a%4===0&&a%100!==0||a%400===0}function ra(){return qa(this.year())}function sa(a,b,c,d,e,f,g){
//can't just apply() to create a date:
//http://stackoverflow.com/questions/181348/instantiating-a-javascript-object-by-calling-prototype-constructor-apply
    var h=new Date(a,b,c,d,e,f,g);
//the date constructor remaps years 0-99 to 1900-1999
    return a<100&&a>=0&&isFinite(h.getFullYear())&&h.setFullYear(a),h}function ta(a){var b=new Date(Date.UTC.apply(null,arguments));
//the Date.UTC function remaps years 0-99 to 1900-1999
    return a<100&&a>=0&&isFinite(b.getUTCFullYear())&&b.setUTCFullYear(a),b}
// start-of-first-week - start-of-year
  function ua(a,b,c){var// first-week day -- which january is always in the first week (4 for iso, 1 for other)
    d=7+b-c,
// first-week day local weekday -- which local weekday is fwd
    e=(7+ta(a,0,d).getUTCDay()-b)%7;return-e+d-1}
//http://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
  function va(a,b,c,d,e){var f,g,h=(7+c-d)%7,i=ua(a,d,e),j=1+7*(b-1)+h+i;return j<=0?(f=a-1,g=pa(f)+j):j>pa(a)?(f=a+1,g=j-pa(a)):(f=a,g=j),{year:f,dayOfYear:g}}function wa(a,b,c){var d,e,f=ua(a.year(),b,c),g=Math.floor((a.dayOfYear()-f-1)/7)+1;return g<1?(e=a.year()-1,d=g+xa(e,b,c)):g>xa(a.year(),b,c)?(d=g-xa(a.year(),b,c),e=a.year()+1):(e=a.year(),d=g),{week:d,year:e}}function xa(a,b,c){var d=ua(a,b,c),e=ua(a+1,b,c);return(pa(a)-d+e)/7}
// HELPERS
// LOCALES
  function ya(a){return wa(a,this._week.dow,this._week.doy).week}function za(){return this._week.dow}function Aa(){return this._week.doy}
// MOMENTS
  function Ba(a){var b=this.localeData().week(this);return null==a?b:this.add(7*(a-b),"d")}function Ca(a){var b=wa(this,1,4).week;return null==a?b:this.add(7*(a-b),"d")}
// HELPERS
  function Da(a,b){return"string"!=typeof a?a:isNaN(a)?(a=b.weekdaysParse(a),"number"==typeof a?a:null):parseInt(a,10)}function Ea(a,b){return"string"==typeof a?b.weekdaysParse(a)%7||7:isNaN(a)?null:a}function Fa(a,b){return a?c(this._weekdays)?this._weekdays[a.day()]:this._weekdays[this._weekdays.isFormat.test(b)?"format":"standalone"][a.day()]:this._weekdays}function Ga(a){return a?this._weekdaysShort[a.day()]:this._weekdaysShort}function Ha(a){return a?this._weekdaysMin[a.day()]:this._weekdaysMin}function Ia(a,b,c){var d,e,f,g=a.toLocaleLowerCase();if(!this._weekdaysParse)for(this._weekdaysParse=[],this._shortWeekdaysParse=[],this._minWeekdaysParse=[],d=0;d<7;++d)f=k([2e3,1]).day(d),this._minWeekdaysParse[d]=this.weekdaysMin(f,"").toLocaleLowerCase(),this._shortWeekdaysParse[d]=this.weekdaysShort(f,"").toLocaleLowerCase(),this._weekdaysParse[d]=this.weekdays(f,"").toLocaleLowerCase();return c?"dddd"===b?(e=je.call(this._weekdaysParse,g),e!==-1?e:null):"ddd"===b?(e=je.call(this._shortWeekdaysParse,g),e!==-1?e:null):(e=je.call(this._minWeekdaysParse,g),e!==-1?e:null):"dddd"===b?(e=je.call(this._weekdaysParse,g),e!==-1?e:(e=je.call(this._shortWeekdaysParse,g),e!==-1?e:(e=je.call(this._minWeekdaysParse,g),e!==-1?e:null))):"ddd"===b?(e=je.call(this._shortWeekdaysParse,g),e!==-1?e:(e=je.call(this._weekdaysParse,g),e!==-1?e:(e=je.call(this._minWeekdaysParse,g),e!==-1?e:null))):(e=je.call(this._minWeekdaysParse,g),e!==-1?e:(e=je.call(this._weekdaysParse,g),e!==-1?e:(e=je.call(this._shortWeekdaysParse,g),e!==-1?e:null)))}function Ja(a,b,c){var d,e,f;if(this._weekdaysParseExact)return Ia.call(this,a,b,c);for(this._weekdaysParse||(this._weekdaysParse=[],this._minWeekdaysParse=[],this._shortWeekdaysParse=[],this._fullWeekdaysParse=[]),d=0;d<7;d++){
// test the regex
    if(
// make the regex if we don't have it already
      e=k([2e3,1]).day(d),c&&!this._fullWeekdaysParse[d]&&(this._fullWeekdaysParse[d]=new RegExp("^"+this.weekdays(e,"").replace(".",".?")+"$","i"),this._shortWeekdaysParse[d]=new RegExp("^"+this.weekdaysShort(e,"").replace(".",".?")+"$","i"),this._minWeekdaysParse[d]=new RegExp("^"+this.weekdaysMin(e,"").replace(".",".?")+"$","i")),this._weekdaysParse[d]||(f="^"+this.weekdays(e,"")+"|^"+this.weekdaysShort(e,"")+"|^"+this.weekdaysMin(e,""),this._weekdaysParse[d]=new RegExp(f.replace(".",""),"i")),c&&"dddd"===b&&this._fullWeekdaysParse[d].test(a))return d;if(c&&"ddd"===b&&this._shortWeekdaysParse[d].test(a))return d;if(c&&"dd"===b&&this._minWeekdaysParse[d].test(a))return d;if(!c&&this._weekdaysParse[d].test(a))return d}}
// MOMENTS
  function Ka(a){if(!this.isValid())return null!=a?this:NaN;var b=this._isUTC?this._d.getUTCDay():this._d.getDay();return null!=a?(a=Da(a,this.localeData()),this.add(a-b,"d")):b}function La(a){if(!this.isValid())return null!=a?this:NaN;var b=(this.day()+7-this.localeData()._week.dow)%7;return null==a?b:this.add(a-b,"d")}function Ma(a){if(!this.isValid())return null!=a?this:NaN;
// behaves the same as moment#day except
// as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
// as a setter, sunday should belong to the previous week.
    if(null!=a){var b=Ea(a,this.localeData());return this.day(this.day()%7?b:b-7)}return this.day()||7}function Na(a){return this._weekdaysParseExact?(i(this,"_weekdaysRegex")||Qa.call(this),a?this._weekdaysStrictRegex:this._weekdaysRegex):(i(this,"_weekdaysRegex")||(this._weekdaysRegex=ue),this._weekdaysStrictRegex&&a?this._weekdaysStrictRegex:this._weekdaysRegex)}function Oa(a){return this._weekdaysParseExact?(i(this,"_weekdaysRegex")||Qa.call(this),a?this._weekdaysShortStrictRegex:this._weekdaysShortRegex):(i(this,"_weekdaysShortRegex")||(this._weekdaysShortRegex=ve),this._weekdaysShortStrictRegex&&a?this._weekdaysShortStrictRegex:this._weekdaysShortRegex)}function Pa(a){return this._weekdaysParseExact?(i(this,"_weekdaysRegex")||Qa.call(this),a?this._weekdaysMinStrictRegex:this._weekdaysMinRegex):(i(this,"_weekdaysMinRegex")||(this._weekdaysMinRegex=we),this._weekdaysMinStrictRegex&&a?this._weekdaysMinStrictRegex:this._weekdaysMinRegex)}function Qa(){function a(a,b){return b.length-a.length}var b,c,d,e,f,g=[],h=[],i=[],j=[];for(b=0;b<7;b++)
// make the regex if we don't have it already
    c=k([2e3,1]).day(b),d=this.weekdaysMin(c,""),e=this.weekdaysShort(c,""),f=this.weekdays(c,""),g.push(d),h.push(e),i.push(f),j.push(d),j.push(e),j.push(f);for(
// Sorting makes sure if one weekday (or abbr) is a prefix of another it
// will match the longer piece.
    g.sort(a),h.sort(a),i.sort(a),j.sort(a),b=0;b<7;b++)h[b]=aa(h[b]),i[b]=aa(i[b]),j[b]=aa(j[b]);this._weekdaysRegex=new RegExp("^("+j.join("|")+")","i"),this._weekdaysShortRegex=this._weekdaysRegex,this._weekdaysMinRegex=this._weekdaysRegex,this._weekdaysStrictRegex=new RegExp("^("+i.join("|")+")","i"),this._weekdaysShortStrictRegex=new RegExp("^("+h.join("|")+")","i"),this._weekdaysMinStrictRegex=new RegExp("^("+g.join("|")+")","i")}
// FORMATTING
  function Ra(){return this.hours()%12||12}function Sa(){return this.hours()||24}function Ta(a,b){U(a,0,0,function(){return this.localeData().meridiem(this.hours(),this.minutes(),b)})}
// PARSING
  function Ua(a,b){return b._meridiemParse}
// LOCALES
  function Va(a){
// IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
// Using charAt should be more compatible.
    return"p"===(a+"").toLowerCase().charAt(0)}function Wa(a,b,c){return a>11?c?"pm":"PM":c?"am":"AM"}function Xa(a){return a?a.toLowerCase().replace("_","-"):a}
// pick the locale from the array
// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
  function Ya(a){for(var b,c,d,e,f=0;f<a.length;){for(e=Xa(a[f]).split("-"),b=e.length,c=Xa(a[f+1]),c=c?c.split("-"):null;b>0;){if(d=Za(e.slice(0,b).join("-")))return d;if(c&&c.length>=b&&v(e,c,!0)>=b-1)
//the next array item is better than a shallower substring of this one
    break;b--}f++}return null}function Za(a){var b=null;
// Find a better way to register and load all the locales in Node
    if(!Be[a]&&"undefined"!=typeof module&&module&&module.exports)try{b=xe._abbr,require("./locale/"+a),
// because defineLocale currently also sets the global locale, we
// want to undo that for lazy loaded locales
      $a(b)}catch(a){}return Be[a]}
// This function will load locale and then set the global locale.  If
// no arguments are passed in, it will simply return the current global
// locale key.
  function $a(a,b){var c;
// moment.duration._locale = moment._locale = data;
    return a&&(c=p(b)?bb(a):_a(a,b),c&&(xe=c)),xe._abbr}function _a(a,b){if(null!==b){var c=Ae;if(b.abbr=a,null!=Be[a])y("defineLocaleOverride","use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."),c=Be[a]._config;else if(null!=b.parentLocale){if(null==Be[b.parentLocale])return Ce[b.parentLocale]||(Ce[b.parentLocale]=[]),Ce[b.parentLocale].push({name:a,config:b}),null;c=Be[b.parentLocale]._config}
// backwards compat for now: also set the locale
// make sure we set the locale AFTER all child locales have been
// created, so we won't end up with the child locale set.
    return Be[a]=new C(B(c,b)),Ce[a]&&Ce[a].forEach(function(a){_a(a.name,a.config)}),$a(a),Be[a]}
// useful for testing
    return delete Be[a],null}function ab(a,b){if(null!=b){var c,d=Ae;
// MERGE
    null!=Be[a]&&(d=Be[a]._config),b=B(d,b),c=new C(b),c.parentLocale=Be[a],Be[a]=c,
// backwards compat for now: also set the locale
      $a(a)}else
// pass null for config to unupdate, useful for tests
    null!=Be[a]&&(null!=Be[a].parentLocale?Be[a]=Be[a].parentLocale:null!=Be[a]&&delete Be[a]);return Be[a]}
// returns locale data
  function bb(a){var b;if(a&&a._locale&&a._locale._abbr&&(a=a._locale._abbr),!a)return xe;if(!c(a)){if(
//short-circuit everything else
    b=Za(a))return b;a=[a]}return Ya(a)}function cb(){return wd(Be)}function db(a){var b,c=a._a;return c&&m(a).overflow===-2&&(b=c[be]<0||c[be]>11?be:c[ce]<1||c[ce]>ea(c[ae],c[be])?ce:c[de]<0||c[de]>24||24===c[de]&&(0!==c[ee]||0!==c[fe]||0!==c[ge])?de:c[ee]<0||c[ee]>59?ee:c[fe]<0||c[fe]>59?fe:c[ge]<0||c[ge]>999?ge:-1,m(a)._overflowDayOfYear&&(b<ae||b>ce)&&(b=ce),m(a)._overflowWeeks&&b===-1&&(b=he),m(a)._overflowWeekday&&b===-1&&(b=ie),m(a).overflow=b),a}
// date from iso format
  function eb(a){var b,c,d,e,f,g,h=a._i,i=De.exec(h)||Ee.exec(h);if(i){for(m(a).iso=!0,b=0,c=Ge.length;b<c;b++)if(Ge[b][1].exec(i[1])){e=Ge[b][0],d=Ge[b][2]!==!1;break}if(null==e)return void(a._isValid=!1);if(i[3]){for(b=0,c=He.length;b<c;b++)if(He[b][1].exec(i[3])){
// match[2] should be 'T' or space
    f=(i[2]||" ")+He[b][0];break}if(null==f)return void(a._isValid=!1)}if(!d&&null!=f)return void(a._isValid=!1);if(i[4]){if(!Fe.exec(i[4]))return void(a._isValid=!1);g="Z"}a._f=e+(f||"")+(g||""),kb(a)}else a._isValid=!1}
// date from iso format or fallback
  function fb(b){var c=Ie.exec(b._i);return null!==c?void(b._d=new Date(+c[1])):(eb(b),void(b._isValid===!1&&(delete b._isValid,a.createFromInputFallback(b))))}
// Pick the first defined of two or three arguments.
  function gb(a,b,c){return null!=a?a:null!=b?b:c}function hb(b){
// hooks is actually the exported moment object
    var c=new Date(a.now());return b._useUTC?[c.getUTCFullYear(),c.getUTCMonth(),c.getUTCDate()]:[c.getFullYear(),c.getMonth(),c.getDate()]}
// convert an array to a date.
// the array should mirror the parameters below
// note: all values past the year are optional and will default to the lowest possible value.
// [year, month, day , hour, minute, second, millisecond]
  function ib(a){var b,c,d,e,f=[];if(!a._d){
// Default to current date.
// * if no year, month, day of month are given, default to today
// * if day of month is given, default month and year
// * if month is given, default only year
// * if year is given, don't default anything
    for(d=hb(a),
//compute day of the year from weeks and weekdays
        a._w&&null==a._a[ce]&&null==a._a[be]&&jb(a),
//if the day of the year is set, figure out what it is
        a._dayOfYear&&(e=gb(a._a[ae],d[ae]),a._dayOfYear>pa(e)&&(m(a)._overflowDayOfYear=!0),c=ta(e,0,a._dayOfYear),a._a[be]=c.getUTCMonth(),a._a[ce]=c.getUTCDate()),b=0;b<3&&null==a._a[b];++b)a._a[b]=f[b]=d[b];
// Zero out whatever was not defaulted, including time
    for(;b<7;b++)a._a[b]=f[b]=null==a._a[b]?2===b?1:0:a._a[b];
// Check for 24:00:00.000
    24===a._a[de]&&0===a._a[ee]&&0===a._a[fe]&&0===a._a[ge]&&(a._nextDay=!0,a._a[de]=0),a._d=(a._useUTC?ta:sa).apply(null,f),
// Apply timezone offset from input. The actual utcOffset can be changed
// with parseZone.
    null!=a._tzm&&a._d.setUTCMinutes(a._d.getUTCMinutes()-a._tzm),a._nextDay&&(a._a[de]=24)}}function jb(a){var b,c,d,e,f,g,h,i;if(b=a._w,null!=b.GG||null!=b.W||null!=b.E)f=1,g=4,
// We need to take the current isoWeekYear, but that depends on
// how we interpret now (local, utc, fixed offset). So create
// a now version of current config (take local/utc/offset flags, and
// create now).
    c=gb(b.GG,a._a[ae],wa(sb(),1,4).year),d=gb(b.W,1),e=gb(b.E,1),(e<1||e>7)&&(i=!0);else{f=a._locale._week.dow,g=a._locale._week.doy;var j=wa(sb(),f,g);c=gb(b.gg,a._a[ae],j.year),
// Default to current week.
    d=gb(b.w,j.week),null!=b.d?(
// weekday -- low day numbers are considered next week
      e=b.d,(e<0||e>6)&&(i=!0)):null!=b.e?(
// local weekday -- counting starts from begining of week
        e=b.e+f,(b.e<0||b.e>6)&&(i=!0)):
      // default to begining of week
      e=f}d<1||d>xa(c,f,g)?m(a)._overflowWeeks=!0:null!=i?m(a)._overflowWeekday=!0:(h=va(c,d,e,f,g),a._a[ae]=h.year,a._dayOfYear=h.dayOfYear)}
// date from string and format string
  function kb(b){
// Move this to another part of the creation flow to prevent circular deps
    if(b._f===a.ISO_8601)return void eb(b);b._a=[],m(b).empty=!0;
// This array is used to make a Date, either with `new Date` or `Date.UTC`
    var c,d,e,f,g,h=""+b._i,i=h.length,j=0;for(e=Y(b._f,b._locale).match(Fd)||[],c=0;c<e.length;c++)f=e[c],d=(h.match($(f,b))||[])[0],
// console.log('token', token, 'parsedInput', parsedInput,
//         'regex', getParseRegexForToken(token, config));
    d&&(g=h.substr(0,h.indexOf(d)),g.length>0&&m(b).unusedInput.push(g),h=h.slice(h.indexOf(d)+d.length),j+=d.length),
// don't parse if it's not a known token
      Id[f]?(d?m(b).empty=!1:m(b).unusedTokens.push(f),da(f,d,b)):b._strict&&!d&&m(b).unusedTokens.push(f);
// add remaining unparsed input length to the string
    m(b).charsLeftOver=i-j,h.length>0&&m(b).unusedInput.push(h),
// clear _12h flag if hour is <= 12
    b._a[de]<=12&&m(b).bigHour===!0&&b._a[de]>0&&(m(b).bigHour=void 0),m(b).parsedDateParts=b._a.slice(0),m(b).meridiem=b._meridiem,
// handle meridiem
      b._a[de]=lb(b._locale,b._a[de],b._meridiem),ib(b),db(b)}function lb(a,b,c){var d;
// Fallback
    return null==c?b:null!=a.meridiemHour?a.meridiemHour(b,c):null!=a.isPM?(d=a.isPM(c),d&&b<12&&(b+=12),d||12!==b||(b=0),b):b}
// date from string and array of format strings
  function mb(a){var b,c,d,e,f;if(0===a._f.length)return m(a).invalidFormat=!0,void(a._d=new Date(NaN));for(e=0;e<a._f.length;e++)f=0,b=q({},a),null!=a._useUTC&&(b._useUTC=a._useUTC),b._f=a._f[e],kb(b),n(b)&&(
// if there is any input that was not parsed add a penalty for that format
    f+=m(b).charsLeftOver,
//or tokens
    f+=10*m(b).unusedTokens.length,m(b).score=f,(null==d||f<d)&&(d=f,c=b));j(a,c||b)}function nb(a){if(!a._d){var b=L(a._i);a._a=h([b.year,b.month,b.day||b.date,b.hour,b.minute,b.second,b.millisecond],function(a){return a&&parseInt(a,10)}),ib(a)}}function ob(a){var b=new r(db(pb(a)));
// Adding is smart enough around DST
    return b._nextDay&&(b.add(1,"d"),b._nextDay=void 0),b}function pb(a){var b=a._i,d=a._f;return a._locale=a._locale||bb(a._l),null===b||void 0===d&&""===b?o({nullInput:!0}):("string"==typeof b&&(a._i=b=a._locale.preparse(b)),s(b)?new r(db(b)):(g(b)?a._d=b:c(d)?mb(a):d?kb(a):qb(a),n(a)||(a._d=null),a))}function qb(b){var d=b._i;void 0===d?b._d=new Date(a.now()):g(d)?b._d=new Date(d.valueOf()):"string"==typeof d?fb(b):c(d)?(b._a=h(d.slice(0),function(a){return parseInt(a,10)}),ib(b)):"object"==typeof d?nb(b):f(d)?
              // from milliseconds
              b._d=new Date(d):a.createFromInputFallback(b)}function rb(a,b,f,g,h){var i={};
// object construction must be done this way.
// https://github.com/moment/moment/issues/1423
    return f!==!0&&f!==!1||(g=f,f=void 0),(d(a)&&e(a)||c(a)&&0===a.length)&&(a=void 0),i._isAMomentObject=!0,i._useUTC=i._isUTC=h,i._l=f,i._i=a,i._f=b,i._strict=g,ob(i)}function sb(a,b,c,d){return rb(a,b,c,d,!1)}
// Pick a moment m from moments so that m[fn](other) is true for all
// other. This relies on the function fn to be transitive.
//
// moments should either be an array of moment objects or an array, whose
// first element is an array of moment objects.
  function tb(a,b){var d,e;if(1===b.length&&c(b[0])&&(b=b[0]),!b.length)return sb();for(d=b[0],e=1;e<b.length;++e)b[e].isValid()&&!b[e][a](d)||(d=b[e]);return d}
// Use [].sort instead?
  function ub(){var a=[].slice.call(arguments,0);return tb("isBefore",a)}function vb(){var a=[].slice.call(arguments,0);return tb("isAfter",a)}function wb(a){var b=L(a),c=b.year||0,d=b.quarter||0,e=b.month||0,f=b.week||0,g=b.day||0,h=b.hour||0,i=b.minute||0,j=b.second||0,k=b.millisecond||0;
// representation for dateAddRemove
    this._milliseconds=+k+1e3*j+// 1000
      6e4*i+// 1000 * 60
      1e3*h*60*60,//using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
// Because of dateAddRemove treats 24 hours as different from a
// day when working around DST, we need to store them separately
      this._days=+g+7*f,
// It is impossible translate months into days without knowing
// which months you are are talking about, so we have to store
// it separately.
      this._months=+e+3*d+12*c,this._data={},this._locale=bb(),this._bubble()}function xb(a){return a instanceof wb}function yb(a){return a<0?Math.round(-1*a)*-1:Math.round(a)}
// FORMATTING
  function zb(a,b){U(a,0,0,function(){var a=this.utcOffset(),c="+";return a<0&&(a=-a,c="-"),c+T(~~(a/60),2)+b+T(~~a%60,2)})}function Ab(a,b){var c=(b||"").match(a);if(null===c)return null;var d=c[c.length-1]||[],e=(d+"").match(Me)||["-",0,0],f=+(60*e[1])+u(e[2]);return 0===f?0:"+"===e[0]?f:-f}
// Return a moment from input, that is local/utc/zone equivalent to model.
  function Bb(b,c){var d,e;
// Use low-level api, because this fn is low-level api.
    return c._isUTC?(d=c.clone(),e=(s(b)||g(b)?b.valueOf():sb(b).valueOf())-d.valueOf(),d._d.setTime(d._d.valueOf()+e),a.updateOffset(d,!1),d):sb(b).local()}function Cb(a){
// On Firefox.24 Date#getTimezoneOffset returns a floating point.
// https://github.com/moment/moment/pull/1871
    return 15*-Math.round(a._d.getTimezoneOffset()/15)}
// MOMENTS
// keepLocalTime = true means only change the timezone, without
// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
// +0200, so we adjust the time as needed, to be valid.
//
// Keeping the time actually adds/subtracts (one hour)
// from the actual represented time. That is why we call updateOffset
// a second time. In case it wants us to change the offset again
// _changeInProgress == true case, then we have to adjust, because
// there is no such time in the given timezone.
  function Db(b,c){var d,e=this._offset||0;if(!this.isValid())return null!=b?this:NaN;if(null!=b){if("string"==typeof b){if(b=Ab(Xd,b),null===b)return this}else Math.abs(b)<16&&(b=60*b);return!this._isUTC&&c&&(d=Cb(this)),this._offset=b,this._isUTC=!0,null!=d&&this.add(d,"m"),e!==b&&(!c||this._changeInProgress?Tb(this,Ob(b-e,"m"),1,!1):this._changeInProgress||(this._changeInProgress=!0,a.updateOffset(this,!0),this._changeInProgress=null)),this}return this._isUTC?e:Cb(this)}function Eb(a,b){return null!=a?("string"!=typeof a&&(a=-a),this.utcOffset(a,b),this):-this.utcOffset()}function Fb(a){return this.utcOffset(0,a)}function Gb(a){return this._isUTC&&(this.utcOffset(0,a),this._isUTC=!1,a&&this.subtract(Cb(this),"m")),this}function Hb(){if(null!=this._tzm)this.utcOffset(this._tzm);else if("string"==typeof this._i){var a=Ab(Wd,this._i);null!=a?this.utcOffset(a):this.utcOffset(0,!0)}return this}function Ib(a){return!!this.isValid()&&(a=a?sb(a).utcOffset():0,(this.utcOffset()-a)%60===0)}function Jb(){return this.utcOffset()>this.clone().month(0).utcOffset()||this.utcOffset()>this.clone().month(5).utcOffset()}function Kb(){if(!p(this._isDSTShifted))return this._isDSTShifted;var a={};if(q(a,this),a=pb(a),a._a){var b=a._isUTC?k(a._a):sb(a._a);this._isDSTShifted=this.isValid()&&v(a._a,b.toArray())>0}else this._isDSTShifted=!1;return this._isDSTShifted}function Lb(){return!!this.isValid()&&!this._isUTC}function Mb(){return!!this.isValid()&&this._isUTC}function Nb(){return!!this.isValid()&&(this._isUTC&&0===this._offset)}function Ob(a,b){var c,d,e,g=a,
// matching against regexp is expensive, do it on demand
    h=null;// checks for null or undefined
    return xb(a)?g={ms:a._milliseconds,d:a._days,M:a._months}:f(a)?(g={},b?g[b]=a:g.milliseconds=a):(h=Ne.exec(a))?(c="-"===h[1]?-1:1,g={y:0,d:u(h[ce])*c,h:u(h[de])*c,m:u(h[ee])*c,s:u(h[fe])*c,ms:u(yb(1e3*h[ge]))*c}):(h=Oe.exec(a))?(c="-"===h[1]?-1:1,g={y:Pb(h[2],c),M:Pb(h[3],c),w:Pb(h[4],c),d:Pb(h[5],c),h:Pb(h[6],c),m:Pb(h[7],c),s:Pb(h[8],c)}):null==g?g={}:"object"==typeof g&&("from"in g||"to"in g)&&(e=Rb(sb(g.from),sb(g.to)),g={},g.ms=e.milliseconds,g.M=e.months),d=new wb(g),xb(a)&&i(a,"_locale")&&(d._locale=a._locale),d}function Pb(a,b){
// We'd normally use ~~inp for this, but unfortunately it also
// converts floats to ints.
// inp may be undefined, so careful calling replace on it.
    var c=a&&parseFloat(a.replace(",","."));
// apply sign while we're at it
    return(isNaN(c)?0:c)*b}function Qb(a,b){var c={milliseconds:0,months:0};return c.months=b.month()-a.month()+12*(b.year()-a.year()),a.clone().add(c.months,"M").isAfter(b)&&--c.months,c.milliseconds=+b-+a.clone().add(c.months,"M"),c}function Rb(a,b){var c;return a.isValid()&&b.isValid()?(b=Bb(b,a),a.isBefore(b)?c=Qb(a,b):(c=Qb(b,a),c.milliseconds=-c.milliseconds,c.months=-c.months),c):{milliseconds:0,months:0}}
// remove 'name' arg after deprecation is removed
  function Sb(a,b){return function(c,d){var e,f;
//invert the arguments, but complain about it
    return null===d||isNaN(+d)||(y(b,"moment()."+b+"(period, number) is deprecated. Please use moment()."+b+"(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."),f=c,c=d,d=f),c="string"==typeof c?+c:c,e=Ob(c,d),Tb(this,e,a),this}}function Tb(b,c,d,e){var f=c._milliseconds,g=yb(c._days),h=yb(c._months);b.isValid()&&(e=null==e||e,f&&b._d.setTime(b._d.valueOf()+f*d),g&&Q(b,"Date",P(b,"Date")+g*d),h&&ja(b,P(b,"Month")+h*d),e&&a.updateOffset(b,g||h))}function Ub(a,b){var c=a.diff(b,"days",!0);return c<-6?"sameElse":c<-1?"lastWeek":c<0?"lastDay":c<1?"sameDay":c<2?"nextDay":c<7?"nextWeek":"sameElse"}function Vb(b,c){
// We want to compare the start of today, vs this.
// Getting start-of-today depends on whether we're local/utc/offset or not.
    var d=b||sb(),e=Bb(d,this).startOf("day"),f=a.calendarFormat(this,e)||"sameElse",g=c&&(z(c[f])?c[f].call(this,d):c[f]);return this.format(g||this.localeData().calendar(f,this,sb(d)))}function Wb(){return new r(this)}function Xb(a,b){var c=s(a)?a:sb(a);return!(!this.isValid()||!c.isValid())&&(b=K(p(b)?"millisecond":b),"millisecond"===b?this.valueOf()>c.valueOf():c.valueOf()<this.clone().startOf(b).valueOf())}function Yb(a,b){var c=s(a)?a:sb(a);return!(!this.isValid()||!c.isValid())&&(b=K(p(b)?"millisecond":b),"millisecond"===b?this.valueOf()<c.valueOf():this.clone().endOf(b).valueOf()<c.valueOf())}function Zb(a,b,c,d){return d=d||"()",("("===d[0]?this.isAfter(a,c):!this.isBefore(a,c))&&(")"===d[1]?this.isBefore(b,c):!this.isAfter(b,c))}function $b(a,b){var c,d=s(a)?a:sb(a);return!(!this.isValid()||!d.isValid())&&(b=K(b||"millisecond"),"millisecond"===b?this.valueOf()===d.valueOf():(c=d.valueOf(),this.clone().startOf(b).valueOf()<=c&&c<=this.clone().endOf(b).valueOf()))}function _b(a,b){return this.isSame(a,b)||this.isAfter(a,b)}function ac(a,b){return this.isSame(a,b)||this.isBefore(a,b)}function bc(a,b,c){var d,e,f,g;// 1000
// 1000 * 60
// 1000 * 60 * 60
// 1000 * 60 * 60 * 24, negate dst
// 1000 * 60 * 60 * 24 * 7, negate dst
    return this.isValid()?(d=Bb(a,this),d.isValid()?(e=6e4*(d.utcOffset()-this.utcOffset()),b=K(b),"year"===b||"month"===b||"quarter"===b?(g=cc(this,d),"quarter"===b?g/=3:"year"===b&&(g/=12)):(f=this-d,g="second"===b?f/1e3:"minute"===b?f/6e4:"hour"===b?f/36e5:"day"===b?(f-e)/864e5:"week"===b?(f-e)/6048e5:f),c?g:t(g)):NaN):NaN}function cc(a,b){
// difference in months
    var c,d,e=12*(b.year()-a.year())+(b.month()-a.month()),
// b is in (anchor - 1 month, anchor + 1 month)
      f=a.clone().add(e,"months");
//check for negative zero, return zero if negative zero
// linear across the month
// linear across the month
    return b-f<0?(c=a.clone().add(e-1,"months"),d=(b-f)/(f-c)):(c=a.clone().add(e+1,"months"),d=(b-f)/(c-f)),-(e+d)||0}function dc(){return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ")}function ec(){var a=this.clone().utc();return 0<a.year()&&a.year()<=9999?z(Date.prototype.toISOString)?this.toDate().toISOString():X(a,"YYYY-MM-DD[T]HH:mm:ss.SSS[Z]"):X(a,"YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]")}/**
   * Return a human readable representation of a moment that can
   * also be evaluated to get a new moment which is the same
   *
   * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
   */
  function fc(){if(!this.isValid())return"moment.invalid(/* "+this._i+" */)";var a="moment",b="";this.isLocal()||(a=0===this.utcOffset()?"moment.utc":"moment.parseZone",b="Z");var c="["+a+'("]',d=0<this.year()&&this.year()<=9999?"YYYY":"YYYYYY",e="-MM-DD[T]HH:mm:ss.SSS",f=b+'[")]';return this.format(c+d+e+f)}function gc(b){b||(b=this.isUtc()?a.defaultFormatUtc:a.defaultFormat);var c=X(this,b);return this.localeData().postformat(c)}function hc(a,b){return this.isValid()&&(s(a)&&a.isValid()||sb(a).isValid())?Ob({to:this,from:a}).locale(this.locale()).humanize(!b):this.localeData().invalidDate()}function ic(a){return this.from(sb(),a)}function jc(a,b){return this.isValid()&&(s(a)&&a.isValid()||sb(a).isValid())?Ob({from:this,to:a}).locale(this.locale()).humanize(!b):this.localeData().invalidDate()}function kc(a){return this.to(sb(),a)}
// If passed a locale key, it will set the locale for this
// instance.  Otherwise, it will return the locale configuration
// variables for this instance.
  function lc(a){var b;return void 0===a?this._locale._abbr:(b=bb(a),null!=b&&(this._locale=b),this)}function mc(){return this._locale}function nc(a){
// the following switch intentionally omits break keywords
// to utilize falling through the cases.
    switch(a=K(a)){case"year":this.month(0);/* falls through */
      case"quarter":case"month":this.date(1);/* falls through */
      case"week":case"isoWeek":case"day":case"date":this.hours(0);/* falls through */
      case"hour":this.minutes(0);/* falls through */
      case"minute":this.seconds(0);/* falls through */
      case"second":this.milliseconds(0)}
// weeks are a special case
// quarters are also special
    return"week"===a&&this.weekday(0),"isoWeek"===a&&this.isoWeekday(1),"quarter"===a&&this.month(3*Math.floor(this.month()/3)),this}function oc(a){
// 'date' is an alias for 'day', so it should be considered as such.
    return a=K(a),void 0===a||"millisecond"===a?this:("date"===a&&(a="day"),this.startOf(a).add(1,"isoWeek"===a?"week":a).subtract(1,"ms"))}function pc(){return this._d.valueOf()-6e4*(this._offset||0)}function qc(){return Math.floor(this.valueOf()/1e3)}function rc(){return new Date(this.valueOf())}function sc(){var a=this;return[a.year(),a.month(),a.date(),a.hour(),a.minute(),a.second(),a.millisecond()]}function tc(){var a=this;return{years:a.year(),months:a.month(),date:a.date(),hours:a.hours(),minutes:a.minutes(),seconds:a.seconds(),milliseconds:a.milliseconds()}}function uc(){
// new Date(NaN).toJSON() === null
    return this.isValid()?this.toISOString():null}function vc(){return n(this)}function wc(){return j({},m(this))}function xc(){return m(this).overflow}function yc(){return{input:this._i,format:this._f,locale:this._locale,isUTC:this._isUTC,strict:this._strict}}function zc(a,b){U(0,[a,a.length],0,b)}
// MOMENTS
  function Ac(a){return Ec.call(this,a,this.week(),this.weekday(),this.localeData()._week.dow,this.localeData()._week.doy)}function Bc(a){return Ec.call(this,a,this.isoWeek(),this.isoWeekday(),1,4)}function Cc(){return xa(this.year(),1,4)}function Dc(){var a=this.localeData()._week;return xa(this.year(),a.dow,a.doy)}function Ec(a,b,c,d,e){var f;return null==a?wa(this,d,e).year:(f=xa(a,d,e),b>f&&(b=f),Fc.call(this,a,b,c,d,e))}function Fc(a,b,c,d,e){var f=va(a,b,c,d,e),g=ta(f.year,0,f.dayOfYear);return this.year(g.getUTCFullYear()),this.month(g.getUTCMonth()),this.date(g.getUTCDate()),this}
// MOMENTS
  function Gc(a){return null==a?Math.ceil((this.month()+1)/3):this.month(3*(a-1)+this.month()%3)}
// HELPERS
// MOMENTS
  function Hc(a){var b=Math.round((this.clone().startOf("day")-this.clone().startOf("year"))/864e5)+1;return null==a?b:this.add(a-b,"d")}function Ic(a,b){b[ge]=u(1e3*("0."+a))}
// MOMENTS
  function Jc(){return this._isUTC?"UTC":""}function Kc(){return this._isUTC?"Coordinated Universal Time":""}function Lc(a){return sb(1e3*a)}function Mc(){return sb.apply(null,arguments).parseZone()}function Nc(a){return a}function Oc(a,b,c,d){var e=bb(),f=k().set(d,b);return e[c](f,a)}function Pc(a,b,c){if(f(a)&&(b=a,a=void 0),a=a||"",null!=b)return Oc(a,b,c,"month");var d,e=[];for(d=0;d<12;d++)e[d]=Oc(a,d,c,"month");return e}
// ()
// (5)
// (fmt, 5)
// (fmt)
// (true)
// (true, 5)
// (true, fmt, 5)
// (true, fmt)
  function Qc(a,b,c,d){"boolean"==typeof a?(f(b)&&(c=b,b=void 0),b=b||""):(b=a,c=b,a=!1,f(b)&&(c=b,b=void 0),b=b||"");var e=bb(),g=a?e._week.dow:0;if(null!=c)return Oc(b,(c+g)%7,d,"day");var h,i=[];for(h=0;h<7;h++)i[h]=Oc(b,(h+g)%7,d,"day");return i}function Rc(a,b){return Pc(a,b,"months")}function Sc(a,b){return Pc(a,b,"monthsShort")}function Tc(a,b,c){return Qc(a,b,c,"weekdays")}function Uc(a,b,c){return Qc(a,b,c,"weekdaysShort")}function Vc(a,b,c){return Qc(a,b,c,"weekdaysMin")}function Wc(){var a=this._data;return this._milliseconds=Ze(this._milliseconds),this._days=Ze(this._days),this._months=Ze(this._months),a.milliseconds=Ze(a.milliseconds),a.seconds=Ze(a.seconds),a.minutes=Ze(a.minutes),a.hours=Ze(a.hours),a.months=Ze(a.months),a.years=Ze(a.years),this}function Xc(a,b,c,d){var e=Ob(b,c);return a._milliseconds+=d*e._milliseconds,a._days+=d*e._days,a._months+=d*e._months,a._bubble()}
// supports only 2.0-style add(1, 's') or add(duration)
  function Yc(a,b){return Xc(this,a,b,1)}
// supports only 2.0-style subtract(1, 's') or subtract(duration)
  function Zc(a,b){return Xc(this,a,b,-1)}function $c(a){return a<0?Math.floor(a):Math.ceil(a)}function _c(){var a,b,c,d,e,f=this._milliseconds,g=this._days,h=this._months,i=this._data;
// if we have a mix of positive and negative values, bubble down first
// check: https://github.com/moment/moment/issues/2166
// The following code bubbles up values, see the tests for
// examples of what that means.
// convert days to months
// 12 months -> 1 year
    return f>=0&&g>=0&&h>=0||f<=0&&g<=0&&h<=0||(f+=864e5*$c(bd(h)+g),g=0,h=0),i.milliseconds=f%1e3,a=t(f/1e3),i.seconds=a%60,b=t(a/60),i.minutes=b%60,c=t(b/60),i.hours=c%24,g+=t(c/24),e=t(ad(g)),h+=e,g-=$c(bd(e)),d=t(h/12),h%=12,i.days=g,i.months=h,i.years=d,this}function ad(a){
// 400 years have 146097 days (taking into account leap year rules)
// 400 years have 12 months === 4800
    return 4800*a/146097}function bd(a){
// the reverse of daysToMonths
    return 146097*a/4800}function cd(a){var b,c,d=this._milliseconds;if(a=K(a),"month"===a||"year"===a)return b=this._days+d/864e5,c=this._months+ad(b),"month"===a?c:c/12;switch(
// handle milliseconds separately because of floating point math errors (issue #1867)
    b=this._days+Math.round(bd(this._months)),a){case"week":return b/7+d/6048e5;case"day":return b+d/864e5;case"hour":return 24*b+d/36e5;case"minute":return 1440*b+d/6e4;case"second":return 86400*b+d/1e3;
// Math.floor prevents floating point math errors here
    case"millisecond":return Math.floor(864e5*b)+d;default:throw new Error("Unknown unit "+a)}}
// Use this.as('ms')?
  function dd(){return this._milliseconds+864e5*this._days+this._months%12*2592e6+31536e6*u(this._months/12)}function ed(a){return function(){return this.as(a)}}function fd(a){return a=K(a),this[a+"s"]()}function gd(a){return function(){return this._data[a]}}function hd(){return t(this.days()/7)}
// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
  function id(a,b,c,d,e){return e.relativeTime(b||1,!!c,a,d)}function jd(a,b,c){var d=Ob(a).abs(),e=of(d.as("s")),f=of(d.as("m")),g=of(d.as("h")),h=of(d.as("d")),i=of(d.as("M")),j=of(d.as("y")),k=e<pf.s&&["s",e]||f<=1&&["m"]||f<pf.m&&["mm",f]||g<=1&&["h"]||g<pf.h&&["hh",g]||h<=1&&["d"]||h<pf.d&&["dd",h]||i<=1&&["M"]||i<pf.M&&["MM",i]||j<=1&&["y"]||["yy",j];return k[2]=b,k[3]=+a>0,k[4]=c,id.apply(null,k)}
// This function allows you to set the rounding function for relative time strings
  function kd(a){return void 0===a?of:"function"==typeof a&&(of=a,!0)}
// This function allows you to set a threshold for relative time strings
  function ld(a,b){return void 0!==pf[a]&&(void 0===b?pf[a]:(pf[a]=b,!0))}function md(a){var b=this.localeData(),c=jd(this,!a,b);return a&&(c=b.pastFuture(+this,c)),b.postformat(c)}function nd(){
// for ISO strings we do not use the normal bubbling rules:
//  * milliseconds bubble up until they become hours
//  * days do not bubble at all
//  * months bubble up until they become years
// This is because there is no context-free conversion between hours and days
// (think of clock changes)
// and also not between days and months (28-31 days per month)
    var a,b,c,d=qf(this._milliseconds)/1e3,e=qf(this._days),f=qf(this._months);
// 3600 seconds -> 60 minutes -> 1 hour
    a=t(d/60),b=t(a/60),d%=60,a%=60,
// 12 months -> 1 year
      c=t(f/12),f%=12;
// inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
    var g=c,h=f,i=e,j=b,k=a,l=d,m=this.asSeconds();return m?(m<0?"-":"")+"P"+(g?g+"Y":"")+(h?h+"M":"")+(i?i+"D":"")+(j||k||l?"T":"")+(j?j+"H":"")+(k?k+"M":"")+(l?l+"S":""):"P0D"}var od,pd;pd=Array.prototype.some?Array.prototype.some:function(a){for(var b=Object(this),c=b.length>>>0,d=0;d<c;d++)if(d in b&&a.call(this,b[d],d,b))return!0;return!1};var qd=pd,rd=a.momentProperties=[],sd=!1,td={};a.suppressDeprecationWarnings=!1,a.deprecationHandler=null;var ud;ud=Object.keys?Object.keys:function(a){var b,c=[];for(b in a)i(a,b)&&c.push(b);return c};var vd,wd=ud,xd={sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},yd={LTS:"h:mm:ss A",LT:"h:mm A",L:"MM/DD/YYYY",LL:"MMMM D, YYYY",LLL:"MMMM D, YYYY h:mm A",LLLL:"dddd, MMMM D, YYYY h:mm A"},zd="Invalid date",Ad="%d",Bd=/\d{1,2}/,Cd={future:"in %s",past:"%s ago",s:"a few seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},Dd={},Ed={},Fd=/(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,Gd=/(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,Hd={},Id={},Jd=/\d/,Kd=/\d\d/,Ld=/\d{3}/,Md=/\d{4}/,Nd=/[+-]?\d{6}/,Od=/\d\d?/,Pd=/\d\d\d\d?/,Qd=/\d\d\d\d\d\d?/,Rd=/\d{1,3}/,Sd=/\d{1,4}/,Td=/[+-]?\d{1,6}/,Ud=/\d+/,Vd=/[+-]?\d+/,Wd=/Z|[+-]\d\d:?\d\d/gi,Xd=/Z|[+-]\d\d(?::?\d\d)?/gi,Yd=/[+-]?\d+(\.\d{1,3})?/,Zd=/[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i,$d={},_d={},ae=0,be=1,ce=2,de=3,ee=4,fe=5,ge=6,he=7,ie=8;vd=Array.prototype.indexOf?Array.prototype.indexOf:function(a){
// I know
      var b;for(b=0;b<this.length;++b)if(this[b]===a)return b;return-1};var je=vd;
// FORMATTING
  U("M",["MM",2],"Mo",function(){return this.month()+1}),U("MMM",0,0,function(a){return this.localeData().monthsShort(this,a)}),U("MMMM",0,0,function(a){return this.localeData().months(this,a)}),
// ALIASES
    J("month","M"),
// PRIORITY
    M("month",8),
// PARSING
    Z("M",Od),Z("MM",Od,Kd),Z("MMM",function(a,b){return b.monthsShortRegex(a)}),Z("MMMM",function(a,b){return b.monthsRegex(a)}),ba(["M","MM"],function(a,b){b[be]=u(a)-1}),ba(["MMM","MMMM"],function(a,b,c,d){var e=c._locale.monthsParse(a,d,c._strict);
// if we didn't find a month name, mark the date as invalid.
    null!=e?b[be]=e:m(c).invalidMonth=a});
// LOCALES
  var ke=/D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,le="January_February_March_April_May_June_July_August_September_October_November_December".split("_"),me="Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),ne=Zd,oe=Zd;
// FORMATTING
  U("Y",0,0,function(){var a=this.year();return a<=9999?""+a:"+"+a}),U(0,["YY",2],0,function(){return this.year()%100}),U(0,["YYYY",4],0,"year"),U(0,["YYYYY",5],0,"year"),U(0,["YYYYYY",6,!0],0,"year"),
// ALIASES
    J("year","y"),
// PRIORITIES
    M("year",1),
// PARSING
    Z("Y",Vd),Z("YY",Od,Kd),Z("YYYY",Sd,Md),Z("YYYYY",Td,Nd),Z("YYYYYY",Td,Nd),ba(["YYYYY","YYYYYY"],ae),ba("YYYY",function(b,c){c[ae]=2===b.length?a.parseTwoDigitYear(b):u(b)}),ba("YY",function(b,c){c[ae]=a.parseTwoDigitYear(b)}),ba("Y",function(a,b){b[ae]=parseInt(a,10)}),
// HOOKS
    a.parseTwoDigitYear=function(a){return u(a)+(u(a)>68?1900:2e3)};
// MOMENTS
  var pe=O("FullYear",!0);
// FORMATTING
  U("w",["ww",2],"wo","week"),U("W",["WW",2],"Wo","isoWeek"),
// ALIASES
    J("week","w"),J("isoWeek","W"),
// PRIORITIES
    M("week",5),M("isoWeek",5),
// PARSING
    Z("w",Od),Z("ww",Od,Kd),Z("W",Od),Z("WW",Od,Kd),ca(["w","ww","W","WW"],function(a,b,c,d){b[d.substr(0,1)]=u(a)});var qe={dow:0,// Sunday is the first day of the week.
    doy:6};
// FORMATTING
  U("d",0,"do","day"),U("dd",0,0,function(a){return this.localeData().weekdaysMin(this,a)}),U("ddd",0,0,function(a){return this.localeData().weekdaysShort(this,a)}),U("dddd",0,0,function(a){return this.localeData().weekdays(this,a)}),U("e",0,0,"weekday"),U("E",0,0,"isoWeekday"),
// ALIASES
    J("day","d"),J("weekday","e"),J("isoWeekday","E"),
// PRIORITY
    M("day",11),M("weekday",11),M("isoWeekday",11),
// PARSING
    Z("d",Od),Z("e",Od),Z("E",Od),Z("dd",function(a,b){return b.weekdaysMinRegex(a)}),Z("ddd",function(a,b){return b.weekdaysShortRegex(a)}),Z("dddd",function(a,b){return b.weekdaysRegex(a)}),ca(["dd","ddd","dddd"],function(a,b,c,d){var e=c._locale.weekdaysParse(a,d,c._strict);
// if we didn't get a weekday name, mark the date as invalid
    null!=e?b.d=e:m(c).invalidWeekday=a}),ca(["d","e","E"],function(a,b,c,d){b[d]=u(a)});
// LOCALES
  var re="Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),se="Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),te="Su_Mo_Tu_We_Th_Fr_Sa".split("_"),ue=Zd,ve=Zd,we=Zd;U("H",["HH",2],0,"hour"),U("h",["hh",2],0,Ra),U("k",["kk",2],0,Sa),U("hmm",0,0,function(){return""+Ra.apply(this)+T(this.minutes(),2)}),U("hmmss",0,0,function(){return""+Ra.apply(this)+T(this.minutes(),2)+T(this.seconds(),2)}),U("Hmm",0,0,function(){return""+this.hours()+T(this.minutes(),2)}),U("Hmmss",0,0,function(){return""+this.hours()+T(this.minutes(),2)+T(this.seconds(),2)}),Ta("a",!0),Ta("A",!1),
// ALIASES
    J("hour","h"),
// PRIORITY
    M("hour",13),Z("a",Ua),Z("A",Ua),Z("H",Od),Z("h",Od),Z("HH",Od,Kd),Z("hh",Od,Kd),Z("hmm",Pd),Z("hmmss",Qd),Z("Hmm",Pd),Z("Hmmss",Qd),ba(["H","HH"],de),ba(["a","A"],function(a,b,c){c._isPm=c._locale.isPM(a),c._meridiem=a}),ba(["h","hh"],function(a,b,c){b[de]=u(a),m(c).bigHour=!0}),ba("hmm",function(a,b,c){var d=a.length-2;b[de]=u(a.substr(0,d)),b[ee]=u(a.substr(d)),m(c).bigHour=!0}),ba("hmmss",function(a,b,c){var d=a.length-4,e=a.length-2;b[de]=u(a.substr(0,d)),b[ee]=u(a.substr(d,2)),b[fe]=u(a.substr(e)),m(c).bigHour=!0}),ba("Hmm",function(a,b,c){var d=a.length-2;b[de]=u(a.substr(0,d)),b[ee]=u(a.substr(d))}),ba("Hmmss",function(a,b,c){var d=a.length-4,e=a.length-2;b[de]=u(a.substr(0,d)),b[ee]=u(a.substr(d,2)),b[fe]=u(a.substr(e))});var xe,ye=/[ap]\.?m?\.?/i,ze=O("Hours",!0),Ae={calendar:xd,longDateFormat:yd,invalidDate:zd,ordinal:Ad,ordinalParse:Bd,relativeTime:Cd,months:le,monthsShort:me,week:qe,weekdays:re,weekdaysMin:te,weekdaysShort:se,meridiemParse:ye},Be={},Ce={},De=/^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/,Ee=/^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/,Fe=/Z|[+-]\d\d(?::?\d\d)?/,Ge=[["YYYYYY-MM-DD",/[+-]\d{6}-\d\d-\d\d/],["YYYY-MM-DD",/\d{4}-\d\d-\d\d/],["GGGG-[W]WW-E",/\d{4}-W\d\d-\d/],["GGGG-[W]WW",/\d{4}-W\d\d/,!1],["YYYY-DDD",/\d{4}-\d{3}/],["YYYY-MM",/\d{4}-\d\d/,!1],["YYYYYYMMDD",/[+-]\d{10}/],["YYYYMMDD",/\d{8}/],
// YYYYMM is NOT allowed by the standard
    ["GGGG[W]WWE",/\d{4}W\d{3}/],["GGGG[W]WW",/\d{4}W\d{2}/,!1],["YYYYDDD",/\d{7}/]],He=[["HH:mm:ss.SSSS",/\d\d:\d\d:\d\d\.\d+/],["HH:mm:ss,SSSS",/\d\d:\d\d:\d\d,\d+/],["HH:mm:ss",/\d\d:\d\d:\d\d/],["HH:mm",/\d\d:\d\d/],["HHmmss.SSSS",/\d\d\d\d\d\d\.\d+/],["HHmmss,SSSS",/\d\d\d\d\d\d,\d+/],["HHmmss",/\d\d\d\d\d\d/],["HHmm",/\d\d\d\d/],["HH",/\d\d/]],Ie=/^\/?Date\((\-?\d+)/i;a.createFromInputFallback=x("value provided is not in a recognized ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non ISO date formats are discouraged and will be removed in an upcoming major release. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",function(a){a._d=new Date(a._i+(a._useUTC?" UTC":""))}),
// constant that refers to the ISO standard
    a.ISO_8601=function(){};var Je=x("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",function(){var a=sb.apply(null,arguments);return this.isValid()&&a.isValid()?a<this?this:a:o()}),Ke=x("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",function(){var a=sb.apply(null,arguments);return this.isValid()&&a.isValid()?a>this?this:a:o()}),Le=function(){return Date.now?Date.now():+new Date};zb("Z",":"),zb("ZZ",""),
// PARSING
    Z("Z",Xd),Z("ZZ",Xd),ba(["Z","ZZ"],function(a,b,c){c._useUTC=!0,c._tzm=Ab(Xd,a)});
// HELPERS
// timezone chunker
// '+10:00' > ['10',  '00']
// '-1530'  > ['-15', '30']
  var Me=/([\+\-]|\d\d)/gi;
// HOOKS
// This function will be called whenever a moment is mutated.
// It is intended to keep the offset in sync with the timezone.
  a.updateOffset=function(){};
// ASP.NET json date format regex
  var Ne=/^(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/,Oe=/^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;Ob.fn=wb.prototype;var Pe=Sb(1,"add"),Qe=Sb(-1,"subtract");a.defaultFormat="YYYY-MM-DDTHH:mm:ssZ",a.defaultFormatUtc="YYYY-MM-DDTHH:mm:ss[Z]";var Re=x("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",function(a){return void 0===a?this.localeData():this.locale(a)});
// FORMATTING
  U(0,["gg",2],0,function(){return this.weekYear()%100}),U(0,["GG",2],0,function(){return this.isoWeekYear()%100}),zc("gggg","weekYear"),zc("ggggg","weekYear"),zc("GGGG","isoWeekYear"),zc("GGGGG","isoWeekYear"),
// ALIASES
    J("weekYear","gg"),J("isoWeekYear","GG"),
// PRIORITY
    M("weekYear",1),M("isoWeekYear",1),
// PARSING
    Z("G",Vd),Z("g",Vd),Z("GG",Od,Kd),Z("gg",Od,Kd),Z("GGGG",Sd,Md),Z("gggg",Sd,Md),Z("GGGGG",Td,Nd),Z("ggggg",Td,Nd),ca(["gggg","ggggg","GGGG","GGGGG"],function(a,b,c,d){b[d.substr(0,2)]=u(a)}),ca(["gg","GG"],function(b,c,d,e){c[e]=a.parseTwoDigitYear(b)}),
// FORMATTING
    U("Q",0,"Qo","quarter"),
// ALIASES
    J("quarter","Q"),
// PRIORITY
    M("quarter",7),
// PARSING
    Z("Q",Jd),ba("Q",function(a,b){b[be]=3*(u(a)-1)}),
// FORMATTING
    U("D",["DD",2],"Do","date"),
// ALIASES
    J("date","D"),
// PRIOROITY
    M("date",9),
// PARSING
    Z("D",Od),Z("DD",Od,Kd),Z("Do",function(a,b){return a?b._ordinalParse:b._ordinalParseLenient}),ba(["D","DD"],ce),ba("Do",function(a,b){b[ce]=u(a.match(Od)[0],10)});
// MOMENTS
  var Se=O("Date",!0);
// FORMATTING
  U("DDD",["DDDD",3],"DDDo","dayOfYear"),
// ALIASES
    J("dayOfYear","DDD"),
// PRIORITY
    M("dayOfYear",4),
// PARSING
    Z("DDD",Rd),Z("DDDD",Ld),ba(["DDD","DDDD"],function(a,b,c){c._dayOfYear=u(a)}),
// FORMATTING
    U("m",["mm",2],0,"minute"),
// ALIASES
    J("minute","m"),
// PRIORITY
    M("minute",14),
// PARSING
    Z("m",Od),Z("mm",Od,Kd),ba(["m","mm"],ee);
// MOMENTS
  var Te=O("Minutes",!1);
// FORMATTING
  U("s",["ss",2],0,"second"),
// ALIASES
    J("second","s"),
// PRIORITY
    M("second",15),
// PARSING
    Z("s",Od),Z("ss",Od,Kd),ba(["s","ss"],fe);
// MOMENTS
  var Ue=O("Seconds",!1);
// FORMATTING
  U("S",0,0,function(){return~~(this.millisecond()/100)}),U(0,["SS",2],0,function(){return~~(this.millisecond()/10)}),U(0,["SSS",3],0,"millisecond"),U(0,["SSSS",4],0,function(){return 10*this.millisecond()}),U(0,["SSSSS",5],0,function(){return 100*this.millisecond()}),U(0,["SSSSSS",6],0,function(){return 1e3*this.millisecond()}),U(0,["SSSSSSS",7],0,function(){return 1e4*this.millisecond()}),U(0,["SSSSSSSS",8],0,function(){return 1e5*this.millisecond()}),U(0,["SSSSSSSSS",9],0,function(){return 1e6*this.millisecond()}),
// ALIASES
    J("millisecond","ms"),
// PRIORITY
    M("millisecond",16),
// PARSING
    Z("S",Rd,Jd),Z("SS",Rd,Kd),Z("SSS",Rd,Ld);var Ve;for(Ve="SSSS";Ve.length<=9;Ve+="S")Z(Ve,Ud);for(Ve="S";Ve.length<=9;Ve+="S")ba(Ve,Ic);
// MOMENTS
  var We=O("Milliseconds",!1);
// FORMATTING
  U("z",0,0,"zoneAbbr"),U("zz",0,0,"zoneName");var Xe=r.prototype;Xe.add=Pe,Xe.calendar=Vb,Xe.clone=Wb,Xe.diff=bc,Xe.endOf=oc,Xe.format=gc,Xe.from=hc,Xe.fromNow=ic,Xe.to=jc,Xe.toNow=kc,Xe.get=R,Xe.invalidAt=xc,Xe.isAfter=Xb,Xe.isBefore=Yb,Xe.isBetween=Zb,Xe.isSame=$b,Xe.isSameOrAfter=_b,Xe.isSameOrBefore=ac,Xe.isValid=vc,Xe.lang=Re,Xe.locale=lc,Xe.localeData=mc,Xe.max=Ke,Xe.min=Je,Xe.parsingFlags=wc,Xe.set=S,Xe.startOf=nc,Xe.subtract=Qe,Xe.toArray=sc,Xe.toObject=tc,Xe.toDate=rc,Xe.toISOString=ec,Xe.inspect=fc,Xe.toJSON=uc,Xe.toString=dc,Xe.unix=qc,Xe.valueOf=pc,Xe.creationData=yc,
// Year
    Xe.year=pe,Xe.isLeapYear=ra,
// Week Year
    Xe.weekYear=Ac,Xe.isoWeekYear=Bc,
// Quarter
    Xe.quarter=Xe.quarters=Gc,
// Month
    Xe.month=ka,Xe.daysInMonth=la,
// Week
    Xe.week=Xe.weeks=Ba,Xe.isoWeek=Xe.isoWeeks=Ca,Xe.weeksInYear=Dc,Xe.isoWeeksInYear=Cc,
// Day
    Xe.date=Se,Xe.day=Xe.days=Ka,Xe.weekday=La,Xe.isoWeekday=Ma,Xe.dayOfYear=Hc,
// Hour
    Xe.hour=Xe.hours=ze,
// Minute
    Xe.minute=Xe.minutes=Te,
// Second
    Xe.second=Xe.seconds=Ue,
// Millisecond
    Xe.millisecond=Xe.milliseconds=We,
// Offset
    Xe.utcOffset=Db,Xe.utc=Fb,Xe.local=Gb,Xe.parseZone=Hb,Xe.hasAlignedHourOffset=Ib,Xe.isDST=Jb,Xe.isLocal=Lb,Xe.isUtcOffset=Mb,Xe.isUtc=Nb,Xe.isUTC=Nb,
// Timezone
    Xe.zoneAbbr=Jc,Xe.zoneName=Kc,
// Deprecations
    Xe.dates=x("dates accessor is deprecated. Use date instead.",Se),Xe.months=x("months accessor is deprecated. Use month instead",ka),Xe.years=x("years accessor is deprecated. Use year instead",pe),Xe.zone=x("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",Eb),Xe.isDSTShifted=x("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",Kb);var Ye=C.prototype;Ye.calendar=D,Ye.longDateFormat=E,Ye.invalidDate=F,Ye.ordinal=G,Ye.preparse=Nc,Ye.postformat=Nc,Ye.relativeTime=H,Ye.pastFuture=I,Ye.set=A,
// Month
    Ye.months=fa,Ye.monthsShort=ga,Ye.monthsParse=ia,Ye.monthsRegex=na,Ye.monthsShortRegex=ma,
// Week
    Ye.week=ya,Ye.firstDayOfYear=Aa,Ye.firstDayOfWeek=za,
// Day of Week
    Ye.weekdays=Fa,Ye.weekdaysMin=Ha,Ye.weekdaysShort=Ga,Ye.weekdaysParse=Ja,Ye.weekdaysRegex=Na,Ye.weekdaysShortRegex=Oa,Ye.weekdaysMinRegex=Pa,
// Hours
    Ye.isPM=Va,Ye.meridiem=Wa,$a("en",{ordinalParse:/\d{1,2}(th|st|nd|rd)/,ordinal:function(a){var b=a%10,c=1===u(a%100/10)?"th":1===b?"st":2===b?"nd":3===b?"rd":"th";return a+c}}),
// Side effect imports
    a.lang=x("moment.lang is deprecated. Use moment.locale instead.",$a),a.langData=x("moment.langData is deprecated. Use moment.localeData instead.",bb);var Ze=Math.abs,$e=ed("ms"),_e=ed("s"),af=ed("m"),bf=ed("h"),cf=ed("d"),df=ed("w"),ef=ed("M"),ff=ed("y"),gf=gd("milliseconds"),hf=gd("seconds"),jf=gd("minutes"),kf=gd("hours"),lf=gd("days"),mf=gd("months"),nf=gd("years"),of=Math.round,pf={s:45,// seconds to minute
    m:45,// minutes to hour
    h:22,// hours to day
    d:26,// days to month
    M:11},qf=Math.abs,rf=wb.prototype;
// Deprecations
// Side effect imports
// FORMATTING
// PARSING
// Side effect imports
  return rf.abs=Wc,rf.add=Yc,rf.subtract=Zc,rf.as=cd,rf.asMilliseconds=$e,rf.asSeconds=_e,rf.asMinutes=af,rf.asHours=bf,rf.asDays=cf,rf.asWeeks=df,rf.asMonths=ef,rf.asYears=ff,rf.valueOf=dd,rf._bubble=_c,rf.get=fd,rf.milliseconds=gf,rf.seconds=hf,rf.minutes=jf,rf.hours=kf,rf.days=lf,rf.weeks=hd,rf.months=mf,rf.years=nf,rf.humanize=md,rf.toISOString=nd,rf.toString=nd,rf.toJSON=nd,rf.locale=lc,rf.localeData=mc,rf.toIsoString=x("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",nd),rf.lang=Re,U("X",0,0,"unix"),U("x",0,0,"valueOf"),Z("x",Vd),Z("X",Yd),ba("X",function(a,b,c){c._d=new Date(1e3*parseFloat(a,10))}),ba("x",function(a,b,c){c._d=new Date(u(a))}),a.version="2.17.1",b(sb),a.fn=Xe,a.min=ub,a.max=vb,a.now=Le,a.utc=k,a.unix=Lc,a.months=Rc,a.isDate=g,a.locale=$a,a.invalid=o,a.duration=Ob,a.isMoment=s,a.weekdays=Tc,a.parseZone=Mc,a.localeData=bb,a.isDuration=xb,a.monthsShort=Sc,a.weekdaysMin=Vc,a.defineLocale=_a,a.updateLocale=ab,a.locales=cb,a.weekdaysShort=Uc,a.normalizeUnits=K,a.relativeTimeRounding=kd,a.relativeTimeThreshold=ld,a.calendarFormat=Ub,a.prototype=Xe,a});

/* resources/assets/js/libraries/datetimepicker.js */
/*! version : 4.17.47
 =========================================================
 bootstrap-datetimejs
 https://github.com/Eonasdan/bootstrap-datetimepicker
 Copyright (c) 2015 Jonathan Peterson
 =========================================================
 */
/*
 The MIT License (MIT)

 Copyright (c) 2015 Jonathan Peterson

 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in
 all copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 THE SOFTWARE.
 */
/*global define:false */
/*global exports:false */
/*global require:false */
/*global jQuery:false */
/*global moment:false */
(function(factory) {
  'use strict';
  if (typeof define === 'function' && define.amd) {
    // AMD is used - Register as an anonymous module.
    define(['jquery', 'moment'], factory);
  }
  else if (typeof exports === 'object') {
    module.exports = factory(require('jquery'), require('moment'));
  }
  else {
    // Neither AMD nor CommonJS used. Use global variables.
    if (typeof jQuery === 'undefined') {
      throw 'bootstrap-datetimepicker requires jQuery to be loaded first';
    }
    if (typeof moment === 'undefined') {
      throw 'bootstrap-datetimepicker requires Moment.js to be loaded first';
    }
    factory(jQuery, moment);
  }
}(function($, moment) {
  'use strict';
  if (!moment) {
    throw new Error('bootstrap-datetimepicker requires Moment.js to be loaded first');
  }
  var dateTimePicker = function(element, options) {
    var picker                        = {},
        date,
        viewDate,
        unset                         = true,
        input,
        component                     = false,
        widget                        = false,
        use24Hours,
        minViewModeNumber             = 0,
        actualFormat,
        parseFormats,
        currentViewMode,
        datePickerModes               = [
          {
            clsName: 'days',
            navFnc : 'M',
            navStep: 1
          },
          {
            clsName: 'months',
            navFnc : 'y',
            navStep: 1
          },
          {
            clsName: 'years',
            navFnc : 'y',
            navStep: 10
          },
          {
            clsName: 'decades',
            navFnc : 'y',
            navStep: 100
          }
        ],
        viewModes                     = ['days', 'months', 'years', 'decades'],
        verticalModes                 = ['top', 'bottom', 'auto'],
        horizontalModes               = ['left', 'right', 'auto'],
        toolbarPlacements             = ['default', 'top', 'bottom'],
        keyMap                        = {
          'up'      : 38,
          38        : 'up',
          'down'    : 40,
          40        : 'down',
          'left'    : 37,
          37        : 'left',
          'right'   : 39,
          39        : 'right',
          'tab'     : 9,
          9         : 'tab',
          'escape'  : 27,
          27        : 'escape',
          'enter'   : 13,
          13        : 'enter',
          'pageUp'  : 33,
          33        : 'pageUp',
          'pageDown': 34,
          34        : 'pageDown',
          'shift'   : 16,
          16        : 'shift',
          'control' : 17,
          17        : 'control',
          'space'   : 32,
          32        : 'space',
          't'       : 84,
          84        : 't',
          'delete'  : 46,
          46        : 'delete'
        },
        keyState                      = {},

        /********************************************************************************
         *
         * Private functions
         *
         ********************************************************************************/

        hasTimeZone                   = function() {
          return moment.tz !==
                 undefined &&
                 options.timeZone !==
                 undefined &&
                 options.timeZone !==
                 null &&
                 options.timeZone !==
                 '';
        },

        getMoment                     = function(d) {
          var returnMoment;

          if (d === undefined || d === null) {
            returnMoment = moment(); //TODO should this use format? and locale?
          }
          else if (moment.isDate(d) || moment.isMoment(d)) {
            // If the date that is passed in is already a Date() or moment() object,
            // pass it directly to moment.
            returnMoment = moment(d);
          }
          else if (hasTimeZone()) { // There is a string to parse and a default time zone
            // parse with the tz function which takes a default time zone if it is not in the format string
            returnMoment = moment.tz(d, parseFormats, options.useStrict, options.timeZone);
          }
          else {
            returnMoment = moment(d, parseFormats, options.useStrict);
          }

          if (hasTimeZone()) {
            returnMoment.tz(options.timeZone);
          }

          return returnMoment;
        },

        isEnabled                     = function(granularity) {
          if (typeof granularity !== 'string' || granularity.length > 1) {
            throw new TypeError('isEnabled expects a single character string parameter');
          }
          switch (granularity) {
            case 'y':
              return actualFormat.indexOf('Y') !== -1;
            case 'M':
              return actualFormat.indexOf('M') !== -1;
            case 'd':
              return actualFormat.toLowerCase().indexOf('d') !== -1;
            case 'h':
            case 'H':
              return actualFormat.toLowerCase().indexOf('h') !== -1;
            case 'm':
              return actualFormat.indexOf('m') !== -1;
            case 's':
              return actualFormat.indexOf('s') !== -1;
            default:
              return false;
          }
        },

        hasTime                       = function() {
          return (isEnabled('h') || isEnabled('m') || isEnabled('s'));
        },

        hasDate                       = function() {
          return (isEnabled('y') || isEnabled('M') || isEnabled('d'));
        },

        getDatePickerTemplate         = function() {
          var headTemplate = $('<thead>')
            .append($('<tr>')
              .append($('<th>').addClass('prev').attr('data-action', 'previous')
                               .append($('<i>').addClass(options.icons.previous))
              )
              .append($('<th>')
                .addClass('picker-switch')
                .attr('data-action', 'pickerSwitch')
                .attr('colspan', (options.calendarWeeks ? '6' : '5')))
              .append($('<th>').addClass('next').attr('data-action', 'next')
                               .append($('<i>').addClass(options.icons.next))
              )
            ),
              contTemplate = $('<tbody>')
                .append($('<tr>')
                  .append($('<td>').attr('colspan', (options.calendarWeeks ? '8' : '7')))
                );

          return [
            $('<div>').addClass('datepicker-days')
                      .append($('<table>').addClass('table-condensed')
                                          .append(headTemplate)
                                          .append($('<tbody>'))
                      ),
            $('<div>').addClass('datepicker-months')
                      .append($('<table>').addClass('table-condensed')
                                          .append(headTemplate.clone())
                                          .append(contTemplate.clone())
                      ),
            $('<div>').addClass('datepicker-years')
                      .append($('<table>').addClass('table-condensed')
                                          .append(headTemplate.clone())
                                          .append(contTemplate.clone())
                      ),
            $('<div>').addClass('datepicker-decades')
                      .append($('<table>').addClass('table-condensed')
                                          .append(headTemplate.clone())
                                          .append(contTemplate.clone())
                      )
          ];
        },

        getTimePickerMainTemplate     = function() {
          var topRow    = $('<tr>'),
              middleRow = $('<tr>'),
              bottomRow = $('<tr>');

          if (isEnabled('h')) {
            topRow.append($('<td>')
              .append($('<a>')
                .attr({href: '#', tabindex: '-1', 'title': options.tooltips.incrementHour})
                .addClass('btn')
                .attr('data-action', 'incrementHours')
                .append($('<i>').addClass(options.icons.up))));
            middleRow.append($('<td>')
              .append($('<span>').addClass('timepicker-hour').attr({
                'data-time-component': 'hours',
                'title'              : options.tooltips.pickHour
              }).attr('data-action', 'showHours')));
            bottomRow.append($('<td>')
              .append($('<a>')
                .attr({href: '#', tabindex: '-1', 'title': options.tooltips.decrementHour})
                .addClass('btn')
                .attr('data-action', 'decrementHours')
                .append($('<i>').addClass(options.icons.down))));
          }
          if (isEnabled('m')) {
            if (isEnabled('h')) {
              topRow.append($('<td>').addClass('separator'));
              middleRow.append($('<td>').addClass('separator').html(':'));
              bottomRow.append($('<td>').addClass('separator'));
            }
            topRow.append($('<td>')
              .append($('<a>')
                .attr({href: '#', tabindex: '-1', 'title': options.tooltips.incrementMinute})
                .addClass('btn')
                .attr('data-action', 'incrementMinutes')
                .append($('<i>').addClass(options.icons.up))));
            middleRow.append($('<td>')
              .append($('<span>').addClass('timepicker-minute').attr({
                'data-time-component': 'minutes',
                'title'              : options.tooltips.pickMinute
              }).attr('data-action', 'showMinutes')));
            bottomRow.append($('<td>')
              .append($('<a>')
                .attr({href: '#', tabindex: '-1', 'title': options.tooltips.decrementMinute})
                .addClass('btn')
                .attr('data-action', 'decrementMinutes')
                .append($('<i>').addClass(options.icons.down))));
          }
          if (isEnabled('s')) {
            if (isEnabled('m')) {
              topRow.append($('<td>').addClass('separator'));
              middleRow.append($('<td>').addClass('separator').html(':'));
              bottomRow.append($('<td>').addClass('separator'));
            }
            topRow.append($('<td>')
              .append($('<a>')
                .attr({href: '#', tabindex: '-1', 'title': options.tooltips.incrementSecond})
                .addClass('btn')
                .attr('data-action', 'incrementSeconds')
                .append($('<i>').addClass(options.icons.up))));
            middleRow.append($('<td>')
              .append($('<span>').addClass('timepicker-second').attr({
                'data-time-component': 'seconds',
                'title'              : options.tooltips.pickSecond
              }).attr('data-action', 'showSeconds')));
            bottomRow.append($('<td>')
              .append($('<a>')
                .attr({href: '#', tabindex: '-1', 'title': options.tooltips.decrementSecond})
                .addClass('btn')
                .attr('data-action', 'decrementSeconds')
                .append($('<i>').addClass(options.icons.down))));
          }

          if (!use24Hours) {
            topRow.append($('<td>').addClass('separator'));
            middleRow.append($('<td>')
              .append($('<button>').addClass('btn btn-info').attr({
                'data-action': 'togglePeriod',
                tabindex     : '-1',
                'title'      : options.tooltips.togglePeriod
              })));
            bottomRow.append($('<td>').addClass('separator'));
          }

          return $('<div>').addClass('timepicker-picker')
                           .append($('<table>').addClass('table-condensed')
                                               .append([topRow, middleRow, bottomRow]));
        },

        getTimePickerTemplate         = function() {
          var hoursView   = $('<div>').addClass('timepicker-hours')
                                      .append($('<table>').addClass('table-condensed')),
              minutesView = $('<div>').addClass('timepicker-minutes')
                                      .append($('<table>').addClass('table-condensed')),
              secondsView = $('<div>').addClass('timepicker-seconds')
                                      .append($('<table>').addClass('table-condensed')),
              ret         = [getTimePickerMainTemplate()];

          if (isEnabled('h')) {
            ret.push(hoursView);
          }
          if (isEnabled('m')) {
            ret.push(minutesView);
          }
          if (isEnabled('s')) {
            ret.push(secondsView);
          }

          return ret;
        },

        getToolbar                    = function() {
          var row = [];
          if (options.showTodayButton) {
            row.push($('<td>').append($('<a>')
              .attr({'data-action': 'today', 'title': options.tooltips.today})
              .append($('<i>').addClass(options.icons.today))));
          }
          if (!options.sideBySide && hasDate() && hasTime()) {
            row.push($('<td>').append($('<a>').attr({
              'data-action': 'togglePicker',
              'title'      : options.tooltips.selectTime
            }).append($('<i>').addClass(options.icons.time))));
          }
          if (options.showClear) {
            row.push($('<td>').append($('<a>')
              .attr({'data-action': 'clear', 'title': options.tooltips.clear})
              .append($('<i>').addClass(options.icons.clear))));
          }
          if (options.showClose) {
            row.push($('<td>').append($('<a>')
              .attr({'data-action': 'close', 'title': options.tooltips.close})
              .append($('<i>').addClass(options.icons.close))));
          }
          return $('<table>').addClass('table-condensed').append($('<tbody>').append($('<tr>').append(row)));
        },

        getTemplate                   = function() {
          var template = $('<div>').addClass('bootstrap-datetimepicker-widget dropdown-menu'),
              dateView = $('<div>').addClass('datepicker').append(getDatePickerTemplate()),
              timeView = $('<div>').addClass('timepicker').append(getTimePickerTemplate()),
              content  = $('<ul>').addClass('list-unstyled'),
              toolbar  = $('<li>')
                .addClass('picker-switch' + (options.collapse ? ' accordion-toggle' : ''))
                .append(getToolbar());

          if (options.inline) {
            template.removeClass('dropdown-menu');
          }

          if (use24Hours) {
            template.addClass('usetwentyfour');
          }

          if (isEnabled('s') && !use24Hours) {
            template.addClass('wider');
          }

          if (options.sideBySide && hasDate() && hasTime()) {
            template.addClass('timepicker-sbs');
            if (options.toolbarPlacement === 'top') {
              template.append(toolbar);
            }
            template.append(
              $('<div>').addClass('row')
                        .append(dateView.addClass('col-md-6'))
                        .append(timeView.addClass('col-md-6'))
            );
            if (options.toolbarPlacement === 'bottom') {
              template.append(toolbar);
            }
            return template;
          }

          if (options.toolbarPlacement === 'top') {
            content.append(toolbar);
          }
          if (hasDate()) {
            content.append($('<li>').addClass((options.collapse && hasTime() ? 'collapse show' : '')).append(dateView));
          }
          if (options.toolbarPlacement === 'default') {
            content.append(toolbar);
          }
          if (hasTime()) {
            content.append($('<li>').addClass((options.collapse && hasDate() ? 'collapse' : '')).append(timeView));
          }
          if (options.toolbarPlacement === 'bottom') {
            content.append(toolbar);
          }
          return template.append(content);
        },

        dataToOptions                 = function() {
          var eData,
              dataOptions = {};

          if (element.is('input') || options.inline) {
            eData = element.data();
          }
          else {
            eData = element.find('input').data();
          }

          if (eData.dateOptions && eData.dateOptions instanceof Object) {
            dataOptions = $.extend(true, dataOptions, eData.dateOptions);
          }

          $.each(options, function(key) {
            var attributeName = 'date' + key.charAt(0).toUpperCase() + key.slice(1);
            if (eData[attributeName] !== undefined) {
              dataOptions[key] = eData[attributeName];
            }
          });
          return dataOptions;
        },

        place                         = function() {
          var position   = (component || element).position(),
              offset     = (component || element).offset(),
              vertical   = options.widgetPositioning.vertical,
              horizontal = options.widgetPositioning.horizontal,
              parent;

          if (options.widgetParent) {
            parent = options.widgetParent.append(widget);
          }
          else if (element.is('input')) {
            parent = element.after(widget).parent();
          }
          else if (options.inline) {
            parent = element.append(widget);
            return;
          }
          else {
            parent = element;
            element.children().first().after(widget);
          }

          // Top and bottom logic
          if (vertical === 'auto') {
            if (offset.top + widget.height() * 1.5 >= $(window).height() + $(window).scrollTop() &&
                widget.height() + element.outerHeight() < offset.top) {
              vertical = 'top';
            }
            else {
              vertical = 'bottom';
            }
          }

          // Left and right logic
          if (horizontal === 'auto') {
            if (parent.width() < offset.left + widget.outerWidth() / 2 &&
                offset.left + widget.outerWidth() > $(window).width()) {
              horizontal = 'right';
            }
            else {
              horizontal = 'left';
            }
          }

          if (vertical === 'top') {
            widget.addClass('top').removeClass('bottom');
          }
          else {
            widget.addClass('bottom').removeClass('top');
          }

          if (horizontal === 'right') {
            widget.addClass('pull-right');
          }
          else {
            widget.removeClass('pull-right');
          }

          // find the first parent element that has a non-static css positioning
          if (parent.css('position') === 'static') {
            parent = parent.parents().filter(function() {
              return $(this).css('position') !== 'static';
            }).first();
          }

          if (parent.length === 0) {
            throw new Error('datetimepicker component should be placed within a non-static positioned container');
          }

          widget.css({
            top   : vertical === 'top' ? 'auto' : position.top + element.outerHeight(),
            bottom: vertical === 'top' ? parent.outerHeight() - (parent === element ? 0 : position.top) : 'auto',
            left  : horizontal === 'left' ? (parent === element ? 0 : position.left) : 'auto',
            right : horizontal === 'left' ? 'auto' : parent.outerWidth() -
                                                     element.outerWidth() -
                                                     (parent === element ? 0 : position.left)
          });
        },

        notifyEvent                   = function(e) {
          if (e.type === 'dp.change' && ((e.date && e.date.isSame(e.oldDate)) || (!e.date && !e.oldDate))) {
            return;
          }
          element.trigger(e);
        },

        viewUpdate                    = function(e) {
          if (e === 'y') {
            e = 'YYYY';
          }
          notifyEvent({
            type    : 'dp.update',
            change  : e,
            viewDate: viewDate.clone()
          });
        },

        showMode                      = function(dir) {
          if (!widget) {
            return;
          }
          if (dir) {
            currentViewMode = Math.max(minViewModeNumber, Math.min(3, currentViewMode + dir));
          }
          widget.find('.datepicker > div')
                .hide()
                .filter('.datepicker-' + datePickerModes[currentViewMode].clsName)
                .show();
        },

        fillDow                       = function() {
          var row         = $('<tr>'),
              currentDate = viewDate.clone().startOf('w').startOf('d');

          if (options.calendarWeeks === true) {
            row.append($('<th>').addClass('cw').text('#'));
          }

          while (currentDate.isBefore(viewDate.clone().endOf('w'))) {
            row.append($('<th>').addClass('dow').text(currentDate.format('dd')));
            currentDate.add(1, 'd');
          }
          widget.find('.datepicker-days thead').append(row);
        },

        isInDisabledDates             = function(testDate) {
          return options.disabledDates[testDate.format('YYYY-MM-DD')] === true;
        },

        isInEnabledDates              = function(testDate) {
          return options.enabledDates[testDate.format('YYYY-MM-DD')] === true;
        },

        isInDisabledHours             = function(testDate) {
          return options.disabledHours[testDate.format('H')] === true;
        },

        isInEnabledHours              = function(testDate) {
          return options.enabledHours[testDate.format('H')] === true;
        },

        isValid                       = function(targetMoment, granularity) {
          if (!targetMoment.isValid()) {
            return false;
          }
          if (options.disabledDates && granularity === 'd' && isInDisabledDates(targetMoment)) {
            return false;
          }
          if (options.enabledDates && granularity === 'd' && !isInEnabledDates(targetMoment)) {
            return false;
          }
          if (options.minDate && targetMoment.isBefore(options.minDate, granularity)) {
            return false;
          }
          if (options.maxDate && targetMoment.isAfter(options.maxDate, granularity)) {
            return false;
          }
          if (options.daysOfWeekDisabled &&
              granularity ===
              'd' &&
              options.daysOfWeekDisabled.indexOf(targetMoment.day()) !==
              -1) {
            return false;
          }
          if (options.disabledHours &&
              (granularity === 'h' || granularity === 'm' || granularity === 's') &&
              isInDisabledHours(targetMoment)) {
            return false;
          }
          if (options.enabledHours &&
              (granularity === 'h' || granularity === 'm' || granularity === 's') &&
              !isInEnabledHours(targetMoment)) {
            return false;
          }
          if (options.disabledTimeIntervals && (granularity === 'h' || granularity === 'm' || granularity === 's')) {
            var found = false;
            $.each(options.disabledTimeIntervals, function() {
              if (targetMoment.isBetween(this[0], this[1])) {
                found = true;
                return false;
              }
            });
            if (found) {
              return false;
            }
          }
          return true;
        },

        fillMonths                    = function() {
          var spans       = [],
              monthsShort = viewDate.clone().startOf('y').startOf('d');
          while (monthsShort.isSame(viewDate, 'y')) {
            spans.push($('<span>')
              .attr('data-action', 'selectMonth')
              .addClass('month')
              .text(monthsShort.format('MMM')));
            monthsShort.add(1, 'M');
          }
          widget.find('.datepicker-months td').empty().append(spans);
        },

        updateMonths                  = function() {
          var monthsView       = widget.find('.datepicker-months'),
              monthsViewHeader = monthsView.find('th'),
              months           = monthsView.find('tbody').find('span');

          monthsViewHeader.eq(0).find('span').attr('title', options.tooltips.prevYear);
          monthsViewHeader.eq(1).attr('title', options.tooltips.selectYear);
          monthsViewHeader.eq(2).find('span').attr('title', options.tooltips.nextYear);

          monthsView.find('.disabled').removeClass('disabled');

          if (!isValid(viewDate.clone().subtract(1, 'y'), 'y')) {
            monthsViewHeader.eq(0).addClass('disabled');
          }

          monthsViewHeader.eq(1).text(viewDate.year());

          if (!isValid(viewDate.clone().add(1, 'y'), 'y')) {
            monthsViewHeader.eq(2).addClass('disabled');
          }

          months.removeClass('active');
          if (date.isSame(viewDate, 'y') && !unset) {
            months.eq(date.month()).addClass('active');
          }

          months.each(function(index) {
            if (!isValid(viewDate.clone().month(index), 'M')) {
              $(this).addClass('disabled');
            }
          });
        },

        updateYears                   = function() {
          var yearsView       = widget.find('.datepicker-years'),
              yearsViewHeader = yearsView.find('th'),
              startYear       = viewDate.clone().subtract(5, 'y'),
              endYear         = viewDate.clone().add(6, 'y'),
              html            = '';

          yearsViewHeader.eq(0).find('span').attr('title', options.tooltips.prevDecade);
          yearsViewHeader.eq(1).attr('title', options.tooltips.selectDecade);
          yearsViewHeader.eq(2).find('span').attr('title', options.tooltips.nextDecade);

          yearsView.find('.disabled').removeClass('disabled');

          if (options.minDate && options.minDate.isAfter(startYear, 'y')) {
            yearsViewHeader.eq(0).addClass('disabled');
          }

          yearsViewHeader.eq(1).text(startYear.year() + '-' + endYear.year());

          if (options.maxDate && options.maxDate.isBefore(endYear, 'y')) {
            yearsViewHeader.eq(2).addClass('disabled');
          }

          while (!startYear.isAfter(endYear, 'y')) {
            html +=
              '<span data-action="selectYear" class="year' +
              (startYear.isSame(date, 'y') && !unset ? ' active' : '') +
              (!isValid(startYear, 'y') ? ' disabled' : '') +
              '">' +
              startYear.year() +
              '</span>';
            startYear.add(1, 'y');
          }

          yearsView.find('td').html(html);
        },

        updateDecades                 = function() {
          var decadesView       = widget.find('.datepicker-decades'),
              decadesViewHeader = decadesView.find('th'),
              startDecade       = moment({y: viewDate.year() - (viewDate.year() % 100) - 1}),
              endDecade         = startDecade.clone().add(100, 'y'),
              startedAt         = startDecade.clone(),
              minDateDecade     = false,
              maxDateDecade     = false,
              endDecadeYear,
              html              = '';

          decadesViewHeader.eq(0).find('span').attr('title', options.tooltips.prevCentury);
          decadesViewHeader.eq(2).find('span').attr('title', options.tooltips.nextCentury);

          decadesView.find('.disabled').removeClass('disabled');

          if (startDecade.isSame(moment({y: 1900})) || (options.minDate && options.minDate.isAfter(startDecade, 'y'))) {
            decadesViewHeader.eq(0).addClass('disabled');
          }

          decadesViewHeader.eq(1).text(startDecade.year() + '-' + endDecade.year());

          if (startDecade.isSame(moment({y: 2000})) || (options.maxDate && options.maxDate.isBefore(endDecade, 'y'))) {
            decadesViewHeader.eq(2).addClass('disabled');
          }

          while (!startDecade.isAfter(endDecade, 'y')) {
            endDecadeYear = startDecade.year() + 12;
            minDateDecade =
              options.minDate && options.minDate.isAfter(startDecade, 'y') && options.minDate.year() <= endDecadeYear;
            maxDateDecade =
              options.maxDate && options.maxDate.isAfter(startDecade, 'y') && options.maxDate.year() <= endDecadeYear;
            html +=
              '<span data-action="selectDecade" class="decade' +
              (date.isAfter(startDecade) && date.year() <= endDecadeYear ? ' active' : '') +
              (!isValid(startDecade, 'y') && !minDateDecade && !maxDateDecade ? ' disabled' : '') +
              '" data-selection="' +
              (startDecade.year() + 6) +
              '">' +
              (startDecade.year() + 1) +
              ' - ' +
              (startDecade.year() + 12) +
              '</span>';
            startDecade.add(12, 'y');
          }
          html += '<span></span><span></span><span></span>'; //push the dangling block over, at least this way it's even

          decadesView.find('td').html(html);
          decadesViewHeader.eq(1).text((startedAt.year() + 1) + '-' + (startDecade.year()));
        },

        fillDate                      = function() {
          var daysView       = widget.find('.datepicker-days'),
              daysViewHeader = daysView.find('th'),
              currentDate,
              html           = [],
              row,
              clsNames       = [],
              i;

          if (!hasDate()) {
            return;
          }

          daysViewHeader.eq(0).find('span').attr('title', options.tooltips.prevMonth);
          daysViewHeader.eq(1).attr('title', options.tooltips.selectMonth);
          daysViewHeader.eq(2).find('span').attr('title', options.tooltips.nextMonth);

          daysView.find('.disabled').removeClass('disabled');
          daysViewHeader.eq(1).text(viewDate.format(options.dayViewHeaderFormat));

          if (!isValid(viewDate.clone().subtract(1, 'M'), 'M')) {
            daysViewHeader.eq(0).addClass('disabled');
          }
          if (!isValid(viewDate.clone().add(1, 'M'), 'M')) {
            daysViewHeader.eq(2).addClass('disabled');
          }

          currentDate = viewDate.clone().startOf('M').startOf('w').startOf('d');

          for (i = 0; i < 42; i++) { //always display 42 days (should show 6 weeks)
            if (currentDate.weekday() === 0) {
              row = $('<tr>');
              if (options.calendarWeeks) {
                row.append('<td class="cw">' + currentDate.week() + '</td>');
              }
              html.push(row);
            }
            clsNames = ['day'];
            if (currentDate.isBefore(viewDate, 'M')) {
              clsNames.push('old');
            }
            if (currentDate.isAfter(viewDate, 'M')) {
              clsNames.push('new');
            }
            if (currentDate.isSame(date, 'd') && !unset) {
              clsNames.push('active');
            }
            if (!isValid(currentDate, 'd')) {
              clsNames.push('disabled');
            }
            if (currentDate.isSame(getMoment(), 'd')) {
              clsNames.push('today');
            }
            if (currentDate.day() === 0 || currentDate.day() === 6) {
              clsNames.push('weekend');
            }
            notifyEvent({
              type      : 'dp.classify',
              date      : currentDate,
              classNames: clsNames
            });
            row.append('<td data-action="selectDay" data-day="' +
                       currentDate.format('L') +
                       '" class="' +
                       clsNames.join(' ') +
                       '">' +
                       currentDate.date() +
                       '</td>');
            currentDate.add(1, 'd');
          }

          daysView.find('tbody').empty().append(html);

          updateMonths();

          updateYears();

          updateDecades();
        },

        fillHours                     = function() {
          var table       = widget.find('.timepicker-hours table'),
              currentHour = viewDate.clone().startOf('d'),
              html        = [],
              row         = $('<tr>');

          if (viewDate.hour() > 11 && !use24Hours) {
            currentHour.hour(12);
          }
          while (currentHour.isSame(viewDate, 'd') &&
                 (use24Hours || (viewDate.hour() < 12 && currentHour.hour() < 12) || viewDate.hour() > 11)) {
            if (currentHour.hour() % 4 === 0) {
              row = $('<tr>');
              html.push(row);
            }
            row.append('<td data-action="selectHour" class="hour' +
                       (!isValid(currentHour, 'h') ? ' disabled' : '') +
                       '">' +
                       currentHour.format(use24Hours ? 'HH' : 'hh') +
                       '</td>');
            currentHour.add(1, 'h');
          }
          table.empty().append(html);
        },

        fillMinutes                   = function() {
          var table         = widget.find('.timepicker-minutes table'),
              currentMinute = viewDate.clone().startOf('h'),
              html          = [],
              row           = $('<tr>'),
              step          = options.stepping === 1 ? 5 : options.stepping;

          while (viewDate.isSame(currentMinute, 'h')) {
            if (currentMinute.minute() % (step * 4) === 0) {
              row = $('<tr>');
              html.push(row);
            }
            row.append('<td data-action="selectMinute" class="minute' +
                       (!isValid(currentMinute, 'm') ? ' disabled' : '') +
                       '">' +
                       currentMinute.format('mm') +
                       '</td>');
            currentMinute.add(step, 'm');
          }
          table.empty().append(html);
        },

        fillSeconds                   = function() {
          var table         = widget.find('.timepicker-seconds table'),
              currentSecond = viewDate.clone().startOf('m'),
              html          = [],
              row           = $('<tr>');

          while (viewDate.isSame(currentSecond, 'm')) {
            if (currentSecond.second() % 20 === 0) {
              row = $('<tr>');
              html.push(row);
            }
            row.append('<td data-action="selectSecond" class="second' +
                       (!isValid(currentSecond, 's') ? ' disabled' : '') +
                       '">' +
                       currentSecond.format('ss') +
                       '</td>');
            currentSecond.add(5, 's');
          }

          table.empty().append(html);
        },

        fillTime                      = function() {
          var toggle, newDate, timeComponents = widget.find('.timepicker span[data-time-component]');

          if (!use24Hours) {
            toggle  = widget.find('.timepicker [data-action=togglePeriod]');
            newDate = date.clone().add((date.hours() >= 12) ? -12 : 12, 'h');

            toggle.text(date.format('A'));

            if (isValid(newDate, 'h')) {
              toggle.removeClass('disabled');
            }
            else {
              toggle.addClass('disabled');
            }
          }
          timeComponents.filter('[data-time-component=hours]').text(date.format(use24Hours ? 'HH' : 'hh'));
          timeComponents.filter('[data-time-component=minutes]').text(date.format('mm'));
          timeComponents.filter('[data-time-component=seconds]').text(date.format('ss'));

          fillHours();
          fillMinutes();
          fillSeconds();
        },

        update                        = function() {
          if (!widget) {
            return;
          }
          fillDate();
          fillTime();
        },

        setValue                      = function(targetMoment) {
          var oldDate = unset ? null : date;

          // case of calling setValue(null or false)
          if (!targetMoment) {
            unset = true;
            input.val('');
            element.data('date', '');
            notifyEvent({
              type   : 'dp.change',
              date   : false,
              oldDate: oldDate
            });
            update();
            return;
          }

          targetMoment = targetMoment.clone().locale(options.locale);

          if (hasTimeZone()) {
            targetMoment.tz(options.timeZone);
          }

          if (options.stepping !== 1) {
            targetMoment.minutes((Math.round(targetMoment.minutes() / options.stepping) * options.stepping)).seconds(0);

            while (options.minDate && targetMoment.isBefore(options.minDate)) {
              targetMoment.add(options.stepping, 'minutes');
            }
          }

          if (isValid(targetMoment)) {
            date     = targetMoment;
            viewDate = date.clone();
            input.val(date.format(actualFormat));
            element.data('date', date.format(actualFormat));
            unset = false;
            update();
            notifyEvent({
              type   : 'dp.change',
              date   : date.clone(),
              oldDate: oldDate
            });
          }
          else {
            if (!options.keepInvalid) {
              input.val(unset ? '' : date.format(actualFormat));
            }
            else {
              notifyEvent({
                type   : 'dp.change',
                date   : targetMoment,
                oldDate: oldDate
              });
            }
            notifyEvent({
              type   : 'dp.error',
              date   : targetMoment,
              oldDate: oldDate
            });
          }
        },

        /**
         * Hides the widget. Possibly will emit dp.hide
         */
        hide                          = function() {
          var transitioning = false;
          if (!widget) {
            return picker;
          }
          // Ignore event if in the middle of a picker transition
          widget.find('.collapse').each(function() {
            var collapseData = $(this).data('collapse');
            if (collapseData && collapseData.transitioning) {
              transitioning = true;
              return false;
            }
            return true;
          });
          if (transitioning) {
            return picker;
          }
          if (component && component.hasClass('btn')) {
            component.toggleClass('active');
          }
          widget.hide();

          $(window).off('resize', place);
          widget.off('click', '[data-action]');
          widget.off('mousedown', false);

          widget.remove();
          widget = false;

          notifyEvent({
            type: 'dp.hide',
            date: date.clone()
          });

          input.blur();

          viewDate = date.clone();

          return picker;
        },

        clear                         = function() {
          setValue(null);
        },

        parseInputDate                = function(inputDate) {
          if (options.parseInputDate === undefined) {
            if (!moment.isMoment(inputDate) || inputDate instanceof Date) {
              inputDate = getMoment(inputDate);
            }
          }
          else {
            inputDate = options.parseInputDate(inputDate);
          }
          //inputDate.locale(options.locale);
          return inputDate;
        },

        /********************************************************************************
         *
         * Widget UI interaction functions
         *
         ********************************************************************************/
        actions                       = {
          next: function() {
            var navFnc = datePickerModes[currentViewMode].navFnc;
            viewDate.add(datePickerModes[currentViewMode].navStep, navFnc);
            fillDate();
            viewUpdate(navFnc);
          },

          previous: function() {
            var navFnc = datePickerModes[currentViewMode].navFnc;
            viewDate.subtract(datePickerModes[currentViewMode].navStep, navFnc);
            fillDate();
            viewUpdate(navFnc);
          },

          pickerSwitch: function() {
            showMode(1);
          },

          selectMonth: function(e) {
            var month = $(e.target).closest('tbody').find('span').index($(e.target));
            viewDate.month(month);
            if (currentViewMode === minViewModeNumber) {
              setValue(date.clone().year(viewDate.year()).month(viewDate.month()));
              if (!options.inline) {
                hide();
              }
            }
            else {
              showMode(-1);
              fillDate();
            }
            viewUpdate('M');
          },

          selectYear: function(e) {
            var year = parseInt($(e.target).text(), 10) || 0;
            viewDate.year(year);
            if (currentViewMode === minViewModeNumber) {
              setValue(date.clone().year(viewDate.year()));
              if (!options.inline) {
                hide();
              }
            }
            else {
              showMode(-1);
              fillDate();
            }
            viewUpdate('YYYY');
          },

          selectDecade: function(e) {
            var year = parseInt($(e.target).data('selection'), 10) || 0;
            viewDate.year(year);
            if (currentViewMode === minViewModeNumber) {
              setValue(date.clone().year(viewDate.year()));
              if (!options.inline) {
                hide();
              }
            }
            else {
              showMode(-1);
              fillDate();
            }
            viewUpdate('YYYY');
          },

          selectDay: function(e) {
            var day = viewDate.clone();
            if ($(e.target).is('.old')) {
              day.subtract(1, 'M');
            }
            if ($(e.target).is('.new')) {
              day.add(1, 'M');
            }
            setValue(day.date(parseInt($(e.target).text(), 10)));
            if (!hasTime() && !options.keepOpen && !options.inline) {
              hide();
            }
          },

          incrementHours: function() {
            var newDate = date.clone().add(1, 'h');
            if (isValid(newDate, 'h')) {
              setValue(newDate);
            }
          },

          incrementMinutes: function() {
            var newDate = date.clone().add(options.stepping, 'm');
            if (isValid(newDate, 'm')) {
              setValue(newDate);
            }
          },

          incrementSeconds: function() {
            var newDate = date.clone().add(1, 's');
            if (isValid(newDate, 's')) {
              setValue(newDate);
            }
          },

          decrementHours: function() {
            var newDate = date.clone().subtract(1, 'h');
            if (isValid(newDate, 'h')) {
              setValue(newDate);
            }
          },

          decrementMinutes: function() {
            var newDate = date.clone().subtract(options.stepping, 'm');
            if (isValid(newDate, 'm')) {
              setValue(newDate);
            }
          },

          decrementSeconds: function() {
            var newDate = date.clone().subtract(1, 's');
            if (isValid(newDate, 's')) {
              setValue(newDate);
            }
          },

          togglePeriod: function() {
            setValue(date.clone().add((date.hours() >= 12) ? -12 : 12, 'h'));
          },

          togglePicker: function(e) {
            var $this    = $(e.target),
                $parent  = $this.closest('ul'),
                expanded = $parent.find('.show'),
                closed   = $parent.find('.collapse:not(.show)'),
                collapseData;

            if (expanded && expanded.length) {
              collapseData = expanded.data('collapse');
              if (collapseData && collapseData.transitioning) {
                return;
              }
              if (expanded.collapse) { // if collapse plugin is available through bootstrap.js then use it
                expanded.collapse('hide');
                closed.collapse('show');
              }
              else { // otherwise just toggle in class on the two views
                expanded.removeClass('show');
                closed.addClass('show');
              }
              if ($this.is('i')) {
                $this.toggleClass(options.icons.time + ' ' + options.icons.date);
              }
              else {
                $this.find('i').toggleClass(options.icons.time + ' ' + options.icons.date);
              }

              // NOTE: uncomment if toggled state will be restored in show()
              //if (component) {
              //    component.find('span').toggleClass(options.icons.time + ' ' + options.icons.date);
              //}
            }
          },

          showPicker: function() {
            widget.find('.timepicker > div:not(.timepicker-picker)').hide();
            widget.find('.timepicker .timepicker-picker').show();
          },

          showHours: function() {
            widget.find('.timepicker .timepicker-picker').hide();
            widget.find('.timepicker .timepicker-hours').show();
          },

          showMinutes: function() {
            widget.find('.timepicker .timepicker-picker').hide();
            widget.find('.timepicker .timepicker-minutes').show();
          },

          showSeconds: function() {
            widget.find('.timepicker .timepicker-picker').hide();
            widget.find('.timepicker .timepicker-seconds').show();
          },

          selectHour: function(e) {
            var hour = parseInt($(e.target).text(), 10);

            if (!use24Hours) {
              if (date.hours() >= 12) {
                if (hour !== 12) {
                  hour += 12;
                }
              }
              else {
                if (hour === 12) {
                  hour = 0;
                }
              }
            }
            setValue(date.clone().hours(hour));
            actions.showPicker.call(picker);
          },

          selectMinute: function(e) {
            setValue(date.clone().minutes(parseInt($(e.target).text(), 10)));
            actions.showPicker.call(picker);
          },

          selectSecond: function(e) {
            setValue(date.clone().seconds(parseInt($(e.target).text(), 10)));
            actions.showPicker.call(picker);
          },

          clear: clear,

          today: function() {
            var todaysDate = getMoment();
            if (isValid(todaysDate, 'd')) {
              setValue(todaysDate);
            }
          },

          close: hide
        },

        doAction                      = function(e) {
          if ($(e.currentTarget).is('.disabled')) {
            return false;
          }
          actions[$(e.currentTarget).data('action')].apply(picker, arguments);
          return false;
        },

        /**
         * Shows the widget. Possibly will emit dp.show and dp.change
         */
        show                          = function() {
          var currentMoment,
              useCurrentGranularity = {
                'year'  : function(m) {
                  return m.month(0).date(1).hours(0).seconds(0).minutes(0);
                },
                'month' : function(m) {
                  return m.date(1).hours(0).seconds(0).minutes(0);
                },
                'day'   : function(m) {
                  return m.hours(0).seconds(0).minutes(0);
                },
                'hour'  : function(m) {
                  return m.seconds(0).minutes(0);
                },
                'minute': function(m) {
                  return m.seconds(0);
                }
              };

          if (input.prop('disabled') || (!options.ignoreReadonly && input.prop('readonly')) || widget) {
            return picker;
          }
          if (input.val() !== undefined && input.val().trim().length !== 0) {
            setValue(parseInputDate(input.val().trim()));
          }
          else if (unset &&
                   options.useCurrent &&
                   (options.inline || (input.is('input') && input.val().trim().length === 0))) {
            currentMoment = getMoment();
            if (typeof options.useCurrent === 'string') {
              currentMoment = useCurrentGranularity[options.useCurrent](currentMoment);
            }
            setValue(currentMoment);
          }
          widget = getTemplate();

          fillDow();
          fillMonths();

          widget.find('.timepicker-hours').hide();
          widget.find('.timepicker-minutes').hide();
          widget.find('.timepicker-seconds').hide();

          update();
          showMode();

          $(window).on('resize', place);
          widget.on('click', '[data-action]', doAction); // this handles clicks on the widget
          widget.on('mousedown', false);

          if (component && component.hasClass('btn')) {
            component.toggleClass('active');
          }
          place();
          widget.show();
          if (options.focusOnShow && !input.is(':focus')) {
            input.focus();
          }

          notifyEvent({
            type: 'dp.show'
          });
          return picker;
        },

        /**
         * Shows or hides the widget
         */
        toggle                        = function() {
          return (widget ? hide() : show());
        },

        keydown                       = function(e) {
          var handler          = null,
              index,
              index2,
              pressedKeys      = [],
              pressedModifiers = {},
              currentKey       = e.which,
              keyBindKeys,
              allModifiersPressed,
              pressed          = 'p';

          keyState[currentKey] = pressed;

          for (index in keyState) {
            if (keyState.hasOwnProperty(index) && keyState[index] === pressed) {
              pressedKeys.push(index);
              if (parseInt(index, 10) !== currentKey) {
                pressedModifiers[index] = true;
              }
            }
          }

          for (index in options.keyBinds) {
            if (options.keyBinds.hasOwnProperty(index) && typeof (options.keyBinds[index]) === 'function') {
              keyBindKeys = index.split(' ');
              if (keyBindKeys.length ===
                  pressedKeys.length &&
                  keyMap[currentKey] ===
                  keyBindKeys[keyBindKeys.length - 1]) {
                allModifiersPressed = true;
                for (index2 = keyBindKeys.length - 2; index2 >= 0; index2--) {
                  if (!(keyMap[keyBindKeys[index2]] in pressedModifiers)) {
                    allModifiersPressed = false;
                    break;
                  }
                }
                if (allModifiersPressed) {
                  handler = options.keyBinds[index];
                  break;
                }
              }
            }
          }

          if (handler) {
            handler.call(picker, widget);
            e.stopPropagation();
            e.preventDefault();
          }
        },

        keyup                         = function(e) {
          keyState[e.which] = 'r';
          e.stopPropagation();
          e.preventDefault();
        },

        change                        = function(e) {
          var val        = $(e.target).val().trim(),
              parsedDate = val ? parseInputDate(val) : null;
          setValue(parsedDate);
          e.stopImmediatePropagation();
          return false;
        },

        attachDatePickerElementEvents = function() {
          input.on({
            'change' : change,
            'blur'   : options.debug ? '' : hide,
            'keydown': keydown,
            'keyup'  : keyup,
            'focus'  : options.allowInputToggle ? show : ''
          });

          if (element.is('input')) {
            input.on({
              'focus': show
            });
          }
          else if (component) {
            component.on('click', toggle);
            component.on('mousedown', false);
          }
        },

        detachDatePickerElementEvents = function() {
          input.off({
            'change' : change,
            'blur'   : blur,
            'keydown': keydown,
            'keyup'  : keyup,
            'focus'  : options.allowInputToggle ? hide : ''
          });

          if (element.is('input')) {
            input.off({
              'focus': show
            });
          }
          else if (component) {
            component.off('click', toggle);
            component.off('mousedown', false);
          }
        },

        indexGivenDates               = function(givenDatesArray) {
          // Store given enabledDates and disabledDates as keys.
          // This way we can check their existence in O(1) time instead of looping through whole array.
          // (for example: options.enabledDates['2014-02-27'] === true)
          var givenDatesIndexed = {};
          $.each(givenDatesArray, function() {
            var dDate = parseInputDate(this);
            if (dDate.isValid()) {
              givenDatesIndexed[dDate.format('YYYY-MM-DD')] = true;
            }
          });
          return (Object.keys(givenDatesIndexed).length) ? givenDatesIndexed : false;
        },

        indexGivenHours               = function(givenHoursArray) {
          // Store given enabledHours and disabledHours as keys.
          // This way we can check their existence in O(1) time instead of looping through whole array.
          // (for example: options.enabledHours['2014-02-27'] === true)
          var givenHoursIndexed = {};
          $.each(givenHoursArray, function() {
            givenHoursIndexed[this] = true;
          });
          return (Object.keys(givenHoursIndexed).length) ? givenHoursIndexed : false;
        },

        initFormatting                = function() {
          var format = options.format || 'L LT';

          actualFormat = format.replace(/(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, function(formatInput) {
            var newinput = date.localeData().longDateFormat(formatInput) || formatInput;
            return newinput.replace(/(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, function(formatInput2) { //temp fix for #740
              return date.localeData().longDateFormat(formatInput2) || formatInput2;
            });
          });


          parseFormats = options.extraFormats ? options.extraFormats.slice() : [];
          if (parseFormats.indexOf(format) < 0 && parseFormats.indexOf(actualFormat) < 0) {
            parseFormats.push(actualFormat);
          }

          use24Hours =
            (actualFormat.toLowerCase().indexOf('a') < 1 && actualFormat.replace(/\[.*?\]/g, '').indexOf('h') < 1);

          if (isEnabled('y')) {
            minViewModeNumber = 2;
          }
          if (isEnabled('M')) {
            minViewModeNumber = 1;
          }
          if (isEnabled('d')) {
            minViewModeNumber = 0;
          }

          currentViewMode = Math.max(minViewModeNumber, currentViewMode);

          if (!unset) {
            setValue(date);
          }
        };

    /********************************************************************************
     *
     * Public API functions
     * =====================
     *
     * Important: Do not expose direct references to private objects or the options
     * object to the outer world. Always return a clone when returning values or make
     * a clone when setting a private variable.
     *
     ********************************************************************************/
    picker.destroy = function() {
      ///<summary>Destroys the widget and removes all attached event listeners</summary>
      hide();
      detachDatePickerElementEvents();
      element.removeData('DateTimePicker');
      element.removeData('date');
    };

    picker.toggle = toggle;

    picker.show = show;

    picker.hide = hide;

    picker.disable = function() {
      ///<summary>Disables the input element, the component is attached to, by adding a disabled="true" attribute to it.
      ///If the widget was visible before that call it is hidden. Possibly emits dp.hide</summary>
      hide();
      if (component && component.hasClass('btn')) {
        component.addClass('disabled');
      }
      input.prop('disabled', true);
      return picker;
    };

    picker.enable = function() {
      ///<summary>Enables the input element, the component is attached to, by removing disabled attribute from
      // it.</summary>
      if (component && component.hasClass('btn')) {
        component.removeClass('disabled');
      }
      input.prop('disabled', false);
      return picker;
    };

    picker.ignoreReadonly = function(ignoreReadonly) {
      if (arguments.length === 0) {
        return options.ignoreReadonly;
      }
      if (typeof ignoreReadonly !== 'boolean') {
        throw new TypeError('ignoreReadonly () expects a boolean parameter');
      }
      options.ignoreReadonly = ignoreReadonly;
      return picker;
    };

    picker.options = function(newOptions) {
      if (arguments.length === 0) {
        return $.extend(true, {}, options);
      }

      if (!(newOptions instanceof Object)) {
        throw new TypeError('options() options parameter should be an object');
      }
      $.extend(true, options, newOptions);
      $.each(options, function(key, value) {
        if (picker[key] !== undefined) {
          picker[key](value);
        }
        else {
          throw new TypeError('option ' + key + ' is not recognized!');
        }
      });
      return picker;
    };

    picker.date = function(newDate) {
      ///<signature helpKeyword="$.fn.datetimepicker.date">
      ///<summary>Returns the component's model current date, a moment object or null if not set.</summary>
      ///<returns type="Moment">date.clone()</returns>
      ///</signature>
      ///<signature>
      ///<summary>Sets the components model current moment to it. Passing a null value unsets the components model
      // current moment. Parsing of the newDate parameter is made using moment library with the options.format and
      // options.useStrict components configuration.</summary> /<param name="newDate"
      // locid="$.fn.datetimepicker.date_p:newDate">Takes string, Date, moment, null parameter.</param> /</signature>
      if (arguments.length === 0) {
        if (unset) {
          return null;
        }
        return date.clone();
      }

      if (newDate !== null && typeof newDate !== 'string' && !moment.isMoment(newDate) && !(newDate instanceof Date)) {
        throw new TypeError('date() parameter must be one of [null, string, moment or Date]');
      }

      setValue(newDate === null ? null : parseInputDate(newDate));
      return picker;
    };

    picker.format = function(newFormat) {
      ///<summary>test su</summary>
      ///<param name="newFormat">info about para</param>
      ///<returns type="string|boolean">returns foo</returns>
      if (arguments.length === 0) {
        return options.format;
      }

      if ((typeof newFormat !== 'string') && ((typeof newFormat !== 'boolean') || (newFormat !== false))) {
        throw new TypeError('format() expects a string or boolean:false parameter ' + newFormat);
      }

      options.format = newFormat;
      if (actualFormat) {
        initFormatting(); // reinit formatting
      }
      return picker;
    };

    picker.timeZone = function(newZone) {
      if (arguments.length === 0) {
        return options.timeZone;
      }

      if (typeof newZone !== 'string') {
        throw new TypeError('newZone() expects a string parameter');
      }

      options.timeZone = newZone;

      return picker;
    };

    picker.dayViewHeaderFormat = function(newFormat) {
      if (arguments.length === 0) {
        return options.dayViewHeaderFormat;
      }

      if (typeof newFormat !== 'string') {
        throw new TypeError('dayViewHeaderFormat() expects a string parameter');
      }

      options.dayViewHeaderFormat = newFormat;
      return picker;
    };

    picker.extraFormats = function(formats) {
      if (arguments.length === 0) {
        return options.extraFormats;
      }

      if (formats !== false && !(formats instanceof Array)) {
        throw new TypeError('extraFormats() expects an array or false parameter');
      }

      options.extraFormats = formats;
      if (parseFormats) {
        initFormatting(); // reinit formatting
      }
      return picker;
    };

    picker.disabledDates = function(dates) {
      ///<signature helpKeyword="$.fn.datetimepicker.disabledDates">
      ///<summary>Returns an array with the currently set disabled dates on the component.</summary>
      ///<returns type="array">options.disabledDates</returns>
      ///</signature>
      ///<signature>
      ///<summary>Setting this takes precedence over options.minDate, options.maxDate configuration. Also calling this
      // function removes the configuration of /options.enabledDates if such exist.</summary> /<param name="dates"
      // locid="$.fn.datetimepicker.disabledDates_p:dates">Takes an [ string or Date or moment ] of values and allows
      // the user to select only from those days.</param> /</signature>
      if (arguments.length === 0) {
        return (options.disabledDates ? $.extend({}, options.disabledDates) : options.disabledDates);
      }

      if (!dates) {
        options.disabledDates = false;
        update();
        return picker;
      }
      if (!(dates instanceof Array)) {
        throw new TypeError('disabledDates() expects an array parameter');
      }
      options.disabledDates = indexGivenDates(dates);
      options.enabledDates  = false;
      update();
      return picker;
    };

    picker.enabledDates = function(dates) {
      ///<signature helpKeyword="$.fn.datetimepicker.enabledDates">
      ///<summary>Returns an array with the currently set enabled dates on the component.</summary>
      ///<returns type="array">options.enabledDates</returns>
      ///</signature>
      ///<signature>
      ///<summary>Setting this takes precedence over options.minDate, options.maxDate configuration. Also calling this
      // function removes the configuration of options.disabledDates if such exist.</summary> /<param name="dates"
      // locid="$.fn.datetimepicker.enabledDates_p:dates">Takes an [ string or Date or moment ] of values and allows
      // the user to select only from those days.</param> /</signature>
      if (arguments.length === 0) {
        return (options.enabledDates ? $.extend({}, options.enabledDates) : options.enabledDates);
      }

      if (!dates) {
        options.enabledDates = false;
        update();
        return picker;
      }
      if (!(dates instanceof Array)) {
        throw new TypeError('enabledDates() expects an array parameter');
      }
      options.enabledDates  = indexGivenDates(dates);
      options.disabledDates = false;
      update();
      return picker;
    };

    picker.daysOfWeekDisabled = function(daysOfWeekDisabled) {
      if (arguments.length === 0) {
        return options.daysOfWeekDisabled.splice(0);
      }

      if ((typeof daysOfWeekDisabled === 'boolean') && !daysOfWeekDisabled) {
        options.daysOfWeekDisabled = false;
        update();
        return picker;
      }

      if (!(daysOfWeekDisabled instanceof Array)) {
        throw new TypeError('daysOfWeekDisabled() expects an array parameter');
      }
      options.daysOfWeekDisabled = daysOfWeekDisabled.reduce(function(previousValue, currentValue) {
        currentValue = parseInt(currentValue, 10);
        if (currentValue > 6 || currentValue < 0 || isNaN(currentValue)) {
          return previousValue;
        }
        if (previousValue.indexOf(currentValue) === -1) {
          previousValue.push(currentValue);
        }
        return previousValue;
      }, []).sort();
      if (options.useCurrent && !options.keepInvalid) {
        var tries = 0;
        while (!isValid(date, 'd')) {
          date.add(1, 'd');
          if (tries === 31) {
            throw 'Tried 31 times to find a valid date';
          }
          tries++;
        }
        setValue(date);
      }
      update();
      return picker;
    };

    picker.maxDate = function(maxDate) {
      if (arguments.length === 0) {
        return options.maxDate ? options.maxDate.clone() : options.maxDate;
      }

      if ((typeof maxDate === 'boolean') && maxDate === false) {
        options.maxDate = false;
        update();
        return picker;
      }

      if (typeof maxDate === 'string') {
        if (maxDate === 'now' || maxDate === 'moment') {
          maxDate = getMoment();
        }
      }

      var parsedDate = parseInputDate(maxDate);

      if (!parsedDate.isValid()) {
        throw new TypeError('maxDate() Could not parse date parameter: ' + maxDate);
      }
      if (options.minDate && parsedDate.isBefore(options.minDate)) {
        throw new TypeError('maxDate() date parameter is before options.minDate: ' + parsedDate.format(actualFormat));
      }
      options.maxDate = parsedDate;
      if (options.useCurrent && !options.keepInvalid && date.isAfter(maxDate)) {
        setValue(options.maxDate);
      }
      if (viewDate.isAfter(parsedDate)) {
        viewDate = parsedDate.clone().subtract(options.stepping, 'm');
      }
      update();
      return picker;
    };

    picker.minDate = function(minDate) {
      if (arguments.length === 0) {
        return options.minDate ? options.minDate.clone() : options.minDate;
      }

      if ((typeof minDate === 'boolean') && minDate === false) {
        options.minDate = false;
        update();
        return picker;
      }

      if (typeof minDate === 'string') {
        if (minDate === 'now' || minDate === 'moment') {
          minDate = getMoment();
        }
      }

      var parsedDate = parseInputDate(minDate);

      if (!parsedDate.isValid()) {
        throw new TypeError('minDate() Could not parse date parameter: ' + minDate);
      }
      if (options.maxDate && parsedDate.isAfter(options.maxDate)) {
        throw new TypeError('minDate() date parameter is after options.maxDate: ' + parsedDate.format(actualFormat));
      }
      options.minDate = parsedDate;
      if (options.useCurrent && !options.keepInvalid && date.isBefore(minDate)) {
        setValue(options.minDate);
      }
      if (viewDate.isBefore(parsedDate)) {
        viewDate = parsedDate.clone().add(options.stepping, 'm');
      }
      update();
      return picker;
    };

    picker.defaultDate = function(defaultDate) {
      ///<signature helpKeyword="$.fn.datetimepicker.defaultDate">
      ///<summary>Returns a moment with the options.defaultDate option configuration or false if not set</summary>
      ///<returns type="Moment">date.clone()</returns>
      ///</signature>
      ///<signature>
      ///<summary>Will set the picker's inital date. If a boolean:false value is passed the options.defaultDate
      // parameter is cleared.</summary> /<param name="defaultDate"
      // locid="$.fn.datetimepicker.defaultDate_p:defaultDate">Takes a string, Date, moment, boolean:false</param>
      // /</signature>
      if (arguments.length === 0) {
        return options.defaultDate ? options.defaultDate.clone() : options.defaultDate;
      }
      if (!defaultDate) {
        options.defaultDate = false;
        return picker;
      }

      if (typeof defaultDate === 'string') {
        if (defaultDate === 'now' || defaultDate === 'moment') {
          defaultDate = getMoment();
        }
        else {
          defaultDate = getMoment(defaultDate);
        }
      }

      var parsedDate = parseInputDate(defaultDate);
      if (!parsedDate.isValid()) {
        throw new TypeError('defaultDate() Could not parse date parameter: ' + defaultDate);
      }
      if (!isValid(parsedDate)) {
        throw new TypeError('defaultDate() date passed is invalid according to component setup validations');
      }

      options.defaultDate = parsedDate;

      if ((options.defaultDate && options.inline) || input.val().trim() === '') {
        setValue(options.defaultDate);
      }
      return picker;
    };

    picker.locale = function(locale) {
      if (arguments.length === 0) {
        return options.locale;
      }

      if (!moment.localeData(locale)) {
        throw new TypeError('locale() locale ' + locale + ' is not loaded from moment locales!');
      }

      options.locale = locale;
      date.locale(options.locale);
      viewDate.locale(options.locale);

      if (actualFormat) {
        initFormatting(); // reinit formatting
      }
      if (widget) {
        hide();
        show();
      }
      return picker;
    };

    picker.stepping = function(stepping) {
      if (arguments.length === 0) {
        return options.stepping;
      }

      stepping = parseInt(stepping, 10);
      if (isNaN(stepping) || stepping < 1) {
        stepping = 1;
      }
      options.stepping = stepping;
      return picker;
    };

    picker.useCurrent = function(useCurrent) {
      var useCurrentOptions = ['year', 'month', 'day', 'hour', 'minute'];
      if (arguments.length === 0) {
        return options.useCurrent;
      }

      if ((typeof useCurrent !== 'boolean') && (typeof useCurrent !== 'string')) {
        throw new TypeError('useCurrent() expects a boolean or string parameter');
      }
      if (typeof useCurrent === 'string' && useCurrentOptions.indexOf(useCurrent.toLowerCase()) === -1) {
        throw new TypeError('useCurrent() expects a string parameter of ' + useCurrentOptions.join(', '));
      }
      options.useCurrent = useCurrent;
      return picker;
    };

    picker.collapse = function(collapse) {
      if (arguments.length === 0) {
        return options.collapse;
      }

      if (typeof collapse !== 'boolean') {
        throw new TypeError('collapse() expects a boolean parameter');
      }
      if (options.collapse === collapse) {
        return picker;
      }
      options.collapse = collapse;
      if (widget) {
        hide();
        show();
      }
      return picker;
    };

    picker.icons = function(icons) {
      if (arguments.length === 0) {
        return $.extend({}, options.icons);
      }

      if (!(icons instanceof Object)) {
        throw new TypeError('icons() expects parameter to be an Object');
      }
      $.extend(options.icons, icons);
      if (widget) {
        hide();
        show();
      }
      return picker;
    };

    picker.tooltips = function(tooltips) {
      if (arguments.length === 0) {
        return $.extend({}, options.tooltips);
      }

      if (!(tooltips instanceof Object)) {
        throw new TypeError('tooltips() expects parameter to be an Object');
      }
      $.extend(options.tooltips, tooltips);
      if (widget) {
        hide();
        show();
      }
      return picker;
    };

    picker.useStrict = function(useStrict) {
      if (arguments.length === 0) {
        return options.useStrict;
      }

      if (typeof useStrict !== 'boolean') {
        throw new TypeError('useStrict() expects a boolean parameter');
      }
      options.useStrict = useStrict;
      return picker;
    };

    picker.sideBySide = function(sideBySide) {
      if (arguments.length === 0) {
        return options.sideBySide;
      }

      if (typeof sideBySide !== 'boolean') {
        throw new TypeError('sideBySide() expects a boolean parameter');
      }
      options.sideBySide = sideBySide;
      if (widget) {
        hide();
        show();
      }
      return picker;
    };

    picker.viewMode = function(viewMode) {
      if (arguments.length === 0) {
        return options.viewMode;
      }

      if (typeof viewMode !== 'string') {
        throw new TypeError('viewMode() expects a string parameter');
      }

      if (viewModes.indexOf(viewMode) === -1) {
        throw new TypeError('viewMode() parameter must be one of (' + viewModes.join(', ') + ') value');
      }

      options.viewMode = viewMode;
      currentViewMode  = Math.max(viewModes.indexOf(viewMode), minViewModeNumber);

      showMode();
      return picker;
    };

    picker.toolbarPlacement = function(toolbarPlacement) {
      if (arguments.length === 0) {
        return options.toolbarPlacement;
      }

      if (typeof toolbarPlacement !== 'string') {
        throw new TypeError('toolbarPlacement() expects a string parameter');
      }
      if (toolbarPlacements.indexOf(toolbarPlacement) === -1) {
        throw new TypeError('toolbarPlacement() parameter must be one of (' + toolbarPlacements.join(', ') + ') value');
      }
      options.toolbarPlacement = toolbarPlacement;

      if (widget) {
        hide();
        show();
      }
      return picker;
    };

    picker.widgetPositioning = function(widgetPositioning) {
      if (arguments.length === 0) {
        return $.extend({}, options.widgetPositioning);
      }

      if (({}).toString.call(widgetPositioning) !== '[object Object]') {
        throw new TypeError('widgetPositioning() expects an object variable');
      }
      if (widgetPositioning.horizontal) {
        if (typeof widgetPositioning.horizontal !== 'string') {
          throw new TypeError('widgetPositioning() horizontal variable must be a string');
        }
        widgetPositioning.horizontal = widgetPositioning.horizontal.toLowerCase();
        if (horizontalModes.indexOf(widgetPositioning.horizontal) === -1) {
          throw new TypeError('widgetPositioning() expects horizontal parameter to be one of (' +
                              horizontalModes.join(', ') +
                              ')');
        }
        options.widgetPositioning.horizontal = widgetPositioning.horizontal;
      }
      if (widgetPositioning.vertical) {
        if (typeof widgetPositioning.vertical !== 'string') {
          throw new TypeError('widgetPositioning() vertical variable must be a string');
        }
        widgetPositioning.vertical = widgetPositioning.vertical.toLowerCase();
        if (verticalModes.indexOf(widgetPositioning.vertical) === -1) {
          throw new TypeError('widgetPositioning() expects vertical parameter to be one of (' +
                              verticalModes.join(', ') +
                              ')');
        }
        options.widgetPositioning.vertical = widgetPositioning.vertical;
      }
      update();
      return picker;
    };

    picker.calendarWeeks = function(calendarWeeks) {
      if (arguments.length === 0) {
        return options.calendarWeeks;
      }

      if (typeof calendarWeeks !== 'boolean') {
        throw new TypeError('calendarWeeks() expects parameter to be a boolean value');
      }

      options.calendarWeeks = calendarWeeks;
      update();
      return picker;
    };

    picker.showTodayButton = function(showTodayButton) {
      if (arguments.length === 0) {
        return options.showTodayButton;
      }

      if (typeof showTodayButton !== 'boolean') {
        throw new TypeError('showTodayButton() expects a boolean parameter');
      }

      options.showTodayButton = showTodayButton;
      if (widget) {
        hide();
        show();
      }
      return picker;
    };

    picker.showClear = function(showClear) {
      if (arguments.length === 0) {
        return options.showClear;
      }

      if (typeof showClear !== 'boolean') {
        throw new TypeError('showClear() expects a boolean parameter');
      }

      options.showClear = showClear;
      if (widget) {
        hide();
        show();
      }
      return picker;
    };

    picker.widgetParent = function(widgetParent) {
      if (arguments.length === 0) {
        return options.widgetParent;
      }

      if (typeof widgetParent === 'string') {
        widgetParent = $(widgetParent);
      }

      if (widgetParent !== null && (typeof widgetParent !== 'string' && !(widgetParent instanceof $))) {
        throw new TypeError('widgetParent() expects a string or a jQuery object parameter');
      }

      options.widgetParent = widgetParent;
      if (widget) {
        hide();
        show();
      }
      return picker;
    };

    picker.keepOpen = function(keepOpen) {
      if (arguments.length === 0) {
        return options.keepOpen;
      }

      if (typeof keepOpen !== 'boolean') {
        throw new TypeError('keepOpen() expects a boolean parameter');
      }

      options.keepOpen = keepOpen;
      return picker;
    };

    picker.focusOnShow = function(focusOnShow) {
      if (arguments.length === 0) {
        return options.focusOnShow;
      }

      if (typeof focusOnShow !== 'boolean') {
        throw new TypeError('focusOnShow() expects a boolean parameter');
      }

      options.focusOnShow = focusOnShow;
      return picker;
    };

    picker.inline = function(inline) {
      if (arguments.length === 0) {
        return options.inline;
      }

      if (typeof inline !== 'boolean') {
        throw new TypeError('inline() expects a boolean parameter');
      }

      options.inline = inline;
      return picker;
    };

    picker.clear = function() {
      clear();
      return picker;
    };

    picker.keyBinds = function(keyBinds) {
      if (arguments.length === 0) {
        return options.keyBinds;
      }

      options.keyBinds = keyBinds;
      return picker;
    };

    picker.getMoment = function(d) {
      return getMoment(d);
    };

    picker.debug = function(debug) {
      if (typeof debug !== 'boolean') {
        throw new TypeError('debug() expects a boolean parameter');
      }

      options.debug = debug;
      return picker;
    };

    picker.allowInputToggle = function(allowInputToggle) {
      if (arguments.length === 0) {
        return options.allowInputToggle;
      }

      if (typeof allowInputToggle !== 'boolean') {
        throw new TypeError('allowInputToggle() expects a boolean parameter');
      }

      options.allowInputToggle = allowInputToggle;
      return picker;
    };

    picker.showClose = function(showClose) {
      if (arguments.length === 0) {
        return options.showClose;
      }

      if (typeof showClose !== 'boolean') {
        throw new TypeError('showClose() expects a boolean parameter');
      }

      options.showClose = showClose;
      return picker;
    };

    picker.keepInvalid = function(keepInvalid) {
      if (arguments.length === 0) {
        return options.keepInvalid;
      }

      if (typeof keepInvalid !== 'boolean') {
        throw new TypeError('keepInvalid() expects a boolean parameter');
      }
      options.keepInvalid = keepInvalid;
      return picker;
    };

    picker.datepickerInput = function(datepickerInput) {
      if (arguments.length === 0) {
        return options.datepickerInput;
      }

      if (typeof datepickerInput !== 'string') {
        throw new TypeError('datepickerInput() expects a string parameter');
      }

      options.datepickerInput = datepickerInput;
      return picker;
    };

    picker.parseInputDate = function(parseInputDate) {
      if (arguments.length === 0) {
        return options.parseInputDate;
      }

      if (typeof parseInputDate !== 'function') {
        throw new TypeError('parseInputDate() sholud be as function');
      }

      options.parseInputDate = parseInputDate;

      return picker;
    };

    picker.disabledTimeIntervals = function(disabledTimeIntervals) {
      ///<signature helpKeyword="$.fn.datetimepicker.disabledTimeIntervals">
      ///<summary>Returns an array with the currently set disabled dates on the component.</summary>
      ///<returns type="array">options.disabledTimeIntervals</returns>
      ///</signature>
      ///<signature>
      ///<summary>Setting this takes precedence over options.minDate, options.maxDate configuration. Also calling this
      // function removes the configuration of /options.enabledDates if such exist.</summary> /<param name="dates"
      // locid="$.fn.datetimepicker.disabledTimeIntervals_p:dates">Takes an [ string or Date or moment ] of values and
      // allows the user to select only from those days.</param> /</signature>
      if (arguments.length === 0) {
        return (options.disabledTimeIntervals ? $.extend({}, options.disabledTimeIntervals) : options.disabledTimeIntervals);
      }

      if (!disabledTimeIntervals) {
        options.disabledTimeIntervals = false;
        update();
        return picker;
      }
      if (!(disabledTimeIntervals instanceof Array)) {
        throw new TypeError('disabledTimeIntervals() expects an array parameter');
      }
      options.disabledTimeIntervals = disabledTimeIntervals;
      update();
      return picker;
    };

    picker.disabledHours = function(hours) {
      ///<signature helpKeyword="$.fn.datetimepicker.disabledHours">
      ///<summary>Returns an array with the currently set disabled hours on the component.</summary>
      ///<returns type="array">options.disabledHours</returns>
      ///</signature>
      ///<signature>
      ///<summary>Setting this takes precedence over options.minDate, options.maxDate configuration. Also calling this
      // function removes the configuration of /options.enabledHours if such exist.</summary> /<param name="hours"
      // locid="$.fn.datetimepicker.disabledHours_p:hours">Takes an [ int ] of values and disallows the user to select
      // only from those hours.</param> /</signature>
      if (arguments.length === 0) {
        return (options.disabledHours ? $.extend({}, options.disabledHours) : options.disabledHours);
      }

      if (!hours) {
        options.disabledHours = false;
        update();
        return picker;
      }
      if (!(hours instanceof Array)) {
        throw new TypeError('disabledHours() expects an array parameter');
      }
      options.disabledHours = indexGivenHours(hours);
      options.enabledHours  = false;
      if (options.useCurrent && !options.keepInvalid) {
        var tries = 0;
        while (!isValid(date, 'h')) {
          date.add(1, 'h');
          if (tries === 24) {
            throw 'Tried 24 times to find a valid date';
          }
          tries++;
        }
        setValue(date);
      }
      update();
      return picker;
    };

    picker.enabledHours = function(hours) {
      ///<signature helpKeyword="$.fn.datetimepicker.enabledHours">
      ///<summary>Returns an array with the currently set enabled hours on the component.</summary>
      ///<returns type="array">options.enabledHours</returns>
      ///</signature>
      ///<signature>
      ///<summary>Setting this takes precedence over options.minDate, options.maxDate configuration. Also calling this
      // function removes the configuration of options.disabledHours if such exist.</summary> /<param name="hours"
      // locid="$.fn.datetimepicker.enabledHours_p:hours">Takes an [ int ] of values and allows the user to select only
      // from those hours.</param> /</signature>
      if (arguments.length === 0) {
        return (options.enabledHours ? $.extend({}, options.enabledHours) : options.enabledHours);
      }

      if (!hours) {
        options.enabledHours = false;
        update();
        return picker;
      }
      if (!(hours instanceof Array)) {
        throw new TypeError('enabledHours() expects an array parameter');
      }
      options.enabledHours  = indexGivenHours(hours);
      options.disabledHours = false;
      if (options.useCurrent && !options.keepInvalid) {
        var tries = 0;
        while (!isValid(date, 'h')) {
          date.add(1, 'h');
          if (tries === 24) {
            throw 'Tried 24 times to find a valid date';
          }
          tries++;
        }
        setValue(date);
      }
      update();
      return picker;
    };
    /**
     * Returns the component's model current viewDate, a moment object or null if not set. Passing a null value unsets
     * the components model current moment. Parsing of the newDate parameter is made using moment library with the
     * options.format and options.useStrict components configuration.
     * @param {Takes string, viewDate, moment, null parameter.} newDate
     * @returns {viewDate.clone()}
     */
    picker.viewDate = function(newDate) {
      if (arguments.length === 0) {
        return viewDate.clone();
      }

      if (!newDate) {
        viewDate = date.clone();
        return picker;
      }

      if (typeof newDate !== 'string' && !moment.isMoment(newDate) && !(newDate instanceof Date)) {
        throw new TypeError('viewDate() parameter must be one of [string, moment or Date]');
      }

      viewDate = parseInputDate(newDate);
      viewUpdate();
      return picker;
    };

    // initializing element and component attributes
    if (element.is('input')) {
      input = element;
    }
    else {
      input = element.find(options.datepickerInput);
      if (input.length === 0) {
        input = element.find('input');
      }
      else if (!input.is('input')) {
        throw new Error('CSS class "' + options.datepickerInput + '" cannot be applied to non input element');
      }
    }

    if (element.hasClass('input-group')) {
      // in case there is more then one 'input-group-addon' Issue #48
      if (element.find('.datepickerbutton').length === 0) {
        component = element.find('.input-group-append');
      }
      else {
        component = element.find('.datepickerbutton');
      }
    }

    if (!options.inline && !input.is('input')) {
      throw new Error('Could not initialize DateTimePicker without an input element');
    }

    // Set defaults for date here now instead of in var declaration
    date     = getMoment();
    viewDate = date.clone();

    $.extend(true, options, dataToOptions());

    picker.options(options);

    initFormatting();

    attachDatePickerElementEvents();

    if (input.prop('disabled')) {
      picker.disable();
    }
    if (input.is('input') && input.val().trim().length !== 0) {
      setValue(parseInputDate(input.val().trim()));
    }
    else if (options.defaultDate && input.attr('placeholder') === undefined) {
      setValue(options.defaultDate);
    }
    if (options.inline) {
      show();
    }
    return picker;
  };

  /********************************************************************************
   *
   * jQuery plugin constructor and defaults object
   *
   ********************************************************************************/

  /**
   * See (http://jquery.com/).
   * @name jQuery
   * @class
   * See the jQuery Library  (http://jquery.com/) for full details.  This just
   * documents the function and classes that are added to jQuery by this plug-in.
   */
  /**
   * See (http://jquery.com/)
   * @name fn
   * @class
   * See the jQuery Library  (http://jquery.com/) for full details.  This just
   * documents the function and classes that are added to jQuery by this plug-in.
   * @memberOf jQuery
   */
  /**
   * Show comments
   * @class datetimepicker
   * @memberOf jQuery.fn
   */
  $.fn.datetimepicker = function(options) {
    options = options || {};

    var args        = Array.prototype.slice.call(arguments, 1),
        isInstance  = true,
        thisMethods = ['destroy', 'hide', 'show', 'toggle'],
        returnValue;

    if (typeof options === 'object') {
      return this.each(function() {
        var $this = $(this),
            _options;
        if (!$this.data('DateTimePicker')) {
          // create a private copy of the defaults object
          _options = $.extend(true, {}, $.fn.datetimepicker.defaults, options);
          $this.data('DateTimePicker', dateTimePicker($this, _options));
        }
      });
    }
    else if (typeof options === 'string') {
      this.each(function() {
        var $this    = $(this),
            instance = $this.data('DateTimePicker');
        if (!instance) {
          throw new Error('bootstrap-datetimepicker("' +
                          options +
                          '") method was called on an element that is not using DateTimePicker');
        }

        returnValue = instance[options].apply(instance, args);
        isInstance  = returnValue === instance;
      });

      if (isInstance || $.inArray(options, thisMethods) > -1) {
        return this;
      }

      return returnValue;
    }

    throw new TypeError('Invalid arguments for DateTimePicker: ' + options);
  };

  $.fn.datetimepicker.defaults = {
    timeZone             : '',
    format               : false,
    dayViewHeaderFormat  : 'MMMM YYYY',
    extraFormats         : false,
    stepping             : 1,
    minDate              : false,
    maxDate              : false,
    useCurrent           : true,
    collapse             : true,
    locale               : moment.locale(),
    defaultDate          : false,
    disabledDates        : false,
    enabledDates         : false,
    icons                : {
      time    : 'fa fa-clock-o',
      date    : 'fa fa-calendar',
      up      : 'fa fa-chevron-up',
      down    : 'fa fa-chevron-down',
      previous: 'fa fa-chevron-left',
      next    : 'fa fa-chevron-right',
      today   : 'fa fa-crosshairs',
      clear   : 'fa fa-trash-o',
      close   : 'fa fa-times'
    },
    tooltips             : {
      today          : 'Go to today',
      clear          : 'Clear selection',
      close          : 'Close the picker',
      selectMonth    : 'Select Month',
      prevMonth      : 'Previous Month',
      nextMonth      : 'Next Month',
      selectYear     : 'Select Year',
      prevYear       : 'Previous Year',
      nextYear       : 'Next Year',
      selectDecade   : 'Select Decade',
      prevDecade     : 'Previous Decade',
      nextDecade     : 'Next Decade',
      prevCentury    : 'Previous Century',
      nextCentury    : 'Next Century',
      pickHour       : 'Pick Hour',
      incrementHour  : 'Increment Hour',
      decrementHour  : 'Decrement Hour',
      pickMinute     : 'Pick Minute',
      incrementMinute: 'Increment Minute',
      decrementMinute: 'Decrement Minute',
      pickSecond     : 'Pick Second',
      incrementSecond: 'Increment Second',
      decrementSecond: 'Decrement Second',
      togglePeriod   : 'Toggle Period',
      selectTime     : 'Select Time'
    },
    useStrict            : false,
    sideBySide           : false,
    daysOfWeekDisabled   : false,
    calendarWeeks        : false,
    viewMode             : 'days',
    toolbarPlacement     : 'default',
    showTodayButton      : false,
    showClear            : false,
    showClose            : false,
    widgetPositioning    : {
      horizontal: 'auto',
      vertical  : 'auto'
    },
    widgetParent         : null,
    ignoreReadonly       : false,
    keepOpen             : false,
    focusOnShow          : true,
    inline               : false,
    keepInvalid          : false,
    datepickerInput      : '.datepickerinput',
    keyBinds             : {
      up             : function(widget) {
        if (!widget) {
          return;
        }
        var d = this.date() || this.getMoment();
        if (widget.find('.datepicker').is(':visible')) {
          this.date(d.clone().subtract(7, 'd'));
        }
        else {
          this.date(d.clone().add(this.stepping(), 'm'));
        }
      },
      down           : function(widget) {
        if (!widget) {
          this.show();
          return;
        }
        var d = this.date() || this.getMoment();
        if (widget.find('.datepicker').is(':visible')) {
          this.date(d.clone().add(7, 'd'));
        }
        else {
          this.date(d.clone().subtract(this.stepping(), 'm'));
        }
      },
      'control up'   : function(widget) {
        if (!widget) {
          return;
        }
        var d = this.date() || this.getMoment();
        if (widget.find('.datepicker').is(':visible')) {
          this.date(d.clone().subtract(1, 'y'));
        }
        else {
          this.date(d.clone().add(1, 'h'));
        }
      },
      'control down' : function(widget) {
        if (!widget) {
          return;
        }
        var d = this.date() || this.getMoment();
        if (widget.find('.datepicker').is(':visible')) {
          this.date(d.clone().add(1, 'y'));
        }
        else {
          this.date(d.clone().subtract(1, 'h'));
        }
      },
      left           : function(widget) {
        if (!widget) {
          return;
        }
        var d = this.date() || this.getMoment();
        if (widget.find('.datepicker').is(':visible')) {
          this.date(d.clone().subtract(1, 'd'));
        }
      },
      right          : function(widget) {
        if (!widget) {
          return;
        }
        var d = this.date() || this.getMoment();
        if (widget.find('.datepicker').is(':visible')) {
          this.date(d.clone().add(1, 'd'));
        }
      },
      pageUp         : function(widget) {
        if (!widget) {
          return;
        }
        var d = this.date() || this.getMoment();
        if (widget.find('.datepicker').is(':visible')) {
          this.date(d.clone().subtract(1, 'M'));
        }
      },
      pageDown       : function(widget) {
        if (!widget) {
          return;
        }
        var d = this.date() || this.getMoment();
        if (widget.find('.datepicker').is(':visible')) {
          this.date(d.clone().add(1, 'M'));
        }
      },
      enter          : function() {
        this.hide();
      },
      escape         : function() {
        this.hide();
      },
      //tab: function (widget) { //this break the flow of the form. disabling for now
      //    var toggle = widget.find('.picker-switch a[data-action="togglePicker"]');
      //    if(toggle.length > 0) toggle.click();
      //},
      'control space': function(widget) {
        if (!widget) {
          return;
        }
        if (widget.find('.timepicker').is(':visible')) {
          widget.find('.btn[data-action="togglePeriod"]').click();
        }
      },
      t              : function() {
        this.date(this.getMoment());
      },
      'delete'       : function() {
        this.clear();
      }
    },
    debug                : false,
    allowInputToggle     : false,
    disabledTimeIntervals: false,
    disabledHours        : false,
    enabledHours         : false,
    viewDate             : false
  };

  return $.fn.datetimepicker;
}));

/* resources/assets/js/libraries/jquery_customizations.js */
$.fn.hasClassStartingWith = function(needle) {
  var found_match = false;
  $(this).each(
    function() {
      var class_list = this.className.split(/\s+/);
      $.each(class_list, function() {
        if (this.indexOf(needle) == 0) {
          found_match = true;
        }
      });
    }
  );
  return found_match;
};

/* resources/assets/js/libraries/clipboard.min.js */
!function(a){if("object"==typeof exports&&"undefined"!=typeof module)module.exports=a();else if("function"==typeof define&&define.amd)define([],a);else{var b;b="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:this,b.Clipboard=a()}}(function(){var a;return function a(b,c,d){function e(g,h){if(!c[g]){if(!b[g]){var i="function"==typeof require&&require;if(!h&&i)return i(g,!0);if(f)return f(g,!0);var j=new Error("Cannot find module '"+g+"'");throw j.code="MODULE_NOT_FOUND",j}var k=c[g]={exports:{}};b[g][0].call(k.exports,function(a){var c=b[g][1][a];return e(c?c:a)},k,k.exports,a,b,c,d)}return c[g].exports}for(var f="function"==typeof require&&require,g=0;g<d.length;g++)e(d[g]);return e}({1:[function(a,b,c){function d(a,b){for(;a&&a.nodeType!==e;){if(a.matches(b))return a;a=a.parentNode}}var e=9;if("undefined"!=typeof Element&&!Element.prototype.matches){var f=Element.prototype;f.matches=f.matchesSelector||f.mozMatchesSelector||f.msMatchesSelector||f.oMatchesSelector||f.webkitMatchesSelector}b.exports=d},{}],2:[function(a,b,c){function d(a,b,c,d,f){var g=e.apply(this,arguments);return a.addEventListener(c,g,f),{destroy:function(){a.removeEventListener(c,g,f)}}}function e(a,b,c,d){return function(c){c.delegateTarget=f(c.target,b),c.delegateTarget&&d.call(a,c)}}var f=a("./closest");b.exports=d},{"./closest":1}],3:[function(a,b,c){c.node=function(a){return void 0!==a&&a instanceof HTMLElement&&1===a.nodeType},c.nodeList=function(a){var b=Object.prototype.toString.call(a);return void 0!==a&&("[object NodeList]"===b||"[object HTMLCollection]"===b)&&"length"in a&&(0===a.length||c.node(a[0]))},c.string=function(a){return"string"==typeof a||a instanceof String},c.fn=function(a){var b=Object.prototype.toString.call(a);return"[object Function]"===b}},{}],4:[function(a,b,c){function d(a,b,c){if(!a&&!b&&!c)throw new Error("Missing required arguments");if(!h.string(b))throw new TypeError("Second argument must be a String");if(!h.fn(c))throw new TypeError("Third argument must be a Function");if(h.node(a))return e(a,b,c);if(h.nodeList(a))return f(a,b,c);if(h.string(a))return g(a,b,c);throw new TypeError("First argument must be a String, HTMLElement, HTMLCollection, or NodeList")}function e(a,b,c){return a.addEventListener(b,c),{destroy:function(){a.removeEventListener(b,c)}}}function f(a,b,c){return Array.prototype.forEach.call(a,function(a){a.addEventListener(b,c)}),{destroy:function(){Array.prototype.forEach.call(a,function(a){a.removeEventListener(b,c)})}}}function g(a,b,c){return i(document.body,a,b,c)}var h=a("./is"),i=a("delegate");b.exports=d},{"./is":3,delegate:2}],5:[function(a,b,c){function d(a){var b;if("SELECT"===a.nodeName)a.focus(),b=a.value;else if("INPUT"===a.nodeName||"TEXTAREA"===a.nodeName){var c=a.hasAttribute("readonly");c||a.setAttribute("readonly",""),a.select(),a.setSelectionRange(0,a.value.length),c||a.removeAttribute("readonly"),b=a.value}else{a.hasAttribute("contenteditable")&&a.focus();var d=window.getSelection(),e=document.createRange();e.selectNodeContents(a),d.removeAllRanges(),d.addRange(e),b=d.toString()}return b}b.exports=d},{}],6:[function(a,b,c){function d(){}d.prototype={on:function(a,b,c){var d=this.e||(this.e={});return(d[a]||(d[a]=[])).push({fn:b,ctx:c}),this},once:function(a,b,c){function d(){e.off(a,d),b.apply(c,arguments)}var e=this;return d._=b,this.on(a,d,c)},emit:function(a){var b=[].slice.call(arguments,1),c=((this.e||(this.e={}))[a]||[]).slice(),d=0,e=c.length;for(d;d<e;d++)c[d].fn.apply(c[d].ctx,b);return this},off:function(a,b){var c=this.e||(this.e={}),d=c[a],e=[];if(d&&b)for(var f=0,g=d.length;f<g;f++)d[f].fn!==b&&d[f].fn._!==b&&e.push(d[f]);return e.length?c[a]=e:delete c[a],this}},b.exports=d},{}],7:[function(b,c,d){!function(e,f){if("function"==typeof a&&a.amd)a(["module","select"],f);else if("undefined"!=typeof d)f(c,b("select"));else{var g={exports:{}};f(g,e.select),e.clipboardAction=g.exports}}(this,function(a,b){"use strict";function c(a){return a&&a.__esModule?a:{default:a}}function d(a,b){if(!(a instanceof b))throw new TypeError("Cannot call a class as a function")}var e=c(b),f="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(a){return typeof a}:function(a){return a&&"function"==typeof Symbol&&a.constructor===Symbol&&a!==Symbol.prototype?"symbol":typeof a},g=function(){function a(a,b){for(var c=0;c<b.length;c++){var d=b[c];d.enumerable=d.enumerable||!1,d.configurable=!0,"value"in d&&(d.writable=!0),Object.defineProperty(a,d.key,d)}}return function(b,c,d){return c&&a(b.prototype,c),d&&a(b,d),b}}(),h=function(){function a(b){d(this,a),this.resolveOptions(b),this.initSelection()}return g(a,[{key:"resolveOptions",value:function(){var b=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};this.action=b.action,this.emitter=b.emitter,this.target=b.target,this.text=b.text,this.trigger=b.trigger,this.selectedText=""}},{key:"initSelection",value:function(){this.text?this.selectFake():this.target&&this.selectTarget()}},{key:"selectFake",value:function(){var b=this,c="rtl"==document.documentElement.getAttribute("dir");this.removeFake(),this.fakeHandlerCallback=function(){return b.removeFake()},this.fakeHandler=document.body.addEventListener("click",this.fakeHandlerCallback)||!0,this.fakeElem=document.createElement("textarea"),this.fakeElem.style.fontSize="12pt",this.fakeElem.style.border="0",this.fakeElem.style.padding="0",this.fakeElem.style.margin="0",this.fakeElem.style.position="absolute",this.fakeElem.style[c?"right":"left"]="-9999px";var d=window.pageYOffset||document.documentElement.scrollTop;this.fakeElem.style.top=d+"px",this.fakeElem.setAttribute("readonly",""),this.fakeElem.value=this.text,document.body.appendChild(this.fakeElem),this.selectedText=(0,e.default)(this.fakeElem),this.copyText()}},{key:"removeFake",value:function(){this.fakeHandler&&(document.body.removeEventListener("click",this.fakeHandlerCallback),this.fakeHandler=null,this.fakeHandlerCallback=null),this.fakeElem&&(document.body.removeChild(this.fakeElem),this.fakeElem=null)}},{key:"selectTarget",value:function(){this.selectedText=(0,e.default)(this.target),this.copyText()}},{key:"copyText",value:function(){var b=void 0;try{b=document.execCommand(this.action)}catch(a){b=!1}this.handleResult(b)}},{key:"handleResult",value:function(b){this.emitter.emit(b?"success":"error",{action:this.action,text:this.selectedText,trigger:this.trigger,clearSelection:this.clearSelection.bind(this)})}},{key:"clearSelection",value:function(){this.target&&this.target.blur(),window.getSelection().removeAllRanges()}},{key:"destroy",value:function(){this.removeFake()}},{key:"action",set:function(){var b=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"copy";if(this._action=b,"copy"!==this._action&&"cut"!==this._action)throw new Error('Invalid "action" value, use either "copy" or "cut"')},get:function(){return this._action}},{key:"target",set:function(b){if(void 0!==b){if(!b||"object"!==("undefined"==typeof b?"undefined":f(b))||1!==b.nodeType)throw new Error('Invalid "target" value, use a valid Element');if("copy"===this.action&&b.hasAttribute("disabled"))throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');if("cut"===this.action&&(b.hasAttribute("readonly")||b.hasAttribute("disabled")))throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');this._target=b}},get:function(){return this._target}}]),a}();a.exports=h})},{select:5}],8:[function(b,c,d){!function(e,f){if("function"==typeof a&&a.amd)a(["module","./clipboard-action","tiny-emitter","good-listener"],f);else if("undefined"!=typeof d)f(c,b("./clipboard-action"),b("tiny-emitter"),b("good-listener"));else{var g={exports:{}};f(g,e.clipboardAction,e.tinyEmitter,e.goodListener),e.clipboard=g.exports}}(this,function(a,b,c,d){"use strict";function e(a){return a&&a.__esModule?a:{default:a}}function f(a,b){if(!(a instanceof b))throw new TypeError("Cannot call a class as a function")}function g(a,b){if(!a)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!b||"object"!=typeof b&&"function"!=typeof b?a:b}function h(a,b){if("function"!=typeof b&&null!==b)throw new TypeError("Super expression must either be null or a function, not "+typeof b);a.prototype=Object.create(b&&b.prototype,{constructor:{value:a,enumerable:!1,writable:!0,configurable:!0}}),b&&(Object.setPrototypeOf?Object.setPrototypeOf(a,b):a.__proto__=b)}function i(a,b){var c="data-clipboard-"+a;if(b.hasAttribute(c))return b.getAttribute(c)}var j=e(b),k=e(c),l=e(d),m=function(){function a(a,b){for(var c=0;c<b.length;c++){var d=b[c];d.enumerable=d.enumerable||!1,d.configurable=!0,"value"in d&&(d.writable=!0),Object.defineProperty(a,d.key,d)}}return function(b,c,d){return c&&a(b.prototype,c),d&&a(b,d),b}}(),n=function(a){function b(a,c){f(this,b);var d=g(this,(b.__proto__||Object.getPrototypeOf(b)).call(this));return d.resolveOptions(c),d.listenClick(a),d}return h(b,a),m(b,[{key:"resolveOptions",value:function(){var b=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};this.action="function"==typeof b.action?b.action:this.defaultAction,this.target="function"==typeof b.target?b.target:this.defaultTarget,this.text="function"==typeof b.text?b.text:this.defaultText}},{key:"listenClick",value:function(b){var c=this;this.listener=(0,l.default)(b,"click",function(a){return c.onClick(a)})}},{key:"onClick",value:function(b){var c=b.delegateTarget||b.currentTarget;this.clipboardAction&&(this.clipboardAction=null),this.clipboardAction=new j.default({action:this.action(c),target:this.target(c),text:this.text(c),trigger:c,emitter:this})}},{key:"defaultAction",value:function(b){return i("action",b)}},{key:"defaultTarget",value:function(b){var c=i("target",b);if(c)return document.querySelector(c)}},{key:"defaultText",value:function(b){return i("text",b)}},{key:"destroy",value:function(){this.listener.destroy(),this.clipboardAction&&(this.clipboardAction.destroy(),this.clipboardAction=null)}}],[{key:"isSupported",value:function(){var b=arguments.length>0&&void 0!==arguments[0]?arguments[0]:["copy","cut"],c="string"==typeof b?[b]:b,d=!!document.queryCommandSupported;return c.forEach(function(a){d=d&&!!document.queryCommandSupported(a)}),d}}]),b}(k.default);a.exports=n})},{"./clipboard-action":7,"good-listener":4,"tiny-emitter":6}]},{},[8])(8)});

/* resources/assets/js/libraries/clipboard.min.js */
!function(a){if("object"==typeof exports&&"undefined"!=typeof module)module.exports=a();else if("function"==typeof define&&define.amd)define([],a);else{var b;b="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:this,b.Clipboard=a()}}(function(){var a;return function a(b,c,d){function e(g,h){if(!c[g]){if(!b[g]){var i="function"==typeof require&&require;if(!h&&i)return i(g,!0);if(f)return f(g,!0);var j=new Error("Cannot find module '"+g+"'");throw j.code="MODULE_NOT_FOUND",j}var k=c[g]={exports:{}};b[g][0].call(k.exports,function(a){var c=b[g][1][a];return e(c?c:a)},k,k.exports,a,b,c,d)}return c[g].exports}for(var f="function"==typeof require&&require,g=0;g<d.length;g++)e(d[g]);return e}({1:[function(a,b,c){function d(a,b){for(;a&&a.nodeType!==e;){if(a.matches(b))return a;a=a.parentNode}}var e=9;if("undefined"!=typeof Element&&!Element.prototype.matches){var f=Element.prototype;f.matches=f.matchesSelector||f.mozMatchesSelector||f.msMatchesSelector||f.oMatchesSelector||f.webkitMatchesSelector}b.exports=d},{}],2:[function(a,b,c){function d(a,b,c,d,f){var g=e.apply(this,arguments);return a.addEventListener(c,g,f),{destroy:function(){a.removeEventListener(c,g,f)}}}function e(a,b,c,d){return function(c){c.delegateTarget=f(c.target,b),c.delegateTarget&&d.call(a,c)}}var f=a("./closest");b.exports=d},{"./closest":1}],3:[function(a,b,c){c.node=function(a){return void 0!==a&&a instanceof HTMLElement&&1===a.nodeType},c.nodeList=function(a){var b=Object.prototype.toString.call(a);return void 0!==a&&("[object NodeList]"===b||"[object HTMLCollection]"===b)&&"length"in a&&(0===a.length||c.node(a[0]))},c.string=function(a){return"string"==typeof a||a instanceof String},c.fn=function(a){var b=Object.prototype.toString.call(a);return"[object Function]"===b}},{}],4:[function(a,b,c){function d(a,b,c){if(!a&&!b&&!c)throw new Error("Missing required arguments");if(!h.string(b))throw new TypeError("Second argument must be a String");if(!h.fn(c))throw new TypeError("Third argument must be a Function");if(h.node(a))return e(a,b,c);if(h.nodeList(a))return f(a,b,c);if(h.string(a))return g(a,b,c);throw new TypeError("First argument must be a String, HTMLElement, HTMLCollection, or NodeList")}function e(a,b,c){return a.addEventListener(b,c),{destroy:function(){a.removeEventListener(b,c)}}}function f(a,b,c){return Array.prototype.forEach.call(a,function(a){a.addEventListener(b,c)}),{destroy:function(){Array.prototype.forEach.call(a,function(a){a.removeEventListener(b,c)})}}}function g(a,b,c){return i(document.body,a,b,c)}var h=a("./is"),i=a("delegate");b.exports=d},{"./is":3,delegate:2}],5:[function(a,b,c){function d(a){var b;if("SELECT"===a.nodeName)a.focus(),b=a.value;else if("INPUT"===a.nodeName||"TEXTAREA"===a.nodeName){var c=a.hasAttribute("readonly");c||a.setAttribute("readonly",""),a.select(),a.setSelectionRange(0,a.value.length),c||a.removeAttribute("readonly"),b=a.value}else{a.hasAttribute("contenteditable")&&a.focus();var d=window.getSelection(),e=document.createRange();e.selectNodeContents(a),d.removeAllRanges(),d.addRange(e),b=d.toString()}return b}b.exports=d},{}],6:[function(a,b,c){function d(){}d.prototype={on:function(a,b,c){var d=this.e||(this.e={});return(d[a]||(d[a]=[])).push({fn:b,ctx:c}),this},once:function(a,b,c){function d(){e.off(a,d),b.apply(c,arguments)}var e=this;return d._=b,this.on(a,d,c)},emit:function(a){var b=[].slice.call(arguments,1),c=((this.e||(this.e={}))[a]||[]).slice(),d=0,e=c.length;for(d;d<e;d++)c[d].fn.apply(c[d].ctx,b);return this},off:function(a,b){var c=this.e||(this.e={}),d=c[a],e=[];if(d&&b)for(var f=0,g=d.length;f<g;f++)d[f].fn!==b&&d[f].fn._!==b&&e.push(d[f]);return e.length?c[a]=e:delete c[a],this}},b.exports=d},{}],7:[function(b,c,d){!function(e,f){if("function"==typeof a&&a.amd)a(["module","select"],f);else if("undefined"!=typeof d)f(c,b("select"));else{var g={exports:{}};f(g,e.select),e.clipboardAction=g.exports}}(this,function(a,b){"use strict";function c(a){return a&&a.__esModule?a:{default:a}}function d(a,b){if(!(a instanceof b))throw new TypeError("Cannot call a class as a function")}var e=c(b),f="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(a){return typeof a}:function(a){return a&&"function"==typeof Symbol&&a.constructor===Symbol&&a!==Symbol.prototype?"symbol":typeof a},g=function(){function a(a,b){for(var c=0;c<b.length;c++){var d=b[c];d.enumerable=d.enumerable||!1,d.configurable=!0,"value"in d&&(d.writable=!0),Object.defineProperty(a,d.key,d)}}return function(b,c,d){return c&&a(b.prototype,c),d&&a(b,d),b}}(),h=function(){function a(b){d(this,a),this.resolveOptions(b),this.initSelection()}return g(a,[{key:"resolveOptions",value:function(){var b=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};this.action=b.action,this.emitter=b.emitter,this.target=b.target,this.text=b.text,this.trigger=b.trigger,this.selectedText=""}},{key:"initSelection",value:function(){this.text?this.selectFake():this.target&&this.selectTarget()}},{key:"selectFake",value:function(){var b=this,c="rtl"==document.documentElement.getAttribute("dir");this.removeFake(),this.fakeHandlerCallback=function(){return b.removeFake()},this.fakeHandler=document.body.addEventListener("click",this.fakeHandlerCallback)||!0,this.fakeElem=document.createElement("textarea"),this.fakeElem.style.fontSize="12pt",this.fakeElem.style.border="0",this.fakeElem.style.padding="0",this.fakeElem.style.margin="0",this.fakeElem.style.position="absolute",this.fakeElem.style[c?"right":"left"]="-9999px";var d=window.pageYOffset||document.documentElement.scrollTop;this.fakeElem.style.top=d+"px",this.fakeElem.setAttribute("readonly",""),this.fakeElem.value=this.text,document.body.appendChild(this.fakeElem),this.selectedText=(0,e.default)(this.fakeElem),this.copyText()}},{key:"removeFake",value:function(){this.fakeHandler&&(document.body.removeEventListener("click",this.fakeHandlerCallback),this.fakeHandler=null,this.fakeHandlerCallback=null),this.fakeElem&&(document.body.removeChild(this.fakeElem),this.fakeElem=null)}},{key:"selectTarget",value:function(){this.selectedText=(0,e.default)(this.target),this.copyText()}},{key:"copyText",value:function(){var b=void 0;try{b=document.execCommand(this.action)}catch(a){b=!1}this.handleResult(b)}},{key:"handleResult",value:function(b){this.emitter.emit(b?"success":"error",{action:this.action,text:this.selectedText,trigger:this.trigger,clearSelection:this.clearSelection.bind(this)})}},{key:"clearSelection",value:function(){this.target&&this.target.blur(),window.getSelection().removeAllRanges()}},{key:"destroy",value:function(){this.removeFake()}},{key:"action",set:function(){var b=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"copy";if(this._action=b,"copy"!==this._action&&"cut"!==this._action)throw new Error('Invalid "action" value, use either "copy" or "cut"')},get:function(){return this._action}},{key:"target",set:function(b){if(void 0!==b){if(!b||"object"!==("undefined"==typeof b?"undefined":f(b))||1!==b.nodeType)throw new Error('Invalid "target" value, use a valid Element');if("copy"===this.action&&b.hasAttribute("disabled"))throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');if("cut"===this.action&&(b.hasAttribute("readonly")||b.hasAttribute("disabled")))throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');this._target=b}},get:function(){return this._target}}]),a}();a.exports=h})},{select:5}],8:[function(b,c,d){!function(e,f){if("function"==typeof a&&a.amd)a(["module","./clipboard-action","tiny-emitter","good-listener"],f);else if("undefined"!=typeof d)f(c,b("./clipboard-action"),b("tiny-emitter"),b("good-listener"));else{var g={exports:{}};f(g,e.clipboardAction,e.tinyEmitter,e.goodListener),e.clipboard=g.exports}}(this,function(a,b,c,d){"use strict";function e(a){return a&&a.__esModule?a:{default:a}}function f(a,b){if(!(a instanceof b))throw new TypeError("Cannot call a class as a function")}function g(a,b){if(!a)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!b||"object"!=typeof b&&"function"!=typeof b?a:b}function h(a,b){if("function"!=typeof b&&null!==b)throw new TypeError("Super expression must either be null or a function, not "+typeof b);a.prototype=Object.create(b&&b.prototype,{constructor:{value:a,enumerable:!1,writable:!0,configurable:!0}}),b&&(Object.setPrototypeOf?Object.setPrototypeOf(a,b):a.__proto__=b)}function i(a,b){var c="data-clipboard-"+a;if(b.hasAttribute(c))return b.getAttribute(c)}var j=e(b),k=e(c),l=e(d),m=function(){function a(a,b){for(var c=0;c<b.length;c++){var d=b[c];d.enumerable=d.enumerable||!1,d.configurable=!0,"value"in d&&(d.writable=!0),Object.defineProperty(a,d.key,d)}}return function(b,c,d){return c&&a(b.prototype,c),d&&a(b,d),b}}(),n=function(a){function b(a,c){f(this,b);var d=g(this,(b.__proto__||Object.getPrototypeOf(b)).call(this));return d.resolveOptions(c),d.listenClick(a),d}return h(b,a),m(b,[{key:"resolveOptions",value:function(){var b=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};this.action="function"==typeof b.action?b.action:this.defaultAction,this.target="function"==typeof b.target?b.target:this.defaultTarget,this.text="function"==typeof b.text?b.text:this.defaultText}},{key:"listenClick",value:function(b){var c=this;this.listener=(0,l.default)(b,"click",function(a){return c.onClick(a)})}},{key:"onClick",value:function(b){var c=b.delegateTarget||b.currentTarget;this.clipboardAction&&(this.clipboardAction=null),this.clipboardAction=new j.default({action:this.action(c),target:this.target(c),text:this.text(c),trigger:c,emitter:this})}},{key:"defaultAction",value:function(b){return i("action",b)}},{key:"defaultTarget",value:function(b){var c=i("target",b);if(c)return document.querySelector(c)}},{key:"defaultText",value:function(b){return i("text",b)}},{key:"destroy",value:function(){this.listener.destroy(),this.clipboardAction&&(this.clipboardAction.destroy(),this.clipboardAction=null)}}],[{key:"isSupported",value:function(){var b=arguments.length>0&&void 0!==arguments[0]?arguments[0]:["copy","cut"],c="string"==typeof b?[b]:b,d=!!document.queryCommandSupported;return c.forEach(function(a){d=d&&!!document.queryCommandSupported(a)}),d}}]),b}(k.default);a.exports=n})},{"./clipboard-action":7,"good-listener":4,"tiny-emitter":6}]},{},[8])(8)});

/* resources/assets/js/node_modules/skeets.debounce/debounce.js */
var debounce = function(func, waitTime, obj, name) {
  if (waitTime === null || typeof waitTime === "undefined") {
    waitTime = 1000;
  }
  if (waitTime < 1) {
    func.apply(obj);
    return true;
  }
  if (typeof name === "undefined" || name === null || name.length < 1) {
    name = "timeout";
  }
  clearTimeout(debounce[name]);

  debounce[name] = setTimeout(function() {
    func.apply(obj);
  }, waitTime);

};

/* resources/assets/js/app/clipboard.js */
function copyToClipboard(textToCopy, context, allowLineBreaks)
{
  allowLineBreaks = allowLineBreaks || false;

  // Hmmm, can't really think why we wouldn't want linebreaks! Turning this to always on for now as it's breaking things...
  allowLineBreaks = true;
  // "context" is the parent element to place the temporary input in for copying. Required for copying while a
  // dialog box is open, etc.
  var input;
  if (allowLineBreaks) {
    input       = document.createElement('textarea');
    input.value = textToCopy;

    textToCopy = textToCopy.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
                           .replace(/"/g, "&quot;").replace(/'/g, "&#039;").replace(/\n/g, "<br>").replace(/ /g, "&nbsp;");
  }
  else {
    input = document.createElement('input');
    input.setAttribute('value', textToCopy);
  }

  var parentElement;
  if (typeof context === "undefined" || context === null) {
    parentElement = document.body;
    parentElement.appendChild(input);
  }
  else {
    parentElement = context;
    parentElement.appendChild(input);
  }

  input.select();
  input.focus();
  var result = document.execCommand('copy');

  parentElement.removeChild(input);

  if (result) {
    if (allowLineBreaks) {
      toast("Copied to clipboard: <br>" + textToCopy.replaceAll("\n", "<br>"));
    }
    else {
      toast("Copied to clipboard: " + textToCopy);
    }
  }
  else {
    toast("Failed to copy text");
  }
  return result;
}

$("body").on("click", ".copy-to-clipboard", function(e) {
  var text        = $(this).attr("data-text");
  var allowBreaks = $(this).attr("data-allow-breaks") === "yes";
  if (typeof text === "string" && text.length > 0) {
    copyToClipboard(text, null, allowBreaks);
  }
  else {
    toast("Nothing to copy!");
  }
  e.stopPropagation();
  e.preventDefault();
});

/* resources/assets/js/vendor/datagrid/stickyHeader.js */
var allStickyHeaders = [];
var stickyHeaderInstanceId = 0;
var StickyHeader = function ($wrapper, zIndex, scrollParent, $horizontalScrollDiv) {
    if ($wrapper.closest(".modal").length) {
        // sticky headers in modals are not supported.
        // fixed elements don't work well in modals, since the modals are transformed (stealing the target of "fixed" away from the viewport!)
        return;
    }
    var self = this;
    self.instanceId = ++stickyHeaderInstanceId;
    self.eventNamespace = ".stickyHeader." + self.instanceId;
    self.$boundParentScrollElements = $();
    self.resized = false;
    self.scroll = function () {
        var top = self.viewportOffset() + "px";
        var currentScroll = self.getScrollTop();
        if (typeof self.$table.offset() === "undefined" || typeof self.$scrollParent.offset() === "undefined") {
            return;
        }
        var scrollTop = self.$table.offset().top - self.$scrollParent.offset().top + self.$scrollParent.scrollTop();
        var scrollBottom = scrollTop + self.$table.outerHeight() - self.$thead.outerHeight();
        var xScroll = (self.$horizontalScroll.scrollLeft()) * -1;
        var stickyThresholdBuffer = self.floating ? self.$theadPlaceholder.outerHeight() : 0;
        var shouldFloat = currentScroll > scrollTop && currentScroll < scrollBottom;

        if (self.$scrollParent.is("html")) {
            scrollTop = self.$table.offset().top;
            shouldFloat = currentScroll > scrollTop && currentScroll < scrollBottom;
        }

        if (self.floating) {
            // Keep the header floating until we've clearly scrolled back above the top.
            // This avoids rapid fixed/unfixed toggling when the placeholder affects scroll anchoring.
            shouldFloat = currentScroll > (scrollTop - stickyThresholdBuffer) && currentScroll < scrollBottom;
        }

        if (shouldFloat) {
            self.$thead.css({position: "fixed", top: top, "z-index": self.zIndex});
            var vertOffset = 0;
            self.$theadRow.each(function () {
                $(this).css({
                    position: "absolute",
                    left: xScroll + "px",
                    "z-index": self.zIndex,
                    "top": vertOffset + "px"
                });
                vertOffset += $(this).height();
            });

            self.$theadPlaceholder.show();
            self.resetPlaceholders();
            if (!self.resized) {
                self.resize();
            }
            self.resized = true;

        } else {
            self.$thead.css("position", self.theadPos);
            self.$theadRow.css("position", self.theadRowPos);
            self.reset();
            self.$theadPlaceholder.hide();
            self.resized = false;

        }
    };
    self.getScrollTop = function ($element) {
        if (typeof $element === "undefined") {
            $element = self.$scrollParent;
        }
        var output = $element.scrollTop();
        if (output > 0) {
            return output;
        }
        if ($element.is("html")) {
            return self.getScrollTop($("body"));
        }
        if ($element.is("body")) {
            return self.getScrollTop($(document));
        }
        return 0;
    };
    self.reset = function () {
        if (!self.floating) {
            return true;
        }
        self.floating = false; // this should be the only place that makes floating false (other than original initialization)
        var cellCount = 0;
        self.$headerCells.each(function () {
            var $thisPlaceholder = self.$placeholderHeaderCells.eq(cellCount);
            var style = $thisPlaceholder.attr("style");
            if (typeof style === "undefined") {
                style = "";
            }
            $(this).attr("style", style);
            cellCount++;
        });
    };
    self.resetPlaceholders = function () {
        if (self.floating) {
            return true;
        }
        self.floating = true; // this should be the only place that makes floating true
        var cellCount = 0;
        self.$placeholderHeaderCells.each(function () {
            var $thisHeader = self.$headerCells.eq(cellCount);
            var style = $thisHeader.attr("style");
            if (typeof style === "undefined") {
                style = "";
            }
            $(this).attr("style", style);
            cellCount++;
        });
    };
    self.resize = function () {
        if (!self.floating) {
            return true;
        }
        var cellCount = 0;
        self.$headerCells.each(function () {
            var $thisPlaceholder = self.$placeholderHeaderCells.eq(cellCount);
            var width = $thisPlaceholder.outerWidth();
            var height = $thisPlaceholder.outerHeight();
            $(this).css({
                width: width + "px",
                "min-width": width + "px",
                "max-width": width + "px",
                height: height + "px",
                "border-top-width": 0
            });
            cellCount++;
        });
        self.$thead.css({
            width: self.$wrapper.outerWidth() + "px",
            "min-width": self.$wrapper.outerWidth() + "px",
            "max-width": self.$wrapper.outerWidth() + "px",
            "overflow": "hidden",
            height: self.$theadPlaceholder.height() + "px"
        });
    };
    self.getHeaderCellPlaceholder = function ($element) {
        var cellCount = 0;
        var result = false;
        self.$headerCells.each(function () {
            if ($(this).is($element)) {
                result = self.$placeholderHeaderCells.eq(cellCount);
            }
            cellCount++;
        });
        return result;
    };
    self.getScrollParent = function (element) {
        var style = getComputedStyle(element);
        var excludeStaticParent = style.position === "absolute";

        if (style.position === "fixed") {
            return $("html");
        }
        for (var parent = element; (parent = parent.parentElement);) {
            style = getComputedStyle(parent);
            if (excludeStaticParent && style.position === "static") {
                continue;
            }
            if (/(auto|scroll)/.test(style.overflow + style.overflowY) && parent.scrollHeight > parent.clientHeight) {
                return $(parent);
            }
        }

        // noinspection JSJQueryEfficiency
        return $("html");
    };
    self.viewportOffset = function () {
        if (!this.$scrollParent.length) {
            return 0;
        }
        if (this.$scrollParent.is($("html"))) {
            return 0;
        }
        return this.$scrollParent[0].getBoundingClientRect().top;
        // return this.$scrollParent[0].getBoundingClientRect().top + this.$scrollParent.offset().top - this.$wrapper[0].offsetTop;
    };
    self.bindAllParents = function ($element, callable) {
        var $parent = $element.parent();
        if (!$parent.length) {
            return true;
        }
        self.$boundParentScrollElements = self.$boundParentScrollElements.add($parent);
        $parent.on("scroll" + self.eventNamespace, callable);
        self.bindAllParents($parent, callable);
    };
    self.destroy = function () {
        self.$thead.css({
            position: self.theadPos,
            top: "",
            "z-index": "",
            width: "",
            "min-width": "",
            "max-width": "",
            overflow: "",
            height: ""
        });
        self.$theadRow.css({
            position: self.theadRowPos,
            left: "",
            "z-index": "",
            top: ""
        });
        self.reset();
        self.$theadPlaceholder.remove();

        $(window).off(self.eventNamespace);
        $(document).off(self.eventNamespace);
        self.$scrollParent.off(self.eventNamespace);
        self.$horizontalScroll.off(self.eventNamespace);
        self.$boundParentScrollElements.off(self.eventNamespace);
        self.$wrapper.removeData("sticky_header");
    };
    if (typeof scrollParent === "undefined") {
        scrollParent = "detect";
    }
    self.$wrapper = $wrapper;
    self.floating = false;
    self.zIndex = zIndex;
    if ($wrapper.is("table")) {
        self.$table = $wrapper;
    } else {
        self.$table = $wrapper.find("table:not(.no-sticky-header):first");
    }

    self.$thead = self.$table.find("thead");
    self.$theadRow = self.$thead.find("tr");
    self.theadPos = self.$thead.css("position");
    self.theadRowPos = self.$theadRow.css("position");
    self.$headerCells = self.$thead.find("th, td");
    self.$horizontalScroll = $horizontalScrollDiv;
    if (scrollParent === "detect") {
        self.$scrollParent = self.getScrollParent(self.$wrapper[0]);
    } else {
        self.$scrollParent = self.$wrapper.closest(scrollParent);
    }

    self.$theadPlaceholder = self.$thead.clone().css({
        "display": "none",
        "visibility": "hidden"
    });

    self.$thead.after(self.$theadPlaceholder);
    self.$placeholderHeaderCells = self.$theadPlaceholder.find("th, td");
    if (self.$scrollParent.is("html")) {
        $(document).on("scroll" + self.eventNamespace, function () {
            self.scroll();
        });
    } else {
        self.$scrollParent.on("scroll" + self.eventNamespace, function () {
            self.scroll();
        });
        self.bindAllParents(self.$scrollParent, self.scroll);
    }

    self.$horizontalScroll.on("scroll" + self.eventNamespace, function () {
        self.scroll();
    });

    self.resize();
    $(window).on("resize" + self.eventNamespace, function () {
        self.resize();
    });
    allStickyHeaders.push(self);
    self.$wrapper.data("sticky_header", allStickyHeaders.length - 1);
};

function getStickyHeader($wrapper) {
    if (typeof $wrapper.data('sticky_header') !== 'undefined') {
        return allStickyHeaders[$wrapper.data("sticky_header")];
    }
    return false;
}

function deleteStickyHeader($wrapper) {
    if (typeof $wrapper.data('sticky_header') !== 'undefined') {
        var index = $wrapper.data("sticky_header");
        var stickyHeader = allStickyHeaders[index];
        if (stickyHeader) {
            stickyHeader.destroy();
        }
        allStickyHeaders.splice(index, 1);
        allStickyHeaders.forEach(function (header, i) {
            if (header && header.$wrapper) {
                header.$wrapper.data("sticky_header", i);
            }
        });
        return true;
    }
    return false;
}

function stickyHeaderResize($wrapper) {
    var stickyHeader = getStickyHeader($wrapper);
    if (stickyHeader === false) {
        return false;
    }
    stickyHeader.resize();
    return true;
}

/* resources/assets/js/vendor/datagrid/dataGrid.js */
/*
* Requires:
*
* debounce
* jquery
* bootstrap
* moment.js
* bootstrap datetime picker
*
* */

$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});
if (typeof Cookies === "undefined") {
    console.log("Include cookies.js before datagrid.js");
}


/* jquery extensions */

$.fn.dataGrid = function (mode, param) {


    var sessionId = $(this).attr('data-grid-session-id');

    if (typeof sessionId !== 'undefined' && sessionId !== false && sessionId.length > 0) {
        return dataGridHelper.getDataGrid(sessionId);
    }


    var $open = this.closest(".data-grid-open");
    var $row;
    if ($open.length) {
        $row = $open.data("row");
        if (!($row instanceof jQuery)) {
            $row = null;
        }
    } else {
        $row = this.closest(".data-grid-tbody");
    }
    switch (mode) {
        case "value":
            if (!$row.length) {
                return false;
            }
            return dataGridHelper.getRowDataValue($row, param);
        case "row":
            if (!$row.length) {
                return false;
            }
            return dataGridHelper.getRowData($row);
        case "open":
            if (!$row.length) {
                return false;
            }
            dataGridHelper.getDataGridFromElement($row).openRow($row, param);

            break;
        case "close":
            if ($open.length) {
                dataGrid = dataGridHelper.getDataGrid($open.attr("data-grid-session-id")).closeRow();
            } else {
                dataGrid = dataGridHelper.getDataGridFromElement(this).closeRow();
            }

            break;
        default:
            var dataGrid;
            if ($open.length) {
                dataGrid = dataGridHelper.getDataGrid($open.attr("data-grid-session-id"));
            } else {
                dataGrid = dataGridHelper.getDataGridFromElement(this);
            }


            if (dataGrid === false || dataGrid === null) {
                return false;
            }
            dataGrid.$selectedRow = $row;
            return dataGrid;

    }


};

var dgUrlParam = {
    remove: function (url, paramName) {
        var reA = new RegExp("&" + paramName + "=[^&#]*", "g");
        var reB = new RegExp("\\?" + paramName + "=[^&#]*&", "g");
        var reC = new RegExp("\\?" + paramName + "=[^&#]*", "g");
        url = url.replace(reA, "");
        url = url.replace(reB, "?");
        url = url.replace(reC, "");

        return url;
    },
    add: function (url, paramName, value) {
        url = url.replace(/#.*$/g, "");
        url = dgUrlParam.remove(url, paramName);
        if (url.indexOf("?") !== -1) {
            var count = (url.match(/\?/g) || []).length;
            if (url.substr(-1) === "?" && count === 1) {
                url += paramName + "=";
            } else {
                url += "&" + paramName + "=";
            }
        } else {
            url += "?" + paramName + "=";
        }
        url += value;

        return url;
    }
};

var allDataGrids = [];

var DataGrid = function ($dataGridElem) {
    dataGridHelper.checkDataGrids();
    var dataGrid = this;

    this.$selectedRow = null;
    this.rowOpen = false;
    this.rowOpenAjaxFinished = false;
    this.$rowThatIsOpen = null;
    this.$lastCheckedCheckbox = $();
    this.additionalBindingFunctions = [];
    this.onRowClickFunctions = [];
    this.disablePushState = false; // used internally, cannot be used to disable the feature
    this.rowToOpenAfterLoading = null;
    this.recentlyOpenedRow = null;
    this.reloadOnClose = false;
    this.onDraw = function (callable) {
        if (typeof callable !== "function") {
            throw new Error("Must pass a function to the onDraw() method.");
        }
        this.onDrawFunctions.push(callable);

        return this;
    };
    this.horizontalScrollVisible = function () {
        var $horizontalScrollElem = dataGrid.wrapper.find(".data-grid-horizontal-scroll:first");
        if (!$horizontalScrollElem.length) {
            return false;
        }
        return ($horizontalScrollElem[0].scrollWidth > $horizontalScrollElem[0].clientWidth);
    };
    this.forgetColumnWidths = function () {
        dataGrid.wrapper.find(".data-grid-header-cell").each(function () {
            var fieldName = $(this).attr("data-field");
            var cookieName = dataGrid.name + "_" + "col_width_" + fieldName;
            Cookies.remove(cookieName);
        });
        dataGrid.wrapper.find(".data-grid-tbody.dg-is-not-row-header:first").find("td.data-grid-data-single").each(function () {
            var fieldName = $(this).attr("data-grid-field");
            var cookieName = dataGrid.name + "_" + "col_width_" + fieldName;
            Cookies.remove(cookieName);
        });
    };
    this.getRowCount = function () {
        return dataGrid.wrapper.find(".data-grid-tbody").length;
    };
    this.onDrawFunctions = [];
    this.onOpen = function (callable) {
        if (typeof callable !== "function") {
            throw new Error("Must pass a function to the onOpen() method.");
        }
        this.onOpenFunctions.push(callable);
        if (this.rowOpen) {
            callable(dataGridHelper.getRowData(dataGrid.$open.data("row")));
        }

        return this;
    };
    this.onRowClick = function (callable) {
        if (typeof callable !== "function") {
            throw new Error("Must pass a function to the onRowClick() method.");
        }
        this.onRowClickFunctions.push(callable);
        return this;
    };
    this.onOpenFunctions = [];
    this.onAfterOpenAjax = function (callable) {
        if (typeof callable !== "function") {
            throw new Error("Must pass a function to the onAfterOpenAjax() method.");
        }
        this.onAfterOpenAjaxFunctions.push(callable);
        if (this.rowOpenAjaxFinished) {
            callable(this.lastAjaxResponse, dataGridHelper.getRowData(dataGrid.$open.data("row")));
        }
        return this;
    };
    this.onAfterOpenAjaxFunctions = [];
    this.onClose = function (callable) {
        if (typeof callable !== "function") {
            throw new Error("Must pass a function to the onClose() method.");
        }
        this.onCloseFunctions.push(callable);
        return this;
    };
    this.onCloseFunctions = [];
    this.beforeSearch = function () {
        // if you return "false", the search is stopped
        return true;
    };
    this.afterSearch = function () {
        // if you return "false", the table is not updated
        return true;
    };
    this.toggleAllChildRows = function () {
        this.hideChildrenRow = !this.hideChildrenRow;
        this.wrapper.find(".data-grid-tbody").each(function () {
            if (dataGrid.hideChildrenRow) {
                dataGridHelper.hideChildRow($(this));
            } else {
                dataGridHelper.showChildRow($(this));
            }
        });
    };
    this.afterDraw = function () {
        if (dataGrid.recentlyOpenedRow !== null) {
            dataGrid.wrapper.find("tbody[data-row-id='" + dataGrid.recentlyOpenedRow + "']").addClass("data-grid-row-flash");
        }
        $("[data-grid-button-search='yes']").off("click", dataGridHelper.searchButtonClick).click(dataGridHelper.searchButtonClick);
        this.wrapper.find(".data-grid-checkbox-row:first").change();
        this.syncStickyHeaderMode();
        if (typeof getStickyHeader === 'function') {
            var stickyHeader = getStickyHeader(this.wrapper);
            if (stickyHeader !== false) {
                stickyHeader.scroll();
            }
        }
        var $advancedSearchesCount = $(".data-grid-advanced-number-search[data-grid-session-id='" + this.id + "']");
        if ($advancedSearchesCount.length) {
            if ($advancedSearchesCount.attr("data-grid-parenthesis") === "yes") {
                $advancedSearchesCount.html("(" + this.advanacedSearchCount + ")");
            } else {
                $advancedSearchesCount.html(this.advanacedSearchCount);
            }
            if ($advancedSearchesCount.attr("data-grid-hide-on-zero") === "yes") {
                if (this.advanacedSearchCount === 0 || this.advanacedSearchCount === "0") {
                    $advancedSearchesCount.hide();
                } else {
                    $advancedSearchesCount.show();
                }
            }
        }


        this.onDrawFunctions.forEach(function (callable) {
            callable(this);
        });

        if (this.rowToOpenAfterLoading !== null) {
            var $row = this.getRowFromId(this.rowToOpenAfterLoading[0]);
            if ($row.length) {
                this.openRow($row, this.rowToOpenAfterLoading[1], this.rowToOpenAfterLoading[2], false, false, this.rowToOpenAfterLoading[3]);
            }
            this.rowToOpenAfterLoading = null;
        }

        // If the width is too wide to fit on the screen, drop the column width cookies so that it doesn't look broken...
        if (dataGrid.horizontalScrollVisible()) {
            this.forgetColumnWidths();
        }

        return true;
    };

    this.initVars = function ($dataGridElem) {
        this.lastAjaxResponse = null;
        this.id = $dataGridElem.attr("data-grid-session-id");
        this.name = $dataGridElem.attr("data-grid-name");
        this.currentPage = $dataGridElem.attr("data-grid-current-page");
        this.totalPages = $dataGridElem.attr("data-grid-total-pages");
        this.totalRecords = $dataGridElem.attr("data-grid-total-records");
        this.totalRecordsFormatted = $dataGridElem.attr("data-grid-total-records-formatted");
        this.advanacedSearchCount = $dataGridElem.attr("data-grid-advanced-search-count");
        this.pageName = $dataGridElem.attr("data-grid-page-name") || "page";
        this.pageSizeName = $dataGridElem.attr("data-grid-page-size-name") || "page_size";
        this.sessionIdVarName = $dataGridElem.attr("data-grid-session-id-var-name") || "page";
        this.hiddenVarsName = $dataGridElem.attr("data-grid-hidden-vars-name");
        this.scrollAboveGrid = $dataGridElem.attr("data-grid-scroll-above-grid") === "yes";
        this.searchActive = $dataGridElem.attr("data-grid-search-active") === "yes";
        this.rowsArePrerendered = $dataGridElem.attr("data-grid-rows-are-prerendered") === "yes";
        this.scrollAboveGridAtStart = $dataGridElem.attr("data-grid-scroll-above-grid-at-start") === "yes";
        this.scrollAboveGridAnimate = $dataGridElem.attr("data-grid-scroll-above-grid-animate") === "yes";
        this.scrollAboveGridPixels = $dataGridElem.attr("data-grid-scroll-above-grid-pixels");
        this.stickyHeader = $dataGridElem.attr("data-grid-sticky-table-header") === "yes";
        this.scrollParentSelector = $dataGridElem.attr("data-grid-scroll-parent-selector");
        this.stickyHeaderZIndex = $dataGridElem.attr("data-grid-sticky-header-z-index");
        this.openOnClick = $dataGridElem.attr("data-grid-open-on-click") === "yes";
        this.checkOnClick = $dataGridElem.attr("data-grid-check-on-click") === "yes";
        this.ajaxOpenAlways = $dataGridElem.attr("data-grid-ajax-open-always") === "yes";
        this.ajaxOpenBlank = $dataGridElem.attr("data-grid-ajax-open-blank") === "yes";
        this.openDelay = $dataGridElem.attr("data-grid-open-delay") === "yes";
        this.openFirstRow = $dataGridElem.attr("data-grid-open-first-row") === "yes";
        this.openRowModeUpdateUrl = $dataGridElem.attr("data-grid-open-row-mode-update-url") === "yes";
        this.openRowModeUrlParamName = $dataGridElem.attr("data-grid-open-row-mode-url-param-name");
        this.openRowMode = $dataGridElem.attr("data-grid-open-row-mode");
        this.hideGearErrorsOnRowOpen = $dataGridElem.attr("data-grid-hide-gear-errors-on-row-open") === "yes";
        this.openHide = $dataGridElem.attr("data-grid-open-hide");
        this.preserveElementsSelector = $dataGridElem.attr("data-grid-preserve-elements");
        this.moveSettingsDialogTo = $dataGridElem.attr("data-grid-move-settings-dialog-to");
        this.allowOpenWhileLoading = $dataGridElem.attr("data-grid-allow-open-while-loading") === "yes";
        this.countCapReached = $dataGridElem.attr("data-grid-count-cap-reached") === "yes";
        this.rowOpenUrlRequireGrid = $dataGridElem.attr("data-grid-row-open-url-require-grid") === "yes";
        this.rowOpenUrlRowIdName = $dataGridElem.attr("data-grid-row-open-url-row-id-name");
        this.openRowClearUrlParams = $dataGridElem.attr("data-grid-open-row-clear-url-params").split(",").filter(function (str) {
            return str.trim() !== "";
        });
        this.closeRowClearUrlParams = $dataGridElem.attr("data-grid-close-row-clear-url-params").split(",").filter(function (str) {
            return str.trim() !== "";
        });
        this.openRowForwardUrlParams = $dataGridElem.attr("data-grid-open-row-forward-url-params").split(",").filter(function (str) {
            return str.trim() !== "";
        });
        this.rowOpenUrlGridParamName = $dataGridElem.attr("data-grid-row-open-url-grid-id-name");
        this.rememberScroll = 0;
        this.currentlyLoading = false;
        this.$rememberScrollDiv = null;
        this.defaultFontSize = $dataGridElem.attr("data-grid-default-font-size");
        this.preserveUrlParams = $dataGridElem.attr("data-grid-preserve-url-params").split(",");
        this.defaultSpacing = $dataGridElem.attr("data-grid-default-spacing");
        if (typeof this.defaulthideChildrenRow === "undefined") {
            this.defaulthideChildrenRow = $dataGridElem.attr("data-grid-hide-children-row") === "yes";
            this.hideChildrenRow = this.defaulthideChildrenRow;
        }


        this.ajaxUrl = $dataGridElem.attr("data-ajax-url");
        this.prerenderedAjaxUrl = $dataGridElem.attr("data-prerendered-ajax-url");
        this.ajaxInputUrl = $dataGridElem.attr("data-ajax-input-url");
        this.csvUrl = $dataGridElem.attr("data-csv-url");
        this.ajaxOpenUrl = $dataGridElem.attr("data-ajax-open-url");
        this.wrapper = $dataGridElem;
        this.$open = $(".data-grid-open[data-grid-session-id='" + dataGrid.id + "']");
        this.settingsModal = $dataGridElem.find(".data-grid-settings-modal");
        this.updateUrlEnabled = $dataGridElem.attr("data-grid-update-url") === "yes";
        this.defaultToLastPage = $dataGridElem.attr("data-grid-default-to-last-page") === "yes";
        this.jsDefaultToFormatted = $dataGridElem.attr("data-grid-js-default-to-formatted") === "yes";
        if (typeof this.searchAjaxRequests === "undefined") {
            this.searchAjaxRequests = [];
        }
        if (typeof this.openAjaxRequests === "undefined") {
            this.openAjaxRequests = [];
        }
        if (typeof this.moveSettingsDialogTo !== "undefined" && this.moveSettingsDialogTo.length > 0) {
            var $newLoc = $(this.moveSettingsDialogTo);
            var $alreadyExists = $newLoc.find("#" + this.settingsModal.attr("id"));
            if ($alreadyExists.length) {
                this.settingsModal.remove();
                this.settingsModal = $alreadyExists;
            } else {
                $(this.moveSettingsDialogTo).append(this.settingsModal.detach());
            }

        }
    };
    this.closeSettingsModal = function () {
        this.settingsModal.modal("hide");
    };
    this.openSettingsModal = function () {
        this.settingsModal.attr("data-grid-session-id", this.id);
        this.settingsModal.modal("show");
    };

    this.preserveElements = function ($wrapper) {
        // let's see if our preserve hidden element is present...
        var $preserveWrapper = $("#data-grid-preserve-element-wrapper");
        if (!$preserveWrapper.length) {
            $preserveWrapper = $("<div style='display: none;' id='data-grid-preserve-element-wrapper'></div>");
            $("body").append($preserveWrapper);
        }

        var $preserveElements = $wrapper.find(this.preserveElementsSelector);
        $preserveWrapper.append($preserveElements);
    };

    this.addSearch = function ($target, field, operation, duplicatesAllowed, callback, replaceInstead, doNotMarkAsAdded) {

        operation = operation || "=";
        duplicatesAllowed = duplicatesAllowed || false;
        replaceInstead = replaceInstead || false;
        doNotMarkAsAdded = doNotMarkAsAdded || false;
        var currentValue = $target.find(".data-grid-search[name='" + field + "'][data-grid-session-id='" + this.id + "'").val();
        var data = { field: field, operation: operation, currentValue: currentValue };
        data[this.sessionIdVarName] = this.id;
        if (this.ajaxInputUrl.length < 1) {
            return false;
        }
        $.ajax({
            url: this.ajaxInputUrl,
            type: "POST",
            data: data,
            success: function (response) {
                var $html = $(response + "<br>");
                var $searchInput = $html.filter(".data-grid-search");
                var $alreadyExists = $("[data-grid-session-id='" + dataGrid.id + "'][name='" + $searchInput.attr("name") + "']");

                if ($alreadyExists.length && !duplicatesAllowed && !replaceInstead) {
                    $alreadyExists.focus();
                    if (typeof callback === "function") {
                        callback($alreadyExists);
                    }
                    return true;
                }
                if (replaceInstead) {
                    dataGrid.preserveElements($target);
                    $target.html($html);
                } else {
                    $target.append($html);
                }

                if ($.isFunction($.fn.tooltip)) {
                    $html.find("[data-toggle='tooltip']").tooltip({ boundary: 'window' });
                    $html.find("[data-bs-toggle='tooltip']").tooltip({ boundary: 'window' });
                }

                if ($searchInput.hasClass("selectpicker")) {
                    $searchInput.selectpicker();
                }
                $html.focus();
                if (!doNotMarkAsAdded) {
                    $html.addClass("data-grid-added-search");
                }
                $html.attr("data-grid-session-id", dataGrid.id);
                dataGridHelper.bindSearchElements(dataGrid, $searchInput);
                if (typeof callback === "function") {
                    callback($searchInput);
                }
            }, error: function (response) {
                if (response.statusText !== "abort") {
                    console.log("Ajax error, response:");
                    console.log(response);
                }
                if (typeof response.responseJSON !==
                    "undefined" &&
                    typeof response.responseJSON.message !==
                    "undefined" &&
                    response.responseJSON.message.length >
                    0 &&
                    typeof toast ===
                    "function") {
                    toast({ message: response.responseJSON.message, type: "danger" });
                } else {
                    if (typeof response.responseText !==
                        "undefined" &&
                        response.responseText.length >
                        0 &&
                        typeof toast ===
                        "function") {
                        toast({ message: response.responseText, type: "danger" });
                    }
                }
            }
        });
    };

    this.initVars($dataGridElem);

    /*
  *
  * Search function
  *
  * pageNum less than zero means "keep previous page number".
  * */
    this.search = function (pageNum, maintainScroll) {
        maintainScroll = maintainScroll || false;
        if (pageNum < 0) {
            pageNum = this.currentPage;
        }
        var defaultPage = 1;
        if (this.defaultToLastPage) {
            defaultPage = parseInt(this.totalPages);
        }
        pageNum = pageNum || defaultPage;
        var data = this.gatherVars();

        data[this.sessionIdVarName] = this.id;
        if (parseInt(pageNum) !== defaultPage) {
            data[this.pageName] = pageNum;
        }

        this.updateUrl(data);
        var ajaxUrlToUse = this.ajaxUrl;
        if (this.rowsArePrerendered) {
            ajaxUrlToUse = this.prerenderedAjaxUrl;
        }

        if (!this.beforeSearch(data)) {
            return true;
        }
        if (ajaxUrlToUse < 1) {
            return false;
        }

        this.searchAjaxRequests.forEach(function (thisAjaxRequest) {
            thisAjaxRequest.abort();
        });
        this.searchAjaxRequests = [];

        dataGrid.wrapper.find(".data-grid-corner-refresh").hide();
        dataGrid.wrapper.find(".data-grid-corner-display-settings").css({ visibility: "hidden" });
        dataGrid.wrapper.find(".data-grid-download-csv").css({ visibility: "hidden" });
        dataGrid.wrapper.find(".data-grid-corner-loader").show();
        dataGrid.wrapper.find(".data-grid-checkbox-row").prop("disabled", true);
        dataGrid.wrapper.find(".data-grid-check-all").prop("disabled", true);
        var $floatLoader = $(".data-grid-float-loader[data-grid-session-id='" + dataGrid.id + "']");
        $floatLoader.show();

        if (!maintainScroll && dataGrid.scrollAboveGridAtStart) {
            dataGrid.ensureTopOfGridIsVisible();
        }

        var $allCheckboxes = dataGrid.wrapper.find(".data-grid-checkbox-row");
        $allCheckboxes.prop("checked", false);
        $($allCheckboxes[0]).change();
        // don't allow opening of any modals that are about to get reset!
        dataGrid.wrapper.find(".modal").each(function () {
            $(this).modal("hide");
        });
        dataGrid.wrapper.find("[data-toggle='modal']").css({ "visibility": "hidden" });
        dataGrid.currentlyLoading = true;
        var ajaxRequest = $.ajax({
            url: ajaxUrlToUse,
            type: "POST",
            data: data,
            success: function (response) {
                dataGrid.currentlyLoading = false;
                var dataGridHTML = response.datagrid;
                var sortButtons = response.sortButtons;
                var fieldName;
                for (fieldName in sortButtons) {
                    if (sortButtons.hasOwnProperty(fieldName)) {
                        //return " data-grid-button-sort='yes' data-grid-field='" . $sort . "' ";
                        var $newSortButton = $(sortButtons[fieldName]);
                        $newSortButton.click(dataGridHelper.sortButtonClick);
                        $("[data-grid-button-sort='yes'][data-grid-field='" + fieldName + "']").find(".data-grid-sort").replaceWith($newSortButton);
                    }
                }
                if (!dataGrid.afterSearch(dataGridHTML, data)) {
                    $floatLoader.hide();
                    return true;
                }
                var $newGrid = $(dataGridHTML);
                var $oldGrid = $(".data-grid-wrapper[data-grid-session-id='" + dataGrid.id + "']");
                if (typeof $oldGrid.data("sticky_header") !== "undefined") {
                    deleteStickyHeader($oldGrid);
                }
                $oldGrid.replaceWith($newGrid);
                var existingDataGridObj = dataGrid;
                // 2019.08.12-TSO: Why was I getting the datagrid object from the ID, when we already have it?
                // var existingDataGridObj = getDataGrid(dataGrid.id, "id");

                if (existingDataGridObj === false) {
                    var newDataGridObj = new DataGrid($newGrid);
                    newDataGridObj.ensureSingleFloatingLoader();
                    if (!dataGrid.scrollAboveGridAtStart) {
                        newDataGridObj.ensureTopOfGridIsVisible();
                    }
                } else {
                    existingDataGridObj.initVars($newGrid);
                    existingDataGridObj.initBindings($newGrid);
                    existingDataGridObj.ensureSingleFloatingLoader();
                    if (!dataGrid.scrollAboveGridAtStart) {
                        existingDataGridObj.ensureTopOfGridIsVisible();
                    }
                }
                dataGrid.wrapper.find(".data-grid-corner-loader").hide();
                dataGrid.wrapper.find(".data-grid-corner-refresh").show();
                dataGrid.wrapper.find(".data-grid-corner-display-settings").css({ visibility: "visible" });
                dataGrid.wrapper.find(".data-grid-download-csv").css({ visibility: "visible" });
                dataGrid.wrapper.find(".data-grid-checkbox-row").prop("disabled", false);
                dataGrid.wrapper.find(".data-grid-check-all").prop("disabled", false);
                dataGrid.afterDraw();
                if ($.isFunction($.fn.tooltip)) {
                    $newGrid.find("[data-toggle='tooltip']").tooltip({ boundary: 'window' });
                    $newGrid.find("[data-bs-toggle='tooltip']").tooltip({ boundary: 'window' });
                }
                $floatLoader.hide();
            }, error: function (response) {
                dataGrid.currentlyLoading = false;
                if (response.statusText !== "abort") {
                    console.log("Ajax error, response:");
                    console.log(response);
                }
                if (typeof response.responseJSON !==
                    "undefined" &&
                    typeof response.responseJSON.message !==
                    "undefined" &&
                    response.responseJSON.message.length >
                    0 &&
                    typeof toast ===
                    "function") {
                    toast({ message: response.responseJSON.message, type: "danger" });
                } else {
                    if (typeof response.responseText !==
                        "undefined" &&
                        response.responseText.length >
                        0 &&
                        typeof toast ===
                        "function") {
                        toast({ message: response.responseText, type: "danger" });
                    }
                }
                $floatLoader.hide();
                dataGrid.wrapper.find(".data-grid-corner-loader").hide();
                dataGrid.wrapper.find(".data-grid-corner-refresh").show();
                dataGrid.wrapper.find(".data-grid-corner-display-settings").css({ visibility: "visible" });
                dataGrid.wrapper.find(".data-grid-download-csv").css({ visibility: "visible" });
                dataGrid.wrapper.find(".data-grid-checkbox-row").prop("disabled", false);
                dataGrid.wrapper.find(".data-grid-check-all").prop("disabled", false);
            }
        });

        this.searchAjaxRequests.push(ajaxRequest);
        return true;
    };
    /*
  *
  * End of search function
  *
  * */

    this.gatherVarAppend = function (output, field, value, isSortOrSortOrder) {
        // Sorts are never arrays (that makes no sense, sorting by the same field multiple times would be pointless)
        if (typeof output[field] === "undefined" || isSortOrSortOrder) {
            output[field] = value;
            return;
        }

        if (Array.isArray(output[field])) {
            output[field].push(value);
            return;
        }

        output[field] = [output[field], value];
    };

    this.gatherVars = function () {
        var output = {};
        var addIfNonDefault = { sort: {}, search: {} };
        var nonDefault = { sort: false, search: false };
        var that = this;


        // ------------
        // ------------
        // ------------
        // ------------
        // ------------

        $(".data-grid-input[data-grid-session-id='" + this.id + "']").each(function () {
            var dataGridSessionId = $(this).attr("data-grid-session-id");
            var isSort = $(this).hasClass("data-grid-input-sort");
            var isSortOrSortOrder = $(this).hasClass("data-grid-input-sort") || $(this).hasClass("data-grid-input-sort-order");
            var sortOrSearch = "search";
            if (isSort) {
                sortOrSearch = "sort";
            }
            var field = $(this).attr("name");
            var value = "";
            var inputType = $(this).attr("type");
            if ((inputType !== "checkbox" && inputType !== "radio") || $(this).is(":checked")) {
                value = $(this).val();
            }


            if (typeof value === "undefined" || value === null) {
                value = "";
            }

            if ($(this).hasClass("data-grid-hidden-checkbox-input") &&
                $(".data-grid-input[type='checkbox'][data-grid-session-id='" + dataGridSessionId + "'][name='" + field + "']:checked").length) {
                // Ignore the hidden checkbox input if the associated input is checked
                return true;
            }
            if ($(this).is("input[type='checkbox']:not(:checked)") &&
                $(".data-grid-input.data-grid-hidden-checkbox-input[type='hidden'][data-grid-session-id='" +
                    dataGridSessionId + "'][name='" + field + "']").length) {
                // Ignore the unchecked checkbox input if the associated hidden input is present
                return true;
            }


            var $shortcutButtons = $("[data-grid-button-search='yes'][data-grid-field='" + field + "']").removeClass("active");
            $shortcutButtons.filter("[data-grid-search-value='" + dg_escapeStr(value) + "']").addClass("active");

            if (value.length > 0) {
                $(this).addClass("active");
            } else {
                $(this).removeClass("active");
            }

            var defaultValue = $(this).attr("data-grid-default-value");
            if (value.length > 0 || $(this).attr("data-has-default") === "yes") {
                if (typeof defaultValue !== "undefined" && defaultValue !== null && defaultValue.length > 0 &&
                    defaultValue.toLowerCase() === value.toLowerCase()) {
                    addIfNonDefault[sortOrSearch][field] = value;

                    return true;
                }

                if (isSort && $(this).attr("data-grid-skip-url") !== "yes"
                    && [that.sessionIdVarName, that.pageSizeName, that.hiddenVarsName, "additionalSearch"].indexOf(field) < 0) {
                    nonDefault[sortOrSearch] = true;
                }
                that.gatherVarAppend(output, field, value, isSortOrSortOrder);

                return true; // continue
            }

            if ($(this).hasClass("data-grid-input-sort") && typeof defaultValue !== "undefined" && defaultValue !== null && defaultValue.length > 0) {
                var $otherSortInputs = $(".data-grid-input[data-grid-session-id='" + that.id + "'][name=" + field + "]");

                var someValueExists = false;
                $otherSortInputs.each(function () {
                    var thisValue = $(this).val();
                    if (typeof thisValue !== "undefined" && thisValue !== null && thisValue.length > 0) {
                        someValueExists = true;
                    }
                });
                if (!someValueExists) {
                    nonDefault[sortOrSearch] = true; // default sort is turned off? that means this is not a default sort.
                }
            }

        });
        // ------------
        // ------------
        // ------------
        // ------------
        // ------------
        // ------------
        // ------------
        // ------------

        if (nonDefault.sort) {
            for (var field in addIfNonDefault.sort) {
                if (addIfNonDefault.sort.hasOwnProperty(field)) {
                    that.gatherVarAppend(output, field, addIfNonDefault.sort[field], true);
                }
            }
        }
        if (nonDefault.search) {
            for (field in addIfNonDefault.search) {
                if (addIfNonDefault.search.hasOwnProperty(field)) {
                    that.gatherVarAppend(output, field, addIfNonDefault.search[field], false);
                }
            }
        }
        output[this.pageSizeName] = $(".data-grid-page-size-select[data-grid-session-id='" + this.id + "']").val();
        if (typeof this.addAdditionalSearch === "function") {
            output["additionalSearch"] = this.addAdditionalSearch();
        }
        if (this.hideChildrenRow !== this.defaulthideChildrenRow) {
            output["inverseChildHidden"] = "yes";
        }
        return output;
    };

    // Only scroll up, never down....
    this.ensureTopOfGridIsVisible = function () {
        if (!this.scrollAboveGrid) {
            return true;
        }
        var $scrollParent = dataGridHelper.getScrollParent(this.wrapper[0]);
        if (!$scrollParent.length) {
            return true;
        }

        var topElement = false;
        if ($scrollParent.is("html")) {
            topElement = true;
            if (parseInt($scrollParent.scrollTop()) === 0) {
                $scrollParent = $("body");
            }
        }

        var topOfGrid = this.wrapper.offset().top - $scrollParent.offset().top;

        if (!topElement) {
            topOfGrid += $scrollParent.scrollTop();
        }

        var topOfView = $scrollParent.scrollTop();


        if (topOfView > topOfGrid) {
            var newScroll = topOfGrid - this.scrollAboveGridPixels;
            if (this.scrollAboveGridAnimate) {
                $scrollParent.stop().animate({ scrollTop: newScroll }, 500, 'swing');
            } else {
                $scrollParent.scrollTop(newScroll);
            }

        }
    };
    this.ensureSingleFloatingLoader = function () {
        var $floaterAlreadySelected = $(".data-grid-float-loader[data-grid-session-id='" + dataGrid.id + "'][data-grid-current-loader='yes']");
        var $floatLoaders = $(".data-grid-float-loader[data-grid-session-id='" + dataGrid.id + "']");
        if ($floaterAlreadySelected.length) {
            $floatLoaders.not($floaterAlreadySelected).remove();
            return $floaterAlreadySelected;
        }

        var $return = null;
        var first = true;
        $floatLoaders.each(function () {
            if (first) {
                $return = $(this).attr("data-grid-current-loader", "yes");
                first = false;
                return true;
            }
            $(this).remove();
        });
        return $return;
    };
    this.pullFloatingLoader = function () {
        return this.ensureSingleFloatingLoader().detach();
    };
    this.removeFloatLoader = function () {
        $(".data-grid-float-loader[data-grid-session-id='" + dataGrid.id + "']").remove();
    };
    this.resetInput = function ($input) {
        $input.each(function () {

            if ($(this).hasClass("data-grid-hidden-checkbox-input")) {
                return true;
            }

            var inputType = $(this).attr("type");
            var defaultValue = $(this).attr("data-grid-default-value");

            if (typeof defaultValue === "undefined" || defaultValue.length < 1) {
                defaultValue = "";
            }
            if ((inputType === "checkbox" || inputType === "radio")) {
                if (defaultValue === $(this).val()) {
                    $(this).prop("checked", true).change();
                } else {
                    $(this).prop("checked", false).change();
                }
                return true;
            }

            $(this).val(defaultValue).change().keyup();
        });
    };
    this.reset = function () {
        $(".data-grid-input[data-grid-session-id='" + this.id + "']").each(function () {
            dataGrid.resetInput($(this));
        });
        $(".data-grid-added-search[data-grid-session-id='" + this.id + "']").each(function () {
            if ($(this).hasClass("selectpicker")) {
                var $wrapper = $(this).closest(".bootstrap-select");
                if ($wrapper.length) {
                    $wrapper.remove();
                    return true;
                }
            }
            $(this).remove();
        });
        return this;
    };
    this.updateUrl = function (data) {

        if (this.disablePushState) {
            return true;
        }
        if (!this.updateUrlEnabled) {
            return true;
        }

        var skipVars = [this.sessionIdVarName, this.pageSizeName, this.hiddenVarsName, "additionalSearch"];

        $("input[data-grid-skip-url='yes'][data-grid-session-id='" + this.id + "']").each(function () {
            skipVars.push($(this).attr("name"));
        });


        var originalUrl = window.location.href.split("?")[0];
        var currentParams = new URLSearchParams(window.location.search);
        var url = originalUrl + "?";
        var first = true;
        var property;

        // Preserve specified params from current URL
        this.preserveUrlParams.forEach(function (key) {
            if (currentParams.has(key)) {
                currentParams.getAll(key).forEach(function (val) {
                    if (!first) {
                        url += "&";
                    }
                    first = false;
                    url += encodeURIComponent(key) + "=" + encodeURIComponent(val);
                });
            }
        });
        for (property in data) {
            if (data.hasOwnProperty(property)) {
                if (skipVars.indexOf(property) > -1) {
                    continue;
                }


                if (Array.isArray(data[property])) {
                    data[property].forEach(function (singleValue) {
                        if (!first) {
                            url += "&";
                        }
                        first = false;
                        url += encodeURIComponent(property) + "[]=" + encodeURIComponent(singleValue);
                    });
                } else {

                    if (!first) {
                        url += "&";
                    }
                    first = false;

                    url += encodeURIComponent(property) + "=" + encodeURIComponent(data[property]);
                }
            }
        }
        // Are there no url query params?
        if (first) {
            // No url query params... don't need the trailing "?"...
            url = originalUrl;
        }

        window.history.pushState({ dataGrid: "yes", mode: "search" }, document.title, url);
        // use this to avoid affecting browser history
        // window.history.replaceState({}, document.title, url);

        return true;
    };
    this.initBindingsInRows = function ($wrapper) {
        dataGridHelper.bindCheckboxes(this, $wrapper);
        dataGridHelper.bindChildRowControlElements(this, $wrapper);
        dataGridHelper.bindLinkElements(this, $wrapper);
        dataGridHelper.bindGears($wrapper);
        dataGridHelper.bindAdditional(this, $wrapper);
        dataGridHelper.bindRows(this, $wrapper);
    };

    this.mobileCardsVisible = function () {
        const $tbody = this.wrapper.find("tbody.data-grid-tbody:first");
        // Block instead of table display? This is a mobile card.
        return $tbody.length && $tbody.css("display") === "block";
    };

    this.syncStickyHeaderMode = function () {
        if (typeof StickyHeader !== "function" || typeof getStickyHeader !== "function") {
            return;
        }

        var stickyHeader = getStickyHeader(this.wrapper);

        if (this.mobileCardsVisible()) {
            if (stickyHeader !== false && typeof deleteStickyHeader === "function") {
                deleteStickyHeader(this.wrapper);
            }
            return;
        }

        if (this.stickyHeader && stickyHeader === false) {
            new StickyHeader(this.wrapper, this.stickyHeaderZIndex, this.scrollParentSelector, this.wrapper.find(".data-grid-horizontal-scroll"));
        }
    };

    this.bindStickyHeaderModeResize = function () {
        if (this.boundStickyHeaderModeResize) {
            return;
        }

        this.boundStickyHeaderModeResize = true;
        var dataGrid = this;

        $(window).on("resize.datagridStickyMode." + this.id, function () {
            dataGrid.syncStickyHeaderMode();

            if (typeof getStickyHeader !== "function") {
                return;
            }

            var stickyHeader = getStickyHeader(dataGrid.wrapper);
            if (stickyHeader !== false) {
                stickyHeader.resize();
                stickyHeader.scroll();
            }
        });
    };


    this.initBindings = function ($dataGridElem) {

        dataGridHelper.bindPaginationAjax(this, $dataGridElem);
        dataGridHelper.bindPageSizeSelect(this, $dataGridElem);
        dataGridHelper.bindSortElements(this, $dataGridElem);
        dataGridHelper.bindRefreshElements(this, $dataGridElem);

        dataGridHelper.bindSearchElements(this);
        dataGridHelper.bindAddSearchButtons(this);
        dataGridHelper.bindSearchForm(this);
        dataGridHelper.bindSettingsButton(this);


        dataGridHelper.bindCookieButtons(this, $dataGridElem);
        this.bindStickyHeaderModeResize();
        this.syncStickyHeaderMode();

        this.initBindingsInRows($dataGridElem);
    };
    this.row = function (row_id) {
        if (typeof row_id === "undefined") {
            return dataGridHelper.getRowData(this.$selectedRow);
        }
        return dataGridHelper.getRowData(this.wrapper.find("tbody[data-row-id='" + row_id + "']"));
    };
    this.rowElem = function (row_id) {
        return this.wrapper.find("tbody[data-row-id='" + row_id + "']");
    };
    this.data = function () {
        if (this.$selectedRow === null) {
            return false;
        }
        return dataGridHelper.getRowData(this.$selectedRow);
    };
    this.value = function (value) {
        if (this.$selectedRow === null) {
            return false;
        }
        return dataGridHelper.getRowDataValue(this.$selectedRow, value);
    };
    this.rowValue = function (row_id, value) {
        return dataGridHelper.getRowDataValue(this.wrapper.find("tbody[data-row-id='" + row_id + "']"), value);
    };
    this.getRowNum = function (rowNum, onlyChecked, formatted) {
        onlyChecked = onlyChecked || false;
        return dataGridHelper.getRowData(this.getRowNumElem(rowNum, onlyChecked), formatted);
    };
    this.getRowNumElem = function (rowNum, onlyChecked) {
        onlyChecked = onlyChecked || false;
        rowNum--;
        if (onlyChecked) {
            var $checkbox = this.wrapper.find("tbody.data-grid-tbody.dg-is-not-row-header input.data-grid-checkbox-row:checked:eq(" + rowNum + ")");
            return $checkbox.closest("tbody.data-grid-tbody");
        } else {
            return this.wrapper.find("tbody.data-grid-tbody.dg-is-not-row-header:eq(" + rowNum + ")");
        }

    };
    this.getRowNumValue = function (rowNum, value) {
        rowNum--;
        return dataGridHelper.getRowDataValue(this.wrapper.find("tbody.data-grid-tbody.dg-is-not-row-header:eq(" + rowNum + ")"), value);
    };
    this.getRows = function () {
        var $rows = this.wrapper.find("tbody.data-grid-tbody.dg-is-not-row-header");
        var output = [];
        $rows.each(function () {
            output.push(dataGridHelper.getRowData($(this)));
        });

        return output;

    };
    this.addRowDetail = function (rowID, detail, rowClass, clearPreviousDetails) {
        if (typeof clearPreviousDetails !== 'boolean') {
            if (clearPreviousDetails === "false") {
                clearPreviousDetails = false;
            } else {
                clearPreviousDetails = true;
            }
        }
        if (typeof rowClass !== "string") {
            rowClass = "";
        }
        var $row = this.wrapper.find("tbody[data-row-id='" + rowID + "']");
        if (!$row.length) {
            return true;
        }
        var colNum = 0;
        $row.find("tr:first").find("td,th").each(function () {
            if ($(this).hasClass("data-grid-expand-with-child")) {
                return true;
            }
            if ($(this).css("display") === "none") {
                return true;
            }
            var colspan = $(this).attr("colspan");
            if (typeof colspan !== "undefined" && colspan > 0) {
                colNum += parseInt(colspan);
            } else {
                colNum += 1;
            }
        });
        var numToRemove = 0;
        if (clearPreviousDetails) {
            var $previousDetails = $row.find(".data-grid-row-detail");
            numToRemove = $row.length;
            $previousDetails.remove();

        }
        $row.append("<tr class='data-grid-row-detail " +
            // rowClass +
            "'><td colspan='" +
            colNum +
            "'><div style='width: 100%;' class='" + rowClass + "'>" +
            detail +
            "</div></td></tr>");
        dataGridHelper.updateTbodyLastTr($row);
        $row.find(".data-grid-expand-with-child").each(function () {
            var currentRowSpan = $(this).attr("rowspan");
            $(this).attr("rowspan", currentRowSpan + 1 - numToRemove);
        });


    };
    this.removeRowDetail = function (rowID) {
        var $row = this.wrapper.find("tbody[data-row-id='" + rowID + "']");
        var $toRemove = $row.find(".data-grid-row-detail");
        if (!$toRemove.length) {
            return true;
        }
        $toRemove.remove();
        dataGridHelper.updateTbodyLastTr($row);
    };

    this.replaceRow = function (rowID, content) {
        var $row = this.wrapper.find(".data-grid-tbody[data-row-id='" + rowID + "']");
        if (!$row.length) {
            return false;
        }
        var dataGrid = $row.dataGrid();
        var openedRowId = dataGrid.getOpenedRowId();

        var $newRow = $(content);

        $row.replaceWith($newRow);

        if (openedRowId !== null) {
            dataGrid.updateOpenedRow(openedRowId);
        }

        if (typeof gearJS !== "undefined") {
            gearJS.auto($newRow);
        }
        this.initBindingsInRows($newRow);

        $newRow.find(".data-grid-checkbox-row").trigger("change").prop("disabled", false);
        return $newRow;
    };

    this.checkedRows = function () {
        var output = [];
        this.wrapper.find(".data-grid-checkbox-row:checked").each(function () {
            output.push($(this).attr("data-row-id"));
        });
        return output;
    };

    this.checkedRowsWithValue = function (field, value) {
        var output = [];
        this.wrapper.find(".data-grid-checkbox-row:checked").each(function () {
            if ($(this).dataGrid().value(field) === value) {
                output.push($(this).attr("data-row-id"));
            }
        });
        return output;
    };

    this.removeUrlParam = function (url, paramName) {
        var reA = new RegExp("&" + paramName + "=[^&#]*", "g");
        var reB = new RegExp("\?" + paramName + "=[^&#]*&", "g");
        var reC = new RegExp("\?" + paramName + "=[^&#]*", "g");
        url = url.replace(reA, "");
        url = url.replace(reB, "?");
        url = url.replace(reC, "");

        return url;
    };

    this.closeRow = function (onCloseParam) {
        var rowToFlash = this.$rowThatIsOpen;
        var result;
        var cancelCloseRow = false;
        if (this.reloadOnClose) {
            this.search(-1, true);
            this.reloadOnClose = false;
        }
        dataGrid.onCloseFunctions.forEach(function (onCloseFunction) {
            result = onCloseFunction(onCloseParam);
            if (typeof result !== "undefined" && result === false) {
                cancelCloseRow = true;
                return false;
            }
        });
        if (cancelCloseRow) {
            return false;
        }
        if (!this.disablePushState) {
            var url = window.location.href;
            url = dgUrlParam.remove(url, this.rowOpenUrlRowIdName);
            if (this.openRowModeUpdateUrl) {
                url = dgUrlParam.remove(url, this.openRowModeUrlParamName);
            }
            this.closeRowClearUrlParams.forEach(function (urlParamToRemove) {
                url = dgUrlParam.remove(url, urlParamToRemove);
            });
            if (this.rowOpenUrlRequireGrid) {
                url = dgUrlParam.remove(url, this.rowOpenUrlGridParamName);
            }
            window.history.pushState({ dataGrid: "yes", mode: "search" }, document.title, url);
        }
        var $hideOnOpen;
        if (dataGrid.openHide === "_grid") {
            $hideOnOpen = $wrapper;
        } else {
            $hideOnOpen = $(dataGrid.openHide);
        }
        dataGrid.$open.hide();
        dataGrid.rowOpen = false;
        dataGrid.rowOpenAjaxFinished = false;
        $hideOnOpen.show().removeClass("d-none");
        if (dataGrid.$rememberScrollDiv !== null) {
            dataGrid.$rememberScrollDiv.scrollTop(dataGrid.rememberScroll);
        }
        dataGrid.preserveElements($(".dg-clear-on-open-close"));
        $(".dg-clear-on-open-close").html("");

        $(".data-grid-row-flash").removeClass("data-grid-row-flash");
        if (rowToFlash !== null && rowToFlash.length) {
            rowToFlash.addClass("data-grid-row-flash");
            dataGrid.recentlyOpenedRow = rowToFlash.attr("data-row-id");
            setTimeout(function () {
                dataGrid.wrapper.find("tbody[data-row-id='" + dataGrid.recentlyOpenedRow + "']").removeClass("data-grid-row-flash");
                dataGrid.recentlyOpenedRow = null;
            }, 7000);
        }
    };

    this.getRowFromId = function (rowId) {
        return this.wrapper.find("tbody[data-row-id='" + rowId + "']");
    };

    this.openRowAfterLoading = function (rowId, mode, blank, onlyWhenOpen) {
        onlyWhenOpen = onlyWhenOpen || false;
        if (!dataGrid.currentlyLoading) {
            var $row = this.getRowFromId(rowId);
            if ($row.length) {
                return this.openRow($row, mode, blank);
            } else {
                return false;
            }
        }
        this.rowToOpenAfterLoading = [rowId, mode, blank, onlyWhenOpen];
        return true;
    }
    this.updateOpenedRow = function (row_id) {
        dataGrid.rowOpen = true;
        var $row = dataGrid.rowElem(row_id);
        if ($row.length) {
            dataGrid.$open.data("row", $row);
            dataGrid.$rowThatIsOpen = $row;
        }
    };
    this.getOpenedRowId = function () {
        var $openRow = dataGrid.$open.data("row")
        if (typeof $openRow === "undefined" || $openRow === "blank" || !$openRow.length) {
            return null;
        }
        return $openRow.dataGrid().value("row_id");
    }

    this.openRow = function ($row, mode, blank, newWindow, openFirstRowMode, onlyWhenOpen) {

        newWindow = newWindow || false;
        if (dataGrid.currentlyLoading && !dataGrid.allowOpenWhileLoading) {
            return true;
        }
        if (onlyWhenOpen && dataGrid.rowOpen === false) {
            return true;
        }

        mode = mode || null;
        blank = blank || false;
        openFirstRowMode = openFirstRowMode || false;

        if (newWindow || (!dataGrid.disablePushState && $row !== null && $($row).length)) {
            var rowId = $($row).dataGrid().value("row_id");

            var url = window.location.href;

            url = dgUrlParam.add(url, this.rowOpenUrlRowIdName, rowId);
            if (!openFirstRowMode) {
                this.openRowClearUrlParams.forEach(function (urlParamToRemove) {
                    url = dgUrlParam.remove(url, urlParamToRemove);
                });
            }
            if (this.rowOpenUrlRequireGrid) {
                url = dgUrlParam.add(url, this.rowOpenUrlGridParamName, dataGrid.name);
            }
            if (this.openRowModeUpdateUrl) {
                if (mode !== null && mode.length > 0) {
                    url = dgUrlParam.add(url, this.openRowModeUrlParamName, mode);
                } else {
                    url = dgUrlParam.remove(url, this.openRowModeUrlParamName);
                }

            }
            if (newWindow) {
                window.open(url);
                return;
            }
            window.history.pushState({
                dataGrid: "yes",
                mode: "openRow",
                rowId: rowId,
                thisDataGridName: dataGrid.name
            }, document.title, url);
        }
        var $hideOnOpen;
        var $scrollParent = dataGridHelper.getScrollParent(dataGrid.wrapper[0]);
        if (dataGrid.hideGearErrorsOnRowOpen) {
            dataGrid.$open.find("[data-gear-element='error-wrapper']").each(function () {
                dataGridHelper.hideFunction(this, $(this).attr("data-grid-show-function"));
            });
        }
        dataGrid.$open.find("[data-grid-open-mode-required='yes']").each(function () {
            dataGridHelper.hideFunction(this, $(this).attr("data-grid-show-function"));
            var thisMode = JSON.parse($(this).attr("data-grid-mode"));
            if (thisMode === mode || ($.isArray(thisMode) && $.inArray(mode, thisMode) !== -1)) {
                dataGridHelper.showFunction(this, $(this).attr("data-grid-show-function"));
            }
        });
        if ($scrollParent.is("html")) {
            if (parseInt($scrollParent.scrollTop()) === 0) {
                $scrollParent = $("body");
            }
        }
        if (dataGrid.openHide === "_grid") {
            $hideOnOpen = $wrapper;
        } else {
            $hideOnOpen = $(dataGrid.openHide);
        }

        dataGrid.rememberScroll = $scrollParent.scrollTop();
        dataGrid.$rememberScrollDiv = $scrollParent;
        dataGrid.startOpenRow($row, mode, blank);
        if (dataGrid.$open.find("[data-grid-load='yes']").length || dataGrid.onAfterOpenAjaxFunctions.length || dataGrid.ajaxOpenAlways) {
            if (!blank) {
                dataGrid.openRowAjax($row, mode);
            } else if (dataGrid.ajaxOpenBlank) {
                dataGrid.openRowAjax(null, mode);
            }
        }
        $hideOnOpen.hide().addClass("d-none");
        dataGrid.$open.css("display", "flex");
        dataGrid.$open.find("input:not([type='hidden']),textarea,select").filter(":not([readonly])").filter(':visible:first').focus();
        dataGrid.rowOpen = true;
        dataGrid.$rowThatIsOpen = $row;
        if (blank) {
            dataGrid.$open.data("row", "blank");
        } else {
            dataGrid.$open.data("row", $row);
        }

        var openOffset = dataGrid.$open.offset();
        if (typeof openOffset !== "undefined") {
            $scrollParent.scrollTop(dataGrid.$open.offset().top - 100);
        }
        var onOpenFunctionParam = {};
        if (!blank) {
            onOpenFunctionParam = dataGridHelper.getRowData(dataGrid.$open.data("row"));
        }
        dataGrid.preserveElements($(".dg-clear-on-open-close"));
        $(".dg-clear-on-open-close").html("");
        dataGrid.onOpenFunctions.forEach(function (onOpenFunction) {
            onOpenFunction(onOpenFunctionParam, mode);
        });

        dataGrid.$open.find("[data-toggle='collapse']").each(function () {
            var $collapseHandle = $(this);
            var $target = $($collapseHandle.attr("data-target"));
            if (!$target.length) {
                return true;
            }
            if ($target.hasClass("show")) {
                $collapseHandle.removeClass("collapsed");
            } else {
                $collapseHandle.addClass("collapsed");
            }
        });

        if ($.isFunction($.fn.tooltip)) {
            dataGrid.$open.find("[data-toggle='tooltip']").tooltip({ boundary: 'window' });
            dataGrid.$open.find("[data-bs-toggle='tooltip']").tooltip({ boundary: 'window' });
        }

        dataGridHelper.bindGears(dataGrid.$open);

        return dataGrid;
    };
    this.startOpenRow = function ($row, mode, blank) {
        blank = blank || false;
        var row;
        var formattedRow;
        var timeStamps;
        if (blank) {
            row = {};
            formattedRow = {};
            timeStamps = {};
        } else {
            row = dataGridHelper.getRowData($row);
            formattedRow = dataGridHelper.getRowData($row, true);
            timeStamps = dataGridHelper.getRowData($row, "timestamp");
        }

        var $loader = dataGrid.$open.find(".data-grid-open-row-ajax-loader:last");
        var $tabs = dataGrid.$open.find(".data-grid-open-tab");
        if ($tabs.length) {
            $tabs.removeClass("active");
            var $activeTab = $tabs.filter("[data-grid-tab-mode='" + mode + "']");
            if (!$activeTab.length) {
                $activeTab = $tabs.filter("[data-grid-tab-default='yes']");
            }
            if ($activeTab.length) {
                $activeTab.addClass("active");

            }
        }


        dataGrid.$open.find("[data-grid-open-row-set-on-open='yes']").each(function () {
            $(this).val($(this).attr("data-grid-new-value")).change();
        });
        dataGrid.$open.find("[data-grid-open-row-hide-on-open='yes']").each(function () {
            dataGridHelper.hideFunction(this, $(this).attr("data-grid-show-function"));
        });
        dataGrid.$open.find("[data-grid-open-row-show-on-open='yes']").each(function () {
            dataGridHelper.showFunction(this, $(this).attr("data-grid-show-function"));
        });
        dataGrid.$open.find("[data-grid-add-class-on-open='yes']").each(function () {
            $(this).addClass($(this).attr("data-grid-class-to-add"));
        });
        dataGrid.$open.find("[data-grid-remove-class-on-open='yes']").each(function () {
            $(this).removeClass($(this).attr("data-grid-class-to-remove"));
        });
        dataGrid.$open.find("[data-grid-open-row-check-on-open='yes']").prop("checked", true);
        dataGrid.$open.find("[data-grid-open-row-uncheck-on-open='yes']").prop("checked", false);


        dataGrid.$open.find("[data-grid-open-row-hide-empty='yes'][data-grid-load='yes']").each(function () {
            $(this).hide();
        });
        dataGrid.$open.find("[data-grid-open-row-hide-not-empty='yes'][data-grid-load='yes']").each(function () {
            $(this).hide();
        });
        dataGrid.$open.find("[data-grid-open-row-hide-if-same='yes'][data-grid-load='yes']").each(function () {
            $(this).hide();
        });
        dataGrid.$open.find("[data-grid-open-row-hide-if-equal='yes'][data-grid-load='yes']").each(function () {
            $(this).hide();
        });
        dataGrid.$open.find("[data-grid-open-row-hide-if-less-than='yes'][data-grid-load='yes']").each(function () {
            $(this).hide();
        });
        dataGrid.$open.find("[data-grid-open-row-hide-if-greater-than='yes'][data-grid-load='yes']").each(function () {
            $(this).hide();
        });
        dataGrid.$open.find("[data-grid-open-row-hide-empty='yes'][data-grid-load='either']").each(function () {
            $(this).hide();
        });
        dataGrid.$open.find("[data-grid-open-row-hide-not-empty='yes'][data-grid-load='either']").each(function () {
            $(this).hide();
        });
        dataGrid.$open.find("[data-grid-open-row-hide-if-same='yes'][data-grid-load='either']").each(function () {
            $(this).hide();
        });
        dataGrid.$open.find("[data-grid-open-row-hide-if-equal='yes'][data-grid-load='either']").each(function () {
            $(this).hide();
        });
        dataGrid.$open.find("[data-grid-open-row-hide-if-less-than='yes'][data-grid-load='either']").each(function () {
            $(this).hide();
        });
        dataGrid.$open.find("[data-grid-open-row-hide-if-greater-than='yes'][data-grid-load='either']").each(function () {
            $(this).hide();
        });

        dataGridHelper.openRowHideEmpty(dataGrid, row, formattedRow);
        dataGridHelper.openRowHideNotEmpty(dataGrid, row, formattedRow);
        dataGridHelper.openRowHideIfSame(dataGrid, row, formattedRow);
        dataGridHelper.openRowHideIfEqual(dataGrid, row, formattedRow);
        dataGridHelper.openRowHideIfGreaterOrLessThan(dataGrid, row, formattedRow);
        dataGridHelper.openRowHideEmpty(dataGrid, row, formattedRow, "either");
        dataGridHelper.openRowHideNotEmpty(dataGrid, row, formattedRow, "either");
        dataGridHelper.openRowHideIfSame(dataGrid, row, formattedRow, "either");
        dataGridHelper.openRowHideIfEqual(dataGrid, row, formattedRow, "either");
        dataGridHelper.openRowHideIfGreaterOrLessThan(dataGrid, row, formattedRow, "either");

        dataGrid.$open.find("[data-grid-open-row-detail='yes'][data-grid-load='no']").each(function () {
            var defaultValueUsed = false;
            var rowToPullFrom = row;
            var newValue;
            var defaultOnlyOnNew = $(this).attr("data-grid-default-new-only");
            var field = $(this).attr("data-grid-field");
            var isDatetime = $(this).attr("data-grid-datetime");
            var isDate = $(this).attr("data-grid-date");
            var isTime = $(this).attr("data-grid-time");
            var prepend = $(this).attr("data-grid-value-prepend");
            var append = $(this).attr("data-grid-value-append");
            isDatetime = typeof isDatetime === "string" && isDatetime === "yes";
            isDate = typeof isDate === "string" && isDate === "yes";
            isTime = typeof isTime === "string" && isTime === "yes";
            defaultOnlyOnNew = typeof defaultOnlyOnNew === "string" && defaultOnlyOnNew === "yes";

            if ($(this).attr("data-grid-source") === "field") {
                if ($(this).attr("data-grid-formatted") === "yes") {
                    rowToPullFrom = formattedRow;
                }

                if (typeof rowToPullFrom[field] === "undefined" || rowToPullFrom[field].length < 1) {
                    newValue = "";
                } else {
                    newValue = rowToPullFrom[field];
                }
            } else {
                var data = dataGrid.gatherVars();
                newValue = data[field];
            }

            if ($(this).attr("data-grid-first-upper") === "yes" && typeof newValue !== "undefined" && newValue.length > 0) {
                newValue = newValue.charAt(0).toUpperCase() + newValue.slice(1);
            }

            var attrName = $(this).attr("data-grid-attr");

            if (!defaultOnlyOnNew || (typeof row["row_id"] === "undefined" || row["row_id"] === null)) {
                if (typeof newValue === "undefined" || newValue.length < 1) {
                    newValue = $(this).attr("data-grid-default-value");
                    defaultValueUsed = true;
                }
            }

            if (typeof prepend !== "undefined") {
                newValue = prepend + newValue;
            }
            if (typeof append !== "undefined") {
                newValue = newValue + append;
            }

            if (typeof attrName === "undefined" || attrName.length < 1 || attrName === "html") {
                dataGrid.preserveElements($(this));
                if ($(this).attr("data-grid-raw") === "no") {
                    $(this).text(newValue);
                } else {
                    $(this).html(newValue);
                }
            } else {
                if (attrName === "value") {
                    var timestamp;
                    var date;
                    if (typeof timeStamps[field] !== "undefined") {
                        timestamp = parseInt(timeStamps[field]);
                    } else {
                        timestamp = null;
                    }
                    if (isDatetime && !defaultValueUsed) {
                        if (timestamp === null) {
                            newValue = "";
                        } else {
                            date = new Date(timestamp * 1000);
                            newValue = date.toISOString().slice(0, 16);
                        }

                    }
                    if (isDate && !defaultValueUsed) {
                        if (timestamp === null) {
                            newValue = "";
                        } else {
                            date = new Date(timestamp * 1000);
                            newValue = date.toISOString().slice(0, 10);
                        }

                    }
                    if (isTime && !defaultValueUsed) {
                        if (timestamp === null) {
                            newValue = "";
                        } else {
                            date = new Date(timestamp * 1000);
                            newValue = date.toISOString().slice(11, 16);
                        }

                    }
                    if (typeof $(this).data("DateTimePicker") !== "undefined") {
                        $(this).data("DateTimePicker").clear();
                    }
                    $(this).val(newValue).change().keyup();
                } else if (attrName === "summernote") {
                    try {
                        $(this).summernote("code", newValue);
                    } catch (e) {
                        var that = this;
                        setTimeout(function () {
                            $(that).summernote("code", newValue);
                        }, 1000);
                    }
                } else if (attrName === "checked") {
                    var check = false;
                    if (newValue === $(this).attr("data-grid-check-if")) {
                        check = true;
                    }
                    if (typeof $(this).attr("data-grid-checkbox-inverse") !== "undefined" && $(this).attr("data-grid-checkbox-inverse") === "yes") {
                        check = !check;
                    }
                    if (check) {
                        $(this).prop("checked", true).change();
                    } else {
                        $(this).prop("checked", false).change();
                    }
                } else {
                    $(this).attr(attrName, newValue);
                }

            }
        });

        dataGrid.$open.find("[data-grid-open-row-detail='yes'][data-grid-load='yes']").each(function () {
            var loader = $(this).attr("data-grid-open-loader") === "yes";
            var loaderSize = $(this).attr("data-grid-open-loader-size");
            dataGrid.preserveElements($(this));
            if (loader && !blank) {
                var $replace = $loader.clone().show();

                if (loaderSize > 0) {
                    $replace.css({ "font-size": loaderSize + "px" });
                    $replace.find("*").css({ "font-size": loaderSize + "px" });
                }
                $(this).html($replace);
            } else {
                $(this).html("");
            }
        });
    };

    this.addHiddenSearch = function (name, value, skipUrl) {
        skipUrl = typeof skipUrl !== "undefined" ? skipUrl : true;
        var $input = $(".data-grid-input[data-grid-session-id='" + this.id + "'][name='" + name + "']");
        if (!$input.length) {
            $input = $("<input>");
            $input.attr("name", name);
            $input.addClass("data-grid-input");
            $input.attr("data-grid-session-id", this.id);
            $input.attr("type", "hidden");
            $("body").append($input);
            dataGridHelper.bindSearchElements(this, $input);
        }
        if (skipUrl) {
            $input.attr("data-grid-skip-url", "yes");
        }
        $input.val(value);
        $input.change();
    };

    this.clear = function () {
        this.wrapper.find(".data-grid-tbody").remove();
    }

    this.openRowAjax = function ($row, mode) {
        if ($row === null) {
            $row = "blank";
        }
        var row = dataGridHelper.getRowData($row, false, true);
        if (typeof mode !== 'undefined' && mode !== null) {
            row._mode = mode;
        }
        if (dataGrid.rowsArePrerendered) {
            row._rowsArePrerendered = true;
        }
        if ($row !== "blank") {
            row.row_id = $row.attr("data-row-id");
        }
        dataGrid.openAjaxRequests.forEach(function (thisAjaxRequest) {
            thisAjaxRequest.abort();
        });

        if (this.openRowForwardUrlParams.length > 0) {
            var urlParams = new URLSearchParams(window.location.search);

            this.openRowForwardUrlParams.forEach(function (urlParamToForward) {
                var paramFromUrl = urlParams.get(urlParamToForward);
                if (typeof paramFromUrl !== "undefined" && paramFromUrl !== null && paramFromUrl.length > 0) {
                    row[urlParamToForward] = paramFromUrl;
                }
            });
        }
        dataGrid.openAjaxRequests = [];
        var ajaxRequest = $.ajax({
            url: dataGrid.ajaxOpenUrl,
            type: "POST",
            data: row,
            success: function (response) {
                dataGrid.lastAjaxResponse = response;
                dataGrid.$open.find("[data-grid-open-row-detail='yes'][data-grid-load='yes']").each(function () {
                    var field = $(this).attr("data-grid-field");
                    dataGrid.preserveElements($(this));
                    if (typeof response[field] === "undefined" || response[field] === null || response[field].length < 1) {
                        $(this).html("");
                        return true;
                    }

                    var $divToChange = $(this);


                    if ($(this).attr("data-grid-in-iframe") === "yes" && response._iframe[field].cancel !== true) {
                        if (typeof iFrameDom === "undefined" || typeof iFrameDom.replace !== "function") {
                            console.log("iFrameDom function not found. Install 'skeets.iframe-dom' through npm.");
                        } else {
                            iFrameDom.replace($(this), response[field], response._iframe[field]);
                        }
                        return true;
                    }

                    var newValue = response[field];
                    if (typeof newValue === "undefined" || newValue.length < 1) {
                        newValue = $(this).attr("data-grid-default-value");
                    }

                    dataGrid.preserveElements($divToChange);

                    if ($(this).attr("data-grid-raw") === "no") {
                        $divToChange.text(newValue);

                    } else {
                        $divToChange.html(newValue);
                    }


                });

                dataGridHelper.openRowHideEmpty(dataGrid, response, null, true);
                dataGridHelper.openRowHideNotEmpty(dataGrid, response, null, true);
                dataGridHelper.openRowHideIfSame(dataGrid, response, null, true);
                dataGridHelper.openRowHideIfEqual(dataGrid, response, null, true);
                dataGridHelper.openRowHideIfGreaterOrLessThan(dataGrid, response, null, true);
                dataGridHelper.openRowHideEmpty(dataGrid, response, null, "either");
                dataGridHelper.openRowHideNotEmpty(dataGrid, response, null, "either");
                dataGridHelper.openRowHideIfSame(dataGrid, response, null, "either");
                dataGridHelper.openRowHideIfEqual(dataGrid, response, null, "either");
                dataGridHelper.openRowHideIfGreaterOrLessThan(dataGrid, response, null, "either");

                var onOpenFunctionParam = dataGridHelper.getRowData(dataGrid.$open.data("row"));
                dataGridHelper.bindGears(dataGrid.$open);
                dataGrid.onAfterOpenAjaxFunctions.forEach(function (onAfterOpenAjaxFunction) {
                    onAfterOpenAjaxFunction(response, onOpenFunctionParam);
                });
                dataGrid.rowOpenAjaxFinished = true;
            }, error: function (response) {
                if (response.statusText !== "abort") {
                    console.log("Ajax error, response:");
                    console.log(response);
                }
                if (typeof response.responseJSON !==
                    "undefined" &&
                    typeof response.responseJSON.message !==
                    "undefined" &&
                    response.responseJSON.message.length >
                    0 &&
                    typeof toast ===
                    "function") {
                    toast({ message: response.responseJSON.message, type: "danger" });
                } else {
                    if (typeof response.responseText !==
                        "undefined" &&
                        response.responseText.length >
                        0 &&
                        typeof toast ===
                        "function") {
                        toast({ message: response.responseText, type: "danger" });
                    }
                }
                dataGrid.rowOpenAjaxFinished = true;
            }
        });
        dataGrid.openAjaxRequests.push(ajaxRequest);

    };

    this.initBindings($dataGridElem);
    dataGridHelper.removeDuplicate(this.id);
    allDataGrids.push(this);
};


var dataGridHelper = {
    boundPopState: false,
    $resizingColumn: null,
    allowSorting: true,
    // safe to call anytime...
    initAll: function () {
        dataGridHelper.auto($("body"));
    },

    auto: function ($elem) {
        $elem.find(".data-grid-wrapper").each(function () {
            // Is this datagrid already set up?
            var alreadyExists = $(this).dataGrid();
            if (alreadyExists !== false && alreadyExists !== null) {
                // Yes, skip it...
                return; // equivilant to "continue" in jquery each
            }
            var thisDataGrid = new DataGrid($(this));
            thisDataGrid.gatherVars();

            if (thisDataGrid.openFirstRow) {
                thisDataGrid.openRow(thisDataGrid.getRowNumElem(1), thisDataGrid.openRowMode, false, false, true);
            }
        });
        $elem.find("[data-grid-button-sort='yes']")
            .off("click", dataGridHelper.sortButtonWrapperClick)
            .click(dataGridHelper.sortButtonWrapperClick)
            .find("a")
            .off("click", dataGridHelper.sortButtonWrapperClick)
            .click(dataGridHelper.sortButtonClick);

        $elem.find("[data-grid-toggle-children='yes']")
            .off("click", dataGridHelper.toggleAllChildRowsTrigger)
            .click(dataGridHelper.toggleAllChildRowsTrigger);

        $elem.find("[data-grid-button-search='yes']").off("click", dataGridHelper.searchButtonClick).click(dataGridHelper.searchButtonClick);

        $elem.find(".data-grid-checkbox-row").prop("disabled", false);
        $elem.find(".data-grid-check-all").prop("disabled", false);


        $elem.find(".data-grid-corner-loader").hide();
        $elem.find(".data-grid-corner-refresh").show();
        $elem.find(".data-grid-corner-display-settings").css({ visibility: "visible" });
        $elem.find(".data-grid-download-csv").css({ visibility: "visible" });
    },

    stickyHeaderResizeFix: function () {
        allDataGrids.forEach(function (thisDataGrid) {
            if (typeof thisDataGrid.syncStickyHeaderMode === "function") {
                thisDataGrid.syncStickyHeaderMode();
            }
            var stickyHeader = getStickyHeader(thisDataGrid.wrapper);
            if (stickyHeader !== false) {
                stickyHeader.resize();
            }
        });
    },

    openRowHideEmpty: function (dataGrid, row, formattedRow, ajax) {
        ajax = ajax || false;
        var selectorAppend = "[data-grid-load='no']";
        if (ajax === true || ajax === "yes") {
            selectorAppend = "[data-grid-load='yes']";
        }
        if (ajax === "either") {
            selectorAppend = "[data-grid-load='either']";
        }

        dataGrid.$open.find("[data-grid-open-row-hide-empty='yes']" + selectorAppend).each(function () {
            var rowToPullFrom = row;
            if (ajax && $(this).attr("data-grid-formatted") === "yes") {
                rowToPullFrom = formattedRow;
            }
            var fieldToCheck = $(this).attr("data-grid-field");
            if (typeof rowToPullFrom[fieldToCheck] === "undefined" || rowToPullFrom[fieldToCheck].trim().length < 1) {
                if (ajax === "either") {
                    return;
                }
                dataGridHelper.hideFunction(this, $(this).attr("data-grid-show-function"));
            } else {
                dataGridHelper.showFunction(this, $(this).attr("data-grid-show-function"));
            }
        });
    },
    openRowHideNotEmpty: function (dataGrid, row, formattedRow, ajax) {
        ajax = ajax || false;
        var selectorAppend = "[data-grid-load='no']";
        if (ajax === true || ajax === "yes") {
            selectorAppend = "[data-grid-load='yes']";
        }
        if (ajax === "either") {
            selectorAppend = "[data-grid-load='either']";
        }

        dataGrid.$open.find("[data-grid-open-row-hide-not-empty='yes']" + selectorAppend).each(function () {
            var rowToPullFrom = row;
            if (ajax && $(this).attr("data-grid-formatted") === "yes") {
                rowToPullFrom = formattedRow;
            }
            var fieldToCheck = $(this).attr("data-grid-field");
            if (typeof rowToPullFrom[fieldToCheck] === "undefined" || rowToPullFrom[fieldToCheck].trim().length < 1) {
                dataGridHelper.showFunction(this, $(this).attr("data-grid-show-function"));
            } else {
                if (ajax === "either") {
                    return;
                }
                dataGridHelper.hideFunction(this, $(this).attr("data-grid-show-function"));
            }
        });

    },
    openRowHideIfSame: function (dataGrid, row, formattedRow, ajax) {
        ajax = ajax || false;
        var selectorAppend = "[data-grid-load='no']";
        if (ajax === true || ajax === "yes") {
            selectorAppend = "[data-grid-load='yes']";
        }
        if (ajax === "either") {
            selectorAppend = "[data-grid-load='either']";
        }


        dataGrid.$open.find("[data-grid-open-row-hide-if-same='yes']" + selectorAppend).each(function () {
            var rowToPullFrom = row;
            if (ajax && $(this).attr("data-grid-formatted") === "yes") {
                rowToPullFrom = formattedRow;
            }
            var fieldA = $(this).attr("data-grid-field-a");
            var fieldB = $(this).attr("data-grid-field-b");
            if (typeof rowToPullFrom[fieldA] === "undefined" || typeof rowToPullFrom[fieldB] === "undefined") {
                if ((typeof rowToPullFrom[fieldA] === "undefined" || rowToPullFrom[fieldA].length < 1) &&
                    (typeof rowToPullFrom[fieldB] === "undefined" || rowToPullFrom[fieldB].length < 1)) {
                    if (ajax === "either") {
                        return;
                    }
                    dataGridHelper.hideFunction(this, $(this).attr("data-grid-show-function"));
                } else {
                    dataGridHelper.showFunction(this, $(this).attr("data-grid-show-function"));
                }
            } else {
                if (rowToPullFrom[fieldA] === rowToPullFrom[fieldB]) {
                    if (ajax === "either") {
                        return;
                    }
                    dataGridHelper.hideFunction(this, $(this).attr("data-grid-show-function"));
                } else {
                    dataGridHelper.showFunction(this, $(this).attr("data-grid-show-function"));
                }
            }
        });

    },
    openRowHideIfEqual: function (dataGrid, row, formattedRow, ajax) {
        ajax = ajax || false;
        var selectorAppend = "[data-grid-load='no']";
        if (ajax === true || ajax === "yes") {
            selectorAppend = "[data-grid-load='yes']";
        }
        if (ajax === "either") {
            selectorAppend = "[data-grid-load='either']";
        }


        dataGrid.$open.find("[data-grid-open-row-hide-if-equal='yes']" + selectorAppend).each(function () {
            var showIt = false;
            var rowToPullFrom = row;
            if (ajax && $(this).attr("data-grid-formatted") === "yes") {
                rowToPullFrom = formattedRow;
            }
            var fieldA = $(this).attr("data-grid-field-a");
            var varToTestAgainst = JSON.parse($(this).attr("data-grid-equal-to-var"));
            if (typeof rowToPullFrom[fieldA] === "undefined" || typeof varToTestAgainst === "undefined") {
                if ((typeof rowToPullFrom[fieldA] === "undefined" || rowToPullFrom[fieldA].length < 1) &&
                    (typeof varToTestAgainst === "undefined" || varToTestAgainst.length < 1)) {
                    showIt = false;
                } else {
                    if (!Array.isArray(varToTestAgainst)) {
                        showIt = true;
                    } else {
                        showIt = true;
                        varToTestAgainst.forEach(function (singleVarToTestAgainst) {
                            if (singleVarToTestAgainst.length < 1) {
                                showIt = false;
                            }
                        });
                    }
                }
            } else {
                if (!Array.isArray(varToTestAgainst)) {
                    if ($(this).attr("data-grid-hide-if-contain") === "yes") {
                        showIt = rowToPullFrom[fieldA].indexOf(varToTestAgainst) === -1;
                    } else {
                        showIt = rowToPullFrom[fieldA] !== varToTestAgainst;
                    }

                } else {
                    showIt = true;
                    varToTestAgainst.forEach(function (singleVarToTestAgainst) {
                        if ($(this).attr("data-grid-hide-if-contain") === "yes") {
                            if (rowToPullFrom[fieldA].indexOf(varToTestAgainst) !== -1) {
                                showIt = false;
                            }
                        } else {
                            if (rowToPullFrom[fieldA] === singleVarToTestAgainst) {
                                showIt = false;
                            }
                        }
                    });
                }
            }

            if ($(this).attr("data-grid-open-row-negate-if-equal") === "yes") {
                showIt = !showIt;
            }

            if (showIt) {
                dataGridHelper.showFunction(this, $(this).attr("data-grid-show-function"));
            } else {
                if (ajax === "either") {
                    return;
                }
                dataGridHelper.hideFunction(this, $(this).attr("data-grid-show-function"));
            }
        });

    },
    openRowHideIfGreaterOrLessThan: function (dataGrid, row, formattedRow, ajax) {
        ajax = ajax || false;
        var selectorAppend = "[data-grid-load='no']";
        if (ajax === true || ajax === "yes") {
            selectorAppend = "[data-grid-load='yes']";
        }
        if (ajax === "either") {
            selectorAppend = "[data-grid-load='either']";
        }


        dataGrid.$open.find("[data-grid-open-row-hide-if-less-than='yes']" + selectorAppend).each(function () {
            var showIt = false;
            var rowToPullFrom = row;
            if (ajax && $(this).attr("data-grid-formatted") === "yes") {
                rowToPullFrom = formattedRow;
            }
            var fieldA = $(this).attr("data-grid-field-a");
            var varToTestAgainst = parseFloat($(this).attr("data-grid-compare-var"));
            if (typeof rowToPullFrom[fieldA] === "undefined" || typeof varToTestAgainst === "undefined") {
                // If either value or comparison value is empty... not really sure what should happen. :P
                showIt = false;
            } else {
                var value = parseFloat(rowToPullFrom[fieldA]);
                if ($(this).attr("data-grid-comparison-inclusive") === "yes") {
                    // the inclusive looks backwards here, but it's not -- the function is "hide", and this variable is "show",
                    // so it ends up looking backwards :P
                    showIt = varToTestAgainst < value;
                } else {
                    showIt = varToTestAgainst <= value;
                }
            }

            if ($(this).attr("data-grid-open-row-negate-if-equal") === "yes") {
                showIt = !showIt;
            }

            if (showIt) {
                dataGridHelper.showFunction(this, $(this).attr("data-grid-show-function"));
            } else {
                if (ajax === "either") {
                    return;
                }
                dataGridHelper.hideFunction(this, $(this).attr("data-grid-show-function"));
            }
        });
        dataGrid.$open.find("[data-grid-open-row-hide-if-greater-than='yes']" + selectorAppend).each(function () {
            var showIt = false;
            var rowToPullFrom = row;
            if (ajax && $(this).attr("data-grid-formatted") === "yes") {
                rowToPullFrom = formattedRow;
            }
            var fieldA = $(this).attr("data-grid-field-a");
            var varToTestAgainst = parseFloat($(this).attr("data-grid-compare-var"));
            if (typeof rowToPullFrom[fieldA] === "undefined" || typeof varToTestAgainst === "undefined") {
                // If either value or comparison value is empty... not really sure what should happen. :P
                showIt = false;
            } else {
                var value = parseFloat(rowToPullFrom[fieldA]);
                if ($(this).attr("data-grid-comparison-inclusive") === "yes") {
                    // the inclusive looks backwards here, but it's not -- the function is "hide", and this variable is "show",
                    // so it ends up looking backwards :P
                    showIt = varToTestAgainst > value;
                } else {
                    showIt = varToTestAgainst >= value;
                }
            }

            if ($(this).attr("data-grid-open-row-negate-if-equal") === "yes") {
                showIt = !showIt;
            }

            if (showIt) {
                dataGridHelper.showFunction(this, $(this).attr("data-grid-show-function"));
            } else {
                if (ajax === "either") {
                    return;
                }
                dataGridHelper.hideFunction(this, $(this).attr("data-grid-show-function"));
            }
        });

    },

    updateTbodyLastTr: function ($tbody) {
        if (!$tbody.is("tbody")) {
            $tbody = $tbody.closest("tbody");
        }
        $tbody.find(".data-grid-last-row-in-tbody").removeClass("data-grid-last-row-in-tbody");
        $tbody.find("tr:visible:last").addClass("data-grid-last-row-in-tbody");
    },
    showFunction: function (element, type) {
        if (typeof type !== "string" || type.length < 1) {
            type = "jquery";
        }
        switch (type) {
            case "bootstrap":
                $(element).addClass("show");
                break;
            case "collapse":
                $(element).collapse("show");
                break;
            case "jquery":
            default:
                $(element).show();
                break;
        }
    },
    hideFunction: function (element, type) {
        if (typeof type !== "string" || type.length < 1) {
            type = "jquery";
        }
        switch (type) {
            case "bootstrap":
                $(element).removeClass("show");
                break;
            case "collapse":
                $(element).collapse("hide");
                break;
            case "jquery":
            default:
                $(element).hide();
                break;
        }
    },


    saveGridColWidth: function (field) {
        var dataGrid = dataGridHelper.$resizingColumn.dataGrid();
        if (dataGrid.horizontalScrollVisible()) {
            // don't save if there's a horizontal scroll bar...
            return;
        }
        var cookieName = dataGrid.name + "_" + "col_width_" + field;
        var $cell = dataGrid.wrapper.find("th[data-field='" + field + "']");
        if (!$cell.length) {
            $cell = dataGrid.wrapper.find("td[data-match-width='" + field + "']");
            if (!$cell.length) {
                $cell = dataGrid.wrapper.find("td[data-grid-field='" + field + "']");
            }
        }
        var cookieValue = $cell.outerWidth();
        Cookies.set(cookieName, cookieValue, { expires: 1 });
    },
    dataGridColumnMouseMove: function (e) {
        if (!dataGridHelper.$resizingColumn.length) {
            dataGridHelper.dataGridColumnMouseUp();
            return true;
        }
        var dataGrid = dataGridHelper.$resizingColumn.dataGrid();
        var widthInverse = dataGridHelper.$resizingColumn.attr("data-width-inverse");
        var inverseMode = false;

        var $elementToResize = dataGridHelper.$resizingColumn;
        if (typeof getStickyHeader === 'function') {
            var stickyHeader = getStickyHeader(dataGrid.wrapper);
        }
        if (stickyHeader !== false) {
            if (stickyHeader.floating) {
                $elementToResize = stickyHeader.getHeaderCellPlaceholder(dataGridHelper.$resizingColumn);
            }
        }


        if (typeof widthInverse !== "undefined" && widthInverse.length > 0) {
            inverseMode = true;
        }

        var newWidth = e.pageX - dataGridHelper.$resizingColumn.offset().left - 6 + (parseInt(dataGridHelper.$resizingColumn.css("padding-left")));
        var field = dataGridHelper.$resizingColumn.attr("data-field");
        var $column = dataGrid.wrapper.find("td[data-match-width='" + field + "']");
        if (!$column.length) {
            $column = dataGrid.wrapper.find("td[data-grid-field='" + field + "']");
        }

        if (newWidth < 50) {
            newWidth = 50;
        }
        var oldWidth = $elementToResize.outerWidth();
        if (!inverseMode) {
            $elementToResize.css({ width: newWidth, "max-width": newWidth, "min-width": newWidth });
            $column.css({ width: newWidth, "max-width": newWidth, "min-width": newWidth });
        } else {
            var changeWidthBy = oldWidth - newWidth;
            var minWidth = $elementToResize.css("min-width");
            if (newWidth < parseInt(minWidth)) {
                return true;
            }
            var $targetColumn = dataGrid.wrapper.find("td[data-match-width='" + widthInverse + "']");
            var $targetHeader = dataGrid.wrapper.find("th[data-field='" + widthInverse + "']");
            var targetNewWidth;
            if (!$targetColumn.length) {
                $targetColumn = dataGrid.wrapper.find("td[data-grid-field='" + widthInverse + "']");
            }
            if ($targetHeader.length) {
                targetNewWidth = $targetHeader.outerWidth() + changeWidthBy;
            } else {
                targetNewWidth = $targetColumn.outerWidth() + changeWidthBy;
            }
            if (targetNewWidth < 50) {
                targetNewWidth = 50;
            }
            $targetHeader.css({ width: targetNewWidth, "max-width": targetNewWidth, "min-width": targetNewWidth });
            $targetColumn.css({ width: targetNewWidth, "max-width": targetNewWidth, "min-width": targetNewWidth });
        }

        if (typeof getStickyHeader === 'function') {
            if (stickyHeader !== false) {
                if (stickyHeader.floating) {
                    stickyHeader.resize();
                }
            }
        }

    },
    dataGridColumnFinalizeWidths: function () {
        // What does this function do? Just makes the CSS for width related properties match reality.
        if (!dataGridHelper.$resizingColumn.length) {
            return true;
        }
        var dataGrid = dataGridHelper.$resizingColumn.dataGrid();
        var widthInverse = dataGridHelper.$resizingColumn.attr("data-width-inverse");
        var inverseMode = false;

        var $elementToResize = dataGridHelper.$resizingColumn;
        if (typeof getStickyHeader === 'function') {
            var stickyHeader = getStickyHeader(dataGrid.wrapper);
        }
        if (stickyHeader !== false) {
            if (stickyHeader.floating) {
                $elementToResize = stickyHeader.getHeaderCellPlaceholder(dataGridHelper.$resizingColumn);
            }
        }
        if (typeof widthInverse !== "undefined" && widthInverse.length > 0) {
            inverseMode = true;
        }

        var field = dataGridHelper.$resizingColumn.attr("data-field");
        var $column = dataGrid.wrapper.find("td[data-match-width='" + field + "']");
        if (!$column.length) {
            $column = dataGrid.wrapper.find("td[data-grid-field='" + field + "']");
        }

        if (!inverseMode) {
            var elementToResizeWidth = $elementToResize.outerWidth();
            var columnWidth = $column.outerWidth();
            $elementToResize.css({
                width: elementToResizeWidth,
                "max-width": elementToResizeWidth,
                "min-width": elementToResizeWidth
            });
            $column.css({ width: columnWidth, "max-width": columnWidth, "min-width": columnWidth });
        } else {
            var $targetColumn = dataGrid.wrapper.find("td[data-match-width='" + widthInverse + "']");
            var $targetHeader = dataGrid.wrapper.find("th[data-field='" + widthInverse + "']");

            if (!$targetColumn.length) {
                $targetColumn = dataGrid.wrapper.find("td[data-grid-field='" + widthInverse + "']");
            }

            var targetHeaderWidth = $targetHeader.outerWidth();
            var targetColumnWidth = $targetColumn.outerWidth();
            $targetHeader.css({
                width: targetHeaderWidth,
                "max-width": targetHeaderWidth,
                "min-width": targetHeaderWidth
            });
            $targetColumn.css({
                width: targetColumnWidth,
                "max-width": targetColumnWidth,
                "min-width": targetColumnWidth
            });
        }

    },
    dataGridColumnMouseUp: function () {
        dataGridHelper.dataGridColumnFinalizeWidths();
        var field = dataGridHelper.$resizingColumn.attr("data-width-inverse");
        var widthInverse = dataGridHelper.$resizingColumn.attr("data-width-inverse");
        if (typeof widthInverse === "undefined" || widthInverse.length < 1) {
            field = dataGridHelper.$resizingColumn.attr("data-field");
        }
        $(document).off("mousemove", dataGridHelper.dataGridColumnMouseMove);
        $(document).off("mouseup", dataGridHelper.dataGridColumnMouseUp);
        dataGridHelper.saveGridColWidth(field);
        // only way to prevent this from triggering the sort on release of mouse button...
        dataGridHelper.allowSorting = false;
        setTimeout(function () {
            dataGridHelper.allowSorting = true;
        }, 100);
        dataGridHelper.$resizingColumn.closest("tr").find("td, th").each(function () {
            $(this).css("cursor", $(this).data("original-cursor"));
        });
    },
    dataGridColumnMouseDown: function () {
        dataGridHelper.$resizingColumn.closest("tr").find("td, th").each(function () {
            $(this).data("original-cursor", $(this).css("cursor"));
            $(this).css("cursor", "col-resize");
        });


    },
    getScrollParent: function (element) {
        var style = getComputedStyle(element);
        var excludeStaticParent = style.position === "absolute";

        if (style.position === "fixed") {
            return $("html");
        }
        for (var parent = element; (parent = parent.parentElement);) {
            style = getComputedStyle(parent);
            if (excludeStaticParent && style.position === "static") {
                continue;
            }
            if (/(auto|scroll)/.test(style.overflow + style.overflowY) && parent.scrollHeight > parent.clientHeight) {
                return $(parent);
            }
        }

        return $("html");
    },
    checkDataGrids: function () {
        var index = allDataGrids.length - 1;
        while (index >= 0) {
            if (!document.body.contains(allDataGrids[index].wrapper[0])) {
                allDataGrids[index].removeFloatLoader();
                allDataGrids.splice(index, 1);
            }

            index -= 1;
        }

    },
    getRowData: function ($row, formatted, ajaxOpen) {
        if (typeof formatted === "undefined" || (formatted !== true && formatted !== "timestamp")) {
            formatted = false;
        }
        if (typeof ajaxOpen === "undefined" || ajaxOpen !== true) {
            ajaxOpen = false;
        }
        var selector = ".data-grid-data-single";
        if (ajaxOpen) {
            selector = ".data-grid-ajax-open-param";
        }
        var output = {};
        if ($row === "blank") {
            return output;
        }
        $row.find(selector).each(function () {
            var value = dataGridHelper.getCellValue($(this), formatted);
            if (formatted === "timestamp" && (typeof value === "undefined" || value === "")) {
                return true;
            }

            output[$(this).attr("data-grid-field")] = value;
        });
        if (formatted !== "timestamp") {
            output["row_id"] = $row.attr("data-row-id");
        }
        return output;
    },
    getRowDataValue: function ($row, value) {
        if (value === "row_id") {
            return $row.attr("data-row-id");
        }

        var $cell = $row.find(".data-grid-data-single[data-grid-field=" + value + "]");
        if (!$cell.length) {
            return false;
        }
        return dataGridHelper.getCellValue($cell);
    },
    showChildRow: function ($row) {
        $row.find(".data-grid-row-child,.data-grid-sub-row-toggle").attr("data-visible", "yes").show();
        $row.find(".data-grid-hide-on-child-hide").show();
        $row.find(".data-grid-hide-on-child-show").hide();
        dataGridHelper.updateTbodyLastTr($row);

        $row.find(".data-grid-expand-with-child").each(function () {
            var currentRowSpan = $(this).attr("rowspan");
            $(this).attr("rowspan", currentRowSpan + 1);
        });
        if (typeof stickyHeaderResize === 'function') {
            stickyHeaderResize($row.closest(".data-grid-wrapper"));
        }

        return true;
    },
    hideChildRow: function ($row) {
        $row.find(".data-grid-row-child,.data-grid-sub-row-toggle").attr("data-visible", "no").hide();
        $row.find(".data-grid-hide-on-child-show").show();
        $row.find(".data-grid-hide-on-child-hide").hide();
        dataGridHelper.updateTbodyLastTr($row);
        $row.find(".data-grid-expand-with-child").each(function () {
            var currentRowSpan = $(this).attr("rowspan");
            $(this).attr("rowspan", currentRowSpan - 1);
        });
        if (typeof stickyHeaderResize === 'function') {
            stickyHeaderResize($row.closest(".data-grid-wrapper"));
        }
        return true;
    },
    toggleChildRow: function ($row) {
        if ($row.find(".data-grid-row-child,.data-grid-sub-row-toggle").attr("data-visible") === "yes") {
            this.hideChildRow($row);
        } else {
            this.showChildRow($row);
        }
        return true;
    },
    getCellValue: function ($cell, formatted) {
        if (typeof formatted === "undefined" || (formatted !== true && formatted !== "timestamp")) {
            formatted = false;
        }

        // This means the formatted & JS values were the same, and the value is only stored in the JS side.
        if (!$cell.find(".data-grid-cell").length && formatted !== "timestamp") {
            formatted = false;
        }

        if (formatted && formatted !== "timestamp") {
            var $inner = $cell.find(".data-grid-cell-inner");
            if ($inner.length) {
                return $inner.html().trim();
            }
            return $cell.html().trim();
        }
        var value;
        if (formatted === "timestamp") {
            return $cell.attr("data-grid-timestamp");
        }

        value = $cell.attr("data-grid-value");
        if (value.length < 1 && !this.jsDefaultToFormatted) {
            return "";
        }
        if (value.length < 1) {
            value = $cell.text().trim();
        }
        return value;
    },
    removeDuplicate: function (id) {
        allDataGrids.forEach(function (dataGrid, index, array) {
            if (dataGrid.id === id) {
                array.splice(index, 1);
            }
        });
    },
    getDataGrid: function (id) {
        var output = null;
        allDataGrids.forEach(function (dataGrid) {
            if (dataGrid.id === id) {
                output = dataGrid;
                return false;
            }
        });
        return output;
    },
    getDataGridFromName: function (name) {
        var output = null;
        allDataGrids.forEach(function (dataGrid) {
            if (dataGrid.name === name) {
                output = dataGrid;
                return false;
            }
        });
        return output;
    },
    bindPaginationAjax: function (dataGrid, $dataGridElem) {
        $dataGridElem.find(".data-grid-pagination-wrapper").on("click", "a", function (e) {
            var page = $(this).attr("data-grid-page");
            if (typeof page === "undefined" || page.length < 1) {
                return true;
            }
            if (dataGrid.search(page)) {
                e.preventDefault();
            }


        });
    },
    bindPageSizeSelect: function (dataGrid, $dataGridElem) {
        $dataGridElem.find(".data-grid-page-size-select").on("change", function (e) {
            var pageSize = $(this).val();
            if (typeof pageSize === "undefined" || pageSize.length < 1) {
                return true;
            }
            if (dataGrid.search()) {
                e.preventDefault();
            }


        });
    },
    bindCheckboxes: function (dataGrid, $dataGridElem) {
        var $checkAll = $dataGridElem.find(".data-grid-check-all");
        $checkAll.on("change", function (e) {
            var $allCheckboxes = dataGrid.wrapper.find(".data-grid-checkbox-row");
            if ($(this).is(":checked")) {
                $allCheckboxes.prop("checked", true);
            } else {
                $allCheckboxes.prop("checked", false);
            }

            $($allCheckboxes[0]).change();


        });
        $dataGridElem.find(".data-grid-checkbox-row,.data-grid-checkbox-query-input").on("change", function (e) {
            var numChecked = dataGrid.wrapper.find(".data-grid-checkbox-row:checked:not(:disabled)").length;
            var $queryCheckbox = $(".data-grid-checkbox-query-input[data-grid-session-id='" + dataGrid.id + "']");

            var uncheckedExists = dataGrid.wrapper.find(".data-grid-checkbox-row:not(:checked):not(:disabled)").length;
            var checkedExists = dataGrid.wrapper.find(".data-grid-checkbox-row:checked:not(:disabled)").length;
            if (checkedExists) {
                dataGrid.wrapper.find(".data-grid-header-bulk-hide").hide();
                dataGrid.wrapper.find(".data-grid-header-bulk-show").show();
                if (typeof stickyHeaderResize === 'function') {
                    stickyHeaderResize(dataGrid.wrapper);
                }
            } else {
                dataGrid.wrapper.find(".data-grid-checkbox-query-wrapper").hide();
                dataGrid.wrapper.find(".data-grid-header-bulk-show").hide();
                dataGrid.wrapper.find(".data-grid-header-bulk-hide").show();
                if (typeof stickyHeaderResize === 'function') {
                    stickyHeaderResize(dataGrid.wrapper);
                }
            }
            if (checkedExists && !uncheckedExists) {
                $checkAll.prop("checked", true);
            } else {
                $checkAll.prop("checked", false);
            }
            // check if there are more records available for selection
            var moreRecords = false;
            if ($queryCheckbox.length) {
                var total = $queryCheckbox.attr("data-record-total");
                total = total.replace(/,/g, '');

                // check if "total" has a plus sign at the end -- indicates there are more records available
                if (total.slice(-1) === "+") {
                    moreRecords = true;
                } else {
                    if (numChecked < parseInt(total)) {
                        moreRecords = true;
                    }
                }
            }
            if (checkedExists && !uncheckedExists && moreRecords) {
                dataGrid.wrapper.find(".data-grid-checkbox-query-wrapper").show();
            } else {
                $queryCheckbox.prop("checked", false);
                dataGrid.wrapper.find(".data-grid-checkbox-query-wrapper").hide();
            }
            $(".data-grid-num-checked-disp[data-grid-session-id='" + dataGrid.id + "']").each(function () {
                var template;
                if (numChecked === 1) {
                    template = $(this).attr("data-single");
                } else {
                    if (numChecked === 0) {
                        template = $(this).attr("data-zero");
                    }
                    if (typeof template === "undefined" || template === null || template.length < 1) {
                        template = $(this).attr("data-plural");
                    }
                }
                if (typeof template === "undefined" || template === null || template.length < 1) {
                    template = "{#}";
                }
                var numDisplay = numChecked;

                if ($queryCheckbox.length && $queryCheckbox.is(":checked")) {
                    numDisplay = $queryCheckbox.attr("data-record-total");
                }
                $(this).attr("data-single");
                $(this).text(template.replace("{#}", numDisplay));
            });

        });
        $dataGridElem.find(".data-grid-checkbox-row").on("click", function (e) {
            if (e.shiftKey) {
                var $thisTbody = $(this).closest("tbody");
                var $lastTbody = dataGrid.$lastCheckedCheckbox.closest("tbody");
                if ($thisTbody.is($lastTbody)) {
                    return true;
                }
                var $allTbodies;
                if ($thisTbody.nextAll().filter($lastTbody).length !== 0) {
                    $allTbodies = $thisTbody.nextUntil($lastTbody).add($thisTbody).add($lastTbody);
                } else {
                    $allTbodies = $lastTbody.nextUntil($thisTbody).add($thisTbody).add($lastTbody);
                }
                if ($(this).is(":checked")) {
                    $allTbodies.find(".data-grid-checkbox-row").prop("checked", true);
                } else {
                    $allTbodies.find(".data-grid-checkbox-row").prop("checked", false);
                }


            }
            dataGrid.$lastCheckedCheckbox = $(this);
        });
        $dataGridElem.find(".data-grid-checkbox-row-wrapper").mousedown(function (e) {
            e.preventDefault();
            $(":focus").blur();
            $(this).find(".data-grid-checkbox-row").focus();
        });
        $dataGridElem.find(".data-grid-checkbox-row-wrapper").click(function (e) {
            if ($(e.target).is("input")) {
                return true;
            }
            e.preventDefault();
            var clickEvent = new MouseEvent('click', {
                'view': window,
                'bubbles': true,
                'cancelable': true,
                'shiftKey': e.shiftKey
            });

            // body[0].dispatchEvent(clickEvent);
            $(this).find(".data-grid-checkbox-row")[0].dispatchEvent(clickEvent);
            // delete jQuery.event.special.click.trigger; // this "fixes" a jquery bug... :P
            // $(this).find(".data-grid-checkbox-row").trigger($.Event('click', {shiftKey: e.shiftKey}));


            // var $checkbox = $(this).find("input");
            // $checkbox.prop("checked", !$checkbox.prop("checked"));
            // $checkbox.change();
        });
    },
    addAdditionalBinding: function (dataGrid, settings) {
        dataGridHelper.bindAdditionalSingle(dataGrid, settings, dataGrid.wrapper);
        dataGrid.additionalBindingFunctions.push(settings);
    },
    bindRefreshElements: function (dataGrid, $dataGridElem) {
        $dataGridElem.find(".data-grid-corner-refresh").on("click", function (e) {
            if (dataGrid.search()) {
                e.preventDefault();
                e.stopPropagation();
            }
        });
    },
    bindChildRowControlElements: function (dataGrid, $dataGridElem) {
        $dataGridElem.find("[data-grid-toggle-children='yes']")
            .off("click", dataGridHelper.toggleAllChildRowsTrigger)
            .click(dataGridHelper.toggleAllChildRowsTrigger);

        $dataGridElem.find(".data-grid-show-child-row").on("click", function (e) {
            dataGridHelper.showChildRow($(this).closest("tbody"));
            e.stopPropagation();
        });
        $dataGridElem.find(".data-grid-hide-child-row").on("click", function (e) {
            dataGridHelper.hideChildRow($(this).closest("tbody"));
            e.stopPropagation();
        });
        $dataGridElem.find(".data-grid-child-row-toggle").on("click", function (e) {
            if ($(e.target).closest(".data-grid-checkbox-row-wrapper").length) {
                return true;
            }
            if ($(e.target).closest(".data-grid-no-child-open").length) {
                return true;
            }
            dataGridHelper.toggleChildRow($(this).closest("tbody"));
            e.stopPropagation();
        });
    },
    bindSortElements: function (dataGrid, $dataGridElem) {
        $dataGridElem.find(".data-grid-header-cell").off("click", dataGridHelper.sortButtonWrapperClick).click(dataGridHelper.sortButtonWrapperClick);

        $dataGridElem.find(".data-grid-resize-column").on("mousedown", function (e) {
            dataGridHelper.$resizingColumn = $(this).closest("th");
            dataGridHelper.dataGridColumnMouseDown();
            $(document).on("mousemove", dataGridHelper.dataGridColumnMouseMove);
            $(document).on("mouseup", dataGridHelper.dataGridColumnMouseUp);
        });

        $dataGridElem.find(".data-grid-count-cap-warning-wrapper").on("closed.bs.alert", function () {
            $dataGridElem.find(".data-grid-hide-count-cap-warning-wrapper").show();
        });

        $dataGridElem.find(".data-grid-hide-count-cap-warning").click(function () {
            var cookieNamePiece = "hide_count_cap_warning";
            var cookieName = dataGrid.name + "_" + cookieNamePiece;
            var cookieValue = "yes";
            Cookies.set(cookieName, cookieValue, { expires: 36500 });
            $(this).closest(".alert").alert("close");
        });


        $dataGridElem.find(".data-grid-sort").on("click", dataGridHelper.sortButtonClick);
    },
    bindLinkElements: function (dataGrid, $dataGridElem) {
        $dataGridElem.find(".data-grid-change-input").off("click", dataGridHelper.searchButtonClick).click(dataGridHelper.searchButtonClick);
    },


    bindCookieButtons: function (dataGrid, $dataGridElem) {
        $dataGridElem.find(".data-grid-open-settings-dialog").click(function (e) {
            e.preventDefault();
            dataGrid.openSettingsModal();
        });

        if (dataGrid.settingsModal.data("bound") === "yes") {
            return true;
        }
        dataGrid.settingsModal.data("bound", "yes");
        dataGrid.settingsModal.find(".data-grid-reset-col-width").click(function (e) {
            dataGrid.forgetColumnWidths();
            dataGrid.search();
        });
        dataGrid.settingsModal.find(".data-grid-reset-all-settings").click(function (e) {
            dataGrid.settingsModal.find(".data-grid-reset-col-width").click();
            dataGrid.settingsModal.find(".data-grid-set-cookie-radio").each(function () {
                var cookieNamePiece = $(this).attr("data-grid-cookie");
                Cookies.remove(dataGrid.name + "_" + cookieNamePiece);
            });
            dataGrid.settingsModal.find(".data-grid-set-cookie-checkbox").each(function () {
                var cookieNamePiece = $(this).attr("data-grid-cookie");
                Cookies.remove(dataGrid.name + "_" + cookieNamePiece);
            });
            Cookies.remove(dataGrid.name + "_" + "hide_count_cap_warning");
            dataGrid.settingsModal.find("label.active").removeClass("active");
            dataGrid.settingsModal.find("input[data-grid-cookie='fontsize'][data-grid-cookie-value='" + dataGrid.defaultFontSize + "']")
                .prop("checked", true)
                .closest("label")
                .addClass("active");
            dataGrid.settingsModal.find("input[data-grid-cookie='spacing'][data-grid-cookie-value='" + dataGrid.defaultSpacing + "']")
                .prop("checked", true)
                .closest("label")
                .addClass("active");

            dataGrid.search();
        });
        dataGrid.settingsModal.find(".data-grid-set-cookie-radio").change(function (e) {

            var cookieNamePiece = $(this).attr("data-grid-cookie");
            var cookieName = dataGrid.name + "_" + cookieNamePiece;
            var cookieValue = $(this).attr("data-grid-cookie-value");
            Cookies.set(cookieName, cookieValue, { expires: 36500 });

            var $table = $(false);

            var dataGrids = getDataGrids(dataGrid.name);

            dataGrids.forEach(function (thisDataGrid) {
                $table = $table.add(thisDataGrid.wrapper.find("table"));
            });

            switch (cookieNamePiece) {
                case "spacing":
                    $table.removeClass("data-grid-spacing-narrower");
                    $table.removeClass("data-grid-spacing-narrow");
                    $table.removeClass("data-grid-spacing-normal");
                    $table.removeClass("data-grid-spacing-wide");
                    $table.removeClass("data-grid-spacing-wider");
                    $table.addClass("data-grid-spacing-" + cookieValue);
                    if (typeof stickyHeaderResize === 'function') {
                        stickyHeaderResize(dataGrid.wrapper);
                    }
                    break;
                case "fontsize":
                    $table.removeClass("data-grid-fontsize-smaller");
                    $table.removeClass("data-grid-fontsize-small");
                    $table.removeClass("data-grid-fontsize-normal");
                    $table.removeClass("data-grid-fontsize-large");
                    $table.removeClass("data-grid-fontsize-larger");
                    $table.addClass("data-grid-fontsize-" + cookieValue);
                    if (typeof stickyHeaderResize === 'function') {
                        stickyHeaderResize(dataGrid.wrapper);
                    }
                    break;
            }

        });
        dataGrid.settingsModal.find(".data-grid-set-cookie-checkbox").change(function (e) {

            // dataGrid.closeSettingsModal();

            var cookieNamePiece = $(this).attr("data-grid-cookie");
            var cookieName = dataGrid.name + "_" + cookieNamePiece;
            var cookieValue = $(this).is(":checked");
            Cookies.set(cookieName, cookieValue, { expires: 36500 });

            if ($(this).attr("data-grid-refresh") === "yes") {
                dataGrid.search();
            }


        });

    },


    bindSearchElements: function (dataGrid, $elem) {

        $elem = $elem || $(".data-grid-search[data-grid-session-id='" + dataGrid.id + "']");
        $elem.each(function () {
            if ($(this).hasClass("db-no-auto-search")) {
                return true;
            }
            var boundSearch = $(this).data("bound_search");
            var searchOperation = $(this).data("search-operation");
            var defaultDate = new Date();
            if (searchOperation === "less" || searchOperation === "lessEq") {
                defaultDate.setHours(23);
                defaultDate.setMinutes(59);
                defaultDate.setSeconds(59);
            } else {
                defaultDate.setHours(0);
                defaultDate.setMinutes(0);
                defaultDate.setSeconds(0);
            }

            if (typeof boundSearch !== "undefined" && boundSearch === true) {
                return true;
            }
            if ($(this).hasClass("dg-datetime-picker")) {
                var format = "YYYY-MM-DD hh:mm a";
                if ($(this).hasClass("dg-datetime-date-no-time")) {
                    format = "YYYY-MM-DD";
                }
                var originalVal = $(this).val();
                $(this).datetimepicker({
                    icons: {
                        time: "fa fa-clock",
                        date: "fa fa-calendar",
                        up: "fa fa-arrow-up",
                        down: "fa fa-arrow-down",
                        next: "fa fa-angle-right",
                        previous: "fa fa-angle-left"
                    },
                    keyBinds: {
                        up: null,
                        down: null,
                        right: null,
                        left: null,
                        delete: null
                    },
                    useCurrent: false,
                    viewDate: defaultDate,
                    defaultDate: defaultDate,
                    format: format
                }).on("dp.change", function () {
                    $(this).keyup();
                });
                $(this).val(originalVal);
            }
            var dataGridSessionId = $(this).attr("data-grid-session-id");
            var inputType;
            if (typeof $(this).attr("type") === "undefined") {
                inputType = "text";
            } else {
                inputType = $(this).attr("type");
            }
            if (!$(this).is("input") && !$(this).is("textarea")) {
                inputType = "select";
            }

            switch (inputType) {
                case "text":
                case "search":
                    $(this).keyup(function () {
                        debounce(function () {
                            dataGridHelper.getDataGrid(dataGridSessionId).search();
                        }, 1000, null, "dg:" + dataGridSessionId);
                    });
                    $(this).on("search", function () {
                        dataGridHelper.getDataGrid(dataGridSessionId).search();
                    });
                    break;
                default:
                    $(this).change(function () {
                        dataGridHelper.getDataGrid(dataGridSessionId).search();
                    });
                    break;
            }
            $(this).data("bound_search", true);
        });
    },
    bindAddSearchButtons: function (dataGrid, $elem) {

        $elem = $elem || $(".data-grid-add-search-button[data-grid-session-id='" + dataGrid.id + "']");
        $elem.each(function () {
            var boundClick = $(this).data("bound_click");
            if (typeof boundClick !== "undefined" && boundClick === true) {
                return true;
            }
            var dataGridSessionId = $(this).attr("data-grid-session-id");
            $(this).click(function () {
                dataGridHelper.getDataGrid(dataGridSessionId).addSearch($($(this).attr("data-grid-append-target")), $(this).attr("data-grid-field"), $(this)
                    .attr("data-grid-operation"), $(this).attr("data-grid-duplicates-allowed") === "yes", null,
                    $(this).attr("data-grid-replace-instead") === "yes",
                    $(this).attr("data-grid-do-not-mark-added") === "yes");

            });
            $(this).data("bound_click", true);
        });
    },
    bindSearchForm: function (dataGrid, $elem) {

        $elem = $elem || $(".data-grid-search-form[data-grid-session-id='" + dataGrid.id + "']");
        $elem.each(function () {
            var boundSearch = $(this).data("bound_search");
            if (typeof boundSearch !== "undefined" && boundSearch === true) {
                return true;
            }

            var dataGridSessionId = $(this).attr("data-grid-session-id");
            $(this).submit(function (e) {
                if (dataGridHelper.getDataGrid(dataGridSessionId).search()) {
                    e.preventDefault();
                }

            });
            $(this).on("reset", function (e) {
                if (dataGridHelper.getDataGrid(dataGridSessionId).reset().search()) {
                    e.preventDefault();
                }

            });
            $(this).data("bound_search", true);
        });
    },
    bindSettingsButton: function (dataGrid, $elem) {
        $elem = $elem || dataGrid.wrapper.find(".data-grid-corner-display-settings");
        dataGrid.wrapper.find(".data-grid-download-csv").click(function () {
            var thisDataGrid = dataGridHelper.getDataGrid(dataGrid.id);
            window.location = thisDataGrid.wrapper.attr("data-csv-url");
        });
        $elem.each(function () {
            var boundSettingsButton = $(this).data("bound_settings_button");
            if (typeof boundSettingsButton !== "undefined" && boundSettingsButton === true) {
                return true;
            }

            $(this).click(function () {
                dataGrid.openSettingsModal();
            });

            $(this).data("bound_settings_button", true);
            return true;
        });
    },
    bindPopState: function () {
        if (this.boundPopState) {
            return true;
        }
        this.boundPopState = true;
        var thisDatagrid = this;

        $(window).bind('popstate', function (e) {
            var state = e.originalEvent.state;
            var preventRedirect = false;
            if (state === null) {
                // prevent from redirecting on a URL hash change (this prevents an infinite loop)
                preventRedirect = true;
            }


            allDataGrids.forEach(function (dataGrid) {
                if (dataGrid.rowOpen) {
                    preventRedirect = true;

                    var url = window.location.href;
                    var origUrl = url;
                    url = dgUrlParam.remove(url, dataGrid.rowOpenUrlRowIdName);
                    if (dataGrid.rowOpenUrlRequireGrid) {
                        url = dgUrlParam.remove(url, dataGrid.rowOpenUrlGridParamName);
                    }
                    if (url === origUrl) {
                        dataGrid.disablePushState = true;
                    }
                    dataGrid.closeRow();
                    dataGrid.disablePushState = false;
                }
            });

            if (preventRedirect) {
                return true;
            }
            if (typeof state !== "object" || state.dataGrid !== "yes") {
                state = { mode: "search" };
            }
            if (state.mode === "openRow") {
                var thisDataGrid = dataGridHelper.getDataGridFromName(state.thisDataGridName);
                thisDataGrid.disablePushState = true;
                thisDataGrid.openRow(thisDataGrid.wrapper.find(".data-grid-row[data-row-id='" + state.rowId + "']"));
                thisDataGrid.disablePushState = false;
                return true;
            }
            // noinspection SillyAssignmentJS
            window.location.href = window.location.href;
        });
    },
    bindRows: function (dataGrid, $wrapper) {
        var $tbody = $wrapper.find("tbody");
        if (!$tbody.length && $wrapper.is("tbody")) {
            $tbody = $wrapper;
        }
        if (dataGrid.openOnClick) {
            $tbody.click(function (e) {
                if ($(this).hasClass("data-grid-row-open-excluded")) {
                    return true;
                }
                var $target = $(e.target);
                if ($target.hasClass("data-grid-no-row-open") || $target.closest(".data-grid-no-row-open").length) {
                    return true;
                }
                if (e.ctrlKey) {
                    dataGrid.openRow($(this), null, false, true);
                } else {
                    dataGrid.openRow($(this));
                }


            });
        }
        if (dataGrid.checkOnClick) {
            $tbody.click(function (e) {
                if ($(this).hasClass("data-grid-row-open-excluded")) {
                    return true;
                }
                var $target = $(e.target);
                if ($target.hasClass("data-grid-no-row-check") || $target.closest(".data-grid-no-row-check").length) {
                    return true;
                }
                $(this).find(".data-grid-checkbox-row").click();
            });
        }
        $tbody.click(function (e) {
            var $this = $(this);
            dataGrid.onRowClickFunctions.forEach(function (callable) {
                callable($this, e);
            });
        });

        var $closeButton = dataGrid.$open.find(".data-grid-details-close-button");
        if ($closeButton.data("bound") !== "yes") {
            $closeButton.click(function () {
                dataGrid.closeRow();
            });
            $closeButton.data("bound", "yes");
        }

        // if (dataGrid.$open.data("bound-escape") !== "yes") {
        // $("body").keyup(function(e) {
        //   if (e.key === "Escape") {
        //     if (Cookies.get(dataGrid.name + "_escapeToClose") !== false || Cookies.get(dataGrid.name + "_escapeToClose") !== "false") {
        //       if (dataGrid.rowOpen) {
        //         dataGrid.closeRow();
        //       }
        //     }
        //   }
        // });
        // dataGrid.$open.data("bound-escape", "yes");
        // }

    },
    bindGears: function ($elem) {
        if (typeof gearJS !== "undefined") {
            gearJS.auto($elem);
        }
    },
    bindAdditional: function (dataGrid, $wrapper) {
        dataGrid.additionalBindingFunctions.forEach(function (additionalBindingFunction) {
            dataGridHelper.bindAdditionalSingle(dataGrid, additionalBindingFunction, $wrapper);
        });
    },
    bindAdditionalSingle: function (dataGrid, settings, $wrapper) {
        $wrapper.find(settings.element).on(settings.trigger, function () {
            settings.callback(dataGrid);
        });
    },
    getDataGridFromElement: function ($elem) {
        if (!($elem instanceof jQuery)) {
            $elem = $($elem);
        }
        var dataGridSessionId;
        if ($elem.attr("data-grid-session-id")) {
            dataGridSessionId = $elem.attr("data-grid-session-id");
        } else {
            var $wrapper = $elem.closest(".data-grid-wrapper");
            if (!$wrapper.length) {
                $wrapper = $elem.closest(".data-grid-open");
            }
            if (!$wrapper.length) {
                $wrapper = $elem.closest(".data-grid-search-form")
            }
            if (!$wrapper.length) {
                return false;
            }

            dataGridSessionId = $wrapper.attr("data-grid-session-id");
        }
        var output = false;
        allDataGrids.forEach(function (dataGrid) {
            if (dataGrid.id === dataGridSessionId) {
                output = dataGrid;
                return false;
            }
        });
        return output;
    },
    getRowFromElement: function ($elem) {
        if (!($elem instanceof jQuery)) {
            $elem = $($elem);
        }
        var $open = $elem.closest(".data-grid-open")
        if ($open.length) {
            return $open.data("row");
        }
        return $elem.closest(".data-grid-tbody");
    },
    searchButtonClick: function (e) {
        if (e.ctrlKey) {
            return true;
        }

        var field = $(this).attr("data-grid-field");
        var searchValue = $(this).attr("data-grid-search-value");
        var dataGridSessionId = $(this).attr("data-grid-session-id");
        var thisDataGrid = $(".data-grid-wrapper[data-grid-session-id='" + dataGridSessionId + "']").dataGrid();

        if ($(this).hasClass("active")) {
            thisDataGrid.resetInput($(".data-grid-input[name=" + field + "][data-grid-session-id='" + thisDataGrid.id + "']"));
            return true;
        }

        var checkIt = true;
        if (searchValue === "uncheck") {
            checkIt = false;
        }

        $(".data-grid-input:not([type=submit],[type=radio],[type=checkbox])[name=" + field + "][data-grid-session-id='" + thisDataGrid.id + "']")
            .val(searchValue).change().keyup();
        $(".data-grid-input:not([type=submit],[type=input],[type=select])[name=" + field + "][data-grid-session-id='" + thisDataGrid.id + "']" +
            "[value=" + JSON.stringify(searchValue) + "]")
            .prop("checked", checkIt);
        if (searchValue.length < 1) {
            $(".data-grid-input:not([type=submit],[type=input],[type=select])[name=" + field + "][data-grid-session-id='" + thisDataGrid.id + "']" +
                "[data-grid-radio-blank='yes']")
                .prop("checked", true);
        }
        if (typeof debounce !== "undefined" && typeof debounce["dg:" + dataGridSessionId] !== "undefined") {
            clearTimeout(debounce["dg:" + dataGridSessionId]);
        }
        if (thisDataGrid.search()) {
            e.preventDefault();
        }

    },
    sortButtonClick: function (e) {
        if (!dataGridHelper.allowSorting) {
            return true;
        }
        if ($(e.target).closest(".data-grid-top-corner").length) {
            return true;
        }
        if ($(e.target).closest(".data-grid-resize-column").length) {
            return true;
        }
        var $input = $(this).find(".data-grid-input-sort");
        var $allSameSorts = $(".data-grid-input-sort" +
            "[data-grid-session-id='" + $input.attr("data-grid-session-id") + "']" +
            "[name='" + $input.attr("name") + "']");
        var $thisSortOrder = $(this).find(".data-grid-input-sort-order");
        var thisDataGrid = $(".data-grid-wrapper[data-grid-session-id='" + $input.attr("data-grid-session-id") + "']").dataGrid();
        var $sortOrders = $(".data-grid-input-sort-order[data-grid-session-id='" + thisDataGrid.id + "']");
        var $sorts = $(".data-grid-input-sort[data-grid-session-id='" + thisDataGrid.id + "']");

        $thisSortOrder.val(null).change();
        if (e.shiftKey) {
            var largestCount = 0;
            $sorts.each(function () {
                if ($(this).val().length < 1) {
                    return true;
                }
                var $thisSortOrder = $(this).closest("a").find(".data-grid-input-sort-order");
                if ($thisSortOrder.val().length < 1) {
                    $thisSortOrder.val(0).change();
                }
                if (parseInt($thisSortOrder.val()) > largestCount) {
                    largestCount = parseInt($thisSortOrder.val());
                }
            });
            $thisSortOrder.val(largestCount + 1).change();
        } else {
            $sortOrders.val(null).change();
            $sorts.val(null).change();
        }

        $allSameSorts.val($input.attr("data-next-value")).change();

        if (thisDataGrid.search()) {
            e.preventDefault();
        }

    },
    toggleAllChildRowsTrigger: function (e) {
        // if it's in a row in the table, toggle that row instead of all rows.
        var $row = $(e.target).closest(".data-grid-tbody");
        if ($row.length) {
            dataGridHelper.toggleChildRow($row);
        } else {
            var thisDataGrid = $(".data-grid-wrapper[data-grid-session-id='" + $(this).attr("data-grid-session-id") + "']").dataGrid();
            thisDataGrid.toggleAllChildRows();
        }
    },

    sortButtonWrapperClick: function (e) {
        if (!dataGridHelper.allowSorting) {
            return true;
        }
        if ($(e.target).is("a")) {
            return true;
        }
        if ($(e.target).closest(".data-grid-top-corner").length) {
            return true;
        }
        if ($(e.target).closest(".data-grid-resize-column").length) {
            return true;
        }
        if (e.shiftKey) {
            var shiftClick = jQuery.Event("click");
            shiftClick.shiftKey = true;
            $(this).find("a").trigger(shiftClick);
        } else {
            $(this).find("a").click();
        }
    },
};

dataGridHelper.auto($("body"));

dataGridHelper.bindPopState();


function getDataGrid(name, searchType) {
    searchType = searchType || "name";
    var output = false;
    allDataGrids.forEach(function (dataGrid) {
        if (searchType === "id" && parseInt(dataGrid[searchType]) === parseInt(name)) {
            output = dataGrid;
            return false;
        }
        if (dataGrid[searchType] === name) {
            output = dataGrid;
            return false;
        }
    });
    return output;
}

function getDataGrids(name) {
    var output = [];
    allDataGrids.forEach(function (dataGrid) {
        if (dataGrid.name === name) {
            output.push(dataGrid);
        }
    });
    return output;
}

dataGridHelper.bindPopState();

$.fn.dataGridOpen = function (mode) {
    return this.dataGrid("open", mode);
};

$.fn.dataGridRow = function () {
    return this.dataGrid("row");
};
$.fn.dataGridValue = function (value) {
    return this.dataGrid("value", value);
};

allDataGrids.forEach(function (thisDataGrid) {
    if (thisDataGrid.horizontalScrollVisible()) {
        thisDataGrid.forgetColumnWidths();
    }
});

function dg_escapeStr(str) {
    if (str) {
        return str.replace(/([ #;?%&,.+*~\':"!^$[\]()=>|\/\\@])/g, '\\$1');
    }

    return str;
}

// export {DataGrid, dataGridHelper};

/* resources/assets/js/vendor/gear/gear.js */
var gearJS = {
    messages: {"copied": "Copied to clipboard: :text", "copy_failed": "Failed to copy text: :text", "connection_failed": "Failed to connect. Check your internet connection and try again.", "request_too_large": "Request too large", "query_selection_unsupported": "Selecting rows not currently displayed is not supported for this action.", "prompt_title": "Set value", "buttonText": "Go", "confirmYes": "Yes", "confirmCancel": "Cancel"},
    message: function (context, key, replacements) {
        var messages = {};
        var $context = context ? $(context) : $();
        if ($context.length && typeof $context.gearJsAttr === "function") {
            messages = $context.gearJsAttr("data-gear-messages") || {};
            if (typeof messages === "string") {
                try { messages = JSON.parse(messages); } catch (e) { messages = {}; }
            }
        }
        var text = Object.prototype.hasOwnProperty.call(messages, key) ? messages[key] : gearJS.messages[key];
        return String(text).replace(/:([a-z_]+)/g, function (token, name) {
            return replacements && Object.prototype.hasOwnProperty.call(replacements, name) ? String(replacements[name]) : token;
        });
    },

    activeAjax: {},
    confirmDialogAppended: false,
    allGears: [],
    promptNeeded: [],

    copyToClipboard: function (textToCopy, context, messageContext) {
        // "context" is the parent element to place the temporary input in for copying. Required for copying while a
        // dialog box is open, etc.
        var input = document.createElement('input');
        input.setAttribute('value', textToCopy);
        var parentElement;
        if (typeof context === "undefined") {
            parentElement = document.body;
            document.body.appendChild(input);
        } else {
            parentElement = context;
            context.appendChild(input);
        }

        input.select();
        input.focus();
        var result = document.execCommand('copy');

        parentElement.removeChild(input);

        if (result) {
            toast(gearJS.message(messageContext || context, 'copied', {text: textToCopy}));
        } else {
            toast(gearJS.message(messageContext || context, 'copy_failed', {text: textToCopy}));
        }
        return result;
    },

    handleSuccess: function ($ele, response, loadingToast) {
        // retrieve these first, since the element may not exist later...
        var gear = $ele.gearJs();
        var defaultUpdateToast = $ele.gearJsAttr("data-gear-default-update-toast");
        var alwaysActions = $ele.gearJsAttr("data-gear-always-actions");
        var toastUpdated = gearJS.runActions(response, loadingToast, $ele);
        if (!toastUpdated) {
            gearJS.runActions(defaultUpdateToast, loadingToast, $ele);
        }

        gearJS.runActions(alwaysActions, loadingToast, $ele);

        $ele.gearJsSucceeded(gear);
    },

    handleError: function ($ele, response, loadingToast) {
        // need to make sure we close the stream if there is one!
        gearJS.killStream($ele);

        if (response.readyState === 0 && response.statusText !== "abort") {
            if (loadingToast !== null) {
                loadingToast.set({time: 0});
            }
            toast({"message": gearJS.message($ele, 'connection_failed'), type: "danger"});
            $ele.gearJsFailed();
            return true;
        }
        gearJS.hideErrors($ele);
        var errorHandled = false;
        if (response.statusText !== "abort") {
            var error;
            var responseIsObject = true;
            try {
                error = JSON.parse(response.responseText);
            } catch (e) {
                responseIsObject = false;
            }
            var toastUpdated = false;
            if (responseIsObject && typeof error.actions !== "undefined") {
                toastUpdated = gearJS.runActions(error.actions, loadingToast, $ele);
                errorHandled = true;
            }
            if (typeof response.status !== "undefined" && parseInt(response.status) === 413) {
                var error413 = $ele.gearJsAttr("data-gear-error-413") || gearJS.message($ele, 'request_too_large');
                var largeRequestToast = {
                    message: error413,
                    time: 5000,
                    type: "danger"
                };
                if (loadingToast !== null) {
                    loadingToast.set(largeRequestToast);
                } else {
                    toast(largeRequestToast);
                }
                toastUpdated = true;
                errorHandled = true;
            }


            var errorToastMessage = {};
            var errorToastIcon = $ele.gearJsAttr("data-gear-error-toast-icon");
            var errorToastType = $ele.gearJsAttr("data-gear-error-toast-type");
            var errorToastAlways = $ele.gearJsAttr("data-gear-error-toast-always") === "yes";
            var time = $ele.gearJsAttr("data-gear-error-toast-time");

            if (responseIsObject && typeof error.message !== "undefined") {
                if (typeof error.errors === "undefined") {
                    error.errors = {_gear_server_error: error.message};
                } else {
                    error.errors._gear_generic = error.message;
                }
            }

            if (responseIsObject && typeof error.errors !== "undefined") {
                if (loadingToast !== null && !toastUpdated) {
                    loadingToast.set({time: 0});
                }
                errorToastMessage = error.errors;
                errorHandled = true;
            } else {
                if (!toastUpdated) {
                    var updateToastMsg;
                    if (typeof response === "object" && typeof response.responseText === "string") {
                        updateToastMsg = response.responseText;
                    } else {
                        if (typeof response === "string") {
                            updateToastMsg = response;
                        }
                    }
                    if (typeof updateToastMsg === "undefined" ||
                        typeof updateToastMsg !== "string" ||
                        updateToastMsg.length < 1 ||
                        updateToastMsg.indexOf("<html") !== -1) {
                        updateToastMsg = $ele.gearJsAttr("data-gear-error-toast");
                    }
                    var errorToastSettings = {
                        message: updateToastMsg,
                        icon: errorToastIcon,
                        time: time,
                        type: errorToastType
                    };
                    if (loadingToast !== null) {
                        loadingToast.set(errorToastSettings);
                    } else {
                        toast(errorToastSettings);
                    }
                }
            }


            if (errorToastMessage.length < 1) {
                time = 0;
            }
            for (var fieldName in errorToastMessage) {
                if (errorToastMessage.hasOwnProperty(fieldName)) {
                    if ($.isArray(errorToastMessage[fieldName])) {
                        errorToastMessage[fieldName].forEach(function (errorSingleMessage) {
                            gearJS.errorDisp($ele, errorSingleMessage, fieldName, errorToastAlways, errorToastIcon, time, errorToastType);
                        });
                    } else {
                        gearJS.errorDisp($ele, errorToastMessage[fieldName], fieldName, errorToastAlways, errorToastIcon, time, errorToastType);
                    }
                }
            }

            gearJS.runActions($ele.gearJsAttr("data-gear-error-actions"), loadingToast, $ele);
            gearJS.runActions($ele.gearJsAttr("data-gear-always-actions"), loadingToast, $ele);

            if (!errorHandled) {
                console.log("Ajax error, response:");
                console.log(response);
            }
        } else {
            var cancelToastMessage = $ele.gearJsAttr("data-gear-cancel-toast");
            var cancelToastIcon = $ele.gearJsAttr("data-gear-cancel-toast-icon");
            if (typeof cancelToastMessage === "undefined" || cancelToastMessage.length < 1) {
                if (loadingToast !== null) {
                    loadingToast.close();
                }
            } else {
                var toastSettings = {
                    time: 1000,
                    message: cancelToastMessage,
                    type: "warning",
                    icon: cancelToastIcon
                };
                if (loadingToast !== null) {
                    loadingToast.set(toastSettings);
                } else {
                    toast(toastSettings);
                }
            }
            gearJS.runActions($ele.gearJsAttr("data-gear-always-actions"), loadingToast, $ele);
        }
        $ele.gearJsFailed();
    },

    prepareConfirmText: function ($ele, text) {
        if (typeof text !== "string") {
            return text;
        }
        var confirmSources = $ele.gearJsAttr("data-gear-confirm-sources");
        var customVars = gearJS.gatherDataInner($ele, confirmSources);
        var mode = $ele.gearJsAttr("data-gear-mode");
        if (typeof customVars.mode === "undefined" && mode !== null && mode.length > 0) {
            customVars.mode = mode;
        }
        for (var varName in customVars) {
            if (customVars.hasOwnProperty(varName)) {
                text = gearJS.handleCustomConfirmVariable(text, varName, customVars[varName]);
            }
        }

        if (typeof dataGridHelper !== "undefined") {


            var $dataGridElement = gearJS.element($ele.gearJsAttr("data-gear-confirm-data-grid-count"), $ele);
            var $confirmCountCheckboxes = $($ele.gearJsAttr("confirm-count-checkbox-selector"));
            var skipIfNoneSelected = $ele.gearJsAttr("data-gear-confirm-skip-none-selected") === "yes";

            var thisDataGrid = $dataGridElement.dataGrid();

            if (thisDataGrid !== false || $confirmCountCheckboxes.length) {


                var numChecked;
                var numAll;
                var numTotal;
                if (thisDataGrid === false) {
                    numAll = $confirmCountCheckboxes.length;
                    numTotal = numAll;
                    numChecked = $confirmCountCheckboxes.filter(":checked").length;
                } else {
                    numChecked = thisDataGrid.wrapper.find(".data-grid-checkbox-row:checked").length;
                    numAll = thisDataGrid.wrapper.find(".data-grid-tbody").length;
                    numTotal = parseInt(thisDataGrid.wrapper.attr("data-grid-total-records"));
                }

                // check if this gear has check query enabled
                if ($ele.gearJsAttr("data-grid-check-query") === "yes") {
                    // check if the check query is active
                    var $checkQueryCheckbox = $(".data-grid-checkbox-query-input[data-grid-session-id='" + thisDataGrid.id + "']");
                    if ($checkQueryCheckbox.is(":checked")) {
                        numChecked = $checkQueryCheckbox.attr("data-record-total");
                    }
                }


                if (numChecked === 0 && skipIfNoneSelected) {
                    return "_gearjs_skip";
                }

                var replacePlural = "$1";

                if (numChecked === 1) {
                    replacePlural = "";
                }
                var replaceSingle = "";

                if (numChecked === 1) {
                    replaceSingle = "$1";
                }
                var replacePluralAll = "$1";

                if (numAll === 1) {
                    replacePluralAll = "";
                }
                var replacePluralTotal = "$1";

                if (numTotal === 1) {
                    replacePluralTotal = "";
                }
                text = text.replace(/{#}/g, numChecked)
                    .replace(/{pl=([^}]+)}/g, replacePlural)
                    .replace(/{pl!=([^}]+)}/g, replaceSingle)
                    .replace(/{#all}/g, numAll)
                    .replace(/{pl:all=([^}]+)}/g, replacePluralAll)
                    .replace(/{#total}/g, numTotal)
                    .replace(/{pl:total=([^}]+)}/g, replacePluralTotal);
            }
        }

        text = text.replace(/{empty\(([^)]*)\)([^}]*)?}/g, function (fullMatch, group1, group2) {
            var testVar = $ele.attr(group1);
            if (typeof customVars[group1] !== "undefined") {
                testVar = customVars[group1];
            }
            if (typeof testVar === "undefined" || testVar === null || testVar.toString().trim().length < 1) {
                return group2;
            }
            return "";

        });
        text = text.replace(/{!empty\(([^)]*)\)([^}]*)?}/g, function (fullMatch, group1, group2) {
            var testVar = $ele.attr(group1);
            if (typeof customVars[group1] !== "undefined") {
                testVar = customVars[group1];
            }
            if (typeof testVar !== "undefined" && testVar !== null && testVar.toString().trim().length > 0) {
                return group2;
            }
            return "";
        });

        text = text.replace(/{if\(([^=<>()!]*)([=<>!]{1,3})([^=<>()]*)\)([^}]*)}/g, function (fullMatch, group1, group2, group3, group4) {
            var compareVar = $ele.attr(group1);
            if (typeof customVars[group1] !== "undefined") {
                compareVar = customVars[group1];
            }
            switch (group2) {
                case "==":
                case "===":
                case "=":
                default:
                    if (compareVar === group3) {
                        return group4;
                    }
                    break;
                case "!==":
                case "!=":
                    if (compareVar !== group3) {
                        return group4;
                    }
                    break;
                case "<":
                    if (parseInt(compareVar) < parseInt(group3)) {
                        return group4;
                    }
                    break;

                case "<=":
                    if (parseInt(compareVar) <= parseInt(group3)) {
                        return group4;
                    }
                    break;
                case ">":
                    if (parseInt(compareVar) > parseInt(group3)) {
                        return group4;
                    }
                    break;
                case ">=":
                    if (parseInt(compareVar) >= parseInt(group3)) {
                        return group4;
                    }
                    break;
            }

            return "";
        });

        return text;
    },
    handleCustomConfirmVariable: function (text, customVarName, customVarValue) {
        if (typeof customVarValue === "object" && typeof customVarValue.value !== "undefined") {
            customVarValue = customVarValue.value;
        }
        var regex = new RegExp("{" + customVarName + "}", "g");
        return text.replace(regex, customVarValue);
    },
    confirm: function ($ele, callback) {
        var title = gearJS.prepareConfirmText($ele, $ele.gearJsAttr("data-gear-confirm-title"));
        if (title === "_gearjs_skip") {
            callback();
        } else {
            onConfirm({
                callback: callback,
                noCallback: function () {
                    gearJS.runActions($ele.gearJsAttr("data-gear-confirm-cancel-actions"), null, $ele);
                },
                title: title,
                body: gearJS.prepareConfirmText($ele, $ele.gearJsAttr("data-gear-confirm-body")),
                cancel: gearJS.prepareConfirmText($ele, $ele.gearJsAttr("data-gear-confirm-cancel")),
                yes: gearJS.prepareConfirmText($ele, $ele.gearJsAttr("data-gear-confirm-yes")),
                yesType: $ele.gearJsAttr("data-gear-confirm-yes-class"),
                timer: $ele.gearJsAttr("data-gear-confirm-time")
            });
        }

    },
    newlyAddedHtml: function ($element) {
        if (typeof dataGridHelper !== "undefined") {
            dataGridHelper.auto($element);
        }
        gearJS.auto($element);
        if (typeof conditionalJsAuto !== "undefined") {
            conditionalJsAuto($element);
        }
    },
    auto: function ($elem, includeDelayed) {
        includeDelayed = includeDelayed || false;
        if (typeof $elem !== "undefined") {
            gearJS.init($elem.find("[data-gear-enabled='yes']"));
            if (includeDelayed) {
                gearJS.init($elem.find("[data-gear-enabled='delayed']"));
            }
        } else {
            gearJS.init($("[data-gear-enabled='yes']"));
            if (includeDelayed) {
                gearJS.init($("[data-gear-enabled='delayed']"));
            }
        }
        gearJS.allGears.forEach(function (gear) {
            // If any child elements of existing gears have been added, they need to be initialized.
            var trigger = gear.$ele.gearJsAttr("data-gear-trigger");
            if (typeof trigger === "undefined" || trigger.length < 1) {
                trigger = "click";
            }
            if (trigger === "submit" || gear.$ele.is("form")) {
                gearJS.initSubmitButtons(gear.$ele);
            }
        });
    },
    hideErrors: function ($ele) {
        var gearName = $ele.gearJsAttr("data-gear-name");
        $("[data-gear-error-name='" + gearName + "']").hide();
    },
    initSubmitButtons: function ($form) {
        var $submitButtons = $form.find("input[type=submit], button");

        $submitButtons.each(function () {
            if ($(this).data("gear-submit-button-initialized") === "yes") {
                return;
            }
            $(this).click(function () {
                $submitButtons.attr("data-gear-clicked-submit", "no");
                $(this).attr("data-gear-clicked-submit", "yes");
                $(this).data("gear-submit-button-initialized", "yes");
            });
        });
    },
    triggerFunction: function ($ele) {
        var debounceTime = $ele.gearJsAttr("data-gear-debounce-time");

        debounce(function () {
            gearJS.hideErrors($ele);
            var data = gearJS.gatherData($ele);
            if (gearJS.promptNeeded.length < 1) {
                gearJS.afterGatherData($ele, data);
            } else {
                var preparedPrompts = {};
                var options = {title: gearJS.message($ele, 'prompt_title'), yes: gearJS.message($ele, 'buttonText'), no: gearJS.message($ele, 'confirmCancel')};
                var confirmTime = parseInt($ele.gearJsAttr("data-gear-confirm-time"));
                gearJS.promptNeeded.forEach(function (thisPrompt) {

                    preparedPrompts[thisPrompt.fieldName] =
                        {
                            label: gearJS.prepareConfirmText($ele, thisPrompt.promptLabel),
                            inputType: thisPrompt.promptDialog.inputType,
                            attr: thisPrompt.promptDialog.attr,
                            class: thisPrompt.promptDialog.class,
                            showWhenField: thisPrompt.promptDialog.showWhenField || null,
                            showWhenValue: thisPrompt.promptDialog.showWhenValue || null,
                            showWhenType: thisPrompt.promptDialog.showWhenType || null,
                            beforeInput: gearJS.prepareConfirmText($ele, thisPrompt.promptDialog.beforeInput),
                            afterInput: gearJS.prepareConfirmText($ele, thisPrompt.promptDialog.afterInput),
                            default: gearJS.prepareConfirmText($ele, thisPrompt.defaultPromptValue),
                            placeholder: gearJS.prepareConfirmText($ele, thisPrompt.promptDialog.placeholder),
                            labelWidth: thisPrompt.promptDialog.labelWidth,
                            yesType: thisPrompt.promptDialog.yesType,
                        };
                    if (thisPrompt.promptLabel === null || thisPrompt.promptLabel.length < 1) {
                        preparedPrompts[thisPrompt.fieldName].hideLabel = true;
                    }
                    if (thisPrompt.promptDialog.inputType === "radio") {
                        preparedPrompts[thisPrompt.fieldName].radioOptions = thisPrompt.promptDialog.selectOptions;
                    } else {
                        preparedPrompts[thisPrompt.fieldName].selectOptions = thisPrompt.promptDialog.selectOptions;
                    }
                    if (thisPrompt.promptDialog.inputType === "checkbox") {
                        preparedPrompts[thisPrompt.fieldName].checked =
                            (thisPrompt.promptDialog.checkedWhen ===
                                thisPrompt.defaultPromptValue ||
                                thisPrompt.value ===
                                thisPrompt.promptDialog.checkedWhen);
                    }

                    if (thisPrompt.promptDialog.title !== null ||
                        thisPrompt.promptDialog.msg !== null ||
                        thisPrompt.promptDialog.yes !== null ||
                        thisPrompt.promptDialog.no !== null ||
                        thisPrompt.promptDialog.hideOnSubmit !== null) {
                        for (var propName in thisPrompt.promptDialog) {
                            if (thisPrompt.promptDialog.hasOwnProperty(propName)) {
                                if (thisPrompt.promptDialog[propName] !== null && thisPrompt.promptDialog[propName] !== undefined) {
                                    var thisValue = thisPrompt.promptDialog[propName];
                                    if (["title", "subtitle", "titleHelpText", "modalSize", "msg", "body", "yes", "no"].indexOf(propName) !== -1) {
                                        thisValue = gearJS.prepareConfirmText($ele, thisValue);
                                    }
                                    options[propName] = thisValue;
                                }
                            }
                        }
                    }

                });
                options.noCallback = function () {
                    gearJS.runActions($ele.gearJsAttr("data-gear-confirm-cancel-actions"), null, $ele);
                };
                options.callback = function (userInput) {
                    for (var prop in userInput) {
                        if (userInput.hasOwnProperty(prop)) {
                            data[prop] = userInput[prop];
                        }
                    }
                    gearJS.afterGatherData($ele, data);
                };
                if (typeof confirmTime !== "undefined" && confirmTime !== null && !isNaN(confirmTime) && confirmTime > 0) {
                    options.timer = confirmTime;
                }
                promptInput(preparedPrompts, options);
            }
        }, debounceTime, $ele, $ele.gearJsAttr("name"));
    },
    afterGatherData: function ($ele, data) {
        //var loadingToastMessage = $ele.gearJsAttr("data-gear-loading-toast");
        var removalWorkaround = $ele.gearJsAttr("data-gear-removal-workaround") === "yes";
        if (removalWorkaround) {
            $ele.detach();
        }
        var loadingToastMessage = gearJS.prepareConfirmText($ele, $ele.gearJsAttr("data-gear-loading-toast"));
        var loadingToastIcon = $ele.gearJsAttr("data-gear-loading-toast-icon");
        var gearName = $ele.gearJsAttr("data-gear-name");
        var cancelDuplicate = $ele.gearJsAttr("data-gear-cancel-duplicate") === "yes";
        var loadingToast = null;
        if (typeof loadingToastMessage === "undefined") {
            loadingToastMessage = "";
        }
        if (typeof loadingToast !== "undefined" && loadingToastMessage.length > 0) {
            loadingToast = toast({"message": loadingToastMessage, "time": -1, "icon": loadingToastIcon})
        }
        gearJS.runActions($ele.gearJsAttr("data-gear-trigger-actions"), loadingToast, $ele);

        $ele.gearJsTriggered();

        if ($ele.gearJsAttr("data-gear-ajax-enabled") === "no") {
            return true;
        }

        if (typeof gearJS.activeAjax[gearName] === "undefined") {
            gearJS.activeAjax[gearName] = [];
        }


        if (cancelDuplicate) {
            gearJS.activeAjax[gearName].forEach(function (ajaxRequest) {
                ajaxRequest.abort();
            });
        }

        gearJS.activeAjax[gearName] = [];

        var mode = $ele.gearJsAttr("mode");
        if (typeof mode !== "undefined" && mode !== null && mode.length > 0) {
            data._gear_mode = mode;
        }

        var containsFile = gearJS.dataContainsFile(data);

        var form_data;
        // these are the defaults https://api.jquery.com/jquery.ajax/
        var processData = true;
        var contentType = 'application/x-www-form-urlencoded; charset=UTF-8';
        var cache = true;

        if (!containsFile) {
            // If there's no file in the data, no need to use the over-complicated FormData object :P
            form_data = data;
        } else {
            processData = false;
            contentType = false;
            cache = false;
            form_data = gearJS.convertToFormData(data);
        }

        // noinspection JSUnusedGlobalSymbols


        gearJS.doAjax(processData, contentType, cache, $ele, form_data, loadingToast);
    },
    generateStreamId: function () {
        var S4 = function () {
            return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
        };
        return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
    },
    killStream: function ($ele) {
        if (typeof $ele === "undefined" || $ele === null || !$ele.length) {
            return;
        }
        var eventSource = $ele.data("_gear_stream_event_source");
        if (typeof eventSource === "undefined" || eventSource === null) {
            return;
        }
        eventSource.close();
    },
    doAjax: function (processData, contentType, cache, $ele, form_data, loadingToast) {
        var removalWorkaround = $ele.gearJsAttr("data-gear-removal-workaround") === "yes";
        var gearName = $ele.gearJsAttr("data-gear-name");
        if (typeof gearName === "undefined" || gearName === null || gearName.length < 1) {
            console.error("ERROR: gear name not found. Was the element removed during 'startAction'?");
            // Try setting removalWorkaround to true (However, this won't work if you use any relative elements, as it detaches the gear from the
            // DOM.)
            return;
        }

        if ($ele.gearJsAttr("data-gear-stream-results") === "yes") {
            var stream_id = gearJS.generateStreamId();

            gearJS.addToData(form_data, "_gear_stream_id", stream_id);
            gearJS.addToData(form_data, "_gear_user_id", $ele.gearJsAttr("data-gear-user-id"));

            if (typeof (EventSource) !== "undefined") {
                var eventSource = new EventSource($ele.gearJsAttr("data-gear-stream-url") + "/" + stream_id);

                eventSource.onmessage = function (event) {
                    if (typeof event.data === "string" && event.data.trim().toLowerCase() === "stop") {
                        eventSource.close();
                        return;
                    }
                    var response = JSON.parse(event.data);
                    gearJS.runActions(response, loadingToast, $ele);
                };
                $ele.data("_gear_stream_event_source", eventSource);
            } else {
                console.error("Your browser does not support server-sent events.");
            }
        }

        var ajaxRequest = $.ajax({
            url: $ele.gearJsAttr("data-gear-ajax-url"),
            type: $ele.gearJsAttr("method"),
            data: form_data,
            dataType: "json",
            processData: processData,
            contentType: contentType,
            cache: cache,
            success: function (response) {
                gearJS.hideErrors($ele);
                if (typeof response === "undefined" || response === null) {
                    return false;
                }
                if (typeof response === "string") {
                    try {
                        response = JSON.parse(response);
                    } catch (e) {
                        return false;
                    }
                }

                if (typeof response._gear_dynamicConfirm !== "undefined" &&
                    response._gear_dynamicConfirm.length > 0 &&
                    response._gear_dynamicConfirm === "yes") {

                    if (typeof loadingToast !== "undefined" && loadingToast !== null) {
                        loadingToast.set({time: 0});
                    }
                    // START
                    // START
                    // START
                    // START

                    var preparedPrompts = {};
                    var options = {title: gearJS.message($ele, 'prompt_title'), yes: gearJS.message($ele, 'buttonText'), no: gearJS.message($ele, 'confirmCancel')};
                    var confirmTime = parseInt($ele.gearJsAttr("data-gear-confirm-time"));
                    response._gear_additional_inputs.forEach(function (thisPrompt) {
                        preparedPrompts[thisPrompt.fieldName] =
                            {
                                label: gearJS.prepareConfirmText($ele, thisPrompt.promptLabel),
                                inputType: thisPrompt.promptDialog.inputType,
                                attr: thisPrompt.promptDialog.attr,
                                class: thisPrompt.promptDialog.class,
                                showWhenField: thisPrompt.promptDialog.showWhenField || null,
                                showWhenValue: thisPrompt.promptDialog.showWhenValue || null,
                                showWhenType: thisPrompt.promptDialog.showWhenType || null,
                                beforeInput: gearJS.prepareConfirmText($ele, thisPrompt.promptDialog.beforeInput),
                                afterInput: gearJS.prepareConfirmText($ele, thisPrompt.promptDialog.afterInput),
                                default: gearJS.prepareConfirmText($ele, thisPrompt.value),
                                placeholder: gearJS.prepareConfirmText($ele, thisPrompt.promptDialog.placeholder),
                                labelWidth: thisPrompt.promptDialog.labelWidth,
                                yesType: thisPrompt.promptDialog.yesType,
                            };
                        if (thisPrompt.promptLabel === null || thisPrompt.promptLabel.length < 1) {
                            preparedPrompts[thisPrompt.fieldName].hideLabel = true;
                        }
                        if (thisPrompt.promptDialog.inputType === "radio") {
                            preparedPrompts[thisPrompt.fieldName].radioOptions = thisPrompt.promptDialog.selectOptions;
                        } else {
                            preparedPrompts[thisPrompt.fieldName].selectOptions = thisPrompt.promptDialog.selectOptions;
                        }
                        if (thisPrompt.promptDialog.inputType === "checkbox") {
                            preparedPrompts[thisPrompt.fieldName].checked =
                                (thisPrompt.promptDialog.checkedWhen ===
                                    thisPrompt.defaultPromptValue ||
                                    thisPrompt.value ===
                                    thisPrompt.promptDialog.checkedWhen);
                        }

                        if (thisPrompt.promptDialog.title !== null ||
                            thisPrompt.promptDialog.msg !== null ||
                            thisPrompt.promptDialog.yes !== null ||
                            thisPrompt.promptDialog.no !== null ||
                            thisPrompt.promptDialog.hideOnSubmit !== null) {
                            for (var propName in thisPrompt.promptDialog) {
                                if (thisPrompt.promptDialog.hasOwnProperty(propName)) {
                                    if (thisPrompt.promptDialog[propName] !== null && thisPrompt.promptDialog[propName] !== undefined) {
                                        var thisValue = thisPrompt.promptDialog[propName];
                                        if (["title", "msg", "body", "yes", "no"].indexOf(propName) !== -1) {
                                            thisValue = gearJS.prepareConfirmText($ele, thisValue);
                                        }
                                        options[propName] = thisValue;
                                    }
                                }
                            }
                        }

                    });
                    options.noCallback = function () {
                        gearJS.runActions($ele.gearJsAttr("data-gear-confirm-cancel-actions"), loadingToast, $ele);
                    };
                    options.callback = function (userInput) {
                        if (!(form_data instanceof FormData)) {
                            if (gearJS.dataContainsFile(userInput)) {
                                processData = false;
                                contentType = false;
                                cache = false;
                                form_data = gearJS.convertToFormData(form_data);
                            }
                        }

                        for (var prop in userInput) {
                            if (userInput.hasOwnProperty(prop)) {
                                if (form_data instanceof FormData) {
                                    gearJS.appendSingleToFormData(form_data, prop, userInput[prop]);
                                } else {
                                    form_data[prop] = userInput[prop];
                                }

                            }
                        }
                        var loadingToastMessage = gearJS.prepareConfirmText($ele, $ele.gearJsAttr("data-gear-loading-toast"));
                        var loadingToastIcon = $ele.gearJsAttr("data-gear-loading-toast-icon");
                        if (typeof loadingToast !== "undefined" && loadingToast !== null && loadingToastMessage.length > 0) {
                            loadingToast = toast({"message": loadingToastMessage, "time": -1, "icon": loadingToastIcon})
                        }
                        gearJS.doAjax(processData, contentType, cache, $ele, form_data, loadingToast);
                    };
                    for (var propNameConfirmDialog in response._gear_confirmDialog) {
                        if (response._gear_confirmDialog.hasOwnProperty(propNameConfirmDialog)) {
                            if (response._gear_confirmDialog[propNameConfirmDialog] !==
                                null &&
                                response._gear_confirmDialog[propNameConfirmDialog] !==
                                undefined) {
                                var thisValue = response._gear_confirmDialog[propNameConfirmDialog];
                                if (["title", "msg", "body", "yes", "no"].indexOf(propNameConfirmDialog) !== -1) {
                                    thisValue = gearJS.prepareConfirmText($ele, thisValue);
                                }
                                if (propNameConfirmDialog === "time") {
                                    propNameConfirmDialog = "timer";
                                }
                                if (propNameConfirmDialog === "yesClass") {
                                    propNameConfirmDialog = "yesType";
                                }
                                options[propNameConfirmDialog] = thisValue;
                            }
                        }
                    }
                    // response._gear_confirmDialog
                    promptInput(preparedPrompts, options);

                    // END
                    // END
                    // END
                    // END

                    return;
                }

                gearJS.handleSuccess($ele, response, loadingToast);
                if (removalWorkaround) {
                    $ele.remove();
                }
            }, error: function (response) {
                gearJS.handleError($ele, response, loadingToast);
                if (removalWorkaround) {
                    $ele.remove();
                }
            }
        });
        gearJS.activeAjax[gearName].push(ajaxRequest);
    },
    checkDisableEvents: function ($ele, events) {
        return gearJS.addEvent($ele, events, function () {
            gearJS.checkEnabledStatus($ele);
        });

    },
    hideErrorEvents: function ($ele, events) {
        return gearJS.addEvent($ele, events, function () {
            gearJS.hideErrors($ele);
        });
    },
    addEvent: function ($ele, events, callback) {
        var hasAnEvent = false;
        if (typeof events === "string") {
            try {
                events = JSON.parse(events);
            } catch (e) {
                return false;
            }
        }
        if (typeof events === "undefined") {
            return false;
        }
        if (typeof events.event === "undefined") {
            events.forEach(function (event) {
                if (gearJS.addEvent($ele, event, callback)) {
                    hasAnEvent = true;
                }
            });
            return hasAnEvent;
        }
        var thisDataGrid;
        if (typeof events.dataGrid !== "undefined" && typeof dataGridHelper !== "undefined") {
            thisDataGrid = gearJS.element(events.dataGrid, $ele).dataGrid();
        }
        switch (events.event) {
            case "_dataGridCheck":
                if (typeof dataGridHelper === "undefined") {
                    break;
                }
                if (thisDataGrid !== null) {
                    hasAnEvent = true;
                    dataGridHelper.addAdditionalBinding(thisDataGrid, {
                        element: ".data-grid-checkbox-row", trigger: "change", callback: function () {
                            callback();
                        }
                    });
                }
                break;
            case "_dataGridDraw":
                if (typeof dataGridHelper === "undefined") {
                    break;
                }
                if (thisDataGrid !== null && typeof thisDataGrid.onDraw !== "undefined") {
                    hasAnEvent = true;
                    thisDataGrid.onDraw(function () {
                        callback();
                    });
                }
                break;
            case "_dataGridOpen":
                if (typeof dataGridHelper === "undefined") {
                    break;
                }
                if (!$ele.closest(".data-grid-open").length) {
                    break;
                }
                if (thisDataGrid !== null && typeof thisDataGrid.onOpen !== "undefined") {
                    hasAnEvent = true;
                    thisDataGrid.onOpen(function () {
                        callback();
                    });
                }
                break;
            default:
                hasAnEvent = true;

                if (typeof events.bindTo === "undefined" || events.bindTo === "self") {
                    var $eventElement = gearJS.element(events.element, $ele);
                    $eventElement.on(events.event, function () {
                        callback();
                    });
                } else {
                    var $bindElement = gearJS.element(events.bindTo, $ele);
                    $bindElement.on(events.event, events.element, function () {
                        callback();
                    });
                }

                break;
        }
        return hasAnEvent;

    },
    startConditions: function ($ele, skipActions) {
        skipActions = skipActions || false;
        var startConditions = $ele.gearJsAttr("data-gear-start-conditions");
        if (typeof startConditions === "undefined") {
            return true;
        }
        if (typeof startConditions === "string") {
            try {
                startConditions = JSON.parse(startConditions);
            } catch (e) {
                return false;
            }
        }
        var actionOnFalse = true;
        if (skipActions) {
            actionOnFalse = "noAction";
        }

        return gearJS.checkConditions(startConditions, $ele, actionOnFalse);
    },
    saveGearAttributes: function (ele) {
        var gearID = $(ele).data("gear-js-id");
        if (typeof gearID !== "undefined" && gearID > 0) {
            return true;
        }
        var exportedName = $(ele).attr("data-gear-exported-name");
        var attributes = {};
        if (typeof exportedName !== "undefined" && exportedName.length > 1) {
            attributes = _gear_exported_vars[exportedName];
        }

        // even if we already had the attributes loaded, overload anything that appears directly as an attribute.
        $.each(ele.attributes, function () {
            if (this.specified && this.name.substring(0, 10) === "data-gear-") {
                attributes[this.name.substring(10)] = this.value;
            }
        });
        attributes.$ele = $(ele);
        gearJS.allGears.push(attributes);
        $(ele).data("gear-js-id", gearJS.allGears.length);

        // remove the attributes, we don't need them anymore...
        if (attributes["remove-attr"] !== "no") {
            attributes["exported-name"] = exportedName;
            // no need to do this right away, it's not absolutely required anyway.... (just makes the HTML cleaner)
            setTimeout(function () {
                gearJS.removeGearAttributes($(ele), attributes);
            }, 1000);
        }
    },
    removeGearAttributes: function ($ele, attributesToRemove) {
        for (var attrName in attributesToRemove) {
            if (attributesToRemove.hasOwnProperty(attrName)) {
                $ele.removeAttr("data-gear-" + attrName);
            }
        }
    },
    init: function ($ele) {
        $ele.each(function () {
            var valueAttr = $(this).attr("value");
            if (typeof valueAttr !== "undefined" && valueAttr !== null && valueAttr.length > 0) {
                $(this).val(valueAttr).change();
            }
            gearJS.saveGearAttributes(this);
            // check if the attributes have been saved to "allGears"
            // if not saved yet, save them
            // Remove the unneeded attributes (but not right away, give it some breathing time)
            // allow an option to skip removing attributes
            var $ele = $(this);
            var trigger = $ele.gearJsAttr("data-gear-trigger");
            if (typeof trigger === "undefined" || trigger.length < 1) {
                trigger = "click";
            }
            if (gearJS.checkDisableEvents($ele, $ele.gearJsAttr("data-gear-check-disable-events"))) {
                gearJS.checkEnabledStatus($ele);
            }
            gearJS.hideErrorEvents($ele, $ele.gearJsAttr("data-gear-hide-error-events"));
            if (trigger === "submit" && $ele.is("form")) {
                gearJS.initSubmitButtons($ele);
            }
            $ele.off(trigger);
            $ele.on(trigger, function (e) {
                if ($ele.hasClass("disabled")) {
                    e.preventDefault();
                    return true;
                }
                if (!gearJS.startConditions($ele)) {
                    e.preventDefault();
                    return;
                }

                if ($ele.gearJsAttr("data-gear-confirm") === "yes") {
                    gearJS.confirm($ele, function () {
                        gearJS.triggerFunction($ele);
                    });
                } else {
                    gearJS.triggerFunction($ele);
                }


                e.preventDefault();
            });
            if (trigger === "gearJS_immediate") {
                $ele.trigger(trigger);
            }
            if ($ele.gearJsAttr("run-on-load") === "yes") {
                gearJS.triggerFunction($ele);
            }
            var runEvery = parseInt($ele.gearJsAttr("run-every"));
            if (runEvery !== 0) {
                var interval = setInterval(function () {
                    if (!$ele.parents("html").length) {
                        clearInterval($ele.data("runEveryInterval"));
                        return true;
                    }
                    gearJS.triggerFunction($ele);
                }, runEvery);
                $ele.data("runEveryInterval", interval);
            }
        });

    },
    errorDisp: function ($ele, message, fieldName, errorToastAlways, icon, time, type) {
        var identifier = $ele.gearJsAttr("data-gear-identifier");
        var identifierClause = "";
        if (typeof identifier !== "undefined" && identifier.length > 1) {
            identifierClause = "[data-gear-identifier='" + identifier + "']";
        }
        var gearName = $ele.gearJsAttr("data-gear-name");
        var $errorWrapper = $("[data-gear-error-name='" + gearName + "'][data-gear-error='" + fieldName + "']" + identifierClause);
        if ($errorWrapper.length) {
            $errorWrapper.html(message);
            $errorWrapper.show();
            var $errorCollapse = $errorWrapper.closest(".collapse");
            if ($errorCollapse.length) {
                $errorCollapse.collapse("show");
            }
            if (!errorToastAlways) {
                return true;
            }
        }
        if (fieldName !== "_gear_generic" || $ele.gearJsAttr("data-gear-validation-error-toast") === "yes") {
            toast({message: message, type: type, icon: icon, time: time});
        }
    },
    runActions: function (response, loadingToast, $triggerElement) {
        if (typeof response === "undefined" || response === null) {
            return false;
        }
        if (typeof response === "string") {
            try {
                response = JSON.parse(response);
            } catch (e) {
                return false;
            }
        }
        var toastUpdated = false;
        if (typeof response._notact !== "undefined" && response._notact === true) {
            gearJS.checkConditions(response, $triggerElement);
            return true;
        }
        if (typeof response.action === "undefined" || response.action.length < 1) {
            response.forEach(function (singleResponse) {
                if (typeof singleResponse._notact !== "undefined" && singleResponse._notact === true) {
                    gearJS.checkConditions(singleResponse, $triggerElement);
                    return true;
                }
                var result;
                if (typeof singleResponse.action === "undefined" || singleResponse.action.length < 1) {
                    result = gearJS.runActions(singleResponse, loadingToast, $triggerElement);
                } else {
                    result = gearJS.runSingleAction(singleResponse, loadingToast, $triggerElement);
                }

                if (result === true) {
                    toastUpdated = true;
                }
                if (result !== true && result !== false) {
                    $triggerElement = result;
                }
            });
            return toastUpdated;
        }
        return gearJS.runSingleAction(response, loadingToast, $triggerElement);
    },
    runSingleAction: function (response, loadingToast, $triggerElement) {
        if (typeof response._notact !== "undefined" && response._notact === true) {
            gearJS.checkConditions(response, $triggerElement);
            return true;
        }
        var action = response.action;
        var toastUpdated = false;
        var $element;
        var $insertElement;
        var thisDataGrid = false;
        var $open;
        var $row;
        if (typeof response.dataGrid !== "undefined" && typeof dataGridHelper !== "undefined") {
            thisDataGrid = gearJS.element(response.dataGrid, $triggerElement).dataGrid();
        }
        switch (action) {
            case "copy_text":
                if (typeof response.text !== "undefined") {
                    gearJS.copyToClipboard(response.text, undefined, $triggerElement)
                } else {
                    console.log("Error, no text to copy");
                }
                break;
            case "update_toast":
                if (loadingToast !== null) {
                    loadingToast.set(response);
                }
                toastUpdated = true;
                break;
            case "addToPrompt":
                var inputToAdd = {};
                inputToAdd[response.field] = response.input;
                modalJs.addInputs(inputToAdd, response.allowDuplicates);
                break;
            case "validationError":
                var errorToastIcon = $triggerElement.gearJsAttr("data-gear-error-toast-icon");
                var errorToastType = $triggerElement.gearJsAttr("data-gear-error-toast-type");
                var errorToastAlways = $triggerElement.gearJsAttr("data-gear-error-toast-always") === "yes";
                var errorTime = $triggerElement.gearJsAttr("data-gear-error-toast-time");
                if ($.isArray(response.message)) {
                    response.message.forEach(function (errorSingleMessage) {
                        gearJS.errorDisp($triggerElement, errorSingleMessage, response.field, errorToastAlways, errorToastIcon, errorTime, errorToastType);
                    });
                } else {
                    gearJS.errorDisp($triggerElement, response.message, response.field, errorToastAlways, errorToastIcon, errorTime, errorToastType);
                }
                break;
            case "update_or_toast":
                if (loadingToast !== null) {
                    loadingToast.set(response);
                } else {
                    toast(response);
                }
                toastUpdated = true;
                break;
            case "update_url":
                if (response.update_history === "yes") {
                    window.history.pushState('', '', response.new_url);
                } else {
                    window.history.replaceState("", "", response.new_url);
                }
                break;
            case "url_add_param":
                var newUrlAdded = gearJS.urlParam.add(response.param_name, response.value);
                if (response.update_history === "yes") {
                    window.history.pushState('', '', newUrlAdded);
                } else {
                    window.history.replaceState("", "", newUrlAdded);
                }
                break;
            case "url_remove_param":
                var newUrlRemoved = gearJS.urlParam.remove(response.param_name);
                if (response.update_history === "yes") {
                    window.history.pushState('', '', newUrlRemoved);
                } else {
                    window.history.replaceState("", "", newUrlRemoved);
                }
                break;
            case "custom_event":
                var event = new CustomEvent(response.event_name, {detail: response.event_data, bubbles: true});
                $triggerElement[0].dispatchEvent(event);
                break;
            case "toast":
                toast(response);
                break;
            case "console":
                console.log(response.content);
                break;
            case "data_grid_row":
                var gearName = $triggerElement.gearJsAttr("data-gear-name");
                var $newRow = thisDataGrid.replaceRow(response.rowID, response.content);
                if ($newRow !== false) {
                    if (typeof gearName === "string" && gearName.length > 0) {
                        var $findGear = $newRow.find("[data-gear-name='" + gearName + "']");
                        if ($findGear.length === 1) {
                            return $findGear;
                        }
                    }
                    return $newRow;
                }

                break;
            case "data_grid_detail":
                if (response.rowID === "_trigger") {
                    response.rowID = $triggerElement.closest(".data-grid-tbody").attr("data-row-id");
                }
                if (typeof thisDataGrid !== "undefined" && thisDataGrid !== null && thisDataGrid !== false) {
                    thisDataGrid.addRowDetail(response.rowID, response.detail, response.rowClass, response.removePreviousDetail);
                }
                break;
            case "data_grid_reload_on_close":
                if (typeof thisDataGrid !== "undefined" && thisDataGrid !== null && thisDataGrid !== false) {
                    thisDataGrid.reloadOnClose = true;
                }
                break;
            case "data_grid_reload":
                var pageNum = 1;
                if (response.dataGridKeepPage === "yes") {
                    pageNum = -1; // use current page number when reloading grid
                }
                if (typeof thisDataGrid !== "undefined" && thisDataGrid !== null && thisDataGrid !== false) {
                    thisDataGrid.search(pageNum, response.dataGridMaintainScroll === "yes");
                }
                break;
            case "data_grid_uncheck":
                var $allCheckboxes = thisDataGrid.wrapper.find(".data-grid-checkbox-row");
                $allCheckboxes.prop("checked", false);

                $($allCheckboxes[0]).change();
                break;
            case "data_grid_close_row":
                if (typeof thisDataGrid !== "undefined" && thisDataGrid !== null && thisDataGrid !== false) {
                    thisDataGrid.closeRow();
                }
                break;
            case "data_grid_open_row":
                if (response.rowID === "_trigger") {
                    response.rowID = $triggerElement.closest(".data-grid-tbody").attr("data-row-id");
                    if (typeof response.rowID === "undefined") {
                        $open = $triggerElement.closest(".data-grid-open");
                        if ($open.length) {
                            $row = $open.data("row");
                            if ($row.length) {
                                response.rowID = $row.attr("data-row-id");
                            }
                        }

                    }
                }
                if (typeof thisDataGrid !== "undefined" && thisDataGrid !== null && thisDataGrid !== false) {
                    thisDataGrid.openRowAfterLoading(response.rowID);
                }
                break;
            case "data_grid_open_row_if_open":
                if (thisDataGrid.rowOpen === false) {
                    break;
                }
                if (response.rowID === "_trigger") {
                    response.rowID = $triggerElement.closest(".data-grid-tbody").attr("data-row-id");
                    if (typeof response.rowID === "undefined") {
                        $open = $triggerElement.closest(".data-grid-open");
                        if ($open.length) {
                            $row = $open.data("row");
                            if ($row.length) {
                                response.rowID = $row.attr("data-row-id");
                            }
                        }

                    }
                }
                if (typeof thisDataGrid !== "undefined" && thisDataGrid !== null && thisDataGrid !== false) {
                    thisDataGrid.openRowAfterLoading(response.rowID, null, false, true);
                }
                break;
            case "dropdown_init":
                $element = gearJS.element(response.element, $triggerElement);
                $element.dropdown("dispose");
                $element.dropdown();
                break;
            case "modal":
                $element = gearJS.element(response.element, $triggerElement);
                if (!$element.hasClass("modal")) {
                    $element = $element.closest(".modal");
                }
                if (response.immediate === true) {
                    $element.removeClass("fade");
                }
                $element.modal(response.function);
                if (response.immediate === true) {
                    $element.addClass("fade");
                }
                break;
            case "hide":
                $element = gearJS.element(response.element, $triggerElement);
                $element.hide();
                break;
            case "show":
                $element = gearJS.element(response.element, $triggerElement);
                $element.show();
                break;
            case "toggle":
                $element = gearJS.element(response.element, $triggerElement);
                $element.toggle();
                break;
            case "setAttr":
                $element = gearJS.element(response.element, $triggerElement);
                $element.attr(response.attr, response.value);
                break;
            case "addProp":
                $element = gearJS.element(response.element, $triggerElement);
                $element.prop(response.prop, true);
                break;
            case "removeProp":
                $element = gearJS.element(response.element, $triggerElement);
                $element.prop(response.prop, false);
                break;
            case "trigger":
                $element = gearJS.element(response.element, $triggerElement);
                $element.trigger(response.event);
                break;
            case "remove":
                $element = gearJS.element(response.element, $triggerElement);
                $element.remove();
                break;
            case "focus":
                $element = gearJS.element(response.element, $triggerElement);
                $element.focus();
                break;
            case "refresh":
                if (typeof response.delaySeconds === "undefined" || response.delaySeconds === null || parseInt(response.delaySeconds) < 1) {
                    location.reload();
                } else {
                    window.setTimeout(function () {
                        location.reload();
                    }, parseInt(response.delaySeconds) * 1000);
                }
                break;
            case "redirect":
                location.replace(response.url);
                break;
            case "open_window":
                window.open(response.url, '_blank').focus();
                break;
            case "stop_interval":
                var interval = $triggerElement.data("runEveryInterval");
                if (typeof interval !== "undefined") {
                    clearInterval(interval);
                }
                break;
            case "removeClass":
                $element = gearJS.element(response.element, $triggerElement);
                $element.removeClass(response.class);
                break;
            case "addClass":
                $element = gearJS.element(response.element, $triggerElement);
                $element.addClass(response.class);
                break;
            case "setValue":
                $element = gearJS.element(response.element, $triggerElement);
                $element.val(response.value);
                if (typeof response.triggerChange !== "undefined" && response.triggerChange === true) {
                    $element.trigger("change");
                }
                break;
            case "check":
                $element = gearJS.element(response.element, $triggerElement);
                $element.prop("checked", true);
                if (typeof response.triggerChange !== "undefined" && response.triggerChange === true) {
                    $element.trigger("change");
                }
                break;
            case "css":
                var cssProperties = JSON.parse(response.cssProperties);
                $element = gearJS.element(response.element, $triggerElement);
                $element.css(cssProperties);
                break;
            case "uncheck":
                $element = gearJS.element(response.element, $triggerElement);
                $element.prop("checked", false);
                if (typeof response.triggerChange !== "undefined" && response.triggerChange === true) {
                    $element.trigger("change");
                }
                break;
            case "javascript":
                eval(response.content);
                break;
            case "customFunction":
                window[response.function](gearJS.element(response.element, $triggerElement));
                break;
            case "insertBefore":
                $element = gearJS.element(response.element, $triggerElement);
                if (typeof response.insertElement !== "undefined" && response.insertElement !== null) {
                    $insertElement = gearJS.element(response.insertElement, $triggerElement);
                    $insertElement.insertBefore($element);
                } else {
                    $insertElement = response.insertHtml;
                    $element.before($insertElement);
                }
                gearJS.newlyAddedHtml($element.parent());
                break;
            case "insertAfter":
                $element = gearJS.element(response.element, $triggerElement);
                if (typeof response.insertElement !== "undefined" && response.insertElement !== null) {
                    $insertElement = gearJS.element(response.insertElement, $triggerElement);
                    $insertElement.insertAfter($element);
                } else {
                    $insertElement = response.insertHtml;
                    $element.after($insertElement);
                }
                gearJS.newlyAddedHtml($element.parent());
                break;
            case "html":
                $element = gearJS.element(response.element, $triggerElement);
                if (typeof response.useIframe !== "undefined" && response.useIframe === true) {
                    if (typeof iFrameDom === "undefined" || typeof iFrameDom.include !== "function") {
                        console.log("iFrameDom function not found. Install 'skeets.iframe-dom' through npm.");
                    } else {
                        if (typeof response.iFrameOptions === "undefined" || response.iFrameOptions === null) {
                            response.iFrameOptions = {};
                        }
                        iFrameDom.include($element, response.content, response.iFrameOptions, response.mode);
                    }
                } else {
                    switch (response.mode) {
                        case "append":
                            $element.append(response.content);
                            break;
                        case "prepend":
                            $element.prepend(response.content);
                            break;
                        case "replace":
                            var $newElement = $(response.content);
                            $element.replaceWith($newElement);
                            $element = $newElement;
                            break;
                        default:
                            $element.html(response.content);
                            break;
                    }
                }
                var $bootstrapTooltips = $element.find("[data-toggle='tooltip']");
                if ($bootstrapTooltips.length) {
                    $bootstrapTooltips.tooltip();
                }
                gearJS.newlyAddedHtml($element);
                break;
            case "text":
                $element = gearJS.element(response.element, $triggerElement);
                switch (response.mode) {
                    case "append":
                        $element.append(response.content.replace(/&/g, "&amp;")
                            .replace(/</g, "&lt;")
                            .replace(/>/g, "&gt;")
                            .replace(/"/g, "&quot;")
                            .replace(/'/g, "&#039;"));
                        break;
                    case "prepend":
                        $element.prepend(response.content.replace(/&/g, "&amp;")
                            .replace(/</g, "&lt;")
                            .replace(/>/g, "&gt;")
                            .replace(/"/g, "&quot;")
                            .replace(/'/g, "&#039;"));
                        break;
                    case "replace":
                    default:
                        $element.text(response.content);
                        break;
                }
                break;
        }

        return toastUpdated;
    },
    gatherData: function ($triggerElement) {
        gearJS.promptNeeded = [];
        var sources = $triggerElement.gearJsAttr("data-gear-sources");
        return gearJS.gatherDataInner($triggerElement, sources);
    },
    gatherDataInner: function ($triggerElement, sources) {
        if (typeof sources === "undefined" || sources.length < 1) {
            return {};
        }
        if (typeof sources === "string") {
            try {
                sources = JSON.parse(sources);
            } catch (e) {
                console.log("Error, unable to parse sources");
                return {};
            }
        }
        var data = {};
        for (var i = 0; i < sources.length; i++) {
            var source = sources[i];
            gearJS.gatherSingleSource(data, source, $triggerElement);
            var sourceArray = gearJS.objToArray(data[source.fieldName]);
            if (source.glue !== false && Array.isArray(sourceArray)) {
                var result = "";
                var first = true;
                sourceArray.forEach(function (pieceOfResult) {
                    if (!first) {
                        result += source.glue;
                    }
                    if (typeof pieceOfResult === "object" && typeof pieceOfResult.value !== "undefined") {
                        result += pieceOfResult.value;
                    } else {
                        result += pieceOfResult;
                    }
                    first = false;
                });
                data[source.fieldName] = result;
            }
        }

        return data;
    },
    gatherFromForm: function (data, $element) {
        if ($element === false) {
            return true;
        }

        var $form = $element;

        if ($form && !$form.is("form")) {
            $form = $form.closest('form');
            if(!$form.length){
                return true;
            }
        }

        var formData = new FormData($form[0]);
        var additionalData = gearJS.formDataToObject(formData);
        var skipDatagridSortInputs = $element.gearJsAttr("data-gear-skip-datagrid-inputs") === "yes";
        for (var property in additionalData) {
            if (additionalData.hasOwnProperty(property)) {
                if (skipDatagridSortInputs && property.lastIndexOf("sort-") === 0) {
                    continue;
                }
                if (skipDatagridSortInputs && property.lastIndexOf("dataGridSessionInput") === 0) {
                    continue;
                }
                data[property] = additionalData[property];
            }
        }
        var $clickedSubmitButton = $form.find("input[type=submit][data-gear-clicked-submit='yes'], button[data-gear-clicked-submit='yes']");
        if ($clickedSubmitButton.length === 1) {
            var buttonName = $clickedSubmitButton.attr("name");
            if (typeof buttonName !== "undefined" && buttonName.length > 0) {
                data[buttonName] = $clickedSubmitButton.val();
            }
        }
        $clickedSubmitButton.attr("data-gear-clicked-submit", "no");
    },
    gatherForDataGridQuery: function (data, $element) {
        if ($element === false) {
            return true;
        }

        data["_dataGridGlobalInput"] = $element.dataGrid().gatherVars();
    },
    checkSingleCondition: function (condition, $triggerElement, actionOnFalse) {
        var output = true;
        var $ConditionElement = false;
        var thisDataGrid = false;
        if (typeof condition.element !== "undefined") {
            $ConditionElement = gearJS.element(condition.element, $triggerElement);
        }
        if (typeof condition.dataGrid !== "undefined" && typeof dataGridHelper !== "undefined") {
            thisDataGrid = gearJS.element(condition.dataGrid, $triggerElement).dataGrid();
        }
        switch (condition.type) {
            case "exists":
                if ($ConditionElement === false || !$ConditionElement.length) {
                    output = false;
                }
                break;
            case "checked":
                if ($ConditionElement === false || !$ConditionElement.length || !$ConditionElement.is(":checked")) {
                    output = false;
                }
                break;
            case "unchecked":
                if ($ConditionElement === false || !$ConditionElement.length || $ConditionElement.is(":checked")) {
                    output = false;
                }
                break;
            case "is":
                if ($ConditionElement === false || !$ConditionElement.length || !$ConditionElement.is(condition.is)) {
                    output = false;
                }
                break;
            case "dataGridOneChecked":
                if (thisDataGrid === false || thisDataGrid.checkedRows().length < 1) {
                    output = false;
                }
                break;
            case "dataGrid":
                if (thisDataGrid === false) {
                    output = false;
                }
                var $row;
                if (condition.rowID === "_trigger") {
                    $row = dataGridHelper.getRowFromElement($triggerElement);
                    if (!($row instanceof jQuery)) {
                        break;
                    }
                } else {
                    $row = thisDataGrid.rowElem(condition.rowID);
                }


                var value = dataGridHelper.getRowDataValue($row, condition.columnName);
                if ($.isArray(condition.value)) {
                    if ($.inArray(value, condition.value) === -1) {
                        output = false;
                    }
                } else {
                    if (value !== condition.value) {
                        output = false;
                    }
                }

                break;
            case "dataGridNotEmpty":
                if (thisDataGrid === false) {
                    output = false;
                }
                var $row;
                if (condition.rowID === "_trigger") {
                    $row = dataGridHelper.getRowFromElement($triggerElement);
                    if (!($row instanceof jQuery)) {
                        break;
                    }
                } else {
                    $row = thisDataGrid.rowElem(condition.rowID);
                }


                var value = dataGridHelper.getRowDataValue($row, condition.columnName);

                if (typeof value === "undefined" || value.length < 1) {
                    output = false;
                }
                break;
            case "dataGridOneCheckedValue":
                if (thisDataGrid === false || thisDataGrid.checkedRowsWithValue(condition.field, condition.value).length < 1) {
                    output = false;
                }
                break;
            case "dataGridAllCheckedHaveValue":
                if (thisDataGrid ===
                    false ||
                    thisDataGrid.checkedRowsWithValue(condition.field, condition.value).length !==
                    thisDataGrid.checkedRows().length) {
                    output = false;
                }
                break;
            case "or":
                if (!gearJS.checkConditions(condition.conditions, $triggerElement, actionOnFalse, true)) {
                    output = false;
                }
                break;
            case "dataGridNotOneChecked":
                if (thisDataGrid === false || thisDataGrid.checkedRows().length > 0) {
                    output = false;
                }
                break;
            case "dataGridNotOneCheckedValue":
                if (thisDataGrid === false || thisDataGrid.checkedRowsWithValue(condition.field, condition.value).length > 0) {
                    output = false;
                }
                break;
            case "attr":
                if ($.isArray(condition.value)) {
                    if ($ConditionElement === false || $.inArray($ConditionElement.attr(condition.attr), condition.value) === -1) {
                        output = false;
                    }
                } else {
                    if ($ConditionElement === false || $ConditionElement.attr(condition.attr) !== condition.value) {
                        output = false;
                    }
                }
                break;
            case "val":
                if ($.isArray(condition.value)) {
                    if ($ConditionElement === false || $.inArray($ConditionElement.val(), condition.value) === -1) {
                        output = false;
                    }
                } else {
                    if ($ConditionElement === false || $ConditionElement.val() !== condition.value) {
                        output = false;
                    }
                }

                break;
            case "not_val":
                output = false;
                if ($.isArray(condition.value)) {
                    if ($ConditionElement === false || $.inArray($ConditionElement.val(), condition.value) === -1) {
                        output = true;
                    }
                } else {
                    if ($ConditionElement === false || $ConditionElement.val() !== condition.value) {
                        output = true;
                    }
                }

                break;
        }
        if (typeof condition.invert !== "undefined" && condition.invert === true) {
            output = !output;
        }
        if (actionOnFalse !== "noAction") {
            if (((actionOnFalse && output === false) || (!actionOnFalse && output === true)) && typeof condition.action !== "undefined") {
                gearJS.runActions(condition.action, null, $triggerElement);
            }
        }
        return output;
    },
    checkConditions: function (conditions, $triggerElement, actionOnFalse, orBinding) {
        actionOnFalse = actionOnFalse || false;
        orBinding = orBinding || false;
        var thisActionOnFalse;
        var output = true;
        if (orBinding) {
            output = false;
        }
        if (typeof conditions === "undefined" || conditions === null) {
            return true;
        }
        if (typeof conditions.type !== "undefined" && conditions.type.length > 0) {
            conditions = [conditions];
        }
        for (var j = 0; j < conditions.length; j++) {
            var condition = conditions[j];
            thisActionOnFalse = actionOnFalse;
            if (condition.actionOnFalse !== "default") {
                thisActionOnFalse = condition.actionOnFalse;
            }
            if (gearJS.checkSingleCondition(condition, $triggerElement, thisActionOnFalse)) {
                if (orBinding) {
                    output = true;
                }
            } else {
                if (!orBinding) {
                    output = false;
                }
            }
        }
        return output;
    },
    gatherSingleSource: function (data, source, $triggerElement) {
        var eachElement = false;
        var $eachElement;
        if (source.prompt) {
            if (typeof source.fieldName === "undefined" || source.fieldName.length < 1) {
                return true;
            }
            source.prompt = false;
            var tmpData = {};
            this.gatherSingleSource(tmpData, source, $triggerElement);
            source.prompt = true;
            source.defaultPromptValue = tmpData[source.fieldName];
            // check if it's a string
            if (typeof source.defaultPromptValue !== "string") {
                var tmpDataB = {};
                source.defaultPromptValue = this.gatherSingleSource(tmpDataB, source.defaultPromptValue, $triggerElement);
                source.defaultPromptValue = tmpDataB[source.fieldName];
            }

            gearJS.promptNeeded.push(source);
            return true;
        }


        if (typeof source.eachElement !== "undefined" && source.eachElement !== null) {
            eachElement = true;
            $eachElement = gearJS.element(source.eachElement, $triggerElement);
        }

        if (!gearJS.checkConditions(source.conditions, $triggerElement, true)) {
            return true;
        }

        if (typeof source.dataGridQueryIfChecked !== "undefined" && source.dataGridQueryIfChecked === true) {
            if (typeof source.fieldName !== "undefined" && source.fieldName.length > 0) {
                var datagrid = $triggerElement.dataGrid();
                if (datagrid !== false && $(".data-grid-checkbox-query-input[data-grid-session-id='" + datagrid.id + "']").is(":checked")) {
                    var allowCheckQuery = $triggerElement.gearJsAttr("data-grid-check-query") == "yes";
                    if (!allowCheckQuery) {
                        toast({
                            "message": gearJS.message($triggerElement, 'query_selection_unsupported'),
                            "type": "danger"
                        });
                        throw "Selecting rows not currently displayed is not supported for this action.";
                    }
                    var field = source.fieldName;

                    gearJS.gatherForDataGridQuery(data, $triggerElement);
                    gearJS.addToData(data, field, "_dataGridQuery", false);
                    return true;
                }
            }
        }

        if (eachElement) {
            if ($eachElement === false) {
                return true;
            }
            $eachElement.each(function () {
                gearJS.gatherAfterVerify(data, source, $triggerElement, $(this));
            });
        } else {
            gearJS.gatherAfterVerify(data, source, $triggerElement);
        }
    },

    gatherAfterVerify: function (data, source, $triggerElement, $eachElement) {
        var $element;
        if (typeof source.element === "undefined" || source.element === null) {
            $element = $triggerElement;
        } else {
            $element = gearJS.element(source.element, $triggerElement, $eachElement);
        }
        var returnArray = source.array || false;
        if (typeof source.eachConditions !== "undefined") {
            for (var k = 0; k < source.eachConditions.length; k++) {
                var condition = source.eachConditions[k];
                var $ConditionElement = gearJS.element(condition.element, $triggerElement, $eachElement);
                if ($ConditionElement === false || !$ConditionElement.length || !$ConditionElement.is(condition.is)) {
                    return true;
                }
            }
        }

        if (typeof source.form !== "undefined" && source.form === true) {
            gearJS.gatherFromForm(data, $element);
            return true;
        }
        if (typeof source.fieldName === "undefined" || source.fieldName.length < 1) {
            return true;
        }
        var field = source.fieldName;

        if (typeof source.js !== "undefined" && source.js.length > 0) {
            gearJS.addToData(data, field, eval(source.js));
            return true;
        }

        if (typeof source.elementData !== "undefined" && source.elementData.length > 0) {
            var returnValue = $element.data(source.elementData);

            if (typeof source.elementDataSub !== "undefined" && source.elementDataSub.length > 0) {
                returnValue = returnValue[source.elementDataSub];
            }
            gearJS.addToData(data, field, returnValue, returnArray);
            return true;
        }


        if (typeof source.dataGridQuery !== "undefined" && source.dataGridQuery === true) {
            gearJS.gatherForDataGridQuery(data, $element);
            gearJS.addToData(data, field, "_dataGridQuery", returnArray);
            return true;
        }

        if (typeof source.value !== "undefined" && source.value !== null) {
            gearJS.addToData(data, field, source.value, returnArray);
            return true;
        }
        if (typeof source.fromUrl !== "undefined" && source.fromUrl === true) {
            if (typeof source.urlParam !== "undefined" && source.urlParam.length > 0) {
                var urlParams = new URLSearchParams(window.location.search);

                gearJS.addToData(data, field, urlParams.get(source.urlParam), returnArray);
                return true;
            }
            gearJS.addToData(data, field, window.location.href, returnArray);
            return true;
        }
        if (typeof source.fromDataGrid !== "undefined" && source.fromDataGrid === true) {

            gearJS.gatherFromDataGridColumn(data, source, field, $element, returnArray);
            return true;
        }

        if (typeof $element === "undefined" || $element === null || $element === false) {
            gearJS.addToData(data, field, "", returnArray);
            return true;
        }

        gearJS.gatherFromAttribute(data, source, field, $element, returnArray);
    },

    gatherFromDataGridColumn: function (data, source, field, $element, returnArray) {
        var output = "";
        if (typeof dataGridHelper === "undefined") {
            gearJS.addToData(data, field, output, returnArray);
            return true;
        }

        if (typeof source.attribute === "undefined" || source.attribute.length < 1) {
            gearJS.addToData(data, field, output, returnArray);
            return true;
        }
        var $dataGridRow;
        if (source.dataGridFirstRow === "yes") {
            $dataGridRow = $element.dataGrid().getRowNumElem(1);
        } else {
            if (source.dataGridFirstRow === "checked") {
                $dataGridRow = $element.dataGrid().getRowNumElem(1, true);
            } else {
                $dataGridRow = dataGridHelper.getRowFromElement($element);
            }
        }
        var rowID = $dataGridRow.attr("data-row-id");
        if (source.attribute === "row_id") {
            gearJS.addToData(data, field, rowID, returnArray);
            return true;
        }
        output = dataGridHelper.getRowDataValue($dataGridRow, source.attribute);
        if (source.dataGridColValOnly) {
            gearJS.addToData(data, field, output, returnArray);
        } else {
            gearJS.addToData(data, field, output, returnArray, rowID);
        }

        return true;
    },

    gatherFromAttribute: function (data, source, field, $element, returnArray) {
        var attribute;

        if (typeof source.attribute === "undefined" || source.attribute.length < 1) {
            attribute = "val";
        } else {
            attribute = source.attribute;
        }
        switch (attribute) {

            case "text":
            case "_text":
                gearJS.addToData(data, field, $element.text().trim(), returnArray);
                break;
            case "html":
            case "_html":
                gearJS.addToData(data, field, $element.html().trim(), returnArray);
                break;
            case "val":
                gearJS.addToData(data, field, $element.val(), returnArray);
                break;
            case "checked":
                gearJS.addToData(data, field, $element.is(":checked"), returnArray);
                break;
            case "unchecked":
                gearJS.addToData(data, field, !$element.is(":checked"), returnArray);
                break;
            default:
                gearJS.addToData(data, field, $element.attr(attribute), returnArray);
                break;

        }
        if (attribute === "val") {

        } else {

        }
    },

    addToData: function (data, field, value, isArray, arrayIndex) {
        if (isArray) {
            if (typeof data[field] === "undefined") {
                if (typeof arrayIndex === "undefined") {
                    data[field] = [];
                } else {
                    data[field] = {};
                }
            }
            if (typeof arrayIndex === "undefined") {
                data[field].push(value);
                return;
            }
            if (typeof arrayIndex !== "undefined" && typeof data[field][arrayIndex] === "undefined") {
                data[field][arrayIndex] = value;
            } else {
                console.log("Warning.... duplicate array indexes found. Is this in a datagrid with multiple rows with the same row_id?");
                gearJS.addToData(data, field, value, isArray, "_" + arrayIndex)
            }

        } else {
            data[field] = value;
        }
    },
    element: function (elementObj, $triggerElement, $eachElement) {
        if (typeof elementObj === "string") {
            elementObj = JSON.parse(elementObj);
        }
        var $output = null;
        var relative = "global";
        var selector;
        elementObj.trace.forEach(function (thisTrace) {
            selector = thisTrace[0];

            if (selector === "this") {
                if (typeof $eachElement !== "undefined" && $eachElement.length) {
                    selector = $eachElement;
                } else {
                    selector = $triggerElement;
                }
            }
            if (selector === "trigger" || selector === "_trigger") {
                selector = $triggerElement;
            }
            if ($output === null) {
                if (selector instanceof jQuery) {
                    $output = selector;
                } else {
                    $output = $(selector);
                }

            } else {
                switch (relative) {
                    case "find":
                        $output = $output.find(selector);
                        break;
                    case "closest":
                        $output = $output.closest(selector);
                        break;
                    default:
                        $output = false;
                        return false;
                }
            }
            relative = thisTrace[1];

        });
        if ($output !== null && ($output === false || !$output.length)) {
            return $output;
        }


        selector = elementObj.selector;
        if (selector === "this") {
            if (typeof $eachElement !== "undefined" && $eachElement.length) {
                selector = $eachElement;
            } else {
                selector = $triggerElement;
            }

        }
        if (selector === "trigger" || selector === "_trigger") {
            selector = $triggerElement;
        }
        if ($output === null) {
            relative = "no";
        }
        switch (relative) {
            case "find":
                if ($output !== null) {
                    $output = $output.find(selector);
                }
                break;
            case "closest":
                if ($output !== null) {
                    $output = $output.closest(selector);
                }
                break;
            default:
                $output = $(selector);
                break;

        }

        return $output;

    },
    serializedArrayToObject: function (array) {
        var output = {};
        array.forEach(function (element) {
            if (typeof output[element.name] === "undefined") {
                output[element.name] = element.value;
            } else {
                if (typeof output[element.name] === "object") {
                    output[element.name].push(element.value);
                } else {
                    output[element.name] = [output[element.name], element.value];
                }

            }

        });

        return output;
    },
    formDataToObject: function (formData) {
        var output = {};
        for (var pair of formData.entries()) {
            if (typeof output[pair[0]] === "undefined") {
                output[pair[0]] = pair[1];
            } else {
                if (typeof output[pair[0]] === "object") {
                    output[pair[0]].push(pair[1]);
                } else {
                    output[pair[0]] = [output[pair[0]], pair[1]];
                }

            }
        }
        return output;
    },
    checkEnabledStatus: function ($ele) {

        var whenConditionsFail = $ele.gearJsAttr("data-gear-when-conditions-fail");
        var whenConditionsFailTitle = $ele.gearJsAttr("data-gear-when-conditions-fail-title");
        if (whenConditionsFail !== "hide") {
            whenConditionsFail = "disable";
        }

        var conditionsSuccess = gearJS.startConditions($ele, true);
        if ($ele.is("form")) {
            $ele = $ele.find("[type=submit]");
        }

        if (conditionsSuccess) {
            if (whenConditionsFail === "hide") {
                $ele.show();
            } else {
                $ele.removeClass("disabled");
            }
        } else {
            if (whenConditionsFail === "hide") {
                $ele.hide();
            } else {
                $ele.addClass("disabled");
            }
        }

        var $tooltipWrapper;
        if (typeof whenConditionsFailTitle !== "undefined" && whenConditionsFailTitle.length > 0) {
            if (conditionsSuccess) {
                $tooltipWrapper = $ele.closest(".gear-js-tooltip-wrapper");
                if ($tooltipWrapper.length) {
                    $tooltipWrapper.tooltip("dispose");
                    $tooltipWrapper.attr("title", "");
                }
            } else {
                // need to wrap the element first because it's disabled and has no pointer events...
                $tooltipWrapper = $ele.closest(".gear-js-tooltip-wrapper");
                if (!$tooltipWrapper.length) {
                    $tooltipWrapper = $("<div>",
                        {
                            class: "gear-js-tooltip-wrapper",
                            style: "display: inline-block;"
                        });
                    $ele.wrap(function () {
                        return $tooltipWrapper;
                    });
                }
                $tooltipWrapper = $ele.closest(".gear-js-tooltip-wrapper");
                $tooltipWrapper.tooltip("dispose");
                $tooltipWrapper.attr("title", whenConditionsFailTitle);
                $tooltipWrapper.tooltip();
            }
        }
    },
    objToArray: function (source) {
        if (Array.isArray(source)) {
            return source;
        }
        if (typeof source !== "object") {
            return source;
        }
        var output = [];
        var key;
        for (key in source) {
            if (source.hasOwnProperty(key)) {
                output.push(source[key]);
            }
        }
        return output;
    },
    urlParam: {
        remove: function (paramName, url) {
            url = url || window.location.href;
            var reA = new RegExp("&" + paramName + "=[^&#]*", "g");
            var reB = new RegExp("\\?" + paramName + "=[^&#]*&", "g");
            var reC = new RegExp("\\?" + paramName + "=[^&#]*", "g");
            url = url.replace(reA, "");
            url = url.replace(reB, "?");
            url = url.replace(reC, "");

            return url;
        },
        add: function (paramName, value, url) {
            url = url || window.location.href;
            url = url.replace(/#.*$/g, "");
            url = gearJS.urlParam.remove(paramName, url);
            if (url.indexOf("?") !== -1) {
                var count = (url.match(/\?/g) || []).length;
                if (url.substr(-1) === "?" && count === 1) {
                    url += paramName + "=";
                } else {
                    url += "&" + paramName + "=";
                }
            } else {
                url += "?" + paramName + "=";
            }
            url += value;

            return url;
        }
    },
    convertToFormData: function (data) {
        var form_data = new FormData();
        gearJS.appendToFormData(form_data, data);
        return form_data;
    },
    appendToFormData: function (form_data, appendData) {
        for (var key in appendData) {
            gearJS.appendSingleToFormData(form_data, key, appendData[key]);
        }
    },
    appendSingleToFormData: function (form_data, key, value) {
        if (Array.isArray(value)) {
            value.forEach(item => gearJS.appendSingleToFormData(form_data, `${key}`, item));
            return;
        }
        form_data.append(key, value);
    },
    dataContainsFile: function (data) {
        var containsFile = false;
        for (var fileTestKey in data) {
            if (data[fileTestKey] instanceof File) {
                containsFile = true;
                break;
            }
        }
        return containsFile;
    }
};

jQuery.fn.extend({
    gearJsAttr: function (attrName, newValue) {
        if (attrName.substring(0, 10) === "data-gear-") {
            attrName = attrName.substring(10);
        }
        var gearID = $(this).data("gear-js-id");
        if (typeof gearID === "undefined" || gearID < 1) {
            if (typeof newValue !== "undefined") {
                $(this).attr("data-gear-" + attrName, newValue);
                return $(this);
            }
            return $(this).attr("data-gear-" + attrName);
        }
        if (typeof newValue !== "undefined") {
            gearJS.allGears[gearID - 1][attrName] = newValue;
            return $(this);
        }
        return gearJS.allGears[gearID - 1][attrName];

    }
});


jQuery.fn.extend({
    gearJsTriggered: function () {
        var thisGear = this.gearJs();
        if (typeof thisGear === "undefined" || thisGear === false ||
            typeof thisGear.customTriggerFunctions === "undefined" ||
            typeof thisGear.customTriggerFunctions.forEach !== 'function') {
            return false;
        }
        var that = this[0];
        thisGear.customTriggerFunctions.forEach(function (customTriggerFunction) {
            customTriggerFunction.apply(that);
        });
    }
});

jQuery.fn.extend({
    gearJsTrigger: function (callback, onlyBindOnce) {
        onlyBindOnce = onlyBindOnce || false;
        if (!$(this).length) {
            console.log("gearJsTrigger called on an empty jQuery object");
            return;
        }
        $(this).each(function () {
            var thisGear = $(this).gearJs();
            if (typeof thisGear === "undefined" || thisGear === false) {
                return true;
            }
            if (typeof thisGear.customTriggerFunctions === "undefined") {
                thisGear.customTriggerFunctions = [];
            }

            if (onlyBindOnce && thisGear.customTriggerFunctions.length > 0) {
                return true;
            }

            thisGear.customTriggerFunctions.push(callback);
        });

    }
});

jQuery.fn.extend({
    gearJsSucceeded: function (thisGear) {
        if (typeof thisGear === "undefined" || thisGear === false ||
            typeof thisGear.customSuccessFunctions === "undefined" ||
            typeof thisGear.customSuccessFunctions.forEach !== 'function') {
            return false;
        }
        var that = this[0];
        thisGear.customSuccessFunctions.forEach(function (customTriggerFunction) {
            customTriggerFunction.apply(that);
        });
    }
});

jQuery.fn.extend({
    gearJsSuccess: function (callback, onlyBindOnce) {
        onlyBindOnce = onlyBindOnce || false;
        if (!$(this).length) {
            console.log("gearJsSuccess called on an empty jQuery object");
            return;
        }
        $(this).each(function () {
            var thisGear = $(this).gearJs();
            if (typeof thisGear === "undefined" || thisGear === false) {
                return true;
            }
            if (typeof thisGear.customSuccessFunctions === "undefined") {
                thisGear.customSuccessFunctions = [];
            }

            if (onlyBindOnce && thisGear.customSuccessFunctions.length > 0) {
                return true;
            }

            thisGear.customSuccessFunctions.push(callback);
        });

    }
});


jQuery.fn.extend({
    gearJsFailed: function () {
        var thisGear = this.gearJs();
        if (typeof thisGear === "undefined" || thisGear === false ||
            typeof thisGear.customFailFunctions === "undefined" ||
            typeof thisGear.customFailFunctions.forEach !== 'function') {
            return false;
        }
        var that = this[0];
        thisGear.customFailFunctions.forEach(function (customTriggerFunction) {
            customTriggerFunction.apply(that);
        });
    }
});

jQuery.fn.extend({
    gearJsFail: function (callback, onlyBindOnce) {
        onlyBindOnce = onlyBindOnce || false;
        if (!$(this).length) {
            console.log("gearJsFail called on an empty jQuery object");
            return;
        }
        $(this).each(function () {
            var thisGear = $(this).gearJs();
            if (typeof thisGear === "undefined" || thisGear === false) {
                return true;
            }
            if (typeof thisGear.customFailFunctions === "undefined") {
                thisGear.customFailFunctions = [];
            }

            if (onlyBindOnce && thisGear.customFailFunctions.length > 0) {
                return true;
            }

            thisGear.customFailFunctions.push(callback);
        });

    }
});


jQuery.fn.extend({
    gearJs: function () {
        var gearID = $(this).data("gear-js-id");
        if (typeof gearID === "undefined" || gearID < 1) {
            return false;
        }
        return gearJS.allGears[gearID - 1];

    }
});
jQuery.fn.extend({
    gearJsAuto: function () {
        gearJS.auto($(this));
    }
});


gearJS.auto();

// export {gearJS};

/* resources/assets/js/vendor/markdown/markdown.js */
$("body").on("submit", ".markdown-refresh-query-form", function(e) {
  e.preventDefault();
  var postData = serializedArrayToObject($(this).serializeArray());
  var that     = this;
  $.ajax({
    url    : $(this).attr("action"),
    type   : "POST",
    data   : postData,
    success: function(response) {
      $(that).closest(".card").replaceWith(response);

    }
    , error: function(response) {
      toast("Query refresh error");
    }
  });
});


function serializedArrayToObject(array)
{
  var output = {};
  array.forEach(function(element) {
    if (typeof output[element.name] === "undefined") {
      output[element.name] = element.value;
    }
    else {
      if (typeof output[element.name] === "object") {
        output[element.name].push(element.value);
      }
      else {
        output[element.name] = [output[element.name], element.value];
      }

    }

  });

  return output;
}

/* resources/assets/js/node_modules/skeets.conditional/conditional.js */
/**
 * Conditional.js - created 2020.09.14-TSO
 *
 * Show / hide content based on value of a given input.
 *
 * 2022.02.23-TSO: added "dynamic".
 *
 */

conditionalJsAuto($("body"));

function conditionalJsVars(element)
{
  var target  = $(element).attr("data-conditional-target");
  var value   = $(element).attr("data-conditional-value");
  var wrapper = $(element).attr("data-conditional-wrapper");
  var type    = $(element).attr("data-conditional-type");
  var option  = $(element).attr("data-conditional");
  var method  = $(element).attr("data-conditional-method");
  var focus   = $(element).attr("data-conditional-focus");
  var trigger = $(element).attr("data-conditional-trigger");

  var not = false;
  var $target;
  if (typeof target === "undefined" || target.length < 1) {
    return false;
  }
  if (typeof method === "undefined" || method.length < 1) {
    method = "display";
  }
  focus = typeof focus !== "undefined" && focus.length > 0;
  if (typeof option !== "undefined" && option === "not") {
    not = true;
  }
  if (typeof type === "undefined" || type.length < 1) {
    if (typeof value !== "undefined") {
      type = "value";
    }
    else {
      type = "not_empty";
    }
  }
  if (typeof wrapper !== "undefined" && wrapper.length > 1) {
    $target = $(element).closest(wrapper).find(target);
  }
  else {
    $target = $(target);
  }
  if (!$target.length) {
    return false;
  }
  return {$target: $target, value: value, type: type, not: not, method: method, focus: focus, trigger: trigger};
}

function dynamicJsVars(element)
{
  var target    = $(element).attr("data-dynamic-target");
  var inputRaw  = $(element).attr("data-dynamic-input-raw");
  var lowerCase = $(element).attr("data-dynamic-lower-case");
  var useHtml   = $(element).attr("data-dynamic-html");
  var wrapper   = $(element).attr("data-dynamic-wrapper");
  var trigger   = $(element).attr("data-dynamic-trigger");

  var $target;
  if (typeof target === "undefined" || target.length < 1) {
    return false;
  }
  if (typeof wrapper !== "undefined" && wrapper.length > 1) {
    $target = $(element).closest(wrapper).find(target);
  }
  else {
    $target = $(target);
  }
  if (!$target.length) {
    return false;
  }
  return {$target: $target, inputRaw: inputRaw, lowerCase: lowerCase, useHtml: useHtml, trigger: trigger};
}

function conditionalJsIf($element, conditional)
{
  var output;

  switch (conditional.type.toLowerCase()) {
    case "radio":
      output = conditional.$target.filter("[value='" + conditional.value + "']:checked").length;
      break;
    case "length":
      output = $element.val().length >= parseInt(conditional.value);
      break;
    case "longer_than":
      output = $element.val().length > parseInt(conditional.value);
      break;
    case "shorter_than":
      output = $element.val().length < parseInt(conditional.value);
      break;
    case "check":
    case "checked":
    case "checkbox":
      output = $element.is(":checked");
      break;
    case "value":
      output = $element.val() === conditional.value;
      break;
    case "contains":
      output = $element.val().indexOf(conditional.value) !== -1;
      break;
    case "array":
      output         = false;
      var valueArray = conditional.value.split(",");
      var elementVal = $element.val();
      valueArray.forEach(function(singleValue) {
        if (elementVal === singleValue.trim()) {
          output = true;
        }
      });
      break;
    default:
    case "not_empty":
      output = $element.val().length > 0;
      break;
  }
  if (conditional.not) {
    return !output;
  }
  else {
    return output;
  }
}

function conditionalJsHide(element, conditional)
{
  switch (conditional.method) {
    case "enable":
    case "enabled":
    case "disable":
    case "disabled":
      $(element).prop("disabled", true);
      break;
    case "read-only":
    case "readonly":
      $(element).prop("readonly", true);
      break;
    case "visible":
    case "invisible":
    case "visibility":
      $(element).css({visibility: "hidden"});
      break;
    default:
      $(element).hide();
      break;
  }
}

function conditionalJsShow(element, conditional)
{
  switch (conditional.method) {
    case "enable":
    case "enabled":
    case "disable":
    case "disabled":
      $(element).prop("disabled", false);
      break;
    case "read-only":
    case "readonly":
      $(element).prop("readonly", false);
      break;
    case "visible":
    case "invisible":
    case "visibility":
      $(element).css({visibility: "visible"});
      break;
    default:
      $(element).show();
      break;
  }
  if (conditional.focus) {
    $(element).focus();
  }
}

function dynamicJsContent($element, $input, dynamic)
{
  var getDisplayText = true;
  if (typeof dynamic.inputRaw !== "undefined" && dynamic.inputRaw === "yes") {
    getDisplayText = false;
  }
  var displayText = $input.val();

  if (getDisplayText) {
    displayText = dynamicJsDisplayText($input);
  }

  if (typeof dynamic.lowerCase !== "undefined" && dynamic.lowerCase === "yes") {
    displayText = displayText.toLowerCase();
  }
  if (typeof dynamic.useHtml !== "undefined" && dynamic.useHtml === "yes") {
    $element.html(displayText);
  }
  else {
    $element.text(displayText);
  }

}

function dynamicJsDisplayText($input)
{
  if (!$input.length) {
    return "";
  }
  var value = $input.val();
  if ($input.is("select")) {

    var $option = $input.find("option[value='" + value + "']:first");
    if (!$option.length) {
      return value;
    }
    return $option.html();
  }

  if (!$input.is("[type='checkbox']") && !$input.is("[type='radio']")) {
    return value;
  }

  var inputId = $input.attr("id");
  var $label;
  if (typeof inputId !== "undefined" && inputId.length > 0) {
    $label = $("label[for='" + inputId + "']:first");
    if ($label.length) {
      return $label.html();
    }
  }
  $label = $input.closest("label");
  if ($label.length) {
    return $label.text();
  }
  return value;
}

function conditionalJsAuto($wrapper)
{
  $wrapper.find(".dynamic-content").each(function() {
    var dynamic = dynamicJsVars(this);
    if (dynamic === false) {
      return true;
    }

    var $that   = $(this);
    var trigger = dynamic.trigger || "change";
    //---- trigger
    dynamic.$target.on(trigger, function() {
      dynamicJsContent($that, $(this), dynamic);
    });
    //--- init
    dynamicJsContent($that, dynamic.$target, dynamic);
    //----
  });
  $wrapper.find(".conditional, .conditional-show").each(function() {
    var conditional = conditionalJsVars(this);
    if (conditional === false) {
      return true;
    }

    var that    = this;
    var trigger = conditional.trigger || "change";
    //---- trigger
    conditional.$target.on(trigger, function() {
      if (conditionalJsIf($(this), conditional)) {
        conditionalJsShow(that, conditional);
      }
      else {
        conditionalJsHide(that, conditional);
      }
    });
    //----init
    if (conditionalJsIf(conditional.$target, conditional)) {
      conditionalJsShow(that, conditional);
    }
    else {
      conditionalJsHide(that, conditional);
    }
    //----
  });
  $wrapper.find(".conditional-hide").each(function() {
    var conditional = conditionalJsVars(this);
    if (conditional === false) {
      return true;
    }

    var that    = this;
    var trigger = conditional.trigger || "change";
    //---- trigger
    conditional.$target.on(trigger, function() {
      if (conditionalJsIf($(this), conditional)) {
        conditionalJsHide(that, conditional);
      }
      else {
        conditionalJsShow(that, conditional);
      }
    });
    //---- init
    if (conditionalJsIf(conditional.$target, conditional)) {
      conditionalJsHide(that, conditional);
    }
    else {
      conditionalJsShow(that, conditional);
    }
    //-----
  });
}

jQuery.fn.extend({
  conditionalJsAuto: function() {
    conditionalJsAuto($(this));
  }
});
